import { defineComponent as Ce, openBlock as $, createElementBlock as q, createElementVNode as ee, toDisplayString as De, createCommentVNode as de, normalizeClass as xe, renderSlot as me, createBlock as ke, unref as U, createVNode as Fe, mergeProps as Ae, shallowRef as kn, watch as Ve, computed as Z, toValue as Ke, reactive as ei, h as Fs, getCurrentInstance as ti, inject as Wn, resolveComponent as Na, createPropsRestProxy as ga, resolveDynamicComponent as Pt, withCtx as Te, ref as we, onMounted as mt, Transition as wn, normalizeProps as _t, guardReactiveProps as Dt, createTextVNode as wt, toRef as Bi, normalizeStyle as Ct, Teleport as ba, useSlots as An, onUpdated as lo, onUnmounted as Ln, withModifiers as sa, Fragment as Ge, renderList as vt, useModel as Wa, mergeModels as Sn, useTemplateRef as it, nextTick as Ya, createSlots as Xa, isRef as Pi, onBeforeUnmount as ni, provide as ai, withDirectives as Qt, withKeys as ri, vModelCheckbox as oo, vModelDynamic as zi, readonly as so, vShow as ii, createStaticVNode as Ns, TransitionGroup as Bs, getCurrentScope as Ps, onScopeDispose as zs, shallowReadonly as Mn, version as Vs, vModelRadio as Hs, toRefs as Ca, onServerPrefetch as Us, onBeforeMount as qs, vModelText as js } from "vue";
import { toArray as Zs, unrefElement as uo, tryOnScopeDispose as Ws, refDebounced as Ys, useTransition as Xs, TransitionPresets as Gs, useScrollLock as co, onClickOutside as Ga, onKeyStroke as fo, useEventListener as Ut, useMediaQuery as Ks, usePreferredReducedMotion as ho, useVibrate as vo, useTimeoutFn as ta, useIntervalFn as Js, useDebounceFn as Qs, useElementSize as Vr, useResizeObserver as eu, usePointerSwipe as tu } from "@vueuse/core";
import { isNotNestedPath as nu, cleanupNonNestedPath as au, useForm as ru, useField as iu } from "vee-validate";
const lu = {
  key: 0,
  class: "lc-count-bubble"
}, Hr = /* @__PURE__ */ Ce({
  __name: "LcCountBubble",
  props: {
    count: {}
  },
  setup(e) {
    return (t, n) => e.count ? ($(), q("div", lu, [
      ee("span", null, De(Math.min(e.count, 99)), 1)
    ])) : de("", !0);
  }
}), Qe = /* @__PURE__ */ Ce({
  __name: "LcIcon",
  props: {
    name: {},
    size: { default: "medium" }
  },
  setup(e) {
    return (t, n) => ($(), q("i", {
      "aria-hidden": "true",
      class: xe(["lc-icon", `lc-icon--${e.name}`, `lc-icon--size-${e.size}`]),
      focusable: "false"
    }, null, 2));
  }
}), R1 = ["large", "medium", "small"], O1 = [
  "account-balance",
  "add",
  "alarm",
  "alert-circle",
  "alert-triangle",
  "arrow-down",
  "arrow-left",
  "arrow-right",
  "arrow-right-small",
  "arrow-up",
  "arrowhead-right",
  "award",
  "bank",
  "bell",
  "bell-off",
  "calendar",
  "camera",
  "camera-scan",
  "card-add-funds",
  "card-expired",
  "card-okay",
  "careers",
  "chat",
  "checkmark",
  "checkmark-circle",
  "checkmark-small",
  "chevron-circle",
  "chevron-close",
  "chevron-down",
  "chevron-left",
  "chevron-right",
  "chevron-up",
  "close",
  "close-account",
  "close-large",
  "cloud-upload",
  "copy",
  "data",
  "day-afternoon",
  "day-evening",
  "day-midday",
  "day-morning",
  "deposit-limits",
  "download",
  "dropdown-down",
  "dropdown-left",
  "dropdown-right",
  "dropdown-up",
  "edit",
  "edit-active",
  "email",
  "emoji-bad",
  "emoji-good",
  "emoji-ok",
  "exclamation",
  "external-link",
  "eye",
  "eye-close",
  "eye-off",
  "file",
  "file-text",
  "file-type",
  "filter",
  "fire",
  "flash",
  "flash-plus",
  "game",
  "gift",
  "heart",
  "helpcenter",
  "hero",
  "hit-megahit",
  "hit-powerhit",
  "house",
  "id",
  "info",
  "info-help",
  "keno",
  "language",
  "language-lt",
  "limits",
  "limits-purchase",
  "link",
  "list",
  "loader",
  "location",
  "location-not-allowed",
  "lock",
  "login",
  "logout",
  "map",
  "mark-all-as-read",
  "menu",
  "message-circle",
  "message-square",
  "minus",
  "mobile-phone",
  "more-horizontal",
  "more-vertical",
  "orders",
  "orders-canceled",
  "orders-multiple-filled-xx",
  "orders-multiple-filled-xxx",
  "orders-multiple-xx",
  "orders-multiple-xxx",
  "orders-purchased",
  "orders-waiting-for-purchase",
  "passkey",
  "pause",
  "payment-options",
  "phone-call",
  "play",
  "play-filled",
  "plus",
  "plus-small",
  "prepaid",
  "prepaid-participating",
  "pricetag",
  "prize",
  "profile-block",
  "profile-circle",
  "profile-close",
  "profile-customer-id",
  "profile-person",
  "profile-personal-info",
  "profile-self-exclusion",
  "protect",
  "question",
  "quick-pick-settings",
  "reset",
  "retailer",
  "save",
  "scratch-autoreveal",
  "scratch-backside",
  "scratch-demo",
  "scratch-now",
  "scratch-processing",
  "scratch-scratched",
  "scratch-unscratched",
  "scratchcard",
  "search",
  "serial-number",
  "settings",
  "shopping-card-empty",
  "shopping-card-filled",
  "shopping-cart",
  "show-all",
  "shuffle-h",
  "shuffle-numbers",
  "shuffle-v",
  "spades",
  "star",
  "status-of-order",
  "subscription",
  "subscription-deactivated",
  "subscription-paused",
  "swap",
  "sync",
  "tab-lotteries",
  "tab-scratchcards",
  "ticket-processing",
  "time",
  "time-pending",
  "time-sandclock",
  "touch",
  "transaction",
  "transaction-credit-note",
  "transaction-debit-note",
  "transaction-funding",
  "transaction-refund",
  "transactions-chargeback",
  "transactions-old",
  "transactions-payout",
  "transactions-reverse-chargeback",
  "trash-empty",
  "trash-full",
  "unlock",
  "unverified-shield",
  "upload",
  "verify",
  "verify-guard",
  "verify-shield",
  "winning",
  "winning-correction",
  "zoom"
], ou = { class: "lc-badge" }, F1 = /* @__PURE__ */ Ce({
  __name: "LcBadge",
  props: {
    count: {},
    icon: {}
  },
  setup(e) {
    return (t, n) => ($(), q("div", ou, [
      me(t.$slots, "icon", {}, () => [
        e.icon ? ($(), ke(U(Qe), {
          key: 0,
          name: e.icon
        }, null, 8, ["name"])) : de("", !0)
      ]),
      Fe(U(Hr), Ae({ count: e.count }, { class: "lc-badge__count" }), null, 16),
      me(t.$slots, "default")
    ]));
  }
});
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const su = (e) => e != null;
var mo = ["input:not([inert]):not([inert] *)", "select:not([inert]):not([inert] *)", "textarea:not([inert]):not([inert] *)", "a[href]:not([inert]):not([inert] *)", "area[href]:not([inert]):not([inert] *)", "button:not([inert]):not([inert] *)", "[tabindex]:not(slot):not([inert]):not([inert] *)", "audio[controls]:not([inert]):not([inert] *)", "video[controls]:not([inert]):not([inert] *)", '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)', "details>summary:first-of-type:not([inert]):not([inert] *)", "details:not([inert]):not([inert] *)"], Ba = /* @__PURE__ */ mo.join(","), go = typeof Element > "u", _n = go ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Pa = !go && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e?.ownerDocument;
}, za = function(t, n) {
  var r;
  n === void 0 && (n = !0);
  var s = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = s === "" || s === "true", a = i || n && t && // closest does not exist on shadow roots, so we fall back to a manual
  // lookup upward, in case it is not defined.
  (typeof t.closest == "function" ? t.closest("[inert]") : za(t.parentNode));
  return a;
}, uu = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, bo = function(t, n, r) {
  if (za(t))
    return [];
  var s = Array.prototype.slice.apply(t.querySelectorAll(Ba));
  return n && _n.call(t, Ba) && s.unshift(t), s = s.filter(r), s;
}, Va = function(t, n, r) {
  for (var s = [], i = Array.from(t); i.length; ) {
    var a = i.shift();
    if (!za(a, !1))
      if (a.tagName === "SLOT") {
        var o = a.assignedElements(), l = o.length ? o : a.children, h = Va(l, !0, r);
        r.flatten ? s.push.apply(s, h) : s.push({
          scopeParent: a,
          candidates: h
        });
      } else {
        var v = _n.call(a, Ba);
        v && r.filter(a) && (n || !t.includes(a)) && s.push(a);
        var c = a.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(a), f = !za(c, !1) && (!r.shadowRootFilter || r.shadowRootFilter(a));
        if (c && f) {
          var m = Va(c === !0 ? a.children : c.children, !0, r);
          r.flatten ? s.push.apply(s, m) : s.push({
            scopeParent: a,
            candidates: m
          });
        } else
          i.unshift.apply(i, a.children);
      }
  }
  return s;
}, po = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, pn = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || uu(t)) && !po(t) ? 0 : t.tabIndex;
}, cu = function(t, n) {
  var r = pn(t);
  return r < 0 && n && !po(t) ? 0 : r;
}, du = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, yo = function(t) {
  return t.tagName === "INPUT";
}, fu = function(t) {
  return yo(t) && t.type === "hidden";
}, hu = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, vu = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, mu = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Pa(t), r = function(o) {
    return n.querySelectorAll('input[type="radio"][name="' + o + '"]');
  }, s;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    s = r(window.CSS.escape(t.name));
  else
    try {
      s = r(t.name);
    } catch (a) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", a.message), !1;
    }
  var i = vu(s, t.form);
  return !i || i === t;
}, gu = function(t) {
  return yo(t) && t.type === "radio";
}, bu = function(t) {
  return gu(t) && !mu(t);
}, pu = function(t) {
  var n, r = t && Pa(t), s = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var a, o, l;
    for (i = !!((a = s) !== null && a !== void 0 && (o = a.ownerDocument) !== null && o !== void 0 && o.contains(s) || t != null && (l = t.ownerDocument) !== null && l !== void 0 && l.contains(t)); !i && s; ) {
      var h, v, c;
      r = Pa(s), s = (h = r) === null || h === void 0 ? void 0 : h.host, i = !!((v = s) !== null && v !== void 0 && (c = v.ownerDocument) !== null && c !== void 0 && c.contains(s));
    }
  }
  return i;
}, Vi = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, s = n.height;
  return r === 0 && s === 0;
}, yu = function(t, n) {
  var r = n.displayCheck, s = n.getShadowRoot;
  if (r === "full-native" && "checkVisibility" in t) {
    var i = t.checkVisibility({
      // Checking opacity might be desirable for some use cases, but natively,
      // opacity zero elements _are_ focusable and tabbable.
      checkOpacity: !1,
      opacityProperty: !1,
      contentVisibilityAuto: !0,
      visibilityProperty: !0,
      // This is an alias for `visibilityProperty`. Contemporary browsers
      // support both. However, this alias has wider browser support (Chrome
      // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
      // we include it anyway.
      checkVisibilityCSS: !0
    });
    return !i;
  }
  var a = getComputedStyle(t), o = a.visibility;
  if (o === "hidden" || o === "collapse")
    return !0;
  var l = _n.call(t, "details>summary:first-of-type"), h = l ? t.parentElement : t;
  if (_n.call(h, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || // full-native can run this branch when it falls through in case
  // Element#checkVisibility is unsupported
  r === "full-native" || r === "legacy-full") {
    if (typeof s == "function") {
      for (var v = t; t; ) {
        var c = t.parentElement, f = Pa(t);
        if (c && !c.shadowRoot && s(c) === !0)
          return Vi(t);
        t.assignedSlot ? t = t.assignedSlot : !c && f !== t.ownerDocument ? t = f.host : t = c;
      }
      t = v;
    }
    if (pu(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return Vi(t);
  return !1;
}, wu = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var s = n.children.item(r);
          if (s.tagName === "LEGEND")
            return _n.call(n, "fieldset[disabled] *") ? !0 : !s.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, Ha = function(t, n) {
  return !(n.disabled || fu(n) || yu(n, t) || // For a details element with a summary, the summary element gets the focus
  hu(n) || wu(n));
}, Ur = function(t, n) {
  return !(bu(n) || pn(n) < 0 || !Ha(t, n));
}, xu = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, wo = function(t) {
  var n = [], r = [];
  return t.forEach(function(s, i) {
    var a = !!s.scopeParent, o = a ? s.scopeParent : s, l = cu(o, a), h = a ? wo(s.candidates) : o;
    l === 0 ? a ? n.push.apply(n, h) : n.push(o) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: s,
      isScope: a,
      content: h
    });
  }), r.sort(du).reduce(function(s, i) {
    return i.isScope ? s.push.apply(s, i.content) : s.push(i.content), s;
  }, []).concat(n);
}, ku = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Ur.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: xu
  }) : r = bo(t, n.includeContainer, Ur.bind(null, n)), wo(r);
}, Su = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = Va([t], n.includeContainer, {
    filter: Ha.bind(null, n),
    flatten: !0,
    getShadowRoot: n.getShadowRoot
  }) : r = bo(t, n.includeContainer, Ha.bind(null, n)), r;
}, Rn = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return _n.call(t, Ba) === !1 ? !1 : Ur(n, t);
}, _u = /* @__PURE__ */ mo.concat("iframe:not([inert]):not([inert] *)").join(","), pr = function(t, n) {
  if (n = n || {}, !t)
    throw new Error("No node provided");
  return _n.call(t, _u) === !1 ? !1 : Ha(n, t);
};
function qr(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function Cu(e) {
  if (Array.isArray(e)) return qr(e);
}
function Hi(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = xo(e)) || t) {
      n && (e = n);
      var r = 0, s = function() {
      };
      return {
        s,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(l) {
          throw l;
        },
        f: s
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, a = !0, o = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var l = n.next();
      return a = l.done, l;
    },
    e: function(l) {
      o = !0, i = l;
    },
    f: function() {
      try {
        a || n.return == null || n.return();
      } finally {
        if (o) throw i;
      }
    }
  };
}
function Eu(e, t, n) {
  return (t = Iu(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Tu(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Au() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ui(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(s) {
      return Object.getOwnPropertyDescriptor(e, s).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function qi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ui(Object(n), !0).forEach(function(r) {
      Eu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ui(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Lu(e) {
  return Cu(e) || Tu(e) || xo(e) || Au();
}
function $u(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Iu(e) {
  var t = $u(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function xo(e, t) {
  if (e) {
    if (typeof e == "string") return qr(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? qr(e, t) : void 0;
  }
}
var Kt = {
  // Returns the trap from the top of the stack.
  getActiveTrap: function(t) {
    return t?.length > 0 ? t[t.length - 1] : null;
  },
  // Pauses the currently active trap, then adds a new trap to the stack.
  activateTrap: function(t, n) {
    var r = Kt.getActiveTrap(t);
    n !== r && Kt.pauseTrap(t);
    var s = t.indexOf(n);
    s === -1 || t.splice(s, 1), t.push(n);
  },
  // Removes the trap from the top of the stack, then unpauses the next trap down.
  deactivateTrap: function(t, n) {
    var r = t.indexOf(n);
    r !== -1 && t.splice(r, 1), Kt.unpauseTrap(t);
  },
  // Pauses the trap at the top of the stack.
  pauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n?._setPausedState(!0);
  },
  // Unpauses the trap at the top of the stack.
  unpauseTrap: function(t) {
    var n = Kt.getActiveTrap(t);
    n && !n._isManuallyPaused() && n._setPausedState(!1);
  }
}, Du = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, Mu = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, ra = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, Ru = function(t) {
  return ra(t) && !t.shiftKey;
}, Ou = function(t) {
  return ra(t) && t.shiftKey;
}, ji = function(t) {
  return setTimeout(t, 0);
}, Gn = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), s = 1; s < n; s++)
    r[s - 1] = arguments[s];
  return typeof t == "function" ? t.apply(void 0, r) : t;
}, Ea = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, Fu = [], Nu = function(t, n) {
  var r = n?.document || document, s = n?.trapStack || Fu, i = qi({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    delayReturnFocus: !0,
    isolateSubtrees: !1,
    isKeyForward: Ru,
    isKeyBackward: Ou
  }, n), a = {
    // containers given to createFocusTrap()
    /** @type {Array<HTMLElement>} */
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    // references to nodes that are siblings to the ancestors of this trap's containers.
    /** @type {Set<HTMLElement>} */
    adjacentElements: /* @__PURE__ */ new Set(),
    // references to nodes that were inert or aria-hidden before the trap was activated.
    /** @type {Set<HTMLElement>} */
    alreadySilent: /* @__PURE__ */ new Set(),
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, o, l = function(E, A, V) {
    return E && E[A] !== void 0 ? E[A] : i[V || A];
  }, h = function(E, A) {
    var V = typeof A?.composedPath == "function" ? A.composedPath() : void 0;
    return a.containerGroups.findIndex(function(H) {
      var K = H.container, B = H.tabbableNodes;
      return K.contains(E) || V?.includes(K) || B.find(function(ae) {
        return ae === E;
      });
    });
  }, v = function(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, V = A.hasFallback, H = V === void 0 ? !1 : V, K = A.params, B = K === void 0 ? [] : K, ae = i[E];
    if (typeof ae == "function" && (ae = ae.apply(void 0, Lu(B))), ae === !0 && (ae = void 0), !ae) {
      if (ae === void 0 || ae === !1)
        return ae;
      throw new Error("`".concat(E, "` was specified but was not a node, or did not return a node"));
    }
    var le = ae;
    if (typeof ae == "string") {
      try {
        le = r.querySelector(ae);
      } catch (se) {
        throw new Error("`".concat(E, '` appears to be an invalid selector; error="').concat(se.message, '"'));
      }
      if (!le && !H)
        throw new Error("`".concat(E, "` as selector refers to no known node"));
    }
    return le;
  }, c = function(E) {
    var A = E.activeElement;
    return A ? A.shadowRoot && A.shadowRoot.activeElement !== null ? c(A.shadowRoot) : A : null;
  }, f = function() {
    var E = v("initialFocus", {
      hasFallback: !0
    });
    if (E === !1)
      return !1;
    if (E === void 0 || E && !pr(E, i.tabbableOptions)) {
      var A = c(r);
      if (h(A) >= 0)
        E = A;
      else {
        var V = a.tabbableGroups[0], H = V && V.firstTabbableNode;
        E = H || v("fallbackFocus");
      }
    } else E === null && (E = v("fallbackFocus"));
    if (!E)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return E;
  }, m = function() {
    if (a.containerGroups = a.containers.map(function(E) {
      var A = ku(E, i.tabbableOptions), V = Su(E, i.tabbableOptions), H = A.length > 0 ? A[0] : void 0, K = A.length > 0 ? A[A.length - 1] : void 0, B = V.find(function(se) {
        return Rn(se);
      }), ae = V.slice().reverse().find(function(se) {
        return Rn(se);
      }), le = !!A.find(function(se) {
        return pn(se) > 0;
      });
      return {
        container: E,
        tabbableNodes: A,
        focusableNodes: V,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: le,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: H,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: K,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: B,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: ae,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(be) {
          var Me = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Se = A.indexOf(be);
          return Se < 0 ? Me ? V.slice(V.indexOf(be) + 1).find(function(te) {
            return Rn(te);
          }) : V.slice(0, V.indexOf(be)).reverse().find(function(te) {
            return Rn(te);
          }) : A[Se + (Me ? 1 : -1)];
        }
      };
    }), a.tabbableGroups = a.containerGroups.filter(function(E) {
      return E.tabbableNodes.length > 0;
    }), a.tabbableGroups.length <= 0 && !v("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (a.containerGroups.find(function(E) {
      return E.posTabIndexesFound;
    }) && a.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, u = function(E) {
    if (E !== !1 && E !== c(document)) {
      if (!E || !E.focus) {
        u(f());
        return;
      }
      E.focus({
        preventScroll: !!i.preventScroll
      }), a.mostRecentlyFocusedNode = E, Du(E) && E.select();
    }
  }, p = function(E) {
    var A = v("setReturnFocus", {
      params: [E]
    });
    return A || (A === !1 ? !1 : E);
  }, S = function(E) {
    var A = E.target, V = E.event, H = E.isBackward, K = H === void 0 ? !1 : H;
    A = A || Ea(V), m();
    var B = null;
    if (a.tabbableGroups.length > 0) {
      var ae = h(A, V), le = ae >= 0 ? a.containerGroups[ae] : void 0;
      if (ae < 0)
        K ? B = a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode : B = a.tabbableGroups[0].firstTabbableNode;
      else if (K) {
        var se = a.tabbableGroups.findIndex(function(ge) {
          var pe = ge.firstTabbableNode;
          return A === pe;
        });
        if (se < 0 && (le.container === A || pr(A, i.tabbableOptions) && !Rn(A, i.tabbableOptions) && !le.nextTabbableNode(A, !1)) && (se = ae), se >= 0) {
          var be = se === 0 ? a.tabbableGroups.length - 1 : se - 1, Me = a.tabbableGroups[be];
          B = pn(A) >= 0 ? Me.lastTabbableNode : Me.lastDomTabbableNode;
        } else ra(V) || (B = le.nextTabbableNode(A, !1));
      } else {
        var Se = a.tabbableGroups.findIndex(function(ge) {
          var pe = ge.lastTabbableNode;
          return A === pe;
        });
        if (Se < 0 && (le.container === A || pr(A, i.tabbableOptions) && !Rn(A, i.tabbableOptions) && !le.nextTabbableNode(A)) && (Se = ae), Se >= 0) {
          var te = Se === a.tabbableGroups.length - 1 ? 0 : Se + 1, he = a.tabbableGroups[te];
          B = pn(A) >= 0 ? he.firstTabbableNode : he.firstDomTabbableNode;
        } else ra(V) || (B = le.nextTabbableNode(A));
      }
    } else
      B = v("fallbackFocus");
    return B;
  }, g = function(E) {
    var A = Ea(E);
    if (!(h(A, E) >= 0)) {
      if (Gn(i.clickOutsideDeactivates, E)) {
        o.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: i.returnFocusOnDeactivate
        });
        return;
      }
      Gn(i.allowOutsideClick, E) || E.preventDefault();
    }
  }, b = function(E) {
    var A = Ea(E), V = h(A, E) >= 0;
    if (V || A instanceof Document)
      V && (a.mostRecentlyFocusedNode = A);
    else {
      E.stopImmediatePropagation();
      var H, K = !0;
      if (a.mostRecentlyFocusedNode)
        if (pn(a.mostRecentlyFocusedNode) > 0) {
          var B = h(a.mostRecentlyFocusedNode), ae = a.containerGroups[B].tabbableNodes;
          if (ae.length > 0) {
            var le = ae.findIndex(function(se) {
              return se === a.mostRecentlyFocusedNode;
            });
            le >= 0 && (i.isKeyForward(a.recentNavEvent) ? le + 1 < ae.length && (H = ae[le + 1], K = !1) : le - 1 >= 0 && (H = ae[le - 1], K = !1));
          }
        } else
          a.containerGroups.some(function(se) {
            return se.tabbableNodes.some(function(be) {
              return pn(be) > 0;
            });
          }) || (K = !1);
      else
        K = !1;
      K && (H = S({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: a.mostRecentlyFocusedNode,
        isBackward: i.isKeyBackward(a.recentNavEvent)
      })), u(H || a.mostRecentlyFocusedNode || f());
    }
    a.recentNavEvent = void 0;
  }, _ = function(E) {
    var A = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    a.recentNavEvent = E;
    var V = S({
      event: E,
      isBackward: A
    });
    V && (ra(E) && E.preventDefault(), u(V));
  }, T = function(E) {
    (i.isKeyForward(E) || i.isKeyBackward(E)) && _(E, i.isKeyBackward(E));
  }, I = function(E) {
    Mu(E) && Gn(i.escapeDeactivates, E) !== !1 && (E.preventDefault(), o.deactivate());
  }, L = function(E) {
    var A = Ea(E);
    h(A, E) >= 0 || Gn(i.clickOutsideDeactivates, E) || Gn(i.allowOutsideClick, E) || (E.preventDefault(), E.stopImmediatePropagation());
  }, C = function() {
    if (a.active) {
      Kt.activateTrap(s, o);
      var E;
      return i.delayInitialFocus ? E = new Promise(function(A) {
        a.delayInitialFocusTimer = ji(function() {
          u(f()), A();
        });
      }) : u(f()), r.addEventListener("focusin", b, !0), r.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), r.addEventListener("click", L, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", T, {
        capture: !0,
        passive: !1
      }), r.addEventListener("keydown", I), E;
    }
  }, F = function(E) {
    a.active && !a.paused && o._setSubtreeIsolation(!1), a.adjacentElements.clear(), a.alreadySilent.clear();
    var A = /* @__PURE__ */ new Set(), V = /* @__PURE__ */ new Set(), H = Hi(E), K;
    try {
      for (H.s(); !(K = H.n()).done; ) {
        var B = K.value;
        A.add(B);
        for (var ae = typeof ShadowRoot < "u" && B.getRootNode() instanceof ShadowRoot, le = B; le; ) {
          A.add(le);
          var se = le.parentElement, be = [];
          se ? be = se.children : !se && ae && (be = le.getRootNode().children, se = le.getRootNode().host, ae = typeof ShadowRoot < "u" && se.getRootNode() instanceof ShadowRoot);
          var Me = Hi(be), Se;
          try {
            for (Me.s(); !(Se = Me.n()).done; ) {
              var te = Se.value;
              V.add(te);
            }
          } catch (he) {
            Me.e(he);
          } finally {
            Me.f();
          }
          le = se;
        }
      }
    } catch (he) {
      H.e(he);
    } finally {
      H.f();
    }
    A.forEach(function(he) {
      V.delete(he);
    }), a.adjacentElements = V;
  }, z = function() {
    if (a.active)
      return r.removeEventListener("focusin", b, !0), r.removeEventListener("mousedown", g, !0), r.removeEventListener("touchstart", g, !0), r.removeEventListener("click", L, !0), r.removeEventListener("keydown", T, !0), r.removeEventListener("keydown", I), o;
  }, X = function(E) {
    var A = a.mostRecentlyFocusedNode;
    if (A) {
      var V = E.some(function(K) {
        var B = Array.from(K.removedNodes);
        return B.some(function(ae) {
          return ae === A || typeof ae.contains == "function" && ae.contains(A);
        });
      });
      if (V && a.containers.some(function(K) {
        return K?.isConnected;
      })) {
        m();
        var H = f();
        u(H);
      }
    }
  }, O = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(X) : void 0, G = function() {
    O && (O.disconnect(), a.active && !a.paused && a.containers.map(function(E) {
      O.observe(E, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return o = {
    get active() {
      return a.active;
    },
    get paused() {
      return a.paused;
    },
    activate: function(E) {
      if (a.active)
        return this;
      var A = l(E, "onActivate"), V = l(E, "onPostActivate"), H = l(E, "checkCanFocusTrap"), K = Kt.getActiveTrap(s), B = !1;
      if (K && !K.paused) {
        var ae;
        (ae = K._setSubtreeIsolation) === null || ae === void 0 || ae.call(K, !1), B = !0;
      }
      try {
        H || m(), a.active = !0, a.paused = !1, a.nodeFocusedBeforeActivation = c(r), A?.({
          trap: o
        });
        var le = function() {
          H && m();
          var Me = function() {
            o._setSubtreeIsolation(!0), G(), V?.({
              trap: o
            });
          }, Se = C();
          Se ? Se.then(Me) : Me();
        };
        if (H)
          return H(a.containers.concat()).then(le, le), this;
        le();
      } catch (be) {
        if (K === Kt.getActiveTrap(s) && B) {
          var se;
          (se = K._setSubtreeIsolation) === null || se === void 0 || se.call(K, !0);
        }
        throw be;
      }
      return this;
    },
    deactivate: function(E) {
      if (!a.active)
        return this;
      var A = qi({
        onDeactivate: i.onDeactivate,
        onPostDeactivate: i.onPostDeactivate,
        checkCanReturnFocus: i.checkCanReturnFocus
      }, E);
      clearTimeout(a.delayInitialFocusTimer), a.delayInitialFocusTimer = void 0, a.paused || o._setSubtreeIsolation(!1), a.alreadySilent.clear(), z(), a.active = !1, a.paused = !1, G(), Kt.deactivateTrap(s, o);
      var V = l(A, "onDeactivate"), H = l(A, "onPostDeactivate"), K = l(A, "checkCanReturnFocus"), B = l(A, "delayReturnFocus"), ae = l(A, "returnFocus", "returnFocusOnDeactivate");
      V?.({
        trap: o
      });
      var le = function() {
        ae && u(p(a.nodeFocusedBeforeActivation)), H?.({
          trap: o
        });
      }, se = function() {
        B && ae ? ji(le) : le();
      };
      return ae && K ? (K(p(a.nodeFocusedBeforeActivation)).then(se, se), this) : (se(), this);
    },
    pause: function(E) {
      return a.active ? (a.manuallyPaused = !0, this._setPausedState(!0, E)) : this;
    },
    unpause: function(E) {
      return a.active ? (a.manuallyPaused = !1, s[s.length - 1] !== this ? this : this._setPausedState(!1, E)) : this;
    },
    updateContainerElements: function(E) {
      var A = [].concat(E).filter(Boolean);
      return a.containers = A.map(function(V) {
        return typeof V == "string" ? r.querySelector(V) : V;
      }), i.isolateSubtrees && F(a.containers), a.active && (m(), a.paused || o._setSubtreeIsolation(!0)), G(), this;
    }
  }, Object.defineProperties(o, {
    _isManuallyPaused: {
      value: function() {
        return a.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(E, A) {
        if (a.paused === E)
          return this;
        if (a.paused = E, E) {
          var V = l(A, "onPause"), H = l(A, "onPostPause");
          V?.({
            trap: o
          }), z(), o._setSubtreeIsolation(!1), G(), H?.({
            trap: o
          });
        } else {
          var K = l(A, "onUnpause"), B = l(A, "onPostUnpause");
          K?.({
            trap: o
          });
          var ae = function() {
            m();
            var se = function() {
              o._setSubtreeIsolation(!0), G(), B?.({
                trap: o
              });
            }, be = C();
            be ? be.then(se) : se();
          };
          ae();
        }
        return this;
      }
    },
    _setSubtreeIsolation: {
      value: function(E) {
        i.isolateSubtrees && a.adjacentElements.forEach(function(A) {
          var V;
          E ? i.isolateSubtrees === "aria-hidden" ? ((A.ariaHidden === "true" || ((V = A.getAttribute("aria-hidden")) === null || V === void 0 ? void 0 : V.toLowerCase()) === "true") && a.alreadySilent.add(A), A.setAttribute("aria-hidden", "true")) : ((A.inert || A.hasAttribute("inert")) && a.alreadySilent.add(A), A.setAttribute("inert", !0)) : a.alreadySilent.has(A) || (i.isolateSubtrees === "aria-hidden" ? A.removeAttribute("aria-hidden") : A.removeAttribute("inert"));
        });
      }
    }
  }), o.updateContainerElements(t), o;
};
function Bu(e, t = {}) {
  let n;
  const { immediate: r, ...s } = t, i = kn(!1), a = kn(!1), o = (c) => n && n.activate(c), l = (c) => n && n.deactivate(c), h = () => {
    n && (n.pause(), a.value = !0);
  }, v = () => {
    n && (n.unpause(), a.value = !1);
  };
  return Ve(Z(() => Zs(Ke(e)).map((c) => {
    const f = Ke(c);
    return typeof f == "string" ? f : uo(f);
  }).filter(su)), (c) => {
    if (c.length)
      if (!n)
        n = Nu(c, {
          ...s,
          onActivate(f) {
            i.value = !0, t.onActivate && t.onActivate(f);
          },
          onDeactivate(f) {
            i.value = !1, t.onDeactivate && t.onDeactivate(f);
          }
        }), r && o();
      else {
        const f = n?.active;
        n?.updateContainerElements(c), !f && r && o();
      }
  }, { flush: "post" }), Ws(() => l()), {
    hasFocus: i,
    isPaused: a,
    activate: o,
    deactivate: l,
    pause: h,
    unpause: v
  };
}
const ko = /* @__PURE__ */ Ce((e, { slots: t }) => {
  const n = kn(), r = ei(Bu(n, e.options));
  return () => {
    if (t.default) return Fs(e.as || "div", { ref: n }, t.default(r));
  };
}, {
  name: "UseFocusTrap",
  props: ["as", "options"]
}), Pu = 864e5, zu = 6e4, Vu = 36e5, Zi = /* @__PURE__ */ Symbol.for("constructDateFrom");
function qn(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Zi in e ? e[Zi](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Mt(e, t) {
  return qn(e, e);
}
function Hu(e, t, n) {
  const r = Mt(e);
  return isNaN(t) ? qn(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Uu(e, t, n) {
  const r = Mt(e);
  if (isNaN(t)) return qn(e, NaN);
  if (!t)
    return r;
  const s = r.getDate(), i = qn(e, r.getTime());
  i.setMonth(r.getMonth() + t + 1, 0);
  const a = i.getDate();
  return s >= a ? i : (r.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    s
  ), r);
}
function Kn(e, t, n) {
  const {
    years: r = 0,
    months: s = 0,
    weeks: i = 0,
    days: a = 0,
    hours: o = 0,
    minutes: l = 0,
    seconds: h = 0
  } = t, v = Mt(e), c = s || r ? Uu(v, s + r * 12) : v, f = a || i ? Hu(c, a + i * 7) : c, m = l + o * 60, p = (h + m * 60) * 1e3;
  return qn(e, +f + p);
}
function Wi(e) {
  const t = Mt(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function un(e, ...t) {
  const n = qn.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Yi(e, t) {
  const n = Mt(e);
  return n.setHours(0, 0, 0, 0), n;
}
function qu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = Yi(r), a = Yi(s), o = +i - Wi(i), l = +a - Wi(a);
  return Math.round((o - l) / Pu);
}
function ia(e, t) {
  const n = +Mt(e) - +Mt(t);
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function ju(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function li(e) {
  return !(!ju(e) && typeof e != "number" || isNaN(+Mt(e)));
}
function Zu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = r.getFullYear() - s.getFullYear(), a = r.getMonth() - s.getMonth();
  return i * 12 + a;
}
function Wu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  );
  return r.getFullYear() - s.getFullYear();
}
function Yu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = Xi(r, s), a = Math.abs(
    qu(r, s)
  );
  r.setDate(r.getDate() - i * a);
  const o = +(Xi(r, s) === -i), l = i * (a - o);
  return l === 0 ? 0 : l;
}
function Xi(e, t) {
  const n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function oi(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function Xu(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = (+r - +s) / Vu;
  return oi(n?.roundingMethod)(i);
}
function So(e, t) {
  return +Mt(e) - +Mt(t);
}
function Gu(e, t, n) {
  const r = So(e, t) / zu;
  return oi(n?.roundingMethod)(r);
}
function Ku(e, t) {
  const n = Mt(e);
  return n.setHours(23, 59, 59, 999), n;
}
function Ju(e, t) {
  const n = Mt(e), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Qu(e, t) {
  const n = Mt(e);
  return +Ku(n) == +Ju(n);
}
function ec(e, t, n) {
  const [r, s, i] = un(
    n?.in,
    e,
    e,
    t
  ), a = ia(s, i), o = Math.abs(
    Zu(s, i)
  );
  if (o < 1) return 0;
  s.getMonth() === 1 && s.getDate() > 27 && s.setDate(30), s.setMonth(s.getMonth() - a * o);
  let l = ia(s, i) === -a;
  Qu(r) && o === 1 && ia(r, i) === 1 && (l = !1);
  const h = a * (o - +l);
  return h === 0 ? 0 : h;
}
function tc(e, t, n) {
  const r = So(e, t) / 1e3;
  return oi(n?.roundingMethod)(r);
}
function nc(e, t, n) {
  const [r, s] = un(
    n?.in,
    e,
    t
  ), i = ia(r, s), a = Math.abs(Wu(r, s));
  r.setFullYear(1584), s.setFullYear(1584);
  const o = ia(r, s) === -i, l = i * (a - +o);
  return l === 0 ? 0 : l;
}
function ac(e, t) {
  const [n, r] = un(e, t.start, t.end);
  return { start: n, end: r };
}
function rc(e, t) {
  const { start: n, end: r } = ac(t?.in, e), s = {}, i = nc(r, n);
  i && (s.years = i);
  const a = Kn(n, { years: s.years }), o = ec(r, a);
  o && (s.months = o);
  const l = Kn(a, { months: s.months }), h = Yu(r, l);
  h && (s.days = h);
  const v = Kn(l, { days: s.days }), c = Xu(r, v);
  c && (s.hours = c);
  const f = Kn(v, { hours: s.hours }), m = Gu(r, f);
  m && (s.minutes = m);
  const u = Kn(f, { minutes: s.minutes }), p = tc(r, u);
  return p && (s.seconds = p), s;
}
function _o(e) {
  return +Mt(e) < Date.now();
}
function ic(e, t, n) {
  let r = (s) => e(s, ...t);
  return n === void 0 ? r : Object.assign(r, { lazy: n, lazyArgs: t });
}
function Ka(e, t, n) {
  let r = e.length - t.length;
  if (r === 0) return e(...t);
  if (r === 1) return ic(e, t, n);
  throw Error("Wrong number of arguments");
}
function Gi(...e) {
  return Ka(lc, e);
}
const lc = (e, t) => e.length >= t;
function St(e) {
  return typeof e == "number" && !Number.isNaN(e);
}
function Ki(e) {
  if (typeof e != "object" || !e) return !1;
  let t = Object.getPrototypeOf(e);
  return t === null || t === Object.prototype;
}
function oc(...e) {
  return Ka(Co, e);
}
function Co(e, t) {
  let n = { ...e, ...t };
  for (let r in t) Object.hasOwn(e, r) && Ki(e[r]) && Ki(t[r]) && (n[r] = Co(e[r], t[r]));
  return n;
}
function en(...e) {
  return Ka(sc, e);
}
function sc(e, t) {
  if (!Gi(t, 1)) return { ...e };
  if (!Gi(t, 2)) {
    let { [t[0]]: r, ...s } = e;
    return s;
  }
  let n = { ...e };
  for (let r of t) delete n[r];
  return n;
}
function uc(...e) {
  return Ka(cc, e);
}
function cc(e, t) {
  let n = {};
  for (let r of t) r in e && (n[r] = e[r]);
  return n;
}
const Eo = {
  general: {
    currency: "USD",
    locale: "en-US"
  },
  lcButton: {
    longPressHint: "Press & Hold"
  },
  lcCard: {
    toggleAriaLabel: "Toggle content visibility"
  },
  lcFlyOut: {
    buttonAriaLabel: "Close flyout",
    to: "#lc-fly-outs",
    visibleInSeconds: 4
  },
  lcHeader: {
    flyOutToggleAriaLabel: "Toggle flyout visibility",
    leftButtonAriaLabel: "Go back"
  },
  lcInfoButton: {
    closeButtonAriaLabel: "Close info modal",
    openButtonAriaLabel: "Open info modal"
  },
  lcLotteryCutoffTime: {
    textCutoffTime: "Cutoff time",
    textTimeIsAlmostUp: "Time’s almost up",
    textTimeToCutoff: "Time until cutoff"
  },
  lcLotteryEditorCard: {
    clearLabel: "Clear",
    quickPickLabel: "Quick Pick",
    toggleAriaLabel: "Toggle play visibility"
  },
  lcLotteryRemainingPicks: {
    doneLabel: "Done!"
  },
  lcModal: {
    closeTriggers: [],
    fullScreen: !1,
    fullSize: !1,
    isVisible: !1,
    noFocusTrap: !1,
    spacing: "large",
    to: "#lc-modals"
  },
  lcPasswordInput: {
    toggleAriaLabel: "Toggle password visibility"
  },
  lcToast: {
    closeButtonAriaLabel: "Close toast"
  }
}, We = ei(Eo), N1 = (e) => {
  Object.assign(We, oc(Eo, e));
}, dc = /* @__PURE__ */ Symbol(), pa = () => {
  const e = ti();
  if (!e?.proxy)
    throw new Error("No instance of Vue detected");
  return "$nuxt" in e.proxy ? Wn(dc) : null;
}, fc = () => pa() ? Na("NuxtTime") : "time", To = /* @__PURE__ */ Ce({
  __name: "CommonDateTime",
  props: {
    day: {},
    hour: {},
    minute: {},
    month: {},
    second: {},
    weekday: {},
    year: {},
    datetime: {},
    locale: { default: () => We.general.locale }
  },
  setup(e) {
    const t = ga(e, ["datetime", "locale"]), n = fc(), r = Z(() => s.value ? i.value?.toISOString() : void 0), s = Z(() => i.value ? li(i.value) : !1), i = Z(() => {
      if (e.datetime)
        return new Date(e.datetime);
    });
    return (a, o) => s.value ? ($(), ke(Pt(U(n)), Ae({
      key: 0,
      class: "lc-datetime"
    }, { ...t, locale: e.locale }, { datetime: r.value }), {
      default: Te(() => [
        me(a.$slots, "default")
      ]),
      _: 3
    }, 16, ["datetime"])) : de("", !0);
  }
}), Yn = (e) => {
  const t = ti(), n = pa();
  return !(t?.proxy && "$router" in t.proxy) || !e ? "a" : n ? Na("NuxtLink") : Na("RouterLink");
}, si = /* @__PURE__ */ Ce({
  __name: "CommonLink",
  props: {
    href: {},
    target: {},
    to: {}
  },
  setup(e) {
    const t = Yn(e.to);
    return (n, r) => ($(), ke(Pt(U(t)), Ae(n.$attrs, n.$props), {
      default: Te(() => [
        me(n.$slots, "default")
      ]),
      _: 3
    }, 16));
  }
}), ua = /* @__PURE__ */ Ce({
  __name: "CommonTransition",
  props: {
    mode: {},
    name: { default: "slide-down-sm" }
  },
  setup(e) {
    const t = we(!1), n = Ys(t, 1);
    return mt(() => {
      t.value = !0;
    }), (r, s) => ($(), ke(wn, _t(Dt({ name: e.name, mode: e.mode })), {
      default: Te(() => [
        U(n) ? me(r.$slots, "default", {}, void 0, void 0, 0) : de("", !0)
      ]),
      _: 3
    }, 16));
  }
}), hc = {
  key: 0,
  class: "lc-feedback-message__content"
}, $n = /* @__PURE__ */ Ce({
  __name: "FeedbackMessage",
  props: {
    content: {},
    disabled: { type: Boolean },
    variant: { default: "default" }
  },
  setup(e) {
    const t = Z(() => [
      "lc-feedback-message",
      `lc-feedback-message--variant-${e.variant}`,
      {
        "lc-feedback-message--disabled": e.disabled
      }
    ]);
    return (n, r) => ($(), q("div", {
      class: xe(t.value),
      role: "alert"
    }, [
      Fe(U(ua), {
        mode: "out-in",
        name: "slide-fade"
      }, {
        default: Te(() => [
          e.content ? ($(), q("p", hc, [
            e.variant === "error" ? ($(), ke(U(Qe), {
              key: 0,
              class: "lc-feedback-message__icon",
              name: "alert-triangle",
              size: "small"
            })) : de("", !0),
            wt(" " + De(e.content), 1)
          ])) : de("", !0)
        ]),
        _: 1
      })
    ], 2));
  }
}), Ao = "--vc-auto-duration", vc = `height var(${Ao}) cubic-bezier(0.33, 1, 0.68, 1)`, Ta = { padding: 0 }, mc = 300, gc = {
  position: "absolute",
  width: "1px",
  height: "1px",
  padding: "0",
  margin: "-1px",
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  border: "0"
};
function Ji(e) {
  return e.value ? parseFloat(getComputedStyle(e.value).height) : 0;
}
function Qi(e) {
  if (!e.value) return {};
  const { transition: t } = getComputedStyle(e.value);
  return t === "all 0s ease 0s" || t === "all" ? { transition: vc } : { transition: t };
}
function el(e) {
  if (!e.value) return !0;
  const { transition: t } = getComputedStyle(e.value);
  return typeof window.requestAnimationFrame > "u" || window.matchMedia("(prefers-reduced-motion: reduce)").matches || t.includes("none") || t.includes("height 0s");
}
function bc(e = 0) {
  if (e === 0) return 0;
  const t = e / 36, n = Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
  return Number.isFinite(n) ? n : 0;
}
const pc = /* @__PURE__ */ Ce({
  inheritAttrs: !0,
  __name: "Collapse",
  props: {
    when: { type: Boolean },
    baseHeight: { default: 0 },
    as: { default: "div" }
  },
  emits: ["collapse", "expand", "collapsed", "expanded"],
  setup(e, { emit: t }) {
    const n = e, r = t, s = Bi(n, "when"), i = Bi(n, "baseHeight"), a = Z(() => ({ overflow: "hidden", height: `${i.value}px` })), o = Z(() => ({
      ...Ta,
      ...i.value === 0 ? { display: "none" } : a.value
    })), l = we(null), h = we(s.value ? "expanded" : "collapsed"), v = (L) => h.value = L;
    function c() {
      return s.value ? Ta : i.value === 0 ? gc : o.value;
    }
    const f = kn(c()), m = (L) => f.value = L, u = (L) => m({ ...f.value, ...L }), p = we(mc), S = (L) => p.value = L, g = Z(() => ({ [Ao]: `${p.value}ms` }));
    let b = NaN;
    function _() {
      m(Ta), v("expanded"), r("expanded");
    }
    function T() {
      m(o.value), v("collapsed"), r("collapsed");
    }
    mt(() => {
      if (!l.value) return;
      const L = bc(l.value.scrollHeight - i.value);
      L > 0 && S(L), !s.value && i.value === 0 && m(o.value);
    }), Ve(s, (L) => {
      if (l.value)
        if (b = NaN, L) {
          if (el(l)) return _();
          v("expanding"), r("expand"), m({
            ...Ta,
            ...a.value,
            ...g.value
          }), requestAnimationFrame(() => {
            if (l.value) {
              if (l.value.scrollHeight === 0) return _();
              b = l.value.scrollHeight, u({
                ...Qi(l),
                height: `${b}px`,
                willChange: "height"
              });
            }
          });
        } else {
          if (el(l) || (v("collapsing"), r("collapse"), u({
            ...g.value,
            height: `${l.value.scrollHeight}px`
          }), l.value.scrollHeight === 0)) return T();
          requestAnimationFrame(() => {
            l.value && u({
              ...a.value,
              ...Qi(l),
              willChange: "height"
            });
          });
        }
    }), Ve(i, (L) => {
      s.value || (L > 0 ? u({ display: void 0, height: `${L}px` }) : u({ display: "none" }));
    });
    function I(L) {
      l.value && L.target && L.target === l.value && L.propertyName === "height" && (s.value ? Math.abs(l.value.scrollHeight - Ji(l)) < 1 ? _() : b < l.value.scrollHeight && u({
        height: `${l.value.scrollHeight}px`
      }) : Math.abs(i.value - Ji(l)) < 1 && T());
    }
    return (L, C) => ($(), ke(Pt(n.as), {
      ref_key: "collapseRef",
      ref: l,
      style: Ct(f.value),
      onTransitionend: I,
      "data-collapse": h.value
    }, {
      default: Te(() => [
        me(L.$slots, "default", _t(Dt({ state: h.value })))
      ]),
      _: 3
    }, 40, ["style", "data-collapse"]));
  }
}), Lo = /* @__PURE__ */ Ce({
  __name: "InternalCollapse",
  props: {
    animated: { type: Boolean },
    as: { default: "div" },
    when: { type: Boolean }
  },
  emits: ["collapse", "collapsed", "expand", "expanded"],
  setup(e) {
    return (t, n) => e.animated ? ($(), ke(U(pc), Ae({
      key: 0,
      class: "lc-collapse"
    }, { as: e.as, when: e.when }, {
      onCollapse: n[0] || (n[0] = (r) => t.$emit("collapse")),
      onCollapsed: n[1] || (n[1] = (r) => t.$emit("collapsed")),
      onExpand: n[2] || (n[2] = (r) => t.$emit("expand")),
      onExpanded: n[3] || (n[3] = (r) => t.$emit("expanded"))
    }), {
      default: Te(() => [
        me(t.$slots, "default")
      ]),
      _: 3
    }, 16)) : ($(), ke(Pt(e.as), { key: 1 }, {
      default: Te(() => [
        me(t.$slots, "default")
      ]),
      _: 3
    }));
  }
}), yc = /* @__PURE__ */ Ce({
  __name: "InternalOptionalTeleport",
  props: {
    to: {}
  },
  setup(e) {
    return (t, n) => e.to ? ($(), ke(ba, {
      key: 0,
      to: e.to
    }, [
      me(t.$slots, "default")
    ], 8, ["to"])) : me(t.$slots, "default", {}, void 0, void 0, 1);
  }
}), wc = ["height", "width"], xc = ["r", "stroke-width"], kc = ["r", "stroke-dasharray", "stroke-dashoffset", "stroke-width"], $o = /* @__PURE__ */ Ce({
  __name: "ProgressCircle",
  props: {
    progress: { default: 0 },
    progressClass: {},
    radius: { default: 24 },
    strokeWidth: { default: 4 },
    trackClass: {}
  },
  setup(e) {
    const t = Z(() => Math.min(100, Math.max(0, e.progress))), n = Z(() => e.radius - e.strokeWidth), r = Z(() => 2 * Math.PI * n.value), s = Z(
      () => r.value - t.value / 100 * r.value
    );
    return (i, a) => ($(), q("svg", {
      class: "lc-progress-circle",
      height: e.radius * 2,
      width: e.radius * 2
    }, [
      ee("circle", {
        class: xe(["lc-progress-circle__track", e.trackClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-width": e.strokeWidth
      }, null, 10, xc),
      ee("circle", {
        class: xe(["lc-progress-circle__progress", e.progressClass]),
        cx: "50%",
        cy: "50%",
        fill: "transparent",
        r: n.value,
        "stroke-dasharray": `${r.value} ${r.value}`,
        "stroke-dashoffset": s.value,
        "stroke-width": e.strokeWidth
      }, null, 10, kc)
    ], 8, wc));
  }
}), Sc = { class: "lc-timer-circle" }, _c = ["aria-valuenow"], Cc = { class: "lc-timer-circle__content" }, Ec = /* @__PURE__ */ Ce({
  __name: "TimerCircle",
  props: {
    durationInMs: { default: 4e3 }
  },
  setup(e) {
    const t = we(0), n = Xs(t, {
      duration: e.durationInMs,
      transition: Gs.linear
    });
    return mt(() => {
      t.value = 100;
    }), (r, s) => ($(), q("div", Sc, [
      ee("div", {
        "aria-valuenow": U(n),
        class: "lc-timer-circle__visual",
        role: "progressbar"
      }, [
        Fe(U($o), Ae({ progress: U(n) }, { class: "lc-timer-circle__progress" }), null, 16)
      ], 8, _c),
      ee("div", Cc, [
        me(r.$slots, "default")
      ])
    ]));
  }
}), Tc = (e, t) => e in t, tn = (e, t) => typeof e == "string" && Object.values(t).includes(e), B1 = ["left", "right"], P1 = ["large", "medium", "small"], z1 = ["button", "reset", "submit"], V1 = ["click", "long-press"], H1 = [
  "primary",
  "primary-ghost",
  "secondary",
  "tertiary",
  "filled",
  "raised"
];
var jr = /* @__PURE__ */ ((e) => (e.Enter = "Enter", e.Space = " ", e))(jr || {});
const Ac = ["aria-valuenow"], Lc = { class: "lc-button__content" }, $c = {
  key: 0,
  class: "lc-button__label-bubble"
}, Ic = {
  key: 0,
  class: "lc-button__overlay"
}, Dc = { class: "lc-button__long-press-hint" }, Mc = {
  key: 1,
  class: "lc-button__overlay"
}, Rc = {
  key: 0,
  class: "lc-button__loading-text"
}, tl = 1e3 / 25, Et = /* @__PURE__ */ Ce({
  __name: "LcButton",
  props: {
    href: {},
    target: {},
    to: {},
    count: {},
    autofocus: { type: Boolean },
    disabled: { type: Boolean },
    growAnimationMaxWidth: { default: "100%" },
    icon: {},
    iconPosition: { default: "left" },
    loading: { type: Boolean },
    loadingText: {},
    longPressDelay: { default: 2500 },
    longPressHint: { default: () => We.lcButton.longPressHint },
    longPressHintDelay: { default: 1300 },
    noPadding: { type: Boolean },
    size: { default: "large" },
    title: {},
    trigger: { default: "click" },
    type: { default: "button" },
    variant: { default: "primary" }
  },
  emits: ["longpress"],
  setup(e, { emit: t }) {
    const n = t, r = An(), s = we(!!r.default), i = we(!1), a = we(!1), o = we(!1), l = we(!1), h = we(0), v = we(null);
    let c, f, m;
    const u = Z(() => [
      "lc-button",
      `lc-button--icon-${e.iconPosition}`,
      `lc-button--size-${e.size}`,
      `lc-button--variant-${e.variant}`,
      {
        "lc-button--disabled": p.value,
        "lc-button--icon-only": !s.value,
        "lc-button--link": S.value,
        "lc-button--loading": e.loading,
        "lc-button--long-press-active": e.trigger === "long-press" && o.value,
        "lc-button--long-press-done": i.value,
        "lc-button--no-padding": e.noPadding,
        "lc-button--overlay-visible": g.value || e.loading,
        "lc-button--pressed": b.value
      }
    ]), p = Z(() => e.disabled || e.loading), S = Z(() => !!(e.href || e.to) && !p.value), g = Z(
      () => a.value && !e.loading && e.trigger === "long-press"
    ), b = Z(() => l.value || !!v.value), _ = Z(() => typeof e.to == "string" ? void 0 : e.to?.replace), T = Z(() => {
      const H = {
        "--grow-animation-max-width": e.growAnimationMaxWidth
      };
      return e.trigger !== "long-press" ? H : {
        ...H,
        "--progress-transition-duration": `${e.longPressDelay}ms`
      };
    }), I = Z(() => S.value ? Yn(e.to) : "button"), L = () => {
      i.value = !1, o.value = !1, G(), E();
    }, C = (H) => {
      p.value || tn(H.key, jr) && (v.value || (v.value = H.key, z()));
    }, F = (H) => {
      tn(H.key, jr) && H.key === v.value && (G(), !l.value && P());
    }, z = (H = !1) => {
      e.trigger !== "click" && (H && window.addEventListener("pointerup", O), clearTimeout(m), o.value = !0);
    }, X = () => {
      p.value || (l.value = !0, z(!0));
    }, O = () => {
      window.removeEventListener("pointerup", O), E(), !v.value && P();
    }, G = () => {
      v.value = null;
    }, P = () => {
      !o.value && !i.value || (i.value ? a.value = !1 : m = setTimeout(() => {
        a.value = !1;
      }, e.longPressHintDelay), i.value = !1, o.value = !1);
    }, E = () => {
      l.value = !1;
    }, A = () => {
      p.value || z();
    }, V = () => {
      E(), P();
    };
    return lo(() => {
      s.value = !!r.default;
    }), Ln(() => {
      clearInterval(c), clearTimeout(f), clearTimeout(m);
    }), Ve(o, (H) => {
      if (!p.value) {
        if (!H) {
          clearInterval(c), clearTimeout(f), h.value = 0;
          return;
        }
        a.value = !0, c = setInterval(() => {
          h.value += tl / e.longPressDelay * 100;
        }, tl), f = setTimeout(() => {
          clearInterval(c), i.value = !0, n("longpress");
        }, e.longPressDelay);
      }
    }), (H, K) => ($(), ke(Pt(I.value), Ae(H.$attrs, {
      autofocus: e.autofocus,
      href: e.href,
      target: e.target,
      title: e.title,
      to: e.to,
      type: e.type,
      style: T.value,
      replace: _.value
    }, {
      "aria-busy": e.loading,
      class: u.value,
      disabled: p.value,
      onBlur: L,
      onContextmenu: K[0] || (K[0] = sa(() => {
      }, ["prevent"])),
      onKeydown: C,
      onKeyup: F,
      onPointerdown: X,
      onPointerup: O,
      onTouchend: V,
      onTouchstartPassive: A
    }), {
      default: Te(() => [
        e.trigger === "long-press" ? ($(), q("div", {
          key: 0,
          "aria-valuenow": h.value,
          class: "lc-button__progress",
          role: "progressbar"
        }, null, 8, Ac)) : de("", !0),
        ee("div", Lc, [
          e.icon ? ($(), ke(U(Qe), {
            key: 0,
            class: "lc-button__icon",
            name: e.icon
          }, null, 8, ["name"])) : de("", !0),
          Fe(wn, { name: "font-size-fade" }, {
            default: Te(() => [
              H.$slots.default ? ($(), q("span", $c, [
                me(H.$slots, "default"),
                Fe(U(Hr), Ae({ count: e.count }, { class: "lc-button__count-text" }), null, 16)
              ])) : de("", !0)
            ]),
            _: 3
          }),
          H.$slots.default ? de("", !0) : ($(), ke(U(Hr), Ae({ key: 1 }, { count: e.count }, { class: "lc-button__count" }), null, 16))
        ]),
        Fe(U(ua), { name: "fade" }, {
          default: Te(() => [
            g.value ? ($(), q("div", Ic, [
              ee("span", Dc, De(e.longPressHint), 1)
            ])) : de("", !0),
            e.loading ? ($(), q("div", Mc, [
              Fe(U(Qe), {
                class: "lc-button__loading-spinner",
                name: "loader"
              }),
              e.loadingText ? ($(), q("span", Rc, De(e.loadingText), 1)) : de("", !0)
            ])) : de("", !0)
          ]),
          _: 1
        })
      ]),
      _: 3
    }, 16, ["aria-busy", "class", "disabled"]));
  }
}), ui = /* @__PURE__ */ Ce({
  __name: "LcSeparator",
  props: {
    variant: { default: "default" }
  },
  setup(e) {
    return (t, n) => ($(), q("hr", {
      class: xe(["lc-separator", `lc-separator--variant-${e.variant}`])
    }, null, 2));
  }
}), U1 = ["dashed", "default"], Tt = (e) => {
  if (e) return `lc-${e}`;
  const t = pa(), n = crypto.randomUUID();
  return t ? `lc-${t.useId() || n}` : `lc-${n}`;
}, ci = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, s] of t)
    n[r] = s;
  return n;
}, Oc = {}, Fc = { viewBox: "0 0 752 8" }, Nc = { id: "perforation" }, Bc = ["cx"];
function Pc(e, t) {
  return $(), q("svg", Fc, [
    ee("mask", Nc, [
      t[0] || (t[0] = ee("rect", {
        fill: "white",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), q(Ge, null, vt(new Array(21), (n, r) => ($(), q("circle", {
        key: r,
        cx: 28 + r * 34.75,
        cy: "18",
        fill: "black",
        r: "16"
      }, null, 8, Bc))), 128))
    ]),
    t[1] || (t[1] = ee("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const zc = /* @__PURE__ */ ci(Oc, [["render", Pc]]), Vc = {}, Hc = { viewBox: "0 0 752 8" }, Uc = { id: "perforation" }, qc = ["points"];
function jc(e, t) {
  return $(), q("svg", Hc, [
    ee("mask", Uc, [
      t[0] || (t[0] = ee("rect", {
        fill: "black",
        height: "8",
        width: "752"
      }, null, -1)),
      ($(!0), q(Ge, null, vt(new Array(150), (n, r) => ($(), q("polygon", {
        key: r,
        fill: "white",
        points: `${r * 5},0 ${4 + r * 5},6 ${8 + r * 5},0`
      }, null, 8, qc))), 128))
    ]),
    t[1] || (t[1] = ee("rect", {
      height: "8",
      mask: "url(#perforation)",
      width: "752"
    }, null, -1))
  ]);
}
const nl = /* @__PURE__ */ ci(Vc, [["render", jc]]), Zc = ["id"], Wc = {
  key: 0,
  class: "lc-card__background"
}, Yc = {
  key: 1,
  class: /* @__PURE__ */ xe(["lc-card__perforation", "lc-card__perforation--top"])
}, Xc = {
  key: 0,
  class: "lc-card__toggle"
}, Gc = {
  key: 2,
  class: /* @__PURE__ */ xe(["lc-card__perforation", "lc-card__perforation--bottom"])
}, ya = /* @__PURE__ */ Ce({
  __name: "LcCard",
  props: /* @__PURE__ */ Sn({
    animated: { type: Boolean },
    bodyClass: {},
    expandable: { type: Boolean },
    footerClass: {},
    headerClass: {},
    headerTo: {},
    id: {},
    modelValue: { type: Boolean },
    onHeaderClick: { type: Function },
    radius: { default: "medium" },
    shadow: { default: "large" },
    showSeparator: { type: Boolean },
    toggleAriaLabel: { default: () => We.lcCard.toggleAriaLabel },
    variant: { default: "default" },
    withWavyBody: { type: Boolean },
    withWavyHeader: { type: Boolean }
  }, {
    modelValue: { default: !1, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = An(), n = Tt(e.id), r = we(!!t.default), s = Wa(e, "modelValue"), i = Z(() => !!e.expandable && !!e.animated), a = Z(() => [
      "lc-card",
      `lc-card--radius-${e.radius}`,
      `lc-card--shadow-${e.shadow}`,
      `lc-card--variant-${e.variant}`,
      {
        "lc-card--animated": i.value,
        "lc-card--expandable": e.expandable,
        "lc-card--expanded": e.expandable && s.value,
        "lc-card--no-body": !r.value,
        "lc-card--wavy-body": e.withWavyBody,
        "lc-card--wavy-header": e.withWavyHeader
      }
    ]), o = () => {
      e.expandable && (s.value = !s.value);
    };
    return lo(() => {
      r.value = !!t.default;
    }), (l, h) => ($(), q("article", {
      id: U(n),
      class: xe(a.value)
    }, [
      l.$slots.background ? ($(), q("div", Wc, [
        me(l.$slots, "background")
      ])) : de("", !0),
      e.variant === "transaction" ? ($(), q("div", Yc, [
        Fe(nl)
      ])) : de("", !0),
      l.$slots.header || e.expandable ? ($(), ke(Pt(e.expandable ? "button" : "div"), {
        key: 2,
        "aria-controls": e.expandable ? `${U(n)}-region` : void 0,
        "aria-expanded": e.expandable ? s.value : void 0,
        "aria-label": e.expandable ? e.toggleAriaLabel : void 0,
        class: "lc-card__header-wrap",
        type: e.expandable ? "button" : void 0,
        onClickPassive: o
      }, {
        default: Te(() => [
          e.headerTo && !e.expandable ? ($(), ke(U(si), {
            key: 0,
            tabindex: "-1",
            to: e.headerTo,
            onClick: e.onHeaderClick
          }, {
            default: Te(() => [
              ee("header", {
                class: xe(["lc-card__header", e.headerClass])
              }, [
                me(l.$slots, "header")
              ], 2)
            ]),
            _: 3
          }, 8, ["to", "onClick"])) : ($(), q("header", {
            key: 1,
            class: xe(["lc-card__header", e.headerClass])
          }, [
            me(l.$slots, "header"),
            e.expandable ? ($(), q(Ge, { key: 0 }, [
              l.$slots.toggle ? ($(), q("div", Xc, [
                me(l.$slots, "toggle")
              ])) : ($(), ke(U(Qe), {
                key: 1,
                class: "lc-card__toggle-icon",
                name: "chevron-down"
              }))
            ], 64)) : de("", !0)
          ], 2))
        ]),
        _: 3
      }, 40, ["aria-controls", "aria-expanded", "aria-label", "type"])) : de("", !0),
      (l.$slots.default || l.$slots.footer) && (!e.expandable || i.value || s.value) ? ($(), ke(U(Lo), Ae({
        key: 3,
        id: `${U(n)}-region`
      }, { when: s.value }, {
        animated: i.value,
        class: "lc-card__body-wrap",
        onCollapse: h[0] || (h[0] = (v) => l.$emit("collapse")),
        onCollapsed: h[1] || (h[1] = (v) => l.$emit("collapsed")),
        onExpand: h[2] || (h[2] = (v) => l.$emit("expand")),
        onExpanded: h[3] || (h[3] = (v) => l.$emit("expanded"))
      }), {
        default: Te(() => [
          l.$slots.default ? ($(), q("div", {
            key: 0,
            class: xe(["lc-card__body", e.bodyClass])
          }, [
            me(l.$slots, "default")
          ], 2)) : de("", !0),
          l.$slots.footer ? ($(), q("footer", {
            key: 1,
            class: xe(["lc-card__footer", e.footerClass])
          }, [
            e.showSeparator ? ($(), ke(U(ui), {
              key: 0,
              variant: "dashed"
            })) : de("", !0),
            me(l.$slots, "footer")
          ], 2)) : de("", !0),
          e.variant !== "default" ? ($(), q("div", Gc, [
            e.variant == "order" ? ($(), ke(zc, { key: 0 })) : ($(), ke(nl, { key: 1 }))
          ])) : de("", !0)
        ]),
        _: 3
      }, 16, ["id", "animated"])) : de("", !0)
    ], 10, Zc));
  }
}), q1 = ["large", "medium", "none"], j1 = ["large", "none", "small"], Z1 = ["default", "order", "transaction"], Kc = { class: "lc-modal__card-header-wrap" }, Jc = { class: "lc-modal__card-header-actions" }, Io = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcModal",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    backgroundClass: {},
    closeTriggers: { default: () => We.lcModal.closeTriggers },
    containerClass: {},
    fullScreen: { type: Boolean },
    fullSize: { type: Boolean },
    isVisible: { type: Boolean, default: () => We.lcModal.isVisible },
    noFocusTrap: { type: Boolean, default: () => We.lcModal.noFocusTrap },
    spacing: { default: () => We.lcModal.spacing },
    to: { default: () => We.lcModal.to },
    transition: {},
    wrapAttrs: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = t, r = we(), s = co(() => document.documentElement), i = Z(() => h("close-button")), l = {
      allowOutsideClick: (f) => {
        const m = f.target;
        return m ? Ke(e.ignoreOutsideClickOn).some((u) => (typeof u == "string" ? document.querySelector(u) : uo(u))?.contains(m) ?? !1) : !1;
      },
      fallbackFocus: (() => {
        const f = document.createElement("button");
        return f.id = "lc-modal-fallback-focus", f.hidden = !0, f;
      })(),
      immediate: !0
    }, h = (f) => e.closeTriggers.includes(f), v = (f) => {
      h(f) && n("close");
    }, c = (f) => {
      r.value = f;
    };
    return Ga(r, () => v("click-outside"), {
      ignore: e.ignoreOutsideClickOn
    }), fo("Escape", () => v("escape")), Ve(
      () => e.isVisible,
      (f) => {
        s.value = f;
      },
      { immediate: !0 }
    ), (f, m) => e.isVisible ? ($(), ke(ba, {
      key: 0,
      class: "lc-modal",
      to: e.to
    }, [
      Fe(U(ua), { name: "fade" }, {
        default: Te(() => [
          ee("div", {
            class: xe([
              "lc-modal__bg",
              {
                "lc-modal__bg--full-screen": e.fullScreen,
                "lc-modal__bg--full-size": e.fullSize
              },
              e.backgroundClass
            ])
          }, [
            Fe(U(ua), Ae(e.wrapAttrs, {
              class: ["lc-modal__wrap", e.containerClass],
              name: e.transition
            }), {
              default: Te(() => [
                ($(), ke(Pt(e.noFocusTrap ? "div" : U(ko)), {
                  options: e.noFocusTrap ? null : l
                }, {
                  default: Te(() => [
                    me(f.$slots, "modal", _t(Dt({ setRef: c })), () => [
                      Fe(U(ya), {
                        ref_key: "modalRef",
                        ref: r,
                        "body-class": "lc-modal__body",
                        class: xe([
                          "lc-modal__card",
                          `lc-modal__card--${e.spacing}`,
                          {
                            "lc-modal__card--full-size": e.fullSize
                          }
                        ]),
                        role: "dialog"
                      }, {
                        default: Te(() => [
                          f.$slots.header || i.value ? ($(), q("header", {
                            key: 0,
                            class: xe(["lc-modal__card-header", {
                              "lc-modal__card-header--close-button": i.value || e.fullSize
                            }])
                          }, [
                            ee("div", Kc, [
                              me(f.$slots, "header")
                            ]),
                            ee("div", Jc, [
                              me(f.$slots, "actions"),
                              i.value ? ($(), ke(U(Et), {
                                key: 0,
                                class: "lc-modal__card-header-close",
                                icon: "close",
                                size: "small",
                                variant: "tertiary",
                                onClickPassive: m[0] || (m[0] = (u) => v("close-button"))
                              })) : de("", !0)
                            ])
                          ], 2)) : de("", !0),
                          me(f.$slots, "default")
                        ]),
                        _: 3
                      }, 8, ["class"])
                    ])
                  ]),
                  _: 3
                }, 8, ["options"]))
              ]),
              _: 3
            }, 16, ["class", "name"])
          ], 2)
        ]),
        _: 3
      })
    ], 8, ["to"])) : de("", !0);
  }
}), W1 = ["click-outside", "close-button", "escape"], Y1 = ["large", "medium", "small"], Qc = 30, ed = 0.3, al = (e) => {
  const t = e.match(/^([\d.]+)(px|dvh|vh|svh|lvh)$/);
  if (t) {
    const s = parseFloat(t[1]);
    return t[2] === "px" ? s : s / 100 * window.innerHeight;
  }
  const n = document.createElement("div");
  n.style.cssText = `height:${e};position:absolute;visibility:hidden`, document.body.appendChild(n);
  const r = n.getBoundingClientRect().height;
  return n.remove(), r;
}, td = ({
  dragAreaRef: e,
  snapHeights: t,
  onClose: n,
  canClose: r
}) => {
  const s = we(0), i = we(0), a = we(!1), o = we(0), l = we(0), h = we(0), v = we(0), c = Z(
    () => Ke(t)[o.value] ?? Ke(t)[0]
  ), f = Z(() => o.value < Ke(t).length - 1), m = () => {
    i.value = 0, s.value = 0, a.value = !1;
  }, u = () => {
    o.value = 0;
  }, p = (_, T) => (T > 0 ? _ / T : 0) > ed || _ > Qc, S = () => {
    if (!a.value) return;
    const _ = v.value - h.value, T = Date.now() - l.value, I = Math.abs(_), L = _ > 0 ? "down" : "up", C = Ke(t);
    if (L === "up" && f.value && p(I, T)) {
      const z = al(C[o.value]) + I;
      let X = o.value + 1, O = 1 / 0;
      for (let G = o.value + 1; G < C.length; G++) {
        const P = Math.abs(al(C[G]) - z);
        P < O && (O = P, X = G);
      }
      o.value = X, m();
      return;
    }
    if (L === "down" && p(I, T) && r()) {
      a.value = !1, n();
      return;
    }
    m();
  }, g = (_) => {
    if (_.target.closest('button, a, [role="button"]')) return;
    _.currentTarget.setPointerCapture(_.pointerId), h.value = _.clientY, v.value = _.clientY, l.value = Date.now(), a.value = !0;
  }, b = (_) => {
    if (!a.value) return;
    v.value = _.clientY;
    const T = v.value - h.value;
    T < 0 && f.value ? (i.value = -T, s.value = 0) : (i.value = 0, s.value = Math.max(0, T));
  };
  return Ut(e, "pointerdown", g), Ut(e, "pointermove", b), Ut(e, "pointerup", S), Ut(e, "pointercancel", S), Ut(e, "lostpointercapture", S), {
    currentSnapHeight: c,
    currentSnapIndex: o,
    dismissOffset: s,
    isDragging: a,
    resetDrag: m,
    resetSnapIndex: u,
    snapTransitionOffset: i
  };
}, nd = { class: "lc-bottom-sheet-modal__header" }, ad = { class: "lc-bottom-sheet-modal__header-actions" }, rd = { class: "lc-bottom-sheet" }, id = ["aria-labelledby"], ld = { class: "lc-bottom-sheet__header-actions" }, Aa = 300, rl = "lc-bottom-sheet__drag-area", od = "(width < 496px)", X1 = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcBottomSheet",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    closeTriggers: { default: () => ["swipe-down", "click-outside", "escape", "close-button"] },
    modalClass: {},
    modelValue: { type: Boolean, default: !1 },
    snapHeights: { default: () => ["50dvh"] },
    to: { default: () => We.lcModal.to }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const n = {
      allowOutsideClick: !0,
      fallbackFocus: () => document.querySelector(`.${rl}`) ?? document.body,
      immediate: !0
    }, r = ["click-outside", "escape", "close-button"], s = t;
    let i;
    const o = `${Tt()}-header`, l = it("dragArea"), h = we(!1), v = we(!1), c = we(!0), f = Ks(od), m = co(() => document.documentElement), {
      currentSnapHeight: u,
      dismissOffset: p,
      isDragging: S,
      resetDrag: g,
      resetSnapIndex: b,
      snapTransitionOffset: _
    } = td({
      dragAreaRef: l,
      snapHeights: Z(() => e.snapHeights),
      onClose: () => L(),
      canClose: () => F("swipe-down")
    }), T = Z(
      () => e.closeTriggers.filter(
        (X) => r.includes(X)
      )
    ), I = Z(() => {
      if (S.value) {
        const O = _.value !== 0;
        return {
          height: O ? `calc(${u.value} + ${_.value}px)` : u.value,
          transform: O ? "translateY(0)" : `translateY(${Math.max(0, p.value)}px)`,
          transition: "none"
        };
      }
      if (h.value)
        return {
          height: u.value,
          transform: "translateY(100%)",
          transition: `transform ${Aa}ms ease`
        };
      const X = c.value;
      return {
        height: u.value,
        transform: X ? "translateY(100%)" : "translateY(0)",
        transition: c.value ? "none" : `height ${Aa}ms ease, transform ${Aa}ms ease`
      };
    }), L = () => {
      h.value || (h.value = !0, i = setTimeout(() => {
        h.value = !1, g(), b(), s("update:modelValue", !1);
      }, Aa));
    }, C = () => {
      F("click-outside") && L();
    }, F = (X) => e.closeTriggers.includes(X), z = (X) => {
      const O = X.target;
      v.value = O.scrollTop > 0;
    };
    return Ve(
      () => e.modelValue,
      async (X) => {
        if (!X) return m.value = !1;
        clearTimeout(i), h.value = !1, g(), v.value = !1, c.value = !0, m.value = !0, await Ya(), requestAnimationFrame(() => {
          c.value = !1;
        });
      },
      { immediate: !0 }
    ), fo("Escape", () => {
      F("escape") && L();
    }), Ln(() => {
      clearTimeout(i), m.value = !1;
    }), (X, O) => U(f) ? e.modelValue ? ($(), ke(ba, {
      key: 1,
      to: e.to
    }, [
      ee("div", rd, [
        ee("div", {
          class: xe(["lc-bottom-sheet__overlay", { "lc-bottom-sheet__overlay--closing": h.value }]),
          role: "presentation",
          onClick: C
        }, null, 2),
        Fe(U(ko), { options: n }, {
          default: Te(() => [
            ee("div", {
              "aria-labelledby": X.$slots.title ? o : void 0,
              "aria-modal": "true",
              class: "lc-bottom-sheet__sheet",
              role: "dialog",
              style: Ct(I.value)
            }, [
              ee("div", {
                ref: "dragArea",
                class: xe([
                  rl,
                  { "lc-bottom-sheet__drag-area--scrolled": v.value }
                ])
              }, [
                O[1] || (O[1] = ee("div", { class: "lc-bottom-sheet__handle" }, [
                  ee("div", { class: "lc-bottom-sheet__handle-pill" })
                ], -1)),
                X.$slots.title || F("close-button") ? ($(), q("div", {
                  key: 0,
                  id: o,
                  class: "lc-bottom-sheet__header"
                }, [
                  me(X.$slots, "title"),
                  ee("div", ld, [
                    me(X.$slots, "actions"),
                    F("close-button") ? ($(), ke(U(Et), {
                      key: 0,
                      class: "lc-modal__card-header-close",
                      icon: "close",
                      size: "small",
                      variant: "tertiary",
                      onClick: L
                    })) : de("", !0)
                  ])
                ])) : de("", !0)
              ], 2),
              ee("div", {
                ref: "contentArea",
                class: "lc-bottom-sheet__content",
                onScroll: z
              }, [
                me(X.$slots, "default")
              ], 544)
            ], 12, id)
          ]),
          _: 3
        })
      ])
    ], 8, ["to"])) : de("", !0) : ($(), ke(U(Io), Ae({ key: 0 }, { to: e.to, ignoreOutsideClickOn: e.ignoreOutsideClickOn }, {
      "background-class": `lc-bottom-sheet-modal lc-bottom-sheet-modal--${v.value ? "scrolled" : "default"}`,
      "is-visible": e.modelValue,
      "container-class": e.modalClass,
      "close-triggers": T.value,
      spacing: "small",
      onClose: O[0] || (O[0] = (G) => s("update:modelValue", !1))
    }), Xa({
      default: Te(() => [
        ee("div", {
          class: xe(["lc-bottom-sheet-modal__content", { "lc-bottom-sheet-modal__content--scrolled": v.value }]),
          onScroll: z
        }, [
          me(X.$slots, "default")
        ], 34)
      ]),
      _: 2
    }, [
      X.$slots.title ? {
        name: "header",
        fn: Te(() => [
          ee("div", nd, [
            me(X.$slots, "title")
          ])
        ]),
        key: "0"
      } : void 0,
      X.$slots.actions ? {
        name: "actions",
        fn: Te(() => [
          ee("div", ad, [
            me(X.$slots, "actions")
          ])
        ]),
        key: "1"
      } : void 0
    ]), 1040, ["background-class", "is-visible", "container-class", "close-triggers"]));
  }
}), G1 = ["swipe-down", "click-outside", "escape"];
function Do(e = {}) {
  let t, n = [];
  const r = ["select", "slideFocus"];
  function s(h) {
    t = h;
    const {
      options: {
        axis: v
      },
      slideRects: c
    } = t.internalEngine();
    v !== "y" && (n = c.map((f) => f.height), r.forEach((f) => t.on(f, o)), o());
  }
  function i() {
    r.forEach((v) => t.off(v, o));
    const h = t.containerNode();
    h.style.height = "", h.getAttribute("style") || h.removeAttribute("style");
  }
  function a() {
    const {
      slideRegistry: h
    } = t.internalEngine(), v = h[t.selectedScrollSnap()];
    return v ? v.map((c) => n[c]).reduce((c, f) => Math.max(c, f), 0) : null;
  }
  function o() {
    a() !== null && (t.containerNode().style.height = `${a()}px`);
  }
  return {
    name: "autoHeight",
    options: e,
    init: s,
    destroy: i
  };
}
Do.globalOptions = void 0;
const sd = {
  active: !0,
  breakpoints: {},
  snapped: "is-snapped",
  inView: "is-in-view",
  draggable: "is-draggable",
  dragging: "is-dragging",
  loop: "is-loop"
};
function Jn(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Qn(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function La(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Ja(e = {}) {
  let t, n, r, s, i = [], a = [];
  const o = ["select"], l = ["pointerDown", "pointerUp"], h = ["slidesInView"], v = {
    snapped: [],
    inView: [],
    draggable: [],
    dragging: [],
    loop: []
  };
  function c(b, _) {
    n = b;
    const {
      mergeOptions: T,
      optionsAtMedia: I
    } = _, L = T(sd, Ja.globalOptions), C = T(L, e);
    t = I(C), r = n.rootNode(), s = n.slideNodes();
    const {
      watchDrag: F,
      loop: z
    } = n.internalEngine().options, X = !!F;
    t.loop && z && (v.loop = Jn(t.loop), La(r, v.loop)), t.draggable && X && (v.draggable = Jn(t.draggable), La(r, v.draggable)), t.dragging && (v.dragging = Jn(t.dragging), l.forEach((O) => n.on(O, m))), t.snapped && (v.snapped = Jn(t.snapped), o.forEach((O) => n.on(O, p)), p()), t.inView && (v.inView = Jn(t.inView), h.forEach((O) => n.on(O, S)), S());
  }
  function f() {
    l.forEach((b) => n.off(b, m)), o.forEach((b) => n.off(b, p)), h.forEach((b) => n.off(b, S)), Qn(r, v.loop), Qn(r, v.draggable), Qn(r, v.dragging), u([], i, v.snapped), u([], a, v.inView), Object.keys(v).forEach((b) => {
      const _ = b;
      v[_] = [];
    });
  }
  function m(b, _) {
    (_ === "pointerDown" ? La : Qn)(r, v.dragging);
  }
  function u(b = [], _ = [], T) {
    const I = _.map((C) => s[C]), L = b.map((C) => s[C]);
    return I.forEach((C) => Qn(C, T)), L.forEach((C) => La(C, T)), b;
  }
  function p() {
    const {
      slideRegistry: b
    } = n.internalEngine(), _ = b[n.selectedScrollSnap()];
    i = u(_, i, v.snapped);
  }
  function S() {
    const b = n.slidesInView();
    a = u(b, a, v.inView);
  }
  return {
    name: "classNames",
    options: e,
    init: c,
    destroy: f
  };
}
Ja.globalOptions = void 0;
function ud(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function il(e) {
  return ud(e) || Array.isArray(e);
}
function cd() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function di(e, t) {
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length) return !1;
  const s = JSON.stringify(Object.keys(e.breakpoints || {})), i = JSON.stringify(Object.keys(t.breakpoints || {}));
  return s !== i ? !1 : n.every((a) => {
    const o = e[a], l = t[a];
    return typeof o == "function" ? `${o}` == `${l}` : !il(o) || !il(l) ? o === l : di(o, l);
  });
}
function ll(e) {
  return e.concat().sort((t, n) => t.name > n.name ? 1 : -1).map((t) => t.options);
}
function dd(e, t) {
  if (e.length !== t.length) return !1;
  const n = ll(e), r = ll(t);
  return n.every((s, i) => {
    const a = r[i];
    return di(s, a);
  });
}
function fi(e) {
  return typeof e == "number";
}
function Zr(e) {
  return typeof e == "string";
}
function Qa(e) {
  return typeof e == "boolean";
}
function ol(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function at(e) {
  return Math.abs(e);
}
function hi(e) {
  return Math.sign(e);
}
function la(e, t) {
  return at(e - t);
}
function fd(e, t) {
  if (e === 0 || t === 0 || at(e) <= at(t)) return 0;
  const n = la(at(e), at(t));
  return at(n / e);
}
function hd(e) {
  return Math.round(e * 100) / 100;
}
function ca(e) {
  return da(e).map(Number);
}
function qt(e) {
  return e[wa(e)];
}
function wa(e) {
  return Math.max(0, e.length - 1);
}
function vi(e, t) {
  return t === wa(e);
}
function sl(e, t = 0) {
  return Array.from(Array(e), (n, r) => t + r);
}
function da(e) {
  return Object.keys(e);
}
function Mo(e, t) {
  return [e, t].reduce((n, r) => (da(r).forEach((s) => {
    const i = n[s], a = r[s], o = ol(i) && ol(a);
    n[s] = o ? Mo(i, a) : a;
  }), n), {});
}
function Wr(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function vd(e, t) {
  const n = {
    start: r,
    center: s,
    end: i
  };
  function r() {
    return 0;
  }
  function s(l) {
    return i(l) / 2;
  }
  function i(l) {
    return t - l;
  }
  function a(l, h) {
    return Zr(e) ? n[e](l) : e(t, l, h);
  }
  return {
    measure: a
  };
}
function fa() {
  let e = [];
  function t(s, i, a, o = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in s)
      s.addEventListener(i, a, o), l = () => s.removeEventListener(i, a, o);
    else {
      const h = s;
      h.addListener(a), l = () => h.removeListener(a);
    }
    return e.push(l), r;
  }
  function n() {
    e = e.filter((s) => s());
  }
  const r = {
    add: t,
    clear: n
  };
  return r;
}
function md(e, t, n, r) {
  const s = fa(), i = 1e3 / 60;
  let a = null, o = 0, l = 0;
  function h() {
    s.add(e, "visibilitychange", () => {
      e.hidden && u();
    });
  }
  function v() {
    m(), s.clear();
  }
  function c(S) {
    if (!l) return;
    a || (a = S, n(), n());
    const g = S - a;
    for (a = S, o += g; o >= i; )
      n(), o -= i;
    const b = o / i;
    r(b), l && (l = t.requestAnimationFrame(c));
  }
  function f() {
    l || (l = t.requestAnimationFrame(c));
  }
  function m() {
    t.cancelAnimationFrame(l), a = null, o = 0, l = 0;
  }
  function u() {
    a = null, o = 0;
  }
  return {
    init: h,
    destroy: v,
    start: f,
    stop: m,
    update: n,
    render: r
  };
}
function gd(e, t) {
  const n = t === "rtl", r = e === "y", s = r ? "y" : "x", i = r ? "x" : "y", a = !r && n ? -1 : 1, o = v(), l = c();
  function h(u) {
    const {
      height: p,
      width: S
    } = u;
    return r ? p : S;
  }
  function v() {
    return r ? "top" : n ? "right" : "left";
  }
  function c() {
    return r ? "bottom" : n ? "left" : "right";
  }
  function f(u) {
    return u * a;
  }
  return {
    scroll: s,
    cross: i,
    startEdge: o,
    endEdge: l,
    measureSize: h,
    direction: f
  };
}
function Cn(e = 0, t = 0) {
  const n = at(e - t);
  function r(h) {
    return h < e;
  }
  function s(h) {
    return h > t;
  }
  function i(h) {
    return r(h) || s(h);
  }
  function a(h) {
    return i(h) ? r(h) ? e : t : h;
  }
  function o(h) {
    return n ? h - n * Math.ceil((h - t) / n) : h;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: a,
    reachedAny: i,
    reachedMax: s,
    reachedMin: r,
    removeOffset: o
  };
}
function Ro(e, t, n) {
  const {
    constrain: r
  } = Cn(0, e), s = e + 1;
  let i = a(t);
  function a(f) {
    return n ? at((s + f) % s) : r(f);
  }
  function o() {
    return i;
  }
  function l(f) {
    return i = a(f), c;
  }
  function h(f) {
    return v().set(o() + f);
  }
  function v() {
    return Ro(e, o(), n);
  }
  const c = {
    get: o,
    set: l,
    add: h,
    clone: v
  };
  return c;
}
function bd(e, t, n, r, s, i, a, o, l, h, v, c, f, m, u, p, S, g, b) {
  const {
    cross: _,
    direction: T
  } = e, I = ["INPUT", "SELECT", "TEXTAREA"], L = {
    passive: !1
  }, C = fa(), F = fa(), z = Cn(50, 225).constrain(m.measure(20)), X = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, G = u ? 43 : 25;
  let P = !1, E = 0, A = 0, V = !1, H = !1, K = !1, B = !1;
  function ae(oe) {
    if (!b) return;
    function ye(Ue) {
      (Qa(b) || b(oe, Ue)) && te(Ue);
    }
    const Pe = t;
    C.add(Pe, "dragstart", (Ue) => Ue.preventDefault(), L).add(Pe, "touchmove", () => {
    }, L).add(Pe, "touchend", () => {
    }).add(Pe, "touchstart", ye).add(Pe, "mousedown", ye).add(Pe, "touchcancel", ge).add(Pe, "contextmenu", ge).add(Pe, "click", pe, !0);
  }
  function le() {
    C.clear(), F.clear();
  }
  function se() {
    const oe = B ? n : t;
    F.add(oe, "touchmove", he, L).add(oe, "touchend", ge).add(oe, "mousemove", he, L).add(oe, "mouseup", ge);
  }
  function be(oe) {
    const ye = oe.nodeName || "";
    return I.includes(ye);
  }
  function Me() {
    return (u ? O : X)[B ? "mouse" : "touch"];
  }
  function Se(oe, ye) {
    const Pe = c.add(hi(oe) * -1), Ue = v.byDistance(oe, !u).distance;
    return u || at(oe) < z ? Ue : S && ye ? Ue * 0.5 : v.byIndex(Pe.get(), 0).distance;
  }
  function te(oe) {
    const ye = Wr(oe, r);
    B = ye, K = u && ye && !oe.buttons && P, P = la(s.get(), a.get()) >= 2, !(ye && oe.button !== 0) && (be(oe.target) || (V = !0, i.pointerDown(oe), h.useFriction(0).useDuration(0), s.set(a), se(), E = i.readPoint(oe), A = i.readPoint(oe, _), f.emit("pointerDown")));
  }
  function he(oe) {
    if (!Wr(oe, r) && oe.touches.length >= 2) return ge(oe);
    const Pe = i.readPoint(oe), Ue = i.readPoint(oe, _), qe = la(Pe, E), Be = la(Ue, A);
    if (!H && !B && (!oe.cancelable || (H = qe > Be, !H)))
      return ge(oe);
    const Ne = i.pointerMove(oe);
    qe > p && (K = !0), h.useFriction(0.3).useDuration(0.75), o.start(), s.add(T(Ne)), oe.preventDefault();
  }
  function ge(oe) {
    const Pe = v.byDistance(0, !1).index !== c.get(), Ue = i.pointerUp(oe) * Me(), qe = Se(T(Ue), Pe), Be = fd(Ue, qe), Ne = G - 10 * Be, Xe = g + Be / 50;
    H = !1, V = !1, F.clear(), h.useDuration(Ne).useFriction(Xe), l.distance(qe, !u), B = !1, f.emit("pointerUp");
  }
  function pe(oe) {
    K && (oe.stopPropagation(), oe.preventDefault(), K = !1);
  }
  function ze() {
    return V;
  }
  return {
    init: ae,
    destroy: le,
    pointerDown: ze
  };
}
function pd(e, t) {
  let r, s;
  function i(c) {
    return c.timeStamp;
  }
  function a(c, f) {
    const u = `client${(f || e.scroll) === "x" ? "X" : "Y"}`;
    return (Wr(c, t) ? c : c.touches[0])[u];
  }
  function o(c) {
    return r = c, s = c, a(c);
  }
  function l(c) {
    const f = a(c) - a(s), m = i(c) - i(r) > 170;
    return s = c, m && (r = c), f;
  }
  function h(c) {
    if (!r || !s) return 0;
    const f = a(s) - a(r), m = i(c) - i(r), u = i(c) - i(s) > 170, p = f / m;
    return m && !u && at(p) > 0.1 ? p : 0;
  }
  return {
    pointerDown: o,
    pointerMove: l,
    pointerUp: h,
    readPoint: a
  };
}
function yd() {
  function e(n) {
    const {
      offsetTop: r,
      offsetLeft: s,
      offsetWidth: i,
      offsetHeight: a
    } = n;
    return {
      top: r,
      right: s + i,
      bottom: r + a,
      left: s,
      width: i,
      height: a
    };
  }
  return {
    measure: e
  };
}
function wd(e) {
  function t(r) {
    return e * (r / 100);
  }
  return {
    measure: t
  };
}
function xd(e, t, n, r, s, i, a) {
  const o = [e].concat(r);
  let l, h, v = [], c = !1;
  function f(S) {
    return s.measureSize(a.measure(S));
  }
  function m(S) {
    if (!i) return;
    h = f(e), v = r.map(f);
    function g(b) {
      for (const _ of b) {
        if (c) return;
        const T = _.target === e, I = r.indexOf(_.target), L = T ? h : v[I], C = f(T ? e : r[I]);
        if (at(C - L) >= 0.5) {
          S.reInit(), t.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (Qa(i) || i(S, b)) && g(b);
    }), n.requestAnimationFrame(() => {
      o.forEach((b) => l.observe(b));
    });
  }
  function u() {
    c = !0, l && l.disconnect();
  }
  return {
    init: m,
    destroy: u
  };
}
function kd(e, t, n, r, s, i) {
  let a = 0, o = 0, l = s, h = i, v = e.get(), c = 0;
  function f() {
    const L = r.get() - e.get(), C = !l;
    let F = 0;
    return C ? (a = 0, n.set(r), e.set(r), F = L) : (n.set(e), a += L / l, a *= h, v += a, e.add(a), F = v - c), o = hi(F), c = v, I;
  }
  function m() {
    const L = r.get() - t.get();
    return at(L) < 1e-3;
  }
  function u() {
    return l;
  }
  function p() {
    return o;
  }
  function S() {
    return a;
  }
  function g() {
    return _(s);
  }
  function b() {
    return T(i);
  }
  function _(L) {
    return l = L, I;
  }
  function T(L) {
    return h = L, I;
  }
  const I = {
    direction: p,
    duration: u,
    velocity: S,
    seek: f,
    settled: m,
    useBaseFriction: b,
    useBaseDuration: g,
    useFriction: T,
    useDuration: _
  };
  return I;
}
function Sd(e, t, n, r, s) {
  const i = s.measure(10), a = s.measure(50), o = Cn(0.1, 0.99);
  let l = !1;
  function h() {
    return !(l || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function v(m) {
    if (!h()) return;
    const u = e.reachedMin(t.get()) ? "min" : "max", p = at(e[u] - t.get()), S = n.get() - t.get(), g = o.constrain(p / a);
    n.subtract(S * g), !m && at(S) < i && (n.set(e.constrain(n.get())), r.useDuration(25).useBaseFriction());
  }
  function c(m) {
    l = !m;
  }
  return {
    shouldConstrain: h,
    constrain: v,
    toggleActive: c
  };
}
function _d(e, t, n, r, s) {
  const i = Cn(-t + e, 0), a = c(), o = v(), l = f();
  function h(u, p) {
    return la(u, p) <= 1;
  }
  function v() {
    const u = a[0], p = qt(a), S = a.lastIndexOf(u), g = a.indexOf(p) + 1;
    return Cn(S, g);
  }
  function c() {
    return n.map((u, p) => {
      const {
        min: S,
        max: g
      } = i, b = i.constrain(u), _ = !p, T = vi(n, p);
      return _ ? g : T || h(S, b) ? S : h(g, b) ? g : b;
    }).map((u) => parseFloat(u.toFixed(3)));
  }
  function f() {
    if (t <= e + s) return [i.max];
    if (r === "keepSnaps") return a;
    const {
      min: u,
      max: p
    } = o;
    return a.slice(u, p);
  }
  return {
    snapsContained: l,
    scrollContainLimit: o
  };
}
function Cd(e, t, n) {
  const r = t[0], s = n ? r - e : qt(t);
  return {
    limit: Cn(s, r)
  };
}
function Ed(e, t, n, r) {
  const i = t.min + 0.1, a = t.max + 0.1, {
    reachedMin: o,
    reachedMax: l
  } = Cn(i, a);
  function h(f) {
    return f === 1 ? l(n.get()) : f === -1 ? o(n.get()) : !1;
  }
  function v(f) {
    if (!h(f)) return;
    const m = e * (f * -1);
    r.forEach((u) => u.add(m));
  }
  return {
    loop: v
  };
}
function Td(e) {
  const {
    max: t,
    length: n
  } = e;
  function r(i) {
    const a = i - t;
    return n ? a / -n : 0;
  }
  return {
    get: r
  };
}
function Ad(e, t, n, r, s) {
  const {
    startEdge: i,
    endEdge: a
  } = e, {
    groupSlides: o
  } = s, l = c().map(t.measure), h = f(), v = m();
  function c() {
    return o(r).map((p) => qt(p)[a] - p[0][i]).map(at);
  }
  function f() {
    return r.map((p) => n[i] - p[i]).map((p) => -at(p));
  }
  function m() {
    return o(h).map((p) => p[0]).map((p, S) => p + l[S]);
  }
  return {
    snaps: h,
    snapsAligned: v
  };
}
function Ld(e, t, n, r, s, i) {
  const {
    groupSlides: a
  } = s, {
    min: o,
    max: l
  } = r, h = v();
  function v() {
    const f = a(i), m = !e || t === "keepSnaps";
    return n.length === 1 ? [i] : m ? f : f.slice(o, l).map((u, p, S) => {
      const g = !p, b = vi(S, p);
      if (g) {
        const _ = qt(S[0]) + 1;
        return sl(_);
      }
      if (b) {
        const _ = wa(i) - qt(S)[0] + 1;
        return sl(_, qt(S)[0]);
      }
      return u;
    });
  }
  return {
    slideRegistry: h
  };
}
function $d(e, t, n, r, s) {
  const {
    reachedAny: i,
    removeOffset: a,
    constrain: o
  } = r;
  function l(u) {
    return u.concat().sort((p, S) => at(p) - at(S))[0];
  }
  function h(u) {
    const p = e ? a(u) : o(u), S = t.map((b, _) => ({
      diff: v(b - p, 0),
      index: _
    })).sort((b, _) => at(b.diff) - at(_.diff)), {
      index: g
    } = S[0];
    return {
      index: g,
      distance: p
    };
  }
  function v(u, p) {
    const S = [u, u + n, u - n];
    if (!e) return u;
    if (!p) return l(S);
    const g = S.filter((b) => hi(b) === p);
    return g.length ? l(g) : qt(S) - n;
  }
  function c(u, p) {
    const S = t[u] - s.get(), g = v(S, p);
    return {
      index: u,
      distance: g
    };
  }
  function f(u, p) {
    const S = s.get() + u, {
      index: g,
      distance: b
    } = h(S), _ = !e && i(S);
    if (!p || _) return {
      index: g,
      distance: u
    };
    const T = t[g] - b, I = u + v(T, 0);
    return {
      index: g,
      distance: I
    };
  }
  return {
    byDistance: f,
    byIndex: c,
    shortcut: v
  };
}
function Id(e, t, n, r, s, i, a) {
  function o(c) {
    const f = c.distance, m = c.index !== t.get();
    i.add(f), f && (r.duration() ? e.start() : (e.update(), e.render(1), e.update())), m && (n.set(t.get()), t.set(c.index), a.emit("select"));
  }
  function l(c, f) {
    const m = s.byDistance(c, f);
    o(m);
  }
  function h(c, f) {
    const m = t.clone().set(c), u = s.byIndex(m.get(), f);
    o(u);
  }
  return {
    distance: l,
    index: h
  };
}
function Dd(e, t, n, r, s, i, a, o) {
  const l = {
    passive: !0,
    capture: !0
  };
  let h = 0;
  function v(m) {
    if (!o) return;
    function u(p) {
      if ((/* @__PURE__ */ new Date()).getTime() - h > 10) return;
      a.emit("slideFocusStart"), e.scrollLeft = 0;
      const b = n.findIndex((_) => _.includes(p));
      fi(b) && (s.useDuration(0), r.index(b, 0), a.emit("slideFocus"));
    }
    i.add(document, "keydown", c, !1), t.forEach((p, S) => {
      i.add(p, "focus", (g) => {
        (Qa(o) || o(m, g)) && u(S);
      }, l);
    });
  }
  function c(m) {
    m.code === "Tab" && (h = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: v
  };
}
function na(e) {
  let t = e;
  function n() {
    return t;
  }
  function r(l) {
    t = a(l);
  }
  function s(l) {
    t += a(l);
  }
  function i(l) {
    t -= a(l);
  }
  function a(l) {
    return fi(l) ? l : l.get();
  }
  return {
    get: n,
    set: r,
    add: s,
    subtract: i
  };
}
function Oo(e, t) {
  const n = e.scroll === "x" ? a : o, r = t.style;
  let s = null, i = !1;
  function a(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function o(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (i) return;
    const m = hd(e.direction(f));
    m !== s && (r.transform = n(m), s = m);
  }
  function h(f) {
    i = !f;
  }
  function v() {
    i || (r.transform = "", t.getAttribute("style") || t.removeAttribute("style"));
  }
  return {
    clear: v,
    to: l,
    toggleActive: h
  };
}
function Md(e, t, n, r, s, i, a, o, l) {
  const v = ca(s), c = ca(s).reverse(), f = g().concat(b());
  function m(C, F) {
    return C.reduce((z, X) => z - s[X], F);
  }
  function u(C, F) {
    return C.reduce((z, X) => m(z, F) > 0 ? z.concat([X]) : z, []);
  }
  function p(C) {
    return i.map((F, z) => ({
      start: F - r[z] + 0.5 + C,
      end: F + t - 0.5 + C
    }));
  }
  function S(C, F, z) {
    const X = p(F);
    return C.map((O) => {
      const G = z ? 0 : -n, P = z ? n : 0, E = z ? "end" : "start", A = X[O][E];
      return {
        index: O,
        loopPoint: A,
        slideLocation: na(-1),
        translate: Oo(e, l[O]),
        target: () => o.get() > A ? G : P
      };
    });
  }
  function g() {
    const C = a[0], F = u(c, C);
    return S(F, n, !1);
  }
  function b() {
    const C = t - a[0] - 1, F = u(v, C);
    return S(F, -n, !0);
  }
  function _() {
    return f.every(({
      index: C
    }) => {
      const F = v.filter((z) => z !== C);
      return m(F, t) <= 0.1;
    });
  }
  function T() {
    f.forEach((C) => {
      const {
        target: F,
        translate: z,
        slideLocation: X
      } = C, O = F();
      O !== X.get() && (z.to(O), X.set(O));
    });
  }
  function I() {
    f.forEach((C) => C.translate.clear());
  }
  return {
    canLoop: _,
    clear: I,
    loop: T,
    loopPoints: f
  };
}
function Rd(e, t, n) {
  let r, s = !1;
  function i(l) {
    if (!n) return;
    function h(v) {
      for (const c of v)
        if (c.type === "childList") {
          l.reInit(), t.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((v) => {
      s || (Qa(n) || n(l, v)) && h(v);
    }), r.observe(e, {
      childList: !0
    });
  }
  function a() {
    r && r.disconnect(), s = !0;
  }
  return {
    init: i,
    destroy: a
  };
}
function Od(e, t, n, r) {
  const s = {};
  let i = null, a = null, o, l = !1;
  function h() {
    o = new IntersectionObserver((u) => {
      l || (u.forEach((p) => {
        const S = t.indexOf(p.target);
        s[S] = p;
      }), i = null, a = null, n.emit("slidesInView"));
    }, {
      root: e.parentElement,
      threshold: r
    }), t.forEach((u) => o.observe(u));
  }
  function v() {
    o && o.disconnect(), l = !0;
  }
  function c(u) {
    return da(s).reduce((p, S) => {
      const g = parseInt(S), {
        isIntersecting: b
      } = s[g];
      return (u && b || !u && !b) && p.push(g), p;
    }, []);
  }
  function f(u = !0) {
    if (u && i) return i;
    if (!u && a) return a;
    const p = c(u);
    return u && (i = p), u || (a = p), p;
  }
  return {
    init: h,
    destroy: v,
    get: f
  };
}
function Fd(e, t, n, r, s, i) {
  const {
    measureSize: a,
    startEdge: o,
    endEdge: l
  } = e, h = n[0] && s, v = u(), c = p(), f = n.map(a), m = S();
  function u() {
    if (!h) return 0;
    const b = n[0];
    return at(t[o] - b[o]);
  }
  function p() {
    if (!h) return 0;
    const b = i.getComputedStyle(qt(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function S() {
    return n.map((b, _, T) => {
      const I = !_, L = vi(T, _);
      return I ? f[_] + v : L ? f[_] + c : T[_ + 1][o] - b[o];
    }).map(at);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: m,
    startGap: v,
    endGap: c
  };
}
function Nd(e, t, n, r, s, i, a, o, l) {
  const {
    startEdge: h,
    endEdge: v,
    direction: c
  } = e, f = fi(n);
  function m(g, b) {
    return ca(g).filter((_) => _ % b === 0).map((_) => g.slice(_, _ + b));
  }
  function u(g) {
    return g.length ? ca(g).reduce((b, _, T) => {
      const I = qt(b) || 0, L = I === 0, C = _ === wa(g), F = s[h] - i[I][h], z = s[h] - i[_][v], X = !r && L ? c(a) : 0, O = !r && C ? c(o) : 0, G = at(z - O - (F + X));
      return T && G > t + l && b.push(_), C && b.push(g.length), b;
    }, []).map((b, _, T) => {
      const I = Math.max(T[_ - 1] || 0);
      return g.slice(I, b);
    }) : [];
  }
  function p(g) {
    return f ? m(g, n) : u(g);
  }
  return {
    groupSlides: p
  };
}
function Bd(e, t, n, r, s, i, a) {
  const {
    align: o,
    axis: l,
    direction: h,
    startIndex: v,
    loop: c,
    duration: f,
    dragFree: m,
    dragThreshold: u,
    inViewThreshold: p,
    slidesToScroll: S,
    skipSnaps: g,
    containScroll: b,
    watchResize: _,
    watchSlides: T,
    watchDrag: I,
    watchFocus: L
  } = i, C = 2, F = yd(), z = F.measure(t), X = n.map(F.measure), O = gd(l, h), G = O.measureSize(z), P = wd(G), E = vd(o, G), A = !c && !!b, V = c || !!b, {
    slideSizes: H,
    slideSizesWithGaps: K,
    startGap: B,
    endGap: ae
  } = Fd(O, z, X, n, V, s), le = Nd(O, G, S, c, z, X, B, ae, C), {
    snaps: se,
    snapsAligned: be
  } = Ad(O, E, z, X, le), Me = -qt(se) + qt(K), {
    snapsContained: Se,
    scrollContainLimit: te
  } = _d(G, Me, be, b, C), he = A ? Se : be, {
    limit: ge
  } = Cd(Me, he, c), pe = Ro(wa(he), v, c), ze = pe.clone(), ue = ca(n), oe = ({
    dragHandler: k,
    scrollBody: w,
    scrollBounds: Y,
    options: {
      loop: W
    }
  }) => {
    W || Y.constrain(k.pointerDown()), w.seek();
  }, ye = ({
    scrollBody: k,
    translate: w,
    location: Y,
    offsetLocation: W,
    previousLocation: ce,
    scrollLooper: R,
    slideLooper: re,
    dragHandler: y,
    animation: fe,
    eventHandler: Ie,
    scrollBounds: d,
    options: {
      loop: ne
    }
  }, Q) => {
    const x = k.settled(), N = !d.shouldConstrain(), J = ne ? x : x && N, Re = J && !y.pointerDown();
    Re && fe.stop();
    const _e = Y.get() * Q + ce.get() * (1 - Q);
    W.set(_e), ne && (R.loop(k.direction()), re.loop()), w.to(W.get()), Re && Ie.emit("settle"), J || Ie.emit("scroll");
  }, Pe = md(r, s, () => oe(D), (k) => ye(D, k)), Ue = 0.68, qe = he[pe.get()], Be = na(qe), Ne = na(qe), Xe = na(qe), ut = na(qe), gt = kd(Be, Xe, Ne, ut, f, Ue), bt = $d(c, he, Me, ge, ut), Ft = Id(Pe, pe, ze, gt, bt, ut, a), Rt = Td(ge), xt = fa(), jt = Od(t, n, a, p), {
    slideRegistry: $t
  } = Ld(A, b, he, te, le, ue), ct = Dd(e, n, $t, Ft, gt, xt, a, L), D = {
    ownerDocument: r,
    ownerWindow: s,
    eventHandler: a,
    containerRect: z,
    slideRects: X,
    animation: Pe,
    axis: O,
    dragHandler: bd(O, e, r, s, ut, pd(O, s), Be, Pe, Ft, gt, bt, pe, a, P, m, u, g, Ue, I),
    eventStore: xt,
    percentOfView: P,
    index: pe,
    indexPrevious: ze,
    limit: ge,
    location: Be,
    offsetLocation: Xe,
    previousLocation: Ne,
    options: i,
    resizeHandler: xd(t, a, s, n, O, _, F),
    scrollBody: gt,
    scrollBounds: Sd(ge, Xe, ut, gt, P),
    scrollLooper: Ed(Me, ge, Xe, [Be, Xe, Ne, ut]),
    scrollProgress: Rt,
    scrollSnapList: he.map(Rt.get),
    scrollSnaps: he,
    scrollTarget: bt,
    scrollTo: Ft,
    slideLooper: Md(O, G, Me, H, K, se, he, Xe, n),
    slideFocus: ct,
    slidesHandler: Rd(t, a, T),
    slidesInView: jt,
    slideIndexes: ue,
    slideRegistry: $t,
    slidesToScroll: le,
    target: ut,
    translate: Oo(O, t)
  };
  return D;
}
function Pd() {
  let e = {}, t;
  function n(h) {
    t = h;
  }
  function r(h) {
    return e[h] || [];
  }
  function s(h) {
    return r(h).forEach((v) => v(t, h)), l;
  }
  function i(h, v) {
    return e[h] = r(h).concat([v]), l;
  }
  function a(h, v) {
    return e[h] = r(h).filter((c) => c !== v), l;
  }
  function o() {
    e = {};
  }
  const l = {
    init: n,
    emit: s,
    off: a,
    on: i,
    clear: o
  };
  return l;
}
const zd = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function Vd(e) {
  function t(i, a) {
    return Mo(i, a || {});
  }
  function n(i) {
    const a = i.breakpoints || {}, o = da(a).filter((l) => e.matchMedia(l).matches).map((l) => a[l]).reduce((l, h) => t(l, h), {});
    return t(i, o);
  }
  function r(i) {
    return i.map((a) => da(a.breakpoints || {})).reduce((a, o) => a.concat(o), []).map(e.matchMedia);
  }
  return {
    mergeOptions: t,
    optionsAtMedia: n,
    optionsMediaQueries: r
  };
}
function Hd(e) {
  let t = [];
  function n(i, a) {
    return t = a.filter(({
      options: o
    }) => e.optionsAtMedia(o).active !== !1), t.forEach((o) => o.init(i, e)), a.reduce((o, l) => Object.assign(o, {
      [l.name]: l
    }), {});
  }
  function r() {
    t = t.filter((i) => i.destroy());
  }
  return {
    init: n,
    destroy: r
  };
}
function Ua(e, t, n) {
  const r = e.ownerDocument, s = r.defaultView, i = Vd(s), a = Hd(i), o = fa(), l = Pd(), {
    mergeOptions: h,
    optionsAtMedia: v,
    optionsMediaQueries: c
  } = i, {
    on: f,
    off: m,
    emit: u
  } = l, p = O;
  let S = !1, g, b = h(zd, Ua.globalOptions), _ = h(b), T = [], I, L, C;
  function F() {
    const {
      container: ue,
      slides: oe
    } = _;
    L = (Zr(ue) ? e.querySelector(ue) : ue) || e.children[0];
    const Pe = Zr(oe) ? L.querySelectorAll(oe) : oe;
    C = [].slice.call(Pe || L.children);
  }
  function z(ue) {
    const oe = Bd(e, L, C, r, s, ue, l);
    if (ue.loop && !oe.slideLooper.canLoop()) {
      const ye = Object.assign({}, ue, {
        loop: !1
      });
      return z(ye);
    }
    return oe;
  }
  function X(ue, oe) {
    S || (b = h(b, ue), _ = v(b), T = oe || T, F(), g = z(_), c([b, ...T.map(({
      options: ye
    }) => ye)]).forEach((ye) => o.add(ye, "change", O)), _.active && (g.translate.to(g.location.get()), g.animation.init(), g.slidesInView.init(), g.slideFocus.init(ze), g.eventHandler.init(ze), g.resizeHandler.init(ze), g.slidesHandler.init(ze), g.options.loop && g.slideLooper.loop(), L.offsetParent && C.length && g.dragHandler.init(ze), I = a.init(ze, T)));
  }
  function O(ue, oe) {
    const ye = le();
    G(), X(h({
      startIndex: ye
    }, ue), oe), l.emit("reInit");
  }
  function G() {
    g.dragHandler.destroy(), g.eventStore.clear(), g.translate.clear(), g.slideLooper.clear(), g.resizeHandler.destroy(), g.slidesHandler.destroy(), g.slidesInView.destroy(), g.animation.destroy(), a.destroy(), o.clear();
  }
  function P() {
    S || (S = !0, o.clear(), G(), l.emit("destroy"), l.clear());
  }
  function E(ue, oe, ye) {
    !_.active || S || (g.scrollBody.useBaseFriction().useDuration(oe === !0 ? 0 : _.duration), g.scrollTo.index(ue, ye || 0));
  }
  function A(ue) {
    const oe = g.index.add(1).get();
    E(oe, ue, -1);
  }
  function V(ue) {
    const oe = g.index.add(-1).get();
    E(oe, ue, 1);
  }
  function H() {
    return g.index.add(1).get() !== le();
  }
  function K() {
    return g.index.add(-1).get() !== le();
  }
  function B() {
    return g.scrollSnapList;
  }
  function ae() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function le() {
    return g.index.get();
  }
  function se() {
    return g.indexPrevious.get();
  }
  function be() {
    return g.slidesInView.get();
  }
  function Me() {
    return g.slidesInView.get(!1);
  }
  function Se() {
    return I;
  }
  function te() {
    return g;
  }
  function he() {
    return e;
  }
  function ge() {
    return L;
  }
  function pe() {
    return C;
  }
  const ze = {
    canScrollNext: H,
    canScrollPrev: K,
    containerNode: ge,
    internalEngine: te,
    destroy: P,
    off: m,
    on: f,
    emit: u,
    plugins: Se,
    previousScrollSnap: se,
    reInit: p,
    rootNode: he,
    scrollNext: A,
    scrollPrev: V,
    scrollProgress: ae,
    scrollSnapList: B,
    scrollTo: E,
    selectedScrollSnap: le,
    slideNodes: pe,
    slidesInView: be,
    slidesNotInView: Me
  };
  return X(t, n), setTimeout(() => l.emit("init"), 0), ze;
}
Ua.globalOptions = void 0;
function er(e = {}, t = []) {
  const n = Pi(e), r = Pi(t);
  let s = n ? e.value : e, i = r ? t.value : t;
  const a = kn(), o = kn();
  function l() {
    o.value && o.value.reInit(s, i);
  }
  return mt(() => {
    !cd() || !a.value || (Ua.globalOptions = er.globalOptions, o.value = Ua(a.value, s, i));
  }), ni(() => {
    o.value && o.value.destroy();
  }), n && Ve(e, (h) => {
    di(s, h) || (s = h, l());
  }), r && Ve(t, (h) => {
    dd(i, h) || (i = h, l());
  }), [a, o];
}
er.globalOptions = void 0;
const K1 = ["default", "highlight"], J1 = ["click", "keyboard"], Yr = /* @__PURE__ */ Symbol();
var Ra = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e))(Ra || {});
const Ud = ["tabindex"], ul = 1.08, qd = /* @__PURE__ */ Ce({
  __name: "LcCarousel",
  props: {
    duration: { default: 25 },
    loop: { type: Boolean },
    skipSnaps: { type: Boolean },
    adaptiveHeight: { type: Boolean },
    defaultIndex: { default: 0 },
    disableSwipe: { type: Boolean },
    id: {},
    keyExtractor: { type: Function },
    keyProp: {},
    moveTriggers: { default: () => [] },
    renderOnlyVisible: { type: Boolean },
    slides: {},
    variant: { default: "default" },
    visibleSlideBuffer: { default: 0 }
  },
  emits: ["ready", "changed"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      align: "start",
      containScroll: "trimSnaps"
    }, i = {
      align: "center",
      containScroll: !1,
      loop: !1,
      skipSnaps: !0
    }, a = {
      duration: e.duration,
      inViewThreshold: 2 / 100,
      loop: e.loop,
      skipSnaps: e.skipSnaps,
      watchDrag: !e.disableSwipe,
      watchResize: ({ containerNode: te, emit: he, reInit: ge }, pe) => {
        if (!e.adaptiveHeight) return !0;
        for (const ze of pe) {
          if (te() === ze.target) return !0;
          requestAnimationFrame(() => {
            ge(), he("resize");
          });
          break;
        }
        return !1;
      },
      ...e.variant === "highlight" ? i : s
    }, o = [
      ...e.adaptiveHeight ? [Do()] : [],
      Ja({
        draggable: "",
        dragging: "lc-carousel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-carousel__slide--snapped"
      })
    ], [l, h] = er(
      {
        ...a,
        startIndex: e.defaultIndex
      },
      o
    ), v = Wn(Yr, () => null, !0), c = ho(), f = we(0), m = we(e.disableSwipe), u = we(!1), p = we(!1), S = we(
      new Set(
        e.slides.slice(e.defaultIndex - e.visibleSlideBuffer, e.defaultIndex + e.visibleSlideBuffer).map((te, he) => he)
      )
    );
    let g, b, _;
    const T = Z(() => [
      "lc-carousel",
      `lc-carousel--variant-${e.variant}`,
      {
        "lc-carousel--adaptive-height": e.adaptiveHeight,
        "lc-carousel--draggable": !m.value,
        "lc-carousel--keyboard-enabled": H("keyboard"),
        "lc-carousel--swipe-hint": p.value
      }
    ]), I = () => {
      e.disableSwipe || (h.value?.reInit({
        ...a,
        watchDrag: !1
      }), m.value = !0);
    }, L = () => {
      e.disableSwipe || (h.value?.reInit({
        ...a,
        watchDrag: !0
      }), m.value = !1);
    }, C = (te, he) => e.keyExtractor ? e.keyExtractor(te, he) : e.keyProp && Tc(e.keyProp, te) ? String(te[e.keyProp]) : String(he), F = (te) => {
      const he = {
        "aria-roledescription": "slide",
        role: "group"
      };
      return K(te) ? he : {
        ...he,
        "aria-hidden": "true",
        inert: "true"
      };
    }, z = ({ clientX: te }) => {
      if (!h.value || !H("click") || m.value) return;
      const ge = h.value.slideNodes().map((pe) => pe.getBoundingClientRect());
      for (const [pe, { left: ze, right: ue }] of ge.entries())
        if (!(te < ze || te > ue)) {
          ae(pe);
          break;
        }
    }, X = () => {
      u.value = !0, Me(), Se(), r("ready");
    }, O = (te) => {
      if (!(!tn(te.key, Ra) || !H("keyboard") || m.value))
        switch (te.preventDefault(), te.stopPropagation(), te.key) {
          case Ra.ArrowLeft:
            se();
            break;
          case Ra.ArrowRight:
            le();
            break;
        }
    }, G = () => {
      v?.disable();
    }, P = () => {
      v?.enable();
    }, E = () => {
      Me(), Se();
    }, A = () => {
      const te = h.value?.selectedScrollSnap() ?? 0;
      r("changed", te);
    }, V = () => {
      clearTimeout(b), b = setTimeout(() => h.value?.reInit(), 50);
    }, H = (te) => e.moveTriggers.includes(te), K = (te) => S.value.has(te), B = (te) => !te || c.value === "reduce", ae = (te, he = !0) => {
      h.value?.scrollTo(te, B(he));
    }, le = (te = !0) => {
      h.value?.scrollNext(B(te));
    }, se = (te = !0) => {
      h.value?.scrollPrev(B(te));
    }, be = async () => {
      p.value || (p.value = !0, await new Promise((te) => {
        _ = setTimeout(() => {
          p.value = !1, te();
        }, 1800);
      }));
    }, Me = () => {
      if (!h.value || e.variant !== "highlight") return;
      const { rootNode: te, slideNodes: he } = h.value, ge = he(), ze = te().getBoundingClientRect(), ue = ze.left + ze.width / 2;
      let oe = ge[0], ye = 1 / 0;
      ge.forEach((Be) => {
        const Ne = Be.getBoundingClientRect(), Xe = Ne.left + Ne.width / 2, ut = Math.abs(Xe - ue);
        ut < ye && (oe = Be, ye = ut);
      });
      const qe = oe.offsetWidth * (ul - 1) / 2;
      ge.forEach((Be, Ne) => {
        if (Be === oe) {
          f.value = Ne, Be.style.transform = `scale(${ul.toString()}) translateX(0px)`, Be.style.zIndex = "1";
          return;
        }
        const Xe = Be.getBoundingClientRect(), gt = Xe.left + Xe.width / 2 < ue ? -1 : 1;
        Be.style.transform = `scale(1) translateX(${(gt * qe).toString()}px)`, Be.style.zIndex = "0";
      });
    }, Se = () => {
      if (!h.value) return;
      const te = h.value.slidesInView();
      if (!te.length) return;
      const he = e.slides.length, ge = /* @__PURE__ */ new Set();
      te.forEach((pe) => {
        for (let ze = -e.visibleSlideBuffer; ze <= e.visibleSlideBuffer; ze++) {
          const ue = (pe + ze + he) % he;
          ge.add(ue);
        }
      }), S.value = ge;
    };
    return mt(() => {
      h.value && (h.value.on("init", X).on("pointerDown", G).on("pointerUp", P).on("reInit", E).on("resize", Se).on("scroll", Me).on("select", A).on("slidesChanged", Me).on("slidesInView", Se), e.adaptiveHeight && (g = new ResizeObserver(V), h.value.slideNodes().forEach((te) => g?.observe(te))));
    }), Ln(() => {
      clearTimeout(_), clearTimeout(b), g?.disconnect();
    }), Ve(
      [() => e.disableSwipe, () => e.loop, () => e.skipSnaps, () => e.variant],
      ([te, he, ge, pe]) => {
        m.value = te, h.value?.reInit({
          ...a,
          loop: he,
          skipSnaps: ge,
          watchDrag: !te,
          ...pe === "highlight" ? i : s
        });
      }
    ), t({
      disable: I,
      enable: L,
      moveToIndex: ae,
      next: le,
      prev: se,
      showSwipeHint: be
    }), ai(Yr, {
      disable: I,
      enable: L
    }), (te, he) => ($(), q("div", {
      class: xe(T.value),
      tabindex: H("keyboard") ? 0 : void 0,
      onClickPassive: z,
      onKeydown: O
    }, [
      ee("div", {
        ref_key: "emblaRef",
        ref: l,
        class: "lc-carousel__container"
      }, [
        ee("div", Ae({ id: e.id }, { class: "lc-carousel__wrap" }), [
          ($(!0), q(Ge, null, vt(e.slides, (ge, pe) => me(te.$slots, "slide", Ae({ ref_for: !0 }, { slide: ge, index: pe }, {
            key: C(ge, pe),
            attributes: F(pe),
            isHighlighted: f.value === pe,
            isVisible: K(pe)
          }))), 128))
        ], 16)
      ], 512)
    ], 42, Ud));
  }
}), jd = ["for"], Zd = { class: "lc-checkbox__control" }, Wd = ["id", "data-click-name"], Yd = ["id"], Q1 = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcCheckbox",
  props: {
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "checkbox" },
    noFeedback: { type: Boolean },
    value: { type: Boolean }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Tt(e.id), { vibrate: s } = vo(), i = Z(() => [
      "lc-checkbox",
      {
        "lc-checkbox--checked": e.value,
        "lc-checkbox--disabled": e.disabled,
        "lc-checkbox--error": !!e.errorMessage
      }
    ]), a = Z({
      get: () => e.value,
      set: (o) => {
        n("update:value", o), s();
      }
    });
    return (o, l) => ($(), q("div", {
      class: xe([i.value, o.$attrs.class])
    }, [
      ee("label", {
        class: "lc-checkbox__wrap",
        for: U(r)
      }, [
        ee("div", Zd, [
          Qt(ee("input", Ae({ id: U(r) }, {
            ...en(o.$attrs, ["class"]),
            disabled: e.disabled,
            name: e.name
          }, {
            "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
            class: "lc-checkbox__input",
            "data-click-listener": "blur,focus",
            "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_checkbox`,
            type: "checkbox",
            onKeydown: l[1] || (l[1] = ri((h) => a.value = !a.value, ["enter"]))
          }), null, 16, Wd), [
            [oo, a.value]
          ]),
          Fe(U(Qe), {
            class: "lc-checkbox__icon",
            name: "checkmark"
          })
        ]),
        e.label ? ($(), q("span", {
          key: 0,
          id: `${U(r)}-label`,
          class: "lc-checkbox__label"
        }, De(e.label), 9, Yd)) : de("", !0)
      ], 8, jd),
      e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), Xd = () => typeof window > "u";
function Fo(e, t) {
  const n = pa(), r = typeof e == "string" ? e : void 0, s = typeof e == "function" ? e : t;
  if (n)
    return r ? n.useState(r, s) : n.useState(s);
  const i = s ? Ke(s()) : void 0;
  return we(i);
}
const mi = {
  drawingShort: {
    hour: "numeric",
    minute: "numeric",
    weekday: "short"
  }
}, No = (e, t) => rc({
  end: new Date(t),
  start: new Date(e)
}), Bo = ({ date: e, format: t, locale: n, timeZone: r }) => new Intl.DateTimeFormat(n ?? "en-US", {
  ...mi[t],
  timeZone: r
}).format(new Date(e)), yr = (e) => typeof e != "number" ? "" : e <= 0 ? "00" : e < 10 ? `0${e}` : String(e), Gd = /* @__PURE__ */ Ce({
  __name: "LcCountdown",
  props: {
    expiresAt: {},
    variant: { default: "default" }
  },
  emits: ["expired", "update"],
  setup(e, { emit: t }) {
    const n = {
      hours: 0,
      minutes: 0,
      seconds: 0
    }, r = t, s = Xd(), i = Fo(() => /* @__PURE__ */ new Date()), a = we(!1);
    let o;
    const l = Z(() => {
      if (a.value) return n;
      const { hours: g, minutes: b, seconds: _ } = No(i.value, f.value);
      return {
        ...n,
        hours: g || 0,
        minutes: b || 0,
        seconds: _ || 0
      };
    }), h = Z(() => v.value ? f.value.toISOString() : void 0), v = Z(() => li(f.value)), c = Z(() => {
      const { hours: g, minutes: b, seconds: _ } = l.value, T = `${yr(b)}:${yr(_)}`;
      return e.variant === "without-hours" ? T : `${yr(g)}:${T}`;
    }), f = Z(() => new Date(e.expiresAt)), m = () => {
      a.value = !0, r("expired"), clearInterval(o);
    }, u = () => {
      i.value = /* @__PURE__ */ new Date(), r("update");
    }, p = () => _o(f.value), S = () => {
      o && clearInterval(o), o = setInterval(() => {
        p() ? m() : u();
      }, 1e3);
    };
    return ni(() => {
      clearInterval(o);
    }), Ve(
      h,
      () => {
        s || (a.value = !1, S());
      },
      {
        immediate: !0
      }
    ), (g, b) => v.value ? ($(), q("time", Ae({ key: 0 }, { datetime: h.value }, { class: "lc-countdown" }), De(c.value), 17)) : de("", !0);
  }
}), eg = ["default", "without-hours"], Kd = { class: "lc-data-list" }, tg = /* @__PURE__ */ Ce({
  __name: "LcDataList",
  setup(e) {
    return (t, n) => ($(), q("ul", Kd, [
      me(t.$slots, "default")
    ]));
  }
}), Jd = { class: "lc-data-list-item" }, Qd = { class: "lc-data-list-item__content" }, ef = {
  key: 0,
  class: "lc-data-list-item__headline"
}, tf = {
  key: 0,
  class: "lc-data-list-item__text"
}, nf = { key: 0 }, af = {
  key: 0,
  class: "lc-data-list-item__underneath"
}, ng = /* @__PURE__ */ Ce({
  __name: "LcDataListItem",
  props: {
    headline: {},
    text: {}
  },
  setup(e) {
    return (t, n) => ($(), q("li", Jd, [
      ee("div", Qd, [
        ee("section", null, [
          e.headline ? ($(), q("span", ef, De(e.headline), 1)) : de("", !0),
          me(t.$slots, "default", {}, () => [
            e.text ? ($(), q("p", tf, De(e.text), 1)) : de("", !0)
          ])
        ]),
        t.$slots.suffix ? ($(), q("aside", nf, [
          me(t.$slots, "suffix")
        ])) : de("", !0)
      ]),
      t.$slots.underneath ? ($(), q("div", af, [
        me(t.$slots, "underneath")
      ])) : de("", !0)
    ]));
  }
});
var rf = Object.defineProperty, lf = (e, t, n) => t in e ? rf(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oa = (e, t, n) => lf(e, typeof t != "symbol" ? t + "" : t, n);
const cl = {
  "#": { pattern: /[0-9]/ },
  "@": { pattern: /[a-zA-Z]/ },
  "*": { pattern: /[a-zA-Z0-9]/ }
}, dl = (e, t, n) => e.replaceAll(t, "").replace(n, ".").replace("..", ".").replace(/[^.\d]/g, ""), fl = (e, t, n) => {
  var r;
  return new Intl.NumberFormat(((r = n.number) == null ? void 0 : r.locale) ?? "en", {
    minimumFractionDigits: e,
    maximumFractionDigits: t,
    roundingMode: "trunc"
  });
}, of = (e, t = !0, n) => {
  var r, s, i, a;
  const o = ((r = n.number) == null ? void 0 : r.unsigned) !== !0 && e.startsWith("-") ? "-" : "", l = ((s = n.number) == null ? void 0 : s.fraction) ?? 0;
  let h = fl(0, l, n);
  const v = h.formatToParts(1000.12), c = ((i = v.find((S) => S.type === "group")) == null ? void 0 : i.value) ?? " ", f = ((a = v.find((S) => S.type === "decimal")) == null ? void 0 : a.value) ?? ".", m = dl(e, c, f);
  if (Number.isNaN(parseFloat(m))) return o;
  const u = m.split(".");
  if (u[1] != null && u[1].length >= 1) {
    const S = u[1].length <= l ? u[1].length : l;
    h = fl(S, l, n);
  }
  let p = h.format(parseFloat(m));
  return t ? l > 0 && m.endsWith(".") && !m.slice(0, -1).includes(".") && (p += f) : p = dl(p, c, f), o + p;
}, Po = (e) => JSON.parse(e.replaceAll("'", '"')), sf = (e, t = {}) => {
  const n = { ...t };
  e.dataset.maska != null && e.dataset.maska !== "" && (n.mask = uf(e.dataset.maska)), e.dataset.maskaEager != null && (n.eager = $a(e.dataset.maskaEager)), e.dataset.maskaReversed != null && (n.reversed = $a(e.dataset.maskaReversed)), e.dataset.maskaTokensReplace != null && (n.tokensReplace = $a(e.dataset.maskaTokensReplace)), e.dataset.maskaTokens != null && (n.tokens = cf(e.dataset.maskaTokens));
  const r = {};
  return e.dataset.maskaNumberLocale != null && (r.locale = e.dataset.maskaNumberLocale), e.dataset.maskaNumberFraction != null && (r.fraction = parseInt(e.dataset.maskaNumberFraction)), e.dataset.maskaNumberUnsigned != null && (r.unsigned = $a(e.dataset.maskaNumberUnsigned)), (e.dataset.maskaNumber != null || Object.values(r).length > 0) && (n.number = r), n;
}, $a = (e) => e !== "" ? !!JSON.parse(e) : !0, uf = (e) => e.startsWith("[") && e.endsWith("]") ? Po(e) : e, cf = (e) => {
  if (e.startsWith("{") && e.endsWith("}"))
    return Po(e);
  const t = {};
  return e.split("|").forEach((n) => {
    const r = n.split(":");
    t[r[0]] = {
      pattern: zo() ? new RegExp(r[1], "u") : new RegExp(r[1]),
      optional: r[2] === "optional",
      multiple: r[2] === "multiple",
      repeated: r[2] === "repeated"
    };
  }), t;
}, zo = () => {
  try {
    return new RegExp("\\p{L}", "u"), !0;
  } catch {
    return !1;
  }
};
class df {
  constructor(t = {}) {
    oa(this, "opts", {}), oa(this, "memo", /* @__PURE__ */ new Map());
    const n = { ...t };
    if (n.tokens != null) {
      n.tokens = n.tokensReplace ? { ...n.tokens } : { ...cl, ...n.tokens };
      for (const r of Object.values(n.tokens))
        typeof r.pattern == "string" && (r.pattern = zo() ? new RegExp(r.pattern, "u") : new RegExp(r.pattern));
    } else
      n.tokens = cl;
    Array.isArray(n.mask) && (n.mask.length > 1 ? n.mask = [...n.mask].sort((r, s) => r.length - s.length) : n.mask = n.mask[0] ?? ""), n.mask === "" && (n.mask = null), this.opts = n;
  }
  masked(t) {
    return this.process(String(t), this.findMask(String(t)));
  }
  unmasked(t) {
    return this.process(String(t), this.findMask(String(t)), !1);
  }
  isEager() {
    return this.opts.eager === !0;
  }
  isReversed() {
    return this.opts.reversed === !0;
  }
  completed(t) {
    const n = this.findMask(String(t));
    if (this.opts.mask == null || n == null) return !1;
    const r = this.process(String(t), n).length;
    return typeof this.opts.mask == "string" ? r >= this.opts.mask.length : r >= n.length;
  }
  findMask(t) {
    const n = this.opts.mask;
    if (n == null)
      return null;
    if (typeof n == "string")
      return n;
    if (typeof n == "function")
      return n(t);
    const r = this.process(t, n.slice(-1).pop() ?? "", !1);
    return n.find((s) => this.process(t, s, !1).length >= r.length) ?? "";
  }
  escapeMask(t) {
    const n = [], r = [];
    return t.split("").forEach((s, i) => {
      s === "!" && t[i - 1] !== "!" ? r.push(i - r.length) : n.push(s);
    }), { mask: n.join(""), escaped: r };
  }
  process(t, n, r = !0) {
    if (this.opts.number != null) return of(t, r, this.opts);
    if (n == null) return t;
    const s = `v=${t},mr=${n},m=${r ? 1 : 0}`;
    if (this.memo.has(s)) return this.memo.get(s);
    const { mask: i, escaped: a } = this.escapeMask(n), o = [], l = this.opts.tokens != null ? this.opts.tokens : {}, h = this.isReversed() ? -1 : 1, v = this.isReversed() ? "unshift" : "push", c = this.isReversed() ? 0 : i.length - 1, f = this.isReversed() ? () => S > -1 && g > -1 : () => S < i.length && g < t.length, m = (_) => !this.isReversed() && _ <= c || this.isReversed() && _ >= c;
    let u, p = -1, S = this.isReversed() ? i.length - 1 : 0, g = this.isReversed() ? t.length - 1 : 0, b = !1;
    for (; f(); ) {
      const _ = i.charAt(S), T = l[_], I = T?.transform != null ? T.transform(t.charAt(g)) : t.charAt(g);
      if (!a.includes(S) && T != null ? (I.match(T.pattern) != null ? (o[v](I), T.repeated ? (p === -1 ? p = S : S === c && S !== p && (S = p - h), c === p && (S -= h)) : T.multiple && (b = !0, S -= h), S += h) : T.multiple ? b && (S += h, g -= h, b = !1) : I === u ? u = void 0 : T.optional && (S += h, g -= h), g += h) : (r && !this.isEager() && o[v](_), I === _ && !this.isEager() ? g += h : u = _, this.isEager() || (S += h)), this.isEager())
        for (; m(S) && (l[i.charAt(S)] == null || a.includes(S)); ) {
          if (r) {
            if (o[v](i.charAt(S)), t.charAt(g) === i.charAt(S)) {
              S += h, g += h;
              continue;
            }
          } else i.charAt(S) === t.charAt(g) && (g += h);
          S += h;
        }
    }
    return this.memo.set(s, o.join("")), this.memo.get(s);
  }
}
class ff {
  constructor(t, n = {}) {
    oa(this, "items", /* @__PURE__ */ new Map()), oa(this, "eventAbortController"), oa(this, "onInput", (r) => {
      if (r instanceof CustomEvent && r.type === "input" && !r.isTrusted && !r.bubbles)
        return;
      const s = r.target, i = this.items.get(s);
      if (i === void 0) return;
      const a = "inputType" in r && r.inputType.startsWith("delete"), o = i.isEager(), l = a && o && i.unmasked(s.value) === "" ? "" : s.value;
      this.fixCursor(s, a, () => this.setValue(s, l));
    }), this.options = n, this.eventAbortController = new AbortController(), this.init(this.getInputs(t));
  }
  update(t = {}) {
    this.options = { ...t }, this.init(Array.from(this.items.keys()));
  }
  updateValue(t) {
    var n;
    t.value !== "" && t.value !== ((n = this.processInput(t)) == null ? void 0 : n.masked) && this.setValue(t, t.value);
  }
  destroy() {
    this.eventAbortController.abort(), this.items.clear();
  }
  init(t) {
    const n = this.getOptions(this.options);
    for (const r of t) {
      if (!this.items.has(r)) {
        const { signal: i } = this.eventAbortController;
        r.addEventListener("input", this.onInput, { capture: !0, signal: i });
      }
      const s = new df(sf(r, n));
      this.items.set(r, s), queueMicrotask(() => this.updateValue(r)), r.selectionStart === null && s.isEager() && console.warn("Maska: input of `%s` type is not supported", r.type);
    }
  }
  getInputs(t) {
    return typeof t == "string" ? Array.from(document.querySelectorAll(t)) : "length" in t ? Array.from(t) : [t];
  }
  getOptions(t) {
    const { onMaska: n, preProcess: r, postProcess: s, ...i } = t;
    return i;
  }
  fixCursor(t, n, r) {
    var s, i;
    const a = t.selectionStart, o = t.value;
    if (r(), a === null || a === o.length && !n) return;
    const l = t.value, h = o.slice(0, a), v = l.slice(0, a), c = (s = this.processInput(t, h)) == null ? void 0 : s.unmasked, f = (i = this.processInput(t, v)) == null ? void 0 : i.unmasked;
    if (c === void 0 || f === void 0) return;
    let m = a;
    h !== v && (m += n ? l.length - o.length : c.length - f.length), t.setSelectionRange(m, m);
  }
  setValue(t, n) {
    const r = this.processInput(t, n);
    r !== void 0 && (t.value = r.masked, this.options.onMaska != null && (Array.isArray(this.options.onMaska) ? this.options.onMaska.forEach((s) => s(r)) : this.options.onMaska(r)), t.dispatchEvent(new CustomEvent("maska", { detail: r })), t.dispatchEvent(new CustomEvent("input", { detail: r.masked })));
  }
  processInput(t, n) {
    const r = this.items.get(t);
    if (r === void 0) return;
    let s = n ?? t.value;
    this.options.preProcess != null && (s = this.options.preProcess(s));
    let i = r.masked(s);
    return this.options.postProcess != null && (i = this.options.postProcess(i)), {
      masked: i,
      unmasked: r.unmasked(s),
      completed: r.completed(s)
    };
  }
}
const wr = /* @__PURE__ */ new WeakMap(), hf = (e, t) => {
  if (e.arg == null || e.instance == null) return;
  const n = "setup" in e.instance.$.type;
  e.arg in e.instance ? e.instance[e.arg] = t : n && console.warn("Maska: please expose `%s` using defineExpose", e.arg);
}, vf = (e, t) => {
  var n;
  const r = e instanceof HTMLInputElement ? e : e.querySelector("input");
  if (r == null || r?.type === "file") return;
  let s = {};
  if (t.value != null && (s = typeof t.value == "string" ? { mask: t.value } : { ...t.value }), t.arg != null) {
    const i = (a) => {
      const o = t.modifiers.unmasked ? a.unmasked : t.modifiers.completed ? a.completed : a.masked;
      hf(t, o);
    };
    s.onMaska = s.onMaska == null ? i : Array.isArray(s.onMaska) ? [...s.onMaska, i] : [s.onMaska, i];
  }
  wr.has(r) ? (n = wr.get(r)) == null || n.update(s) : wr.set(r, new ff(r, s));
}, mf = ["for"], gf = ["id"], bf = { class: "lc-input__input-wrap" }, pf = ["data-testid"], yf = ["data-testid"], tr = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: { default: "input" },
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean, default: !0 },
    suffixClass: {},
    type: { default: "text" },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = { Z: { pattern: "[1-9]" } }, s = n, i = it("input"), a = Tt(e.id), o = we(!1), l = Z(() => [
      "lc-input",
      {
        "lc-input--disabled": e.disabled,
        "lc-input--error": !!e.errorMessage,
        "lc-input--has-label": !!e.label
      }
    ]), h = Z(() => ({
      "aria-labelledby": e.label ? `${a}-label` : void 0,
      autocomplete: e.autocomplete,
      class: "lc-input__input",
      "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_input`,
      disabled: e.disabled,
      id: a,
      inputmode: e.inputmode,
      name: e.name,
      onFocusin: () => o.value = !0,
      onFocusout: () => o.value = !1,
      pattern: e.pattern,
      placeholder: e.placeholder,
      spellcheck: e.spellcheck,
      type: e.type
    })), v = Z(() => [
      "lc-input__label",
      {
        "lc-input__label--floating": o.value || !!e.value || typeof e.value == "number"
      }
    ]), c = Z(() => e.mask ? m(e.mask) ? { ...e.mask, tokens: { ...r, ...e.mask.tokens } } : { mask: e.mask, tokens: r } : {}), f = Z({
      get: () => e.value,
      set: (u) => {
        s("update:value", u);
      }
    }), m = (u) => u.mask !== void 0;
    return mt(() => {
      e.autofocus && i.value?.focus(), e.value && s("update:value", e.value);
    }), t({ ref: i }), (u, p) => ($(), q("div", {
      class: xe([l.value, u.$attrs.class])
    }, [
      ee("label", {
        class: "lc-input__wrap",
        for: U(a)
      }, [
        e.label ? ($(), q("span", {
          key: 0,
          id: `${U(a)}-label`,
          class: xe(v.value)
        }, De(e.label), 11, gf)) : de("", !0),
        ee("div", bf, [
          u.$slots.prefix ? ($(), q("div", {
            key: 0,
            class: xe(["lc-input__prefix", e.prefixClass])
          }, [
            me(u.$slots, "prefix")
          ], 2)) : de("", !0),
          e.mask ? Qt(($(), q("input", Ae({
            key: 1,
            ref: "input"
          }, {
            ...en(u.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[0] || (p[0] = (S) => f.value = S),
            "data-testid": u.$attrs["data-testid"] ?? "lc-input-with-mask"
          }), null, 16, pf)), [
            [zi, f.value],
            [U(vf), c.value]
          ]) : Qt(($(), q("input", Ae({
            key: 2,
            ref: "input"
          }, {
            ...en(u.$attrs, ["class"]),
            ...h.value
          }, {
            "onUpdate:modelValue": p[1] || (p[1] = (S) => f.value = S),
            "data-testid": u.$attrs["data-testid"] ?? "lc-input-without-mask"
          }), null, 16, yf)), [
            [zi, f.value]
          ]),
          u.$slots.suffix ? ($(), q("div", {
            key: 3,
            class: xe(["lc-input__suffix", e.suffixClass])
          }, [
            me(u.$slots, "suffix")
          ], 2)) : de("", !0)
        ])
      ], 8, mf),
      e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({ key: 0 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), ag = [
  "decimal",
  "email",
  "none",
  "numeric",
  "search",
  "tel",
  "text",
  "url"
], rg = [
  "email",
  "number",
  "password",
  "search",
  "tel",
  "text",
  "url"
], ig = /* @__PURE__ */ Ce({
  __name: "LcDateInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null], default: "##/##/####" },
    name: {},
    noFeedback: { type: Boolean },
    placeholder: { default: "MM/DD/YYYY" },
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {}
  },
  setup(e) {
    const t = ga(e, ["mask", "placeholder"]);
    return (n, r) => ($(), ke(U(tr), Ae({ ...n.$attrs, ...t, mask: e.mask, placeholder: e.placeholder }, {
      class: "lc-date-input",
      inputmode: "numeric",
      pattern: "[0-9]*"
    }), null, 16));
  }
}), wf = { class: "lc-description-list" }, lg = /* @__PURE__ */ Ce({
  __name: "LcDescriptionList",
  setup(e) {
    return (t, n) => ($(), q("dl", wf, [
      me(t.$slots, "default")
    ]));
  }
}), Vo = /* @__PURE__ */ Symbol();
var ln = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Backspace = "Backspace", e.Dead = "Dead", e.Delete = "Delete", e.Eight = "8", e.Five = "5", e.Four = "4", e.Nine = "9", e.One = "1", e.Seven = "7", e.Six = "6", e.Three = "3", e.Two = "2", e.Zero = "0", e))(ln || {});
const og = /* @__PURE__ */ Ce({
  __name: "LcDigitInput",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    type: {},
    index: { default: 0 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = ga(e, ["index"]), i = it("input"), a = Wn(Vo, () => null, !0), o = Z(() => Ke(a?.config)), l = Z(() => s.disabled || !!Ke(a?.disabled)), h = Z(() => l.value ? "*" : "#"), v = Z({
      get: () => l.value ? "X" : f.value,
      set: (u) => {
        if (l.value || u === "X") return;
        const p = typeof u == "number" ? u : null;
        r("update:value", p), a?.updateValue(e.index, p);
      }
    }), c = Z(() => a ? `${Ke(a.name)}_input_${e.index}` : s.name), f = Z(() => a ? Ke(a.value)?.[e.index] : s.value), m = (u) => {
      if (tn(u.key, ln))
        switch (u.key !== ln.Dead && u.preventDefault(), u.key) {
          case ln.ArrowLeft:
            a?.focusPrevious(e.index);
            break;
          case ln.ArrowRight:
            a?.focusNext(e.index);
            break;
          case ln.Backspace:
          case ln.Delete:
            v.value = null;
            break;
          case ln.Dead: {
            const p = u.target;
            p?.blur(), setTimeout(() => p?.focus(), 1);
            break;
          }
          default: {
            const p = parseInt(u.key);
            v.value = p, a?.focusNext(e.index);
          }
        }
    };
    return t({
      disabled: l,
      index: e.index,
      inputRef: i
    }), (u, p) => ($(), ke(U(tr), Ae({ ref: "input" }, { ...u.$attrs, ...s, ...o.value, disabled: l.value, mask: h.value, name: c.value }, {
      autocomplete: "off",
      class: "lc-digit-input",
      inputmode: "numeric",
      pattern: "[0-9]*",
      tabindex: l.value ? -1 : 0,
      value: v.value,
      onKeydown: m
    }), null, 16, ["tabindex", "value"]));
  }
}), xf = ["id"], kf = ["id"], Sf = ["aria-labelledby"], sg = /* @__PURE__ */ Ce({
  __name: "LcDigitInputGroup",
  props: {
    disabled: { type: Boolean },
    errorMessage: {},
    feedbackMessageClass: {},
    helpMessage: {},
    id: {},
    legendClass: {},
    name: { default: "digit-input-group" },
    noFeedback: { type: Boolean },
    value: {},
    wrapperClass: {}
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = we([]), i = Tt(e.id), a = (f, m) => {
      const u = [...e.value ?? []];
      u[f] = m, r("update:value", u);
    }, o = () => {
      const f = s.value.findIndex((m) => !m.disabled);
      s.value[f]?.inputRef?.ref?.focus();
    }, l = (f) => {
      if (f < 0 || f >= s.value.length) return;
      const m = s.value[f];
      m.disabled || m.inputRef?.ref?.focus();
    }, h = (f, m) => {
      if (a(f, m), m !== null) {
        v(f);
        return;
      }
      if (f <= 0 || typeof e.value?.[f] == "number") return;
      const p = s.value.slice(0, f).reverse().find(({ disabled: S }) => !S)?.index;
      typeof p == "number" && (l(p), a(p, null));
    }, v = (f, m = !0) => {
      const u = m ? f + 1 : f - 1;
      if (u < 0 || u >= s.value.length) return;
      const p = s.value[u];
      if (p.disabled) {
        v(u, m);
        return;
      }
      p.inputRef?.ref?.focus();
    }, c = (f) => {
      const m = f;
      m?.inputRef?.ref && (s.value[m.index] = m);
    };
    return mt(o), t({ focusFirstEnabledInput: o, focusInputByIndex: l }), ai(Vo, {
      config: so(
        Z(() => ({
          errorMessage: e.errorMessage,
          noFeedback: !0
        }))
      ),
      disabled: () => e.disabled,
      focusNext: (f) => v(f),
      focusPrevious: (f) => v(f, !1),
      name: () => e.name,
      updateValue: h,
      value: () => e.value
    }), (f, m) => ($(), q("fieldset", Ae(f.$attrs, {
      id: U(i),
      class: "lc-digit-input-group"
    }), [
      f.$slots.legend ? ($(), q("legend", {
        key: 0,
        id: `${U(i)}-label`,
        class: xe(["lc-digit-input-group__label", e.legendClass])
      }, [
        me(f.$slots, "legend")
      ], 10, kf)) : de("", !0),
      ee("div", {
        "aria-labelledby": f.$slots.legend ? `${U(i)}-label` : void 0,
        class: xe(["lc-digit-input-group__wrap", e.wrapperClass]),
        role: "group"
      }, [
        me(f.$slots, "default", _t(Dt({ setRef: c })))
      ], 10, Sf),
      e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({ key: 1 }, { disabled: e.disabled }, {
        class: e.feedbackMessageClass,
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["class", "content", "variant"]))
    ], 16, xf));
  }
}), _f = ["id"], Cf = ["aria-expanded"], Ef = /* @__PURE__ */ Ce({
  __name: "LcExpandable",
  props: /* @__PURE__ */ Sn({
    animated: { type: Boolean },
    contentClass: {},
    disabled: { type: Boolean },
    headerClass: {},
    id: {},
    modelValue: { type: Boolean }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["collapse", "collapsed", "expand", "expanded"], ["update:modelValue"]),
  setup(e) {
    const t = Tt(e.id), n = `${t}-region`, r = Wa(e, "modelValue"), s = Z(() => [
      "lc-expandable",
      {
        "lc-expandable--animated": e.animated,
        "lc-expandable--disabled": e.disabled,
        "lc-expandable--expanded": r.value
      }
    ]), i = Z(() => ["lc-expandable__content", e.contentClass]), a = () => {
      r.value = !r.value;
    };
    return (o, l) => ($(), q("article", Ae(o.$attrs, {
      id: U(t),
      class: s.value
    }), [
      ee("button", Ae({ "aria-controls": n }, { disabled: e.disabled }, {
        "aria-expanded": r.value,
        class: ["lc-expandable__header", e.headerClass],
        type: "button",
        onClickPassive: a
      }), [
        me(o.$slots, "header"),
        e.disabled ? de("", !0) : ($(), ke(U(Qe), {
          key: 0,
          class: "lc-expandable__header-icon",
          name: "chevron-down"
        }))
      ], 16, Cf),
      e.animated ? ($(), ke(U(Lo), {
        key: 0,
        animated: "",
        class: "lc-expandable__collapse",
        when: r.value,
        onCollapse: l[0] || (l[0] = (h) => o.$emit("collapse")),
        onCollapsed: l[1] || (l[1] = (h) => o.$emit("collapsed")),
        onExpand: l[2] || (l[2] = (h) => o.$emit("expand")),
        onExpanded: l[3] || (l[3] = (h) => o.$emit("expanded"))
      }, {
        default: Te(() => [
          ee("section", {
            id: n,
            class: xe(i.value),
            role: "region"
          }, [
            me(o.$slots, "default")
          ], 2)
        ]),
        _: 3
      }, 8, ["when"])) : Qt(($(), q("section", {
        key: 1,
        id: n,
        class: xe(i.value),
        role: "region"
      }, [
        me(o.$slots, "default")
      ], 2)), [
        [ii, r.value]
      ])
    ], 16, _f));
  }
}), Tf = { class: "lc-expandable-list" }, ug = /* @__PURE__ */ Ce({
  __name: "LcExpandableList",
  setup(e) {
    return (t, n) => ($(), q("div", Tf, [
      me(t.$slots, "default")
    ]));
  }
}), Af = () => {
  const e = we(!1);
  return mt(() => {
    e.value = !0;
  }), Ln(() => {
    e.value = !1;
  }), e;
}, Lf = {
  key: 0,
  class: "lc-fly-out__illustration"
}, $f = { class: "lc-fly-out__message" }, cg = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcFlyOut",
  props: {
    buttonAriaLabel: { default: () => We.lcFlyOut.buttonAriaLabel },
    isVisible: { type: Boolean },
    message: {},
    to: { default: () => We.lcFlyOut.to },
    visibleInSeconds: { default: () => We.lcFlyOut.visibleInSeconds }
  },
  emits: ["update:isVisible"],
  setup(e, { emit: t }) {
    const n = t, r = Af(), s = Z(() => e.visibleInSeconds * 1e3), { start: i, stop: a } = ta(
      () => {
        n("update:isVisible", !1);
      },
      s,
      { immediate: !1 }
    );
    return Ln(a), Ve(
      () => e.isVisible,
      (o) => {
        o ? i() : a();
      },
      { immediate: !0 }
    ), (o, l) => U(r) ? ($(), ke(ba, {
      key: 0,
      class: "lc-fly-out",
      to: e.to
    }, [
      Fe(U(ua), { name: "slide-down-lg" }, {
        default: Te(() => [
          e.isVisible ? ($(), q("div", Ae({ key: 0 }, o.$attrs, { class: "lc-fly-out__container" }), [
            Fe(U(Ec), {
              class: "lc-fly-out__timer",
              "duration-in-ms": s.value
            }, {
              default: Te(() => [
                Fe(U(Et), {
                  "aria-label": e.buttonAriaLabel,
                  icon: "close",
                  variant: "tertiary",
                  onClick: l[0] || (l[0] = (h) => o.$emit("update:isVisible", !1))
                }, null, 8, ["aria-label"])
              ]),
              _: 1
            }, 8, ["duration-in-ms"]),
            o.$slots.default ? ($(), q("div", Lf, [
              me(o.$slots, "default")
            ])) : de("", !0),
            ee("p", $f, De(e.message), 1)
          ], 16)) : de("", !0)
        ]),
        _: 3
      })
    ], 8, ["to"])) : de("", !0);
  }
});
const ha = (e) => e !== null && !!e && typeof e == "object" && !Array.isArray(e);
function hl(e) {
  return Number(e) >= 0;
}
function If(e) {
  return typeof e == "object" && e !== null;
}
function Df(e) {
  return e == null ? e === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(e);
}
function vl(e) {
  if (!If(e) || Df(e) !== "[object Object]")
    return !1;
  if (Object.getPrototypeOf(e) === null)
    return !0;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t;
}
function Ho(e, t) {
  return Object.keys(t).forEach((n) => {
    if (vl(t[n]) && vl(e[n])) {
      e[n] || (e[n] = {}), Ho(e[n], t[n]);
      return;
    }
    e[n] = t[n];
  }), e;
}
function Mf(e, t = { abortEarly: !1 }) {
  return {
    __type: "VVTypedSchema",
    async parse(r) {
      var s;
      try {
        return {
          value: await e.validate(r, Object.assign({}, t)),
          errors: []
        };
      } catch (i) {
        const a = i;
        if (a.name !== "ValidationError")
          throw i;
        if (!(!((s = a.inner) === null || s === void 0) && s.length) && a.errors.length)
          return { errors: [{ path: a.path, errors: a.errors }] };
        const o = a.inner.reduce((l, h) => {
          const v = h.path || "";
          return l[v] || (l[v] = { errors: [], path: v }), l[v].errors.push(...h.errors), l;
        }, {});
        return { errors: Object.values(o) };
      }
    },
    cast(r) {
      try {
        return e.cast(r);
      } catch {
        const i = e.getDefault();
        return ha(i) && ha(r) ? Ho(i, r) : r;
      }
    },
    describe(r) {
      try {
        if (!r)
          return ml(e.spec);
        const s = Rf(r, e);
        return s ? ml(s) : {
          required: !1,
          exists: !1
        };
      } catch {
        return process.env.NODE_ENV !== "production" && console.warn(`Failed to describe path ${r} on the schema, returning a default description.`), {
          required: !1,
          exists: !1
        };
      }
    }
  };
}
function ml(e) {
  return {
    required: !e.optional,
    exists: !0
  };
}
function Rf(e, t) {
  if (!gl(t))
    return null;
  if (nu(e)) {
    const s = t.fields[au(e)];
    return s?.spec || null;
  }
  const n = (e || "").split(/\.|\[(\d+)\]/).filter(Boolean);
  let r = t;
  for (let s = 0; s < n.length; s++) {
    const i = n[s];
    if (gl(r) && i in r.fields ? r = r.fields[i] : Of(r) && hl(i) ? r = r.spec.types[Number(i)] : hl(i) && Ff(r) && (r = r.innerType), s === n.length - 1)
      return r.spec;
  }
  return null;
}
function Of(e) {
  return ha(e) && e.type === "tuple";
}
function gl(e) {
  return ha(e) && e.type === "object";
}
function Ff(e) {
  return ha(e) && e.type === "array";
}
const dg = /* @__PURE__ */ Ce({
  __name: "LcForm",
  props: {
    initialValues: {},
    onSubmit: { type: Function },
    resetOnSubmit: { type: Boolean },
    validateOnMount: { type: Boolean },
    validationSchema: {}
  },
  setup(e, { expose: t }) {
    const n = e, {
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: o,
      setErrors: l,
      setValues: h,
      validate: v,
      values: c
    } = ru({
      initialValues: n.initialValues,
      validateOnMount: n.validateOnMount,
      validationSchema: n.validationSchema ? Mf(n.validationSchema) : void 0
    }), f = async (m) => {
      m.preventDefault();
      try {
        s.value = !0;
        const { valid: u, values: p } = await v();
        u && n.onSubmit && await n.onSubmit(p), u && n.resetOnSubmit && o();
      } finally {
        s.value = !1;
      }
    };
    return t({
      isFieldValid: r,
      isSubmitting: s,
      meta: i,
      resetField: a,
      resetForm: o,
      setErrors: l,
      setValues: h,
      validate: v,
      values: c
    }), (m, u) => ($(), q("form", {
      class: "lc-form",
      novalidate: "",
      onSubmit: f
    }, [
      me(m.$slots, "default", _t(Dt({ isSubmitting: U(s), meta: U(i), values: U(c) })))
    ], 32));
  }
}), fg = [
  "aggressive",
  "blur",
  "eager",
  "lazy",
  "passive"
];
var Uo = /* @__PURE__ */ ((e) => (e.InputEnd = "lottocom_form_input_end", e))(Uo || {});
const Nt = {
  Blur: "onBlur",
  Change: "onChange",
  Update: "onUpdate:value"
}, Nf = { class: "lc-form-field" }, hg = /* @__PURE__ */ Ce({
  __name: "LcFormField",
  props: {
    mode: { default: "aggressive" },
    name: {}
  },
  setup(e, { expose: t }) {
    const n = {
      aggressive: () => [Nt.Blur, Nt.Update],
      blur: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Blur],
      eager: ({ errorMessage: f }) => f.value ? [Nt.Update] : [Nt.Change],
      lazy: () => [Nt.Change],
      passive: () => []
    }, {
      errorMessage: r,
      handleBlur: s,
      handleChange: i,
      meta: a,
      value: o
    } = iu(() => e.name, {}, { validateOnValueUpdate: !1 }), l = {
      [Nt.Blur]: (f) => c(f, !0),
      [Nt.Change]: (f) => i(f, !0),
      [Nt.Update]: (f) => i(f, !0)
    }, h = Z(() => ({
      errorMessage: r.value,
      name: e.name,
      value: o.value,
      ...v.value
    })), v = Z(() => {
      const f = {
        [Nt.Blur]: (m) => c(m, !1),
        [Nt.Update]: (m) => i(m, !1)
      };
      return n[e.mode]({
        errorMessage: r,
        meta: a
      }).forEach((m) => {
        f[m] = l[m];
      }), f;
    }), c = async (f, m) => {
      if (s(f, m), await Ya(), !f) return;
      const u = new CustomEvent(Uo.InputEnd, {
        detail: {
          _value: f
        }
      });
      window.dispatchEvent(u);
    };
    return t({ field: h }), (f, m) => ($(), q("div", Nf, [
      me(f.$slots, "default", _t(Dt({ field: h.value })))
    ]));
  }
}), Bf = ["id"], Pf = { ref: "wrapper" }, zf = { class: "lc-header__wrap" }, Vf = { class: "lc-header__left-button-wrap" }, Hf = { class: "lc-header__headline-wrap" }, Uf = {
  key: 0,
  class: "lc-header__fly-out-toggle-wrap"
}, qf = ["id", "aria-labelledby"], jf = { class: "lc-header__fly-out-content-container" }, vg = /* @__PURE__ */ Ce({
  __name: "LcHeader",
  props: {
    href: {},
    target: {},
    to: {},
    ignoreOutsideClickOn: { default: () => [We.lcModal.to] },
    closeFlyOutOnOutsideClick: { type: Boolean, default: !0 },
    flyOutContentClass: {},
    flyOutToggleAriaLabel: { default: () => We.lcHeader.flyOutToggleAriaLabel },
    flyOutToggleClass: {},
    headlineClass: {},
    id: {},
    leftButtonAriaLabel: { default: () => We.lcHeader.leftButtonAriaLabel },
    leftButtonIcon: { default: "arrow-left" },
    withFlyOut: { type: Boolean }
  },
  emits: ["left-button-click"],
  setup(e) {
    const t = it("wrapper"), n = Tt(e.id), r = we(!1), s = Z(() => [
      "lc-header",
      {
        "lc-header--active": r.value,
        "lc-header--with-fly-out": e.withFlyOut
      }
    ]), i = () => {
      r.value = !r.value;
    };
    return Ga(
      t,
      () => {
        !e.closeFlyOutOnOutsideClick || !r.value || (r.value = !1);
      },
      { ignore: [...Ke(e.ignoreOutsideClickOn)] }
    ), (a, o) => ($(), q("header", {
      id: U(n),
      class: xe(s.value)
    }, [
      ee("div", Pf, [
        ee("div", zf, [
          ee("div", Vf, [
            Fe(U(Et), Ae({ href: e.href, target: e.target, to: e.to }, {
              "aria-label": e.leftButtonAriaLabel,
              icon: e.leftButtonIcon,
              size: "small",
              variant: "tertiary",
              onClick: o[0] || (o[0] = (l) => a.$emit("left-button-click"))
            }), null, 16, ["aria-label", "icon"])
          ]),
          ee("div", Hf, [
            ee("h1", {
              class: xe(["lc-header__headline", e.headlineClass])
            }, [
              me(a.$slots, "headline")
            ], 2)
          ]),
          me(a.$slots, "right", {}, () => [
            e.withFlyOut ? ($(), q("div", Uf, [
              Fe(U(Et), {
                id: `${U(n)}-toggle`,
                "aria-controls": `${U(n)}-region`,
                "aria-expanded": r.value,
                "aria-label": e.flyOutToggleAriaLabel,
                class: xe(["lc-header__fly-out-toggle", e.flyOutToggleClass]),
                icon: "chevron-down",
                "icon-position": "right",
                "no-padding": "",
                size: "small",
                variant: "tertiary",
                onClickPassive: i
              }, {
                default: Te(() => [
                  me(a.$slots, "fly-out-toggle")
                ]),
                _: 3
              }, 8, ["id", "aria-controls", "aria-expanded", "aria-label", "class"])
            ])) : de("", !0)
          ])
        ]),
        e.withFlyOut && r.value ? ($(), q("div", {
          key: 0,
          id: `${U(n)}-region`,
          "aria-labelledby": `${U(n)}-toggle`,
          class: "lc-header__fly-out",
          role: "region"
        }, [
          ee("div", jf, [
            ee("div", {
              class: xe(["lc-header__fly-out-content", e.flyOutContentClass])
            }, [
              me(a.$slots, "fly-out-content")
            ], 2)
          ])
        ], 8, qf)) : de("", !0)
      ], 512),
      me(a.$slots, "default")
    ], 10, Bf));
  }
}), Zf = /* @__PURE__ */ Ce({
  __name: "LcHighFrequencyBall",
  props: {
    content: {},
    opacity: { default: 1 },
    size: { default: "medium" }
  },
  setup(e) {
    const t = Z(() => ["lc-high-frequency-ball", `lc-high-frequency-ball--size-${e.size}`]);
    return (n, r) => ($(), q("div", {
      class: xe(t.value),
      style: Ct({
        "--ball-opacity": e.opacity
      })
    }, De(e.content), 7));
  }
}), Wf = { class: "lc-high-frequency-ball-background" }, qo = /* @__PURE__ */ Ce({
  __name: "LcHighFrequencyBallBackground",
  props: {
    ballConfig: {},
    gradientClass: {}
  },
  setup(e) {
    return (t, n) => ($(), q("div", Wf, [
      ($(!0), q(Ge, null, vt(e.ballConfig, (r, s) => ($(), ke(Zf, {
        key: s,
        class: "lc-high-frequency-ball-background__ball",
        content: r.content,
        opacity: r.opacity,
        size: r.size,
        style: Ct({
          "--ball-position-top": r.top,
          "--ball-position-left": r.left
        })
      }, null, 8, ["content", "opacity", "size", "style"]))), 128)),
      ee("div", {
        class: xe(["lc-high-frequency-ball-background__gradient", e.gradientClass])
      }, null, 2)
    ]));
  }
}), Yf = {
  key: 0,
  class: "lc-lottery-jackpot__placeholder"
}, Xf = { class: "lc-lottery-jackpot__value" }, Gf = { class: "lc-lottery-jackpot__currency" }, Kf = {
  key: 0,
  class: "lc-lottery-jackpot__numeral"
}, bl = 10 ** 9, pl = 10 ** 6, Jf = "mil millones", Qf = "mil M", jo = /* @__PURE__ */ Ce({
  __name: "LcLotteryJackpot",
  props: {
    currency: { default: () => We.general.currency },
    locale: { default: () => We.general.locale },
    noShadow: { type: Boolean },
    placeholder: {},
    size: { default: "medium" },
    value: {}
  },
  setup(e) {
    const t = bl * 100, n = pl * 100, r = Z(() => {
      let a;
      const o = e.value >= t, l = e.value >= n;
      switch (!0) {
        case o:
          a = Math.floor(e.value / bl) / 100;
          break;
        case l:
          a = Math.floor(e.value / pl) / 100;
          break;
        default:
          a = e.value / 100;
          break;
      }
      const [h, v] = a.toFixed(2).split("."), c = v.replace(/0+$/, ""), f = l || o;
      let m = c;
      !f && c.length >= 1 ? m = v : f && h.length >= 3 ? m = "" : f && c.length > 1 && (m = c.slice(0, 1));
      const u = m.length > 0 ? [h, m].join(".") : h, p = m.length;
      return new Intl.NumberFormat(e.locale, {
        maximumFractionDigits: p,
        minimumFractionDigits: p
      }).format(Number(u));
    }), s = Z(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: a }) => a === "currency")?.value ?? e.currency
    ), i = Z(() => {
      if (e.value < n) return null;
      const a = new Intl.NumberFormat(e.locale, {
        compactDisplay: "long",
        maximumFractionDigits: 12,
        minimumFractionDigits: 2,
        notation: "compact"
      }).format(e.value / 100).split(" ").slice(1).join(" ");
      return a === Jf ? Qf : a;
    });
    return (a, o) => ($(), q("div", {
      class: xe([
        "lc-lottery-jackpot",
        `lc-lottery-jackpot--size-${e.size}`,
        { "lc-lottery-jackpot--no-shadow": e.noShadow }
      ])
    }, [
      e.placeholder ? ($(), q("span", Yf, De(e.placeholder), 1)) : ($(), q(Ge, { key: 1 }, [
        ee("span", Xf, [
          ee("span", Gf, De(s.value), 1),
          ee("span", null, De(r.value), 1)
        ]),
        i.value ? ($(), q("span", Kf, De(i.value), 1)) : de("", !0)
      ], 64))
    ], 2));
  }
}), mg = ["large", "medium", "small"], Zo = () => typeof window < "u", e0 = { class: "lc-info-button__modal" }, t0 = { class: "lc-info-button__modal-header" }, n0 = { class: "lc-info-button__modal-headline" }, a0 = { class: "lc-info-button__modal-text" }, Wo = /* @__PURE__ */ Ce({
  __name: "LcInfoButton",
  props: {
    to: {},
    closeButtonAriaLabel: { default: () => We.lcInfoButton.closeButtonAriaLabel },
    disabled: { type: Boolean, default: !1 },
    headline: {},
    openButtonAriaLabel: { default: () => We.lcInfoButton.openButtonAriaLabel },
    text: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = Zo(), n = we(!1), r = () => {
      n.value = !1;
    }, s = () => {
      e.disabled || (n.value = !0);
    };
    return (i, a) => ($(), q("div", {
      class: xe(["lc-info-button", `lc-info-button--variant-${e.variant}`])
    }, [
      Fe(U(Et), Ae({ disabled: e.disabled }, {
        "aria-label": e.openButtonAriaLabel,
        class: "lc-info-button__button-open",
        icon: "info",
        size: "small",
        variant: "tertiary",
        onClickPassive: s
      }), null, 16, ["aria-label"]),
      U(t) && n.value ? ($(), ke(U(Io), Ae({ key: 0 }, { to: e.to, isVisible: n.value }, {
        "close-triggers": ["escape", "click-outside"],
        spacing: "small",
        onClosePassive: r
      }), {
        default: Te(() => [
          ee("div", e0, [
            ee("header", t0, [
              ee("span", n0, De(e.headline), 1),
              Fe(U(Et), {
                "aria-label": e.closeButtonAriaLabel,
                icon: "close",
                size: "small",
                variant: "tertiary",
                onClick: r
              }, null, 8, ["aria-label"])
            ]),
            me(i.$slots, "default", {}, () => [
              ee("p", a0, De(e.text), 1)
            ])
          ])
        ]),
        _: 3
      }, 16)) : de("", !0)
    ], 2));
  }
}), gg = ["default", "prominent"], r0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='11.9999'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M19.4149%2015.1688C18.8733%2019.0325%2016.1778%2021.4239%2011.7967%2021.4239C7.80659%2021.4239%204.34435%2017.7274%205.29956%2014.3591C6.14178%2011.3891%208.79864%2011.1375%209.58553%207.65315C11.2998%209.28806%2010.8823%2010.6768%2010.5907%2012.0319C10.34%2013.1974%2010.7651%2014.5391%2011.7967%2014.5391C13.0342%2014.5391%2013.5051%2013.1541%2013.0342%2011.7364C12.2699%209.43549%2010.4881%206.2479%2012.2267%203.90869C13.3913%206.00993%2014.7039%206.89025%2016.4607%208.40282C18.7036%2010.3339%2019.7843%2012.5328%2019.4149%2015.1688Z'%20fill='%23000860'/%3e%3cpath%20d='M7.99905%203.70487C9.59553%207.89517%205.86485%209.98417%205.86485%209.98417C5.07622%206.82574%206.57056%206.64536%207.99905%203.70487Z'%20fill='%23000860'/%3e%3c/svg%3e", i0 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='56'%20height='55'%20fill='none'%3e%3cg%20filter='url(%23a)'%3e%3cpath%20fill='%2300C572'%20d='M24.064%204.19A1%201%200%200%201%2025.427%204L27.1%205.192a1%201%200%200%200%201.185-.016l1.638-1.24a1%201%200%200%201%201.368.153l1.323%201.572a1%201%200%200%200%201.151.279l1.895-.794a1%201%200%200%201%201.288.49l.89%201.85a1%201%200%200%200%201.046.557l2.033-.297a1%201%200%200%201%201.125.794l.402%202.014a1%201%200%200%200%20.875.799l2.042.218a1%201%200%200%201%20.893%201.048l-.112%202.052a1%201%200%200%200%20.649.99l1.924.72a1%201%200%200%201%20.604%201.237l-.618%201.96a1%201%200%200%200%20.381%201.12l1.685%201.176a1%201%200%200%201%20.277%201.349l-1.086%201.744a1%201%200%200%200%20.091%201.18l1.34%201.558a1%201%200%200%201-.067%201.375l-1.485%201.419a1%201%200%200%200-.206%201.166l.91%201.842a1%201%200%200%201-.407%201.315l-1.791%201.005a1%201%200%200%200-.49%201.079l.424%202.01a1%201%200%200%201-.721%201.173l-1.986.528a1%201%200%200%200-.742.923l-.089%202.052a1%201%200%200%201-.99.957l-2.055.017a1%201%200%200%200-.948.71l-.597%201.965a1%201%200%200%201-1.197.68l-1.994-.493a1%201%200%200%200-1.095.45l-1.067%201.756a1%201%200%200%201-1.33.361l-1.808-.974a1%201%200%200%200-1.172.165l-1.47%201.435a1%201%200%200%201-1.377.02l-1.51-1.394a1%201%200%200%200-1.177-.132l-1.78%201.024a1%201%200%200%201-1.339-.324l-1.115-1.725a1%201%200%200%200-1.108-.42l-1.98.55a1%201%200%200%201-1.215-.647l-.651-1.949a1%201%200%200%200-.968-.682l-2.054.04a1%201%200%200%201-1.017-.929l-.146-2.05a1%201%200%200%200-.768-.901l-2-.472a1%201%200%200%201-.753-1.153l.367-2.02a1%201%200%200%200-.519-1.065l-1.819-.955a1%201%200%200%201-.444-1.303l.86-1.866a1%201%200%200%200-.239-1.16L4.738%2029.73a1%201%200%200%201-.105-1.373l1.296-1.593a1%201%200%200%200%20.058-1.183l-1.135-1.713a1%201%200%200%201%20.24-1.356l1.651-1.222a1%201%200%200%200%20.35-1.131l-.672-1.942a1%201%200%200%201%20.569-1.254l1.903-.772a1%201%200%200%200%20.62-1.009l-.168-2.047a1%201%200%200%201%20.863-1.073l2.036-.275a1%201%200%200%200%20.852-.823l.345-2.025a1%201%200%200%201%201.103-.825l2.04.24a1%201%200%200%200%201.03-.585l.838-1.875a1%201%200%200%201%201.274-.525l1.916.74a1%201%200%200%200%201.143-.31z'/%3e%3cpath%20fill='%23fff'%20d='M12.886%2035.433a.42.42%200%200%201-.32-.075.41.41%200%200%201-.16-.286l-1.538-10.943a.41.41%200%200%201%20.075-.32.41.41%200%200%201%20.286-.16l1.532-.215q.254-.036.387.066.135.101.178.163l5.481%206.389-.97-6.902a.41.41%200%200%201%20.075-.32.4.4%200%200%201%20.27-.158l1.717-.242a.41.41%200%200%201%20.32.076q.135.101.16.286l1.538%2010.943a.45.45%200%200%201-.075.32.41.41%200%200%201-.287.16l-1.549.217q-.252.036-.386-.065-.12-.12-.178-.164l-5.434-6.172.94%206.683a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.176-1.57a.42.42%200%200%201-.32-.076.41.41%200%200%201-.16-.286l-1.538-10.943a.42.42%200%200%201%20.076-.32.41.41%200%200%201%20.286-.16l7.626-1.072a.41.41%200%200%201%20.32.076q.135.101.16.286l.19%201.347a.4.4%200%200%201-.078.303.42.42%200%200%201-.287.16l-5.454.767.372%202.643%205.084-.715a.42.42%200%200%201%20.32.075q.133.102.16.287l.175%201.246a.4.4%200%200%201-.078.302.42.42%200%200%201-.287.16l-5.084.715.384%202.727%205.589-.785a.42.42%200%200%201%20.32.075q.133.102.16.287l.187%201.33a.41.41%200%200%201-.076.32.41.41%200%200%201-.286.16zm11.278-1.586a.64.64%200%200%201-.459-.09.66.66%200%200%201-.237-.344l-3.436-10.521a.15.15%200%200%201-.026-.065l-.007-.05a.33.33%200%200%201%20.067-.25.32.32%200%200%201%20.236-.154l1.768-.248q.438-.061.538.285l2.263%206.943.742-4.619q.03-.142.128-.31.096-.167.366-.206l1.06-.149q.27-.038.409.097a.8.8%200%200%201%20.192.265l2%204.217.247-7.28q0-.36.456-.424l1.767-.248a.32.32%200%200%201%20.27.082.33.33%200%200%201%20.133.222l.008.05a.15.15%200%200%201-.008.07l-.403%2011.06a.62.62%200%200%201-.15.4q-.13.172-.399.21l-1.364.192q-.27.038-.44-.076a.9.9%200%200%201-.227-.277l-2.535-4.966-1.05%205.47a.8.8%200%200%201-.16.331q-.117.154-.402.194z'/%3e%3c/g%3e%3cdefs%3e%3cfilter%20id='a'%20width='54.296'%20height='56.295'%20x='.852'%20y='.102'%20color-interpolation-filters='sRGB'%20filterUnits='userSpaceOnUse'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'/%3e%3cfeColorMatrix%20in='SourceAlpha'%20result='hardAlpha'%20values='0%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%200%20127%200'/%3e%3cfeOffset%20dy='2'/%3e%3cfeComposite%20in2='hardAlpha'%20operator='out'/%3e%3cfeColorMatrix%20values='0%200%200%200%200%200%200%200%200%200.0313726%200%200%200%200%200.376471%200%200%200%200.06%200'/%3e%3cfeBlend%20in2='BackgroundImageFix'%20result='effect1_dropShadow_11660_18282'/%3e%3cfeBlend%20in='SourceGraphic'%20in2='effect1_dropShadow_11660_18282'%20result='shape'/%3e%3c/filter%3e%3c/defs%3e%3c/svg%3e", l0 = "data:image/svg+xml,%3csvg%20width='24'%20height='25'%20viewBox='0%200%2024%2025'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12.0001'%20cy='12.9417'%20r='11'%20fill='white'/%3e%3ccircle%20cx='12'%20cy='12.9417'%20r='9.21486'%20transform='rotate(-11.3509%2012%2012.9417)'%20fill='%23000860'/%3e%3cpath%20d='M10.5288%205.61047C9.30234%205.85667%208.15728%206.40664%207.19846%207.21001C6.23963%208.01338%205.49769%209.04448%205.04059%2010.2089L12.0003%2012.941L10.5288%205.61047Z'%20fill='white'/%3e%3c/svg%3e", o0 = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='12'%20cy='12'%20r='11'%20fill='white'/%3e%3cpath%20d='M11.7802%2013.8032L14.3303%2012.5401L14.5266%2012.7531C16.3077%2014.6859%2017.2575%2017.2414%2017.1712%2019.8683C17.1679%2019.9693%2017.1041%2020.0585%2017.0095%2020.0942L13.4144%2021.4522C13.2796%2021.5031%2013.1355%2021.4035%2013.1355%2021.2594L13.1356%2020.3255C13.1356%2018.0815%2012.6742%2015.8615%2011.7802%2013.8032Z'%20fill='%23000860'/%3e%3cpath%20d='M11.0112%209.27934C11.0323%209.19513%2011.1291%209.15558%2011.2031%209.20086L17.6251%2012.5888C17.715%2012.6438%2017.7043%2012.7778%2017.6066%2012.8177L9.86212%2016.2293C9.76448%2016.2693%209.66293%2016.1812%209.6886%2016.0789L11.0112%209.27934Z'%20fill='%23000860'/%3e%3cpath%20d='M5.25467%200.422462C5.25301%200.280381%205.41499%200.19807%205.52878%200.283175L8.27821%202.33962C8.3234%202.37342%208.38232%202.38282%208.43577%202.36475L11.6885%201.26567C11.8231%201.22018%2011.9515%201.3488%2011.9057%201.48331L10.7995%204.73366C10.7813%204.78707%2010.7906%204.84601%2010.8243%204.89127L12.8748%207.64518C12.9596%207.75915%2012.8769%207.92095%2012.7349%207.91898L9.30178%207.87136C9.24536%207.87057%209.19217%207.8976%209.15954%207.94364L7.17404%2010.7447C7.09187%2010.8607%206.91245%2010.832%206.87042%2010.6963L5.85482%207.41653C5.83813%207.36263%205.79599%207.32039%205.74213%207.30359L2.46457%206.28085C2.32893%206.23852%202.3007%206.05904%202.41681%205.97712L5.22222%203.99773C5.26833%203.9652%205.29547%203.91207%205.29481%203.85565L5.25467%200.422462Z'%20fill='%23000860'/%3e%3c/svg%3e", s0 = {
  key: 0,
  fill: "none",
  height: "32",
  viewBox: "0 0 21 32",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
}, u0 = ["src"], c0 = {
  key: 2,
  class: "lc-teaser-badge__text"
}, d0 = ["src"], f0 = 8, rn = 10, h0 = 20, v0 = /* @__PURE__ */ Ce({
  __name: "LcTeaserBadge",
  props: {
    infoHeadline: {},
    infoText: {},
    title: {},
    variant: {}
  },
  setup(e) {
    const t = Z(() => [
      "lc-teaser-badge",
      `lc-teaser-badge--variant-${e.variant}`,
      {
        "lc-teaser-badge--multiple-lines": n.value
      }
    ]), n = Z(() => s.value.length > 1), r = Z(() => {
      switch (e.variant) {
        case "fire":
          return r0;
        case "pie":
          return l0;
        case "star":
          return o0;
        default:
          return null;
      }
    }), s = Z(() => {
      if (!e.title) return [];
      const i = e.title.substring(0, h0);
      if (i.length <= f0) return [i];
      const o = i.split(" ").filter(Boolean);
      if (o.length === 1)
        return [
          i.slice(0, rn),
          i.slice(rn)
        ];
      let l = "";
      const h = [];
      return o.forEach((v) => {
        if (l.length + v.length + (l.length ? 1 : 0) <= rn) {
          l.length > 0 && (l += " "), l += v;
          return;
        }
        if (v.length > rn) {
          if (l.length > 0) {
            let c = 0;
            l.length < rn && (l += " ", c = rn - l.length, l += v.slice(0, c)), h.push(l), h.push(v.slice(c)), l = "";
            return;
          }
          h.push(v.slice(0, rn)), l = v.slice(rn);
          return;
        }
        h.push(l), l = v;
      }), l.length > 0 && h.push(l), h.length > 2 ? [h[0], h.slice(1).join(" ")] : h;
    });
    return (i, a) => ($(), q("div", {
      class: xe(t.value)
    }, [
      e.variant === "price-tag" ? ($(), q("svg", s0, [...a[0] || (a[0] = [
        ee("path", {
          d: "M20.4593 2C20.4593 0.895431 19.5638 0 18.4593 0H16.9403C16.602 0 16.2693 0.0858105 15.9732 0.249404L1.49209 8.24989C0.854856 8.60195 0.459259 9.27247 0.459259 10.0005V21.9995C0.459259 22.7275 0.854856 23.398 1.49209 23.7501L15.9732 31.7506C16.2693 31.9142 16.602 32 16.9403 32H18.4593C19.5638 32 20.4593 31.1046 20.4593 30V2Z",
          fill: "currentColor"
        }, null, -1)
      ])])) : de("", !0),
      r.value ? ($(), q("img", {
        key: 1,
        alt: "",
        height: "24",
        src: r.value,
        width: "24"
      }, null, 8, u0)) : de("", !0),
      e.variant !== "new" ? ($(), q("span", c0, De(s.value.join(`
`)), 1)) : ($(), q("img", {
        key: 3,
        alt: "New",
        height: "48",
        src: U(i0),
        width: "48"
      }, null, 8, d0)),
      e.variant !== "new" && e.variant !== "floating" && e.infoHeadline && e.infoText ? ($(), ke(U(Wo), {
        key: 4,
        headline: e.infoHeadline,
        "open-button-aria-label": `${U(We).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : de("", !0)
    ], 2));
  }
}), bg = ["fire", "lightning", "money", "star"], pg = [
  "fire",
  "floating",
  "new",
  "pie",
  "price-tag",
  "star",
  "text"
], yg = ["bottom-m", "bottom-xl", "top-m", "top-xl"], Yo = ["badge", "default", "hero"];
var Xo = /* @__PURE__ */ ((e) => (e.Blue = "#a8e2ff", e.Green = "#84f9c1", e.YellowBright = "#ffec8d", e.YellowDark = "#f2c219", e))(Xo || {});
const m0 = { class: "lc-teaser-hero-badge__text-wrap" }, g0 = /* @__PURE__ */ Ce({
  __name: "LcTeaserHeroBadge",
  props: {
    color: { default: () => Xo.YellowBright },
    infoHeadline: {},
    infoText: {},
    subtitle: {},
    title: {},
    variant: {}
  },
  setup(e) {
    return (t, n) => ($(), q("div", {
      class: xe(["lc-teaser-hero-badge", `lc-teaser-hero-badge--variant-${e.variant}`]),
      style: Ct({
        "--teaser-badge-color": e.color
      })
    }, [
      ee("div", m0, [
        ee("span", null, De(e.title), 1),
        ee("span", null, De(e.subtitle), 1)
      ]),
      e.infoHeadline && e.infoText ? ($(), ke(U(Wo), {
        key: 0,
        headline: e.infoHeadline,
        "open-button-aria-label": `${U(We).lcInfoButton.openButtonAriaLabel} ${e.title}`,
        text: e.infoText
      }, null, 8, ["headline", "open-button-aria-label", "text"])) : de("", !0)
    ], 6));
  }
}), b0 = (e) => !!e.title && !!e.subtitle, p0 = { class: "lc-teaser__background" }, nr = /* @__PURE__ */ Ce({
  __name: "LcTeaser",
  props: {
    bodyClass: {},
    footerClass: {},
    headerClass: {},
    headerTo: {},
    onHeaderClick: { type: Function },
    backgroundPattern: {},
    badge: {},
    variant: { default: "default" }
  },
  setup(e) {
    const t = An(), n = Z(() => [
      ["lc-teaser", `lc-teaser--variant-${e.variant}`],
      {
        [`lc-teaser--background-pattern-${String(e.backgroundPattern)}`]: e.variant === "hero" && !!e.backgroundPattern,
        [`lc-teaser--variant-badge-${String(e.badge?.variant)}`]: !!e.badge,
        "lc-teaser--has-background": !!t.background
      }
    ]);
    return (r, s) => ($(), ke(U(ya), Ae({ headerTo: e.headerTo }, {
      "body-class": ["lc-teaser__body", e.bodyClass],
      class: n.value,
      "footer-class": ["lc-teaser__footer", e.footerClass],
      "header-class": ["lc-teaser__header", e.headerClass],
      radius: "large",
      onHeaderClick: e.onHeaderClick
    }), Xa({
      default: Te(() => [
        me(r.$slots, "default"),
        e.badge ? ($(), q(Ge, { key: 0 }, [
          U(b0)(e.badge) ? ($(), ke(g0, _t(Ae({ key: 0 }, e.badge)), null, 16)) : ($(), ke(v0, _t(Ae({ key: 1 }, e.badge)), null, 16))
        ], 64)) : de("", !0)
      ]),
      _: 2
    }, [
      r.$slots.background ? {
        name: "background",
        fn: Te(() => [
          ee("div", p0, [
            me(r.$slots, "background")
          ])
        ]),
        key: "0"
      } : void 0,
      r.$slots.header ? {
        name: "header",
        fn: Te(() => [
          me(r.$slots, "header")
        ]),
        key: "1"
      } : void 0,
      r.$slots.footer ? {
        name: "footer",
        fn: Te(() => [
          me(r.$slots, "footer")
        ]),
        key: "2"
      } : void 0
    ]), 1040, ["body-class", "class", "footer-class", "header-class", "onHeaderClick"]));
  }
}), y0 = { class: "lc-high-frequency-teaser__background" }, w0 = { class: "lc-high-frequency-teaser__jackpot-section" }, x0 = {
  key: 0,
  class: "lc-high-frequency-teaser__jackpot-headline"
}, k0 = { class: "lc-high-frequency-teaser__button-container" }, S0 = { class: "lc-high-frequency-teaser__button-wrap" }, _0 = { class: "lc-high-frequency-teaser__hint-container" }, C0 = {
  key: 0,
  class: "lc-high-frequency-teaser__hint-text"
}, wg = /* @__PURE__ */ Ce({
  __name: "LcHighFrequencyTeaser",
  props: {
    backgroundPattern: {},
    badge: {},
    headline: {},
    jackpot: {},
    locale: {},
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" },
    ballConfig: {},
    hint: {}
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    An();
    const t = Z(() => [
      "lc-high-frequency-teaser",
      `lc-high-frequency-teaser--variant-${e.variant}`
    ]), n = Z(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (r, s) => ($(), ke(U(nr), Ae({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-high-frequency-teaser__body",
      class: t.value,
      "footer-class": "lc-high-frequency-teaser__footer",
      "header-to": e.primaryButtonProps.to,
      onHeaderClick: e.onTeaserClick
    }), {
      background: Te(() => [
        ee("div", y0, [
          Fe(U(qo), _t(Dt({ ballConfig: e.ballConfig })), null, 16)
        ])
      ]),
      header: Te(() => [
        me(r.$slots, "lottery-logo")
      ]),
      default: Te(() => [
        ee("section", w0, [
          ($(), ke(Pt(n.value), {
            class: "lc-high-frequency-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Te(() => [
              e.headline ? ($(), q("strong", x0, De(e.headline), 1)) : de("", !0),
              Fe(U(jo), Ae(e.jackpot, {
                "no-shadow": "",
                size: "small"
              }), null, 16)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ee("section", k0, [
          ee("div", S0, [
            me(r.$slots, "primary-button", {}, () => [
              Fe(U(Et), Ae(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-high-frequency-teaser__button",
                "no-padding": "",
                onClick: s[0] || (s[0] = (i) => r.$emit("primary-button-click"))
              }), {
                default: Te(() => [
                  wt(De(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])
            ])
          ])
        ]),
        ee("section", _0, [
          e.hint ? ($(), q("p", C0, [
            me(r.$slots, "hint", {}, () => [
              wt(De(e.hint), 1)
            ])
          ])) : de("", !0)
        ])
      ]),
      _: 3
    }, 16, ["class", "header-to", "onHeaderClick"]));
  }
}), E0 = {
  width: "47",
  height: "47",
  viewBox: "0 0 47 47",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, T0 = ["stroke"], A0 = ["stroke"], yl = "lc-high-frequency-teaser-watch-arrows-gradient-1", wl = "lc-high-frequency-teaser-watch-arrows-gradient-2", L0 = /* @__PURE__ */ Ce({
  __name: "ArrowsIcon",
  setup(e) {
    return (t, n) => ($(), q("svg", E0, [
      ee("path", {
        d: "M6.29812 18.431C7.41552 14.3207 9.97378 10.7492 13.5059 8.36858C17.0381 5.98793 21.3086 4.95686 25.5378 5.46358C29.7671 5.9703 33.6731 7.98101 36.5429 11.1287C39.4127 14.2764 41.0549 18.3511 41.1696 22.6091",
        stroke: `url(#${yl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, T0),
      n[2] || (n[2] = ee("path", {
        d: "M38.1073 20.6755L41.1265 22.9697C41.2144 23.0366 41.3399 23.0195 41.4067 22.9315L43.7009 19.9123",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ee("path", {
        d: "M40.5545 28.3175C39.3918 32.4153 36.7942 35.9583 33.236 38.2998C29.6778 40.6413 25.3962 41.6251 21.1727 41.0717C16.9493 40.5183 13.0657 38.4646 10.2309 35.2854C7.39604 32.1062 5.79899 28.0136 5.73126 23.7546",
        stroke: `url(#${wl})`,
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, 8, A0),
      n[3] || (n[3] = ee("path", {
        d: "M8.73274 25.8842L5.71355 23.5899C5.6256 23.5231 5.50013 23.5402 5.4333 23.6282L3.1391 26.6474",
        stroke: "var(--arrows-icon-color, white)",
        "stroke-width": "1.6",
        "stroke-linecap": "round"
      }, null, -1)),
      ee("defs", null, [
        ee("linearGradient", {
          id: yl,
          x1: "35.7167",
          y1: "6.28729",
          x2: "7.80661",
          y2: "13.8312",
          gradientUnits: "userSpaceOnUse"
        }, [...n[0] || (n[0] = [
          ee("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ee("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])]),
        ee("linearGradient", {
          id: wl,
          x1: "11.0036",
          y1: "40.1356",
          x2: "38.9953",
          y2: "32.9005",
          gradientUnits: "userSpaceOnUse"
        }, [...n[1] || (n[1] = [
          ee("stop", { "stop-color": "var(--arrows-icon-color, white)" }, null, -1),
          ee("stop", {
            offset: "1",
            "stop-color": "var(--arrows-icon-color-fade, #0F133C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), $0 = {}, I0 = {
  viewBox: "0 0 45 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
};
function D0(e, t) {
  return $(), q("svg", I0, [...t[0] || (t[0] = [
    Ns('<path class="star star-1" fill-rule="evenodd" clip-rule="evenodd" d="M5.25845 10.7151C4.91385 10.5772 4.91385 10.0894 5.25845 9.95156C6.48681 9.46014 7.46014 8.48681 7.95157 7.25845C8.08943 6.91385 8.57723 6.91385 8.7151 7.25845C9.20653 8.48681 10.1799 9.46014 11.4082 9.95156C11.7528 10.0894 11.7528 10.5772 11.4082 10.7151C10.1799 11.2065 9.20653 12.1798 8.7151 13.4082C8.57723 13.7528 8.08943 13.7528 7.95157 13.4082C7.46014 12.1798 6.48681 11.2065 5.25845 10.7151Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-2" fill-rule="evenodd" clip-rule="evenodd" d="M0.155071 19.2291C-0.0516903 19.1463 -0.0516903 18.8537 0.155071 18.7709C0.892087 18.4761 1.47608 17.8921 1.77094 17.1551C1.85366 16.9483 2.14634 16.9483 2.22906 17.1551C2.52392 17.8921 3.10791 18.4761 3.84493 18.7709C4.05169 18.8537 4.05169 19.1463 3.84493 19.2291C3.10791 19.5239 2.52392 20.1079 2.22906 20.8449C2.14634 21.0517 1.85366 21.0517 1.77094 20.8449C1.47608 20.1079 0.892087 19.5239 0.155071 19.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-3" fill-rule="evenodd" clip-rule="evenodd" d="M41.1551 18.2291C40.9483 18.1463 40.9483 17.8537 41.1551 17.7709C41.8921 17.4761 42.4761 16.8921 42.7709 16.1551C42.8537 15.9483 43.1463 15.9483 43.2291 16.1551C43.5239 16.8921 44.1079 17.4761 44.8449 17.7709C45.0517 17.8537 45.0517 18.1463 44.8449 18.2291C44.1079 18.5239 43.5239 19.1079 43.2291 19.8449C43.1463 20.0517 42.8537 20.0517 42.7709 19.8449C42.4761 19.1079 41.8921 18.5239 41.1551 18.2291Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-4" fill-rule="evenodd" clip-rule="evenodd" d="M32.2068 21.9721C31.9311 21.8618 31.9311 21.4715 32.2068 21.3613C33.1894 20.9681 33.9681 20.1894 34.3613 19.2068C34.4715 18.9311 34.8618 18.9311 34.9721 19.2068C35.3652 20.1894 36.1439 20.9681 37.1266 21.3613C37.4023 21.4715 37.4023 21.8618 37.1266 21.9721C36.1439 22.3652 35.3652 23.1439 34.9721 24.1266C34.8618 24.4022 34.4715 24.4022 34.3613 24.1266C33.9681 23.1439 33.1894 22.3652 32.2068 21.9721Z" fill="currentColor" data-v-0c679bcf></path><path class="star star-5" fill-rule="evenodd" clip-rule="evenodd" d="M31.2068 2.97208C30.9311 2.86179 30.9311 2.47154 31.2068 2.36125C32.1894 1.96811 32.9681 1.18945 33.3613 0.206761C33.4715 -0.0689204 33.8618 -0.0689204 33.9721 0.206761C34.3652 1.18945 35.1439 1.96811 36.1266 2.36125C36.4023 2.47154 36.4023 2.86179 36.1266 2.97208C35.1439 3.36522 34.3652 4.14388 33.9721 5.12657C33.8618 5.40225 33.4715 5.40225 33.3613 5.12657C32.9681 4.14388 32.1894 3.36522 31.2068 2.97208Z" fill="currentColor" data-v-0c679bcf></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.2651 4.74748C19.6333 4.10999 20.4491 3.89126 21.0867 4.2592L32.6479 10.935C33.2856 11.3032 33.5044 12.1189 33.1362 12.7566C32.7679 13.3941 31.9522 13.6129 31.3146 13.2449L31.144 13.1459L30.5047 14.2553C29.6757 15.6906 28.226 16.6584 26.5828 16.8751L24.0815 17.2045L25.0464 19.5352C25.6807 21.067 25.5666 22.8078 24.7378 24.2436L24.101 25.3464L24.2469 25.4311C24.8843 25.7994 25.102 26.6151 24.7339 27.2527C24.3657 27.89 23.5511 28.1087 22.9135 27.741L11.351 21.0652C10.7137 20.6969 10.496 19.8811 10.8641 19.2436C11.2324 18.6065 12.0469 18.3886 12.6844 18.7566L12.8354 18.8438L13.4734 17.7397C14.3024 16.3041 15.7518 15.3352 17.3953 15.1186L19.8966 14.7878L18.9318 12.4571C18.2977 10.9256 18.4117 9.18694 19.2404 7.75138L19.8797 6.64201L19.7534 6.56909C19.1157 6.20089 18.8969 5.38518 19.2651 4.74748ZM17.7443 17.7618C16.9225 17.87 16.1965 18.3552 15.782 19.073L15.1492 20.1694L21.7951 24.0066L22.4292 22.9102C22.8434 22.1925 22.901 21.3218 22.5841 20.5561L21.2365 17.3009L17.7443 17.7618ZM21.549 9.08472C21.135 9.80227 21.0773 10.6721 21.394 11.4376L22.7417 14.6928L26.2339 14.2319C27.0556 14.1236 27.7816 13.6396 28.1961 12.922L28.8289 11.8243L22.1831 7.98706L21.549 9.08472Z" fill="currentColor" data-v-0c679bcf></path>', 6)
  ])]);
}
const M0 = /* @__PURE__ */ ci($0, [["render", D0], ["__scopeId", "data-v-0c679bcf"]]), R0 = {
  width: "48",
  height: "54",
  viewBox: "16 6 48 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true"
}, O0 = ["fill"], xl = "lc-high-frequency-teaser-watch-play-button-gradient", F0 = /* @__PURE__ */ Ce({
  __name: "PlayButtonIcon",
  setup(e) {
    return (t, n) => ($(), q("svg", R0, [
      n[1] || (n[1] = ee("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        transform: "translate(2.4, 2.4)",
        fill: "var(--play-button-icon-shadow-color, #D3A700)"
      }, null, -1)),
      ee("path", {
        d: "M59.3284 29.7494C61.5573 31.0562 61.5573 34.323 59.3284 35.6297L23.015 56.9192C20.7861 58.2259 18 56.5925 18 53.9791L18 11.4C18 8.78658 20.7861 7.15318 23.015 8.45991L59.3284 29.7494Z",
        fill: `url(#${xl})`
      }, null, 8, O0),
      ee("defs", null, [
        ee("radialGradient", {
          id: xl,
          cx: "0",
          cy: "0",
          r: "1",
          gradientUnits: "userSpaceOnUse",
          gradientTransform: "translate(30.339 18.8727) rotate(103.105) scale(31.1141 42.8816)"
        }, [...n[0] || (n[0] = [
          ee("stop", { "stop-color": "var(--play-button-icon-color-start, #FFF5C9)" }, null, -1),
          ee("stop", {
            offset: "1",
            "stop-color": "var(--play-button-icon-color-end, #FBCD0C)"
          }, null, -1)
        ])])
      ])
    ]));
  }
}), ea = {
  SPIN_DELAY: 50,
  PAUSE_DELAY: 2550,
  LABEL_DELAY: 3350,
  IDLE_DELAY: 13350,
  IDLE_SPIN_INTERVAL: 1e4
}, N0 = { class: "lc-high-frequency-teaser-watch__background-wrapper" }, B0 = { class: "lc-high-frequency-teaser-watch__header-wrapper" }, P0 = { class: "lc-high-frequency-teaser-watch__game-badge" }, z0 = { class: "lc-high-frequency-teaser-watch__game-label" }, V0 = { class: "lc-high-frequency-teaser-watch__game-number" }, H0 = { class: "lc-high-frequency-teaser-watch__game-icon" }, U0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__pause-icon"
}, q0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__icon-area"
}, j0 = { class: "lc-high-frequency-teaser-watch__timer-value" }, Z0 = { class: "lc-high-frequency-teaser-watch__timer-unit" }, W0 = {
  key: 0,
  class: "lc-high-frequency-teaser-watch__new-game-label"
}, Y0 = { class: "lc-high-frequency-teaser-watch__main" }, X0 = { class: "lc-high-frequency-teaser-watch__title" }, xg = /* @__PURE__ */ Ce({
  __name: "LcHighFrequencyTeaserWatch",
  props: {
    ballConfig: {},
    gameLabel: {},
    gameNumber: {},
    timerValueLabel: {},
    timerUnitLabel: {},
    isOperational: { type: Boolean, default: !0 },
    title: {},
    to: {}
  },
  setup(e) {
    const t = we("idle"), n = we(e.gameNumber), r = we(!1), s = we(0), i = Z(() => e.to ? Yn(e.to) : "div"), a = Z(() => String(n.value).split("")), o = Z(() => t.value === "spinning"), l = Z(() => t.value === "idle" || o.value), h = Z(() => ({
      "lc-high-frequency-teaser-watch__timer-icon--spinning": o.value
    })), v = Z(() => ({
      "lc-high-frequency-teaser-watch__timer-text--hidden": o.value
    })), c = Z(() => ({
      "lc-high-frequency-teaser-watch__arrows--spinning": o.value,
      "lc-high-frequency-teaser-watch__arrows--idle-spin": s.value > 0 && t.value === "idle"
    })), f = Z(() => ({
      "lc-high-frequency-teaser-watch__play-button--heartbeat": r.value
    })), { pause: m, resume: u } = Js(
      () => {
        t.value === "idle" && e.isOperational && s.value++;
      },
      ea.IDLE_SPIN_INTERVAL,
      { immediate: e.isOperational }
    ), { start: p, stop: S } = ta(
      () => {
        t.value = "spinning";
      },
      ea.SPIN_DELAY,
      { immediate: !1 }
    ), { start: g, stop: b } = ta(
      () => t.value = "paused",
      ea.PAUSE_DELAY,
      { immediate: !1 }
    ), _ = we(e.gameNumber), { start: T, stop: I } = ta(
      () => {
        t.value = "label", n.value = _.value, r.value = !1, requestAnimationFrame(() => {
          r.value = !0;
        });
      },
      ea.LABEL_DELAY,
      { immediate: !1 }
    ), { start: L, stop: C } = ta(
      () => {
        t.value = "idle", r.value = !1, u();
      },
      ea.IDLE_DELAY,
      { immediate: !1 }
    ), F = () => {
      S(), b(), I(), C();
    };
    return Ve(
      () => e.isOperational,
      (z) => {
        z ? u() : (F(), m(), t.value = "idle", r.value = !1);
      }
    ), Ve(
      () => e.gameNumber,
      (z, X) => {
        if (z === X || !e.isOperational) {
          n.value = z;
          return;
        }
        F(), m(), _.value = z, t.value = "idle", p(), g(), T(), L();
      }
    ), (z, X) => ($(), ke(Pt(i.value), _t(Dt({ to: e.to })), {
      default: Te(() => [
        Fe(U(nr), {
          class: "lc-high-frequency-teaser-watch",
          "body-class": "lc-high-frequency-teaser-watch__body",
          "footer-class": "lc-high-frequency-teaser-watch__footer"
        }, {
          background: Te(() => [
            ee("div", N0, [
              Fe(U(qo), Ae({
                class: "lc-high-frequency-teaser-watch__background",
                "gradient-class": "lc-high-frequency-teaser-watch__gradient"
              }, { ballConfig: e.ballConfig }), null, 16)
            ])
          ]),
          header: Te(() => [
            ee("div", B0, [
              ee("div", P0, [
                ee("span", z0, De(e.gameLabel), 1),
                ee("span", V0, [
                  ($(!0), q(Ge, null, vt(a.value, (O, G) => ($(), q("span", {
                    key: `pos-${G}`,
                    class: "lc-high-frequency-teaser-watch__digit-slot"
                  }, [
                    Fe(Bs, { name: "lc-high-frequency-teaser-watch-digit" }, {
                      default: Te(() => [
                        ($(), q("span", {
                          key: O,
                          class: "lc-high-frequency-teaser-watch__digit",
                          style: Ct({ transitionDelay: `${G * 35}ms` })
                        }, De(O), 5))
                      ]),
                      _: 2
                    }, 1024)
                  ]))), 128))
                ])
              ]),
              ee("div", H0, [
                Fe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                  default: Te(() => [
                    e.isOperational ? de("", !0) : ($(), q("div", U0, [
                      Fe(M0)
                    ]))
                  ]),
                  _: 1
                }),
                e.isOperational ? ($(), q("div", q0, [
                  Fe(wn, { name: "lc-high-frequency-teaser-watch-fade" }, {
                    default: Te(() => [
                      l.value ? ($(), q("div", {
                        key: 0,
                        class: xe(["lc-high-frequency-teaser-watch__timer-icon", h.value])
                      }, [
                        ee("span", {
                          class: xe(["lc-high-frequency-teaser-watch__timer-text", v.value])
                        }, [
                          ee("span", j0, De(e.timerValueLabel), 1),
                          ee("span", Z0, De(e.timerUnitLabel), 1)
                        ], 2),
                        ($(), q("div", {
                          key: `arrows-${s.value}`,
                          class: xe(["lc-high-frequency-teaser-watch__arrows", c.value])
                        }, [
                          Fe(L0)
                        ], 2))
                      ], 2)) : de("", !0)
                    ]),
                    _: 1
                  }),
                  Fe(wn, { name: "lc-high-frequency-teaser-watch-label" }, {
                    default: Te(() => [
                      t.value === "label" ? ($(), q("div", W0, [
                        me(z.$slots, "new-game-label")
                      ])) : de("", !0)
                    ]),
                    _: 3
                  })
                ])) : de("", !0)
              ])
            ])
          ]),
          footer: Te(() => [
            me(z.$slots, "message")
          ]),
          default: Te(() => [
            ee("div", Y0, [
              ee("div", {
                class: xe(["lc-high-frequency-teaser-watch__play-button", f.value])
              }, [
                Fe(F0)
              ], 2),
              ee("span", X0, De(e.title), 1)
            ])
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 16));
  }
});
var Bn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", G0 = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Ia = 0; Ia < Bn.length; Ia++)
  G0[Bn.charCodeAt(Ia)] = Ia;
var K0 = function(e) {
  var t = new Uint8Array(e), n, r = t.length, s = "";
  for (n = 0; n < r; n += 3)
    s += Bn[t[n] >> 2], s += Bn[(t[n] & 3) << 4 | t[n + 1] >> 4], s += Bn[(t[n + 1] & 15) << 2 | t[n + 2] >> 6], s += Bn[t[n + 2] & 63];
  return r % 3 === 2 ? s = s.substring(0, s.length - 1) + "=" : r % 3 === 1 && (s = s.substring(0, s.length - 2) + "=="), s;
}, J0 = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], aa = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], s = J0.indexOf(r);
    t = t * 83 + s;
  }
  return t;
}, xr = (e) => {
  let t = e / 255;
  return t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
}, kr = (e) => {
  let t = Math.max(0, Math.min(1, e));
  return t <= 31308e-7 ? Math.trunc(t * 12.92 * 255 + 0.5) : Math.trunc((1.055 * Math.pow(t, 0.4166666666666667) - 0.055) * 255 + 0.5);
}, Q0 = (e) => e < 0 ? -1 : 1, Sr = (e, t) => Q0(e) * Math.pow(Math.abs(e), t), kl = class extends Error {
  constructor(t) {
    super(t), this.name = "ValidationError", this.message = t;
  }
}, eh = (e) => {
  if (!e || e.length < 6) throw new kl("The blurhash string must be at least 6 characters");
  let t = aa(e[0]), n = Math.floor(t / 9) + 1, r = t % 9 + 1;
  if (e.length !== 4 + 2 * r * n) throw new kl(`blurhash length mismatch: length is ${e.length} but it should be ${4 + 2 * r * n}`);
}, th = (e) => {
  let t = e >> 16, n = e >> 8 & 255, r = e & 255;
  return [xr(t), xr(n), xr(r)];
}, nh = (e, t) => {
  let n = Math.floor(e / 361), r = Math.floor(e / 19) % 19, s = e % 19;
  return [Sr((n - 9) / 9, 2) * t, Sr((r - 9) / 9, 2) * t, Sr((s - 9) / 9, 2) * t];
}, ah = (e, t, n, r) => {
  eh(e), r = r | 1;
  let s = aa(e[0]), i = Math.floor(s / 9) + 1, a = s % 9 + 1, o = (aa(e[1]) + 1) / 166, l = new Array(a * i);
  for (let c = 0; c < l.length; c++) if (c === 0) {
    let f = aa(e.substring(2, 6));
    l[c] = th(f);
  } else {
    let f = aa(e.substring(4 + c * 2, 6 + c * 2));
    l[c] = nh(f, o * r);
  }
  let h = t * 4, v = new Uint8ClampedArray(h * n);
  for (let c = 0; c < n; c++) for (let f = 0; f < t; f++) {
    let m = 0, u = 0, p = 0;
    for (let _ = 0; _ < i; _++) for (let T = 0; T < a; T++) {
      let I = Math.cos(Math.PI * f * T / t) * Math.cos(Math.PI * c * _ / n), L = l[T + _ * a];
      m += L[0] * I, u += L[1] * I, p += L[2] * I;
    }
    let S = kr(m), g = kr(u), b = kr(p);
    v[4 * f + 0 + c * h] = S, v[4 * f + 1 + c * h] = g, v[4 * f + 2 + c * h] = b, v[4 * f + 3 + c * h] = 255;
  }
  return v;
}, rh = ah;
function ih(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function lh(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var _r = { exports: {} }, Cr = {}, Sl;
function cn() {
  return Sl || (Sl = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function n(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var o = a.shift();
        if (o) {
          if (typeof o != "object")
            throw new TypeError(o + "must be non-object");
          for (var l in o)
            n(o, l) && (i[l] = o[l]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var r = {
      arraySet: function(i, a, o, l, h) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(o, o + l), h);
          return;
        }
        for (var v = 0; v < l; v++)
          i[h + v] = a[o + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, o, l, h, v, c;
        for (l = 0, a = 0, o = i.length; a < o; a++)
          l += i[a].length;
        for (c = new Uint8Array(l), h = 0, a = 0, o = i.length; a < o; a++)
          v = i[a], c.set(v, h), h += v.length;
        return c;
      }
    }, s = {
      arraySet: function(i, a, o, l, h) {
        for (var v = 0; v < l; v++)
          i[h + v] = a[o + v];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, r)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, s));
    }, e.setTyped(t);
  })(Cr)), Cr;
}
var On = {}, Vt = {}, mn = {}, _l;
function oh() {
  if (_l) return mn;
  _l = 1;
  var e = cn(), t = 4, n = 0, r = 1, s = 2;
  function i(w) {
    for (var Y = w.length; --Y >= 0; )
      w[Y] = 0;
  }
  var a = 0, o = 1, l = 2, h = 3, v = 258, c = 29, f = 256, m = f + 1 + c, u = 30, p = 19, S = 2 * m + 1, g = 15, b = 16, _ = 7, T = 256, I = 16, L = 17, C = 18, F = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), z = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), X = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), O = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], G = 512, P = new Array((m + 2) * 2);
  i(P);
  var E = new Array(u * 2);
  i(E);
  var A = new Array(G);
  i(A);
  var V = new Array(v - h + 1);
  i(V);
  var H = new Array(c);
  i(H);
  var K = new Array(u);
  i(K);
  function B(w, Y, W, ce, R) {
    this.static_tree = w, this.extra_bits = Y, this.extra_base = W, this.elems = ce, this.max_length = R, this.has_stree = w && w.length;
  }
  var ae, le, se;
  function be(w, Y) {
    this.dyn_tree = w, this.max_code = 0, this.stat_desc = Y;
  }
  function Me(w) {
    return w < 256 ? A[w] : A[256 + (w >>> 7)];
  }
  function Se(w, Y) {
    w.pending_buf[w.pending++] = Y & 255, w.pending_buf[w.pending++] = Y >>> 8 & 255;
  }
  function te(w, Y, W) {
    w.bi_valid > b - W ? (w.bi_buf |= Y << w.bi_valid & 65535, Se(w, w.bi_buf), w.bi_buf = Y >> b - w.bi_valid, w.bi_valid += W - b) : (w.bi_buf |= Y << w.bi_valid & 65535, w.bi_valid += W);
  }
  function he(w, Y, W) {
    te(
      w,
      W[Y * 2],
      W[Y * 2 + 1]
      /*.Len*/
    );
  }
  function ge(w, Y) {
    var W = 0;
    do
      W |= w & 1, w >>>= 1, W <<= 1;
    while (--Y > 0);
    return W >>> 1;
  }
  function pe(w) {
    w.bi_valid === 16 ? (Se(w, w.bi_buf), w.bi_buf = 0, w.bi_valid = 0) : w.bi_valid >= 8 && (w.pending_buf[w.pending++] = w.bi_buf & 255, w.bi_buf >>= 8, w.bi_valid -= 8);
  }
  function ze(w, Y) {
    var W = Y.dyn_tree, ce = Y.max_code, R = Y.stat_desc.static_tree, re = Y.stat_desc.has_stree, y = Y.stat_desc.extra_bits, fe = Y.stat_desc.extra_base, Ie = Y.stat_desc.max_length, d, ne, Q, x, N, J, Re = 0;
    for (x = 0; x <= g; x++)
      w.bl_count[x] = 0;
    for (W[w.heap[w.heap_max] * 2 + 1] = 0, d = w.heap_max + 1; d < S; d++)
      ne = w.heap[d], x = W[W[ne * 2 + 1] * 2 + 1] + 1, x > Ie && (x = Ie, Re++), W[ne * 2 + 1] = x, !(ne > ce) && (w.bl_count[x]++, N = 0, ne >= fe && (N = y[ne - fe]), J = W[ne * 2], w.opt_len += J * (x + N), re && (w.static_len += J * (R[ne * 2 + 1] + N)));
    if (Re !== 0) {
      do {
        for (x = Ie - 1; w.bl_count[x] === 0; )
          x--;
        w.bl_count[x]--, w.bl_count[x + 1] += 2, w.bl_count[Ie]--, Re -= 2;
      } while (Re > 0);
      for (x = Ie; x !== 0; x--)
        for (ne = w.bl_count[x]; ne !== 0; )
          Q = w.heap[--d], !(Q > ce) && (W[Q * 2 + 1] !== x && (w.opt_len += (x - W[Q * 2 + 1]) * W[Q * 2], W[Q * 2 + 1] = x), ne--);
    }
  }
  function ue(w, Y, W) {
    var ce = new Array(g + 1), R = 0, re, y;
    for (re = 1; re <= g; re++)
      ce[re] = R = R + W[re - 1] << 1;
    for (y = 0; y <= Y; y++) {
      var fe = w[y * 2 + 1];
      fe !== 0 && (w[y * 2] = ge(ce[fe]++, fe));
    }
  }
  function oe() {
    var w, Y, W, ce, R, re = new Array(g + 1);
    for (W = 0, ce = 0; ce < c - 1; ce++)
      for (H[ce] = W, w = 0; w < 1 << F[ce]; w++)
        V[W++] = ce;
    for (V[W - 1] = ce, R = 0, ce = 0; ce < 16; ce++)
      for (K[ce] = R, w = 0; w < 1 << z[ce]; w++)
        A[R++] = ce;
    for (R >>= 7; ce < u; ce++)
      for (K[ce] = R << 7, w = 0; w < 1 << z[ce] - 7; w++)
        A[256 + R++] = ce;
    for (Y = 0; Y <= g; Y++)
      re[Y] = 0;
    for (w = 0; w <= 143; )
      P[w * 2 + 1] = 8, w++, re[8]++;
    for (; w <= 255; )
      P[w * 2 + 1] = 9, w++, re[9]++;
    for (; w <= 279; )
      P[w * 2 + 1] = 7, w++, re[7]++;
    for (; w <= 287; )
      P[w * 2 + 1] = 8, w++, re[8]++;
    for (ue(P, m + 1, re), w = 0; w < u; w++)
      E[w * 2 + 1] = 5, E[w * 2] = ge(w, 5);
    ae = new B(P, F, f + 1, m, g), le = new B(E, z, 0, u, g), se = new B(new Array(0), X, 0, p, _);
  }
  function ye(w) {
    var Y;
    for (Y = 0; Y < m; Y++)
      w.dyn_ltree[Y * 2] = 0;
    for (Y = 0; Y < u; Y++)
      w.dyn_dtree[Y * 2] = 0;
    for (Y = 0; Y < p; Y++)
      w.bl_tree[Y * 2] = 0;
    w.dyn_ltree[T * 2] = 1, w.opt_len = w.static_len = 0, w.last_lit = w.matches = 0;
  }
  function Pe(w) {
    w.bi_valid > 8 ? Se(w, w.bi_buf) : w.bi_valid > 0 && (w.pending_buf[w.pending++] = w.bi_buf), w.bi_buf = 0, w.bi_valid = 0;
  }
  function Ue(w, Y, W, ce) {
    Pe(w), Se(w, W), Se(w, ~W), e.arraySet(w.pending_buf, w.window, Y, W, w.pending), w.pending += W;
  }
  function qe(w, Y, W, ce) {
    var R = Y * 2, re = W * 2;
    return w[R] < w[re] || w[R] === w[re] && ce[Y] <= ce[W];
  }
  function Be(w, Y, W) {
    for (var ce = w.heap[W], R = W << 1; R <= w.heap_len && (R < w.heap_len && qe(Y, w.heap[R + 1], w.heap[R], w.depth) && R++, !qe(Y, ce, w.heap[R], w.depth)); )
      w.heap[W] = w.heap[R], W = R, R <<= 1;
    w.heap[W] = ce;
  }
  function Ne(w, Y, W) {
    var ce, R, re = 0, y, fe;
    if (w.last_lit !== 0)
      do
        ce = w.pending_buf[w.d_buf + re * 2] << 8 | w.pending_buf[w.d_buf + re * 2 + 1], R = w.pending_buf[w.l_buf + re], re++, ce === 0 ? he(w, R, Y) : (y = V[R], he(w, y + f + 1, Y), fe = F[y], fe !== 0 && (R -= H[y], te(w, R, fe)), ce--, y = Me(ce), he(w, y, W), fe = z[y], fe !== 0 && (ce -= K[y], te(w, ce, fe)));
      while (re < w.last_lit);
    he(w, T, Y);
  }
  function Xe(w, Y) {
    var W = Y.dyn_tree, ce = Y.stat_desc.static_tree, R = Y.stat_desc.has_stree, re = Y.stat_desc.elems, y, fe, Ie = -1, d;
    for (w.heap_len = 0, w.heap_max = S, y = 0; y < re; y++)
      W[y * 2] !== 0 ? (w.heap[++w.heap_len] = Ie = y, w.depth[y] = 0) : W[y * 2 + 1] = 0;
    for (; w.heap_len < 2; )
      d = w.heap[++w.heap_len] = Ie < 2 ? ++Ie : 0, W[d * 2] = 1, w.depth[d] = 0, w.opt_len--, R && (w.static_len -= ce[d * 2 + 1]);
    for (Y.max_code = Ie, y = w.heap_len >> 1; y >= 1; y--)
      Be(w, W, y);
    d = re;
    do
      y = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[
        1
        /*SMALLEST*/
      ] = w.heap[w.heap_len--], Be(
        w,
        W,
        1
        /*SMALLEST*/
      ), fe = w.heap[
        1
        /*SMALLEST*/
      ], w.heap[--w.heap_max] = y, w.heap[--w.heap_max] = fe, W[d * 2] = W[y * 2] + W[fe * 2], w.depth[d] = (w.depth[y] >= w.depth[fe] ? w.depth[y] : w.depth[fe]) + 1, W[y * 2 + 1] = W[fe * 2 + 1] = d, w.heap[
        1
        /*SMALLEST*/
      ] = d++, Be(
        w,
        W,
        1
        /*SMALLEST*/
      );
    while (w.heap_len >= 2);
    w.heap[--w.heap_max] = w.heap[
      1
      /*SMALLEST*/
    ], ze(w, Y), ue(W, Ie, w.bl_count);
  }
  function ut(w, Y, W) {
    var ce, R = -1, re, y = Y[1], fe = 0, Ie = 7, d = 4;
    for (y === 0 && (Ie = 138, d = 3), Y[(W + 1) * 2 + 1] = 65535, ce = 0; ce <= W; ce++)
      re = y, y = Y[(ce + 1) * 2 + 1], !(++fe < Ie && re === y) && (fe < d ? w.bl_tree[re * 2] += fe : re !== 0 ? (re !== R && w.bl_tree[re * 2]++, w.bl_tree[I * 2]++) : fe <= 10 ? w.bl_tree[L * 2]++ : w.bl_tree[C * 2]++, fe = 0, R = re, y === 0 ? (Ie = 138, d = 3) : re === y ? (Ie = 6, d = 3) : (Ie = 7, d = 4));
  }
  function gt(w, Y, W) {
    var ce, R = -1, re, y = Y[1], fe = 0, Ie = 7, d = 4;
    for (y === 0 && (Ie = 138, d = 3), ce = 0; ce <= W; ce++)
      if (re = y, y = Y[(ce + 1) * 2 + 1], !(++fe < Ie && re === y)) {
        if (fe < d)
          do
            he(w, re, w.bl_tree);
          while (--fe !== 0);
        else re !== 0 ? (re !== R && (he(w, re, w.bl_tree), fe--), he(w, I, w.bl_tree), te(w, fe - 3, 2)) : fe <= 10 ? (he(w, L, w.bl_tree), te(w, fe - 3, 3)) : (he(w, C, w.bl_tree), te(w, fe - 11, 7));
        fe = 0, R = re, y === 0 ? (Ie = 138, d = 3) : re === y ? (Ie = 6, d = 3) : (Ie = 7, d = 4);
      }
  }
  function bt(w) {
    var Y;
    for (ut(w, w.dyn_ltree, w.l_desc.max_code), ut(w, w.dyn_dtree, w.d_desc.max_code), Xe(w, w.bl_desc), Y = p - 1; Y >= 3 && w.bl_tree[O[Y] * 2 + 1] === 0; Y--)
      ;
    return w.opt_len += 3 * (Y + 1) + 5 + 5 + 4, Y;
  }
  function Ft(w, Y, W, ce) {
    var R;
    for (te(w, Y - 257, 5), te(w, W - 1, 5), te(w, ce - 4, 4), R = 0; R < ce; R++)
      te(w, w.bl_tree[O[R] * 2 + 1], 3);
    gt(w, w.dyn_ltree, Y - 1), gt(w, w.dyn_dtree, W - 1);
  }
  function Rt(w) {
    var Y = 4093624447, W;
    for (W = 0; W <= 31; W++, Y >>>= 1)
      if (Y & 1 && w.dyn_ltree[W * 2] !== 0)
        return n;
    if (w.dyn_ltree[18] !== 0 || w.dyn_ltree[20] !== 0 || w.dyn_ltree[26] !== 0)
      return r;
    for (W = 32; W < f; W++)
      if (w.dyn_ltree[W * 2] !== 0)
        return r;
    return n;
  }
  var xt = !1;
  function jt(w) {
    xt || (oe(), xt = !0), w.l_desc = new be(w.dyn_ltree, ae), w.d_desc = new be(w.dyn_dtree, le), w.bl_desc = new be(w.bl_tree, se), w.bi_buf = 0, w.bi_valid = 0, ye(w);
  }
  function $t(w, Y, W, ce) {
    te(w, (a << 1) + (ce ? 1 : 0), 3), Ue(w, Y, W);
  }
  function ct(w) {
    te(w, o << 1, 3), he(w, T, P), pe(w);
  }
  function D(w, Y, W, ce) {
    var R, re, y = 0;
    w.level > 0 ? (w.strm.data_type === s && (w.strm.data_type = Rt(w)), Xe(w, w.l_desc), Xe(w, w.d_desc), y = bt(w), R = w.opt_len + 3 + 7 >>> 3, re = w.static_len + 3 + 7 >>> 3, re <= R && (R = re)) : R = re = W + 5, W + 4 <= R && Y !== -1 ? $t(w, Y, W, ce) : w.strategy === t || re === R ? (te(w, (o << 1) + (ce ? 1 : 0), 3), Ne(w, P, E)) : (te(w, (l << 1) + (ce ? 1 : 0), 3), Ft(w, w.l_desc.max_code + 1, w.d_desc.max_code + 1, y + 1), Ne(w, w.dyn_ltree, w.dyn_dtree)), ye(w), ce && Pe(w);
  }
  function k(w, Y, W) {
    return w.pending_buf[w.d_buf + w.last_lit * 2] = Y >>> 8 & 255, w.pending_buf[w.d_buf + w.last_lit * 2 + 1] = Y & 255, w.pending_buf[w.l_buf + w.last_lit] = W & 255, w.last_lit++, Y === 0 ? w.dyn_ltree[W * 2]++ : (w.matches++, Y--, w.dyn_ltree[(V[W] + f + 1) * 2]++, w.dyn_dtree[Me(Y) * 2]++), w.last_lit === w.lit_bufsize - 1;
  }
  return mn._tr_init = jt, mn._tr_stored_block = $t, mn._tr_flush_block = D, mn._tr_tally = k, mn._tr_align = ct, mn;
}
var Er, Cl;
function Go() {
  if (Cl) return Er;
  Cl = 1;
  function e(t, n, r, s) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, o = 0; r !== 0; ) {
      o = r > 2e3 ? 2e3 : r, r -= o;
      do
        i = i + n[s++] | 0, a = a + i | 0;
      while (--o);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return Er = e, Er;
}
var Tr, El;
function Ko() {
  if (El) return Tr;
  El = 1;
  function e() {
    for (var r, s = [], i = 0; i < 256; i++) {
      r = i;
      for (var a = 0; a < 8; a++)
        r = r & 1 ? 3988292384 ^ r >>> 1 : r >>> 1;
      s[i] = r;
    }
    return s;
  }
  var t = e();
  function n(r, s, i, a) {
    var o = t, l = a + i;
    r ^= -1;
    for (var h = a; h < l; h++)
      r = r >>> 8 ^ o[(r ^ s[h]) & 255];
    return r ^ -1;
  }
  return Tr = n, Tr;
}
var Ar, Tl;
function gi() {
  return Tl || (Tl = 1, Ar = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), Ar;
}
var Al;
function sh() {
  if (Al) return Vt;
  Al = 1;
  var e = cn(), t = oh(), n = Go(), r = Ko(), s = gi(), i = 0, a = 1, o = 3, l = 4, h = 5, v = 0, c = 1, f = -2, m = -3, u = -5, p = -1, S = 1, g = 2, b = 3, _ = 4, T = 0, I = 2, L = 8, C = 9, F = 15, z = 8, X = 29, O = 256, G = O + 1 + X, P = 30, E = 19, A = 2 * G + 1, V = 15, H = 3, K = 258, B = K + H + 1, ae = 32, le = 42, se = 69, be = 73, Me = 91, Se = 103, te = 113, he = 666, ge = 1, pe = 2, ze = 3, ue = 4, oe = 3;
  function ye(d, ne) {
    return d.msg = s[ne], ne;
  }
  function Pe(d) {
    return (d << 1) - (d > 4 ? 9 : 0);
  }
  function Ue(d) {
    for (var ne = d.length; --ne >= 0; )
      d[ne] = 0;
  }
  function qe(d) {
    var ne = d.state, Q = ne.pending;
    Q > d.avail_out && (Q = d.avail_out), Q !== 0 && (e.arraySet(d.output, ne.pending_buf, ne.pending_out, Q, d.next_out), d.next_out += Q, ne.pending_out += Q, d.total_out += Q, d.avail_out -= Q, ne.pending -= Q, ne.pending === 0 && (ne.pending_out = 0));
  }
  function Be(d, ne) {
    t._tr_flush_block(d, d.block_start >= 0 ? d.block_start : -1, d.strstart - d.block_start, ne), d.block_start = d.strstart, qe(d.strm);
  }
  function Ne(d, ne) {
    d.pending_buf[d.pending++] = ne;
  }
  function Xe(d, ne) {
    d.pending_buf[d.pending++] = ne >>> 8 & 255, d.pending_buf[d.pending++] = ne & 255;
  }
  function ut(d, ne, Q, x) {
    var N = d.avail_in;
    return N > x && (N = x), N === 0 ? 0 : (d.avail_in -= N, e.arraySet(ne, d.input, d.next_in, N, Q), d.state.wrap === 1 ? d.adler = n(d.adler, ne, N, Q) : d.state.wrap === 2 && (d.adler = r(d.adler, ne, N, Q)), d.next_in += N, d.total_in += N, N);
  }
  function gt(d, ne) {
    var Q = d.max_chain_length, x = d.strstart, N, J, Re = d.prev_length, _e = d.nice_match, Le = d.strstart > d.w_size - B ? d.strstart - (d.w_size - B) : 0, je = d.window, ft = d.w_mask, et = d.prev, Ze = d.strstart + K, lt = je[x + Re - 1], pt = je[x + Re];
    d.prev_length >= d.good_match && (Q >>= 2), _e > d.lookahead && (_e = d.lookahead);
    do
      if (N = ne, !(je[N + Re] !== pt || je[N + Re - 1] !== lt || je[N] !== je[x] || je[++N] !== je[x + 1])) {
        x += 2, N++;
        do
          ;
        while (je[++x] === je[++N] && je[++x] === je[++N] && je[++x] === je[++N] && je[++x] === je[++N] && je[++x] === je[++N] && je[++x] === je[++N] && je[++x] === je[++N] && je[++x] === je[++N] && x < Ze);
        if (J = K - (Ze - x), x = Ze - K, J > Re) {
          if (d.match_start = ne, Re = J, J >= _e)
            break;
          lt = je[x + Re - 1], pt = je[x + Re];
        }
      }
    while ((ne = et[ne & ft]) > Le && --Q !== 0);
    return Re <= d.lookahead ? Re : d.lookahead;
  }
  function bt(d) {
    var ne = d.w_size, Q, x, N, J, Re;
    do {
      if (J = d.window_size - d.lookahead - d.strstart, d.strstart >= ne + (ne - B)) {
        e.arraySet(d.window, d.window, ne, ne, 0), d.match_start -= ne, d.strstart -= ne, d.block_start -= ne, x = d.hash_size, Q = x;
        do
          N = d.head[--Q], d.head[Q] = N >= ne ? N - ne : 0;
        while (--x);
        x = ne, Q = x;
        do
          N = d.prev[--Q], d.prev[Q] = N >= ne ? N - ne : 0;
        while (--x);
        J += ne;
      }
      if (d.strm.avail_in === 0)
        break;
      if (x = ut(d.strm, d.window, d.strstart + d.lookahead, J), d.lookahead += x, d.lookahead + d.insert >= H)
        for (Re = d.strstart - d.insert, d.ins_h = d.window[Re], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[Re + 1]) & d.hash_mask; d.insert && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[Re + H - 1]) & d.hash_mask, d.prev[Re & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = Re, Re++, d.insert--, !(d.lookahead + d.insert < H)); )
          ;
    } while (d.lookahead < B && d.strm.avail_in !== 0);
  }
  function Ft(d, ne) {
    var Q = 65535;
    for (Q > d.pending_buf_size - 5 && (Q = d.pending_buf_size - 5); ; ) {
      if (d.lookahead <= 1) {
        if (bt(d), d.lookahead === 0 && ne === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      d.strstart += d.lookahead, d.lookahead = 0;
      var x = d.block_start + Q;
      if ((d.strstart === 0 || d.strstart >= x) && (d.lookahead = d.strstart - x, d.strstart = x, Be(d, !1), d.strm.avail_out === 0) || d.strstart - d.block_start >= d.w_size - B && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, ne === l ? (Be(d, !0), d.strm.avail_out === 0 ? ze : ue) : (d.strstart > d.block_start && (Be(d, !1), d.strm.avail_out === 0), ge);
  }
  function Rt(d, ne) {
    for (var Q, x; ; ) {
      if (d.lookahead < B) {
        if (bt(d), d.lookahead < B && ne === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (Q = 0, d.lookahead >= H && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, Q = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), Q !== 0 && d.strstart - Q <= d.w_size - B && (d.match_length = gt(d, Q)), d.match_length >= H)
        if (x = t._tr_tally(d, d.strstart - d.match_start, d.match_length - H), d.lookahead -= d.match_length, d.match_length <= d.max_lazy_match && d.lookahead >= H) {
          d.match_length--;
          do
            d.strstart++, d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, Q = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart;
          while (--d.match_length !== 0);
          d.strstart++;
        } else
          d.strstart += d.match_length, d.match_length = 0, d.ins_h = d.window[d.strstart], d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + 1]) & d.hash_mask;
      else
        x = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++;
      if (x && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = d.strstart < H - 1 ? d.strstart : H - 1, ne === l ? (Be(d, !0), d.strm.avail_out === 0 ? ze : ue) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : pe;
  }
  function xt(d, ne) {
    for (var Q, x, N; ; ) {
      if (d.lookahead < B) {
        if (bt(d), d.lookahead < B && ne === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (Q = 0, d.lookahead >= H && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, Q = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart), d.prev_length = d.match_length, d.prev_match = d.match_start, d.match_length = H - 1, Q !== 0 && d.prev_length < d.max_lazy_match && d.strstart - Q <= d.w_size - B && (d.match_length = gt(d, Q), d.match_length <= 5 && (d.strategy === S || d.match_length === H && d.strstart - d.match_start > 4096) && (d.match_length = H - 1)), d.prev_length >= H && d.match_length <= d.prev_length) {
        N = d.strstart + d.lookahead - H, x = t._tr_tally(d, d.strstart - 1 - d.prev_match, d.prev_length - H), d.lookahead -= d.prev_length - 1, d.prev_length -= 2;
        do
          ++d.strstart <= N && (d.ins_h = (d.ins_h << d.hash_shift ^ d.window[d.strstart + H - 1]) & d.hash_mask, Q = d.prev[d.strstart & d.w_mask] = d.head[d.ins_h], d.head[d.ins_h] = d.strstart);
        while (--d.prev_length !== 0);
        if (d.match_available = 0, d.match_length = H - 1, d.strstart++, x && (Be(d, !1), d.strm.avail_out === 0))
          return ge;
      } else if (d.match_available) {
        if (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), x && Be(d, !1), d.strstart++, d.lookahead--, d.strm.avail_out === 0)
          return ge;
      } else
        d.match_available = 1, d.strstart++, d.lookahead--;
    }
    return d.match_available && (x = t._tr_tally(d, 0, d.window[d.strstart - 1]), d.match_available = 0), d.insert = d.strstart < H - 1 ? d.strstart : H - 1, ne === l ? (Be(d, !0), d.strm.avail_out === 0 ? ze : ue) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : pe;
  }
  function jt(d, ne) {
    for (var Q, x, N, J, Re = d.window; ; ) {
      if (d.lookahead <= K) {
        if (bt(d), d.lookahead <= K && ne === i)
          return ge;
        if (d.lookahead === 0)
          break;
      }
      if (d.match_length = 0, d.lookahead >= H && d.strstart > 0 && (N = d.strstart - 1, x = Re[N], x === Re[++N] && x === Re[++N] && x === Re[++N])) {
        J = d.strstart + K;
        do
          ;
        while (x === Re[++N] && x === Re[++N] && x === Re[++N] && x === Re[++N] && x === Re[++N] && x === Re[++N] && x === Re[++N] && x === Re[++N] && N < J);
        d.match_length = K - (J - N), d.match_length > d.lookahead && (d.match_length = d.lookahead);
      }
      if (d.match_length >= H ? (Q = t._tr_tally(d, 1, d.match_length - H), d.lookahead -= d.match_length, d.strstart += d.match_length, d.match_length = 0) : (Q = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++), Q && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, ne === l ? (Be(d, !0), d.strm.avail_out === 0 ? ze : ue) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : pe;
  }
  function $t(d, ne) {
    for (var Q; ; ) {
      if (d.lookahead === 0 && (bt(d), d.lookahead === 0)) {
        if (ne === i)
          return ge;
        break;
      }
      if (d.match_length = 0, Q = t._tr_tally(d, 0, d.window[d.strstart]), d.lookahead--, d.strstart++, Q && (Be(d, !1), d.strm.avail_out === 0))
        return ge;
    }
    return d.insert = 0, ne === l ? (Be(d, !0), d.strm.avail_out === 0 ? ze : ue) : d.last_lit && (Be(d, !1), d.strm.avail_out === 0) ? ge : pe;
  }
  function ct(d, ne, Q, x, N) {
    this.good_length = d, this.max_lazy = ne, this.nice_length = Q, this.max_chain = x, this.func = N;
  }
  var D;
  D = [
    /*      good lazy nice chain */
    new ct(0, 0, 0, 0, Ft),
    /* 0 store only */
    new ct(4, 4, 8, 4, Rt),
    /* 1 max speed, no lazy matches */
    new ct(4, 5, 16, 8, Rt),
    /* 2 */
    new ct(4, 6, 32, 32, Rt),
    /* 3 */
    new ct(4, 4, 16, 16, xt),
    /* 4 lazy matches */
    new ct(8, 16, 32, 32, xt),
    /* 5 */
    new ct(8, 16, 128, 128, xt),
    /* 6 */
    new ct(8, 32, 128, 256, xt),
    /* 7 */
    new ct(32, 128, 258, 1024, xt),
    /* 8 */
    new ct(32, 258, 258, 4096, xt)
    /* 9 max compression */
  ];
  function k(d) {
    d.window_size = 2 * d.w_size, Ue(d.head), d.max_lazy_match = D[d.level].max_lazy, d.good_match = D[d.level].good_length, d.nice_match = D[d.level].nice_length, d.max_chain_length = D[d.level].max_chain, d.strstart = 0, d.block_start = 0, d.lookahead = 0, d.insert = 0, d.match_length = d.prev_length = H - 1, d.match_available = 0, d.ins_h = 0;
  }
  function w() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = L, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(A * 2), this.dyn_dtree = new e.Buf16((2 * P + 1) * 2), this.bl_tree = new e.Buf16((2 * E + 1) * 2), Ue(this.dyn_ltree), Ue(this.dyn_dtree), Ue(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(V + 1), this.heap = new e.Buf16(2 * G + 1), Ue(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * G + 1), Ue(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function Y(d) {
    var ne;
    return !d || !d.state ? ye(d, f) : (d.total_in = d.total_out = 0, d.data_type = I, ne = d.state, ne.pending = 0, ne.pending_out = 0, ne.wrap < 0 && (ne.wrap = -ne.wrap), ne.status = ne.wrap ? le : te, d.adler = ne.wrap === 2 ? 0 : 1, ne.last_flush = i, t._tr_init(ne), v);
  }
  function W(d) {
    var ne = Y(d);
    return ne === v && k(d.state), ne;
  }
  function ce(d, ne) {
    return !d || !d.state || d.state.wrap !== 2 ? f : (d.state.gzhead = ne, v);
  }
  function R(d, ne, Q, x, N, J) {
    if (!d)
      return f;
    var Re = 1;
    if (ne === p && (ne = 6), x < 0 ? (Re = 0, x = -x) : x > 15 && (Re = 2, x -= 16), N < 1 || N > C || Q !== L || x < 8 || x > 15 || ne < 0 || ne > 9 || J < 0 || J > _)
      return ye(d, f);
    x === 8 && (x = 9);
    var _e = new w();
    return d.state = _e, _e.strm = d, _e.wrap = Re, _e.gzhead = null, _e.w_bits = x, _e.w_size = 1 << _e.w_bits, _e.w_mask = _e.w_size - 1, _e.hash_bits = N + 7, _e.hash_size = 1 << _e.hash_bits, _e.hash_mask = _e.hash_size - 1, _e.hash_shift = ~~((_e.hash_bits + H - 1) / H), _e.window = new e.Buf8(_e.w_size * 2), _e.head = new e.Buf16(_e.hash_size), _e.prev = new e.Buf16(_e.w_size), _e.lit_bufsize = 1 << N + 6, _e.pending_buf_size = _e.lit_bufsize * 4, _e.pending_buf = new e.Buf8(_e.pending_buf_size), _e.d_buf = 1 * _e.lit_bufsize, _e.l_buf = 3 * _e.lit_bufsize, _e.level = ne, _e.strategy = J, _e.method = Q, W(d);
  }
  function re(d, ne) {
    return R(d, ne, L, F, z, T);
  }
  function y(d, ne) {
    var Q, x, N, J;
    if (!d || !d.state || ne > h || ne < 0)
      return d ? ye(d, f) : f;
    if (x = d.state, !d.output || !d.input && d.avail_in !== 0 || x.status === he && ne !== l)
      return ye(d, d.avail_out === 0 ? u : f);
    if (x.strm = d, Q = x.last_flush, x.last_flush = ne, x.status === le)
      if (x.wrap === 2)
        d.adler = 0, Ne(x, 31), Ne(x, 139), Ne(x, 8), x.gzhead ? (Ne(
          x,
          (x.gzhead.text ? 1 : 0) + (x.gzhead.hcrc ? 2 : 0) + (x.gzhead.extra ? 4 : 0) + (x.gzhead.name ? 8 : 0) + (x.gzhead.comment ? 16 : 0)
        ), Ne(x, x.gzhead.time & 255), Ne(x, x.gzhead.time >> 8 & 255), Ne(x, x.gzhead.time >> 16 & 255), Ne(x, x.gzhead.time >> 24 & 255), Ne(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Ne(x, x.gzhead.os & 255), x.gzhead.extra && x.gzhead.extra.length && (Ne(x, x.gzhead.extra.length & 255), Ne(x, x.gzhead.extra.length >> 8 & 255)), x.gzhead.hcrc && (d.adler = r(d.adler, x.pending_buf, x.pending, 0)), x.gzindex = 0, x.status = se) : (Ne(x, 0), Ne(x, 0), Ne(x, 0), Ne(x, 0), Ne(x, 0), Ne(x, x.level === 9 ? 2 : x.strategy >= g || x.level < 2 ? 4 : 0), Ne(x, oe), x.status = te);
      else {
        var Re = L + (x.w_bits - 8 << 4) << 8, _e = -1;
        x.strategy >= g || x.level < 2 ? _e = 0 : x.level < 6 ? _e = 1 : x.level === 6 ? _e = 2 : _e = 3, Re |= _e << 6, x.strstart !== 0 && (Re |= ae), Re += 31 - Re % 31, x.status = te, Xe(x, Re), x.strstart !== 0 && (Xe(x, d.adler >>> 16), Xe(x, d.adler & 65535)), d.adler = 1;
      }
    if (x.status === se)
      if (x.gzhead.extra) {
        for (N = x.pending; x.gzindex < (x.gzhead.extra.length & 65535) && !(x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), qe(d), N = x.pending, x.pending === x.pending_buf_size)); )
          Ne(x, x.gzhead.extra[x.gzindex] & 255), x.gzindex++;
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), x.gzindex === x.gzhead.extra.length && (x.gzindex = 0, x.status = be);
      } else
        x.status = be;
    if (x.status === be)
      if (x.gzhead.name) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), qe(d), N = x.pending, x.pending === x.pending_buf_size)) {
            J = 1;
            break;
          }
          x.gzindex < x.gzhead.name.length ? J = x.gzhead.name.charCodeAt(x.gzindex++) & 255 : J = 0, Ne(x, J);
        } while (J !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), J === 0 && (x.gzindex = 0, x.status = Me);
      } else
        x.status = Me;
    if (x.status === Me)
      if (x.gzhead.comment) {
        N = x.pending;
        do {
          if (x.pending === x.pending_buf_size && (x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), qe(d), N = x.pending, x.pending === x.pending_buf_size)) {
            J = 1;
            break;
          }
          x.gzindex < x.gzhead.comment.length ? J = x.gzhead.comment.charCodeAt(x.gzindex++) & 255 : J = 0, Ne(x, J);
        } while (J !== 0);
        x.gzhead.hcrc && x.pending > N && (d.adler = r(d.adler, x.pending_buf, x.pending - N, N)), J === 0 && (x.status = Se);
      } else
        x.status = Se;
    if (x.status === Se && (x.gzhead.hcrc ? (x.pending + 2 > x.pending_buf_size && qe(d), x.pending + 2 <= x.pending_buf_size && (Ne(x, d.adler & 255), Ne(x, d.adler >> 8 & 255), d.adler = 0, x.status = te)) : x.status = te), x.pending !== 0) {
      if (qe(d), d.avail_out === 0)
        return x.last_flush = -1, v;
    } else if (d.avail_in === 0 && Pe(ne) <= Pe(Q) && ne !== l)
      return ye(d, u);
    if (x.status === he && d.avail_in !== 0)
      return ye(d, u);
    if (d.avail_in !== 0 || x.lookahead !== 0 || ne !== i && x.status !== he) {
      var Le = x.strategy === g ? $t(x, ne) : x.strategy === b ? jt(x, ne) : D[x.level].func(x, ne);
      if ((Le === ze || Le === ue) && (x.status = he), Le === ge || Le === ze)
        return d.avail_out === 0 && (x.last_flush = -1), v;
      if (Le === pe && (ne === a ? t._tr_align(x) : ne !== h && (t._tr_stored_block(x, 0, 0, !1), ne === o && (Ue(x.head), x.lookahead === 0 && (x.strstart = 0, x.block_start = 0, x.insert = 0))), qe(d), d.avail_out === 0))
        return x.last_flush = -1, v;
    }
    return ne !== l ? v : x.wrap <= 0 ? c : (x.wrap === 2 ? (Ne(x, d.adler & 255), Ne(x, d.adler >> 8 & 255), Ne(x, d.adler >> 16 & 255), Ne(x, d.adler >> 24 & 255), Ne(x, d.total_in & 255), Ne(x, d.total_in >> 8 & 255), Ne(x, d.total_in >> 16 & 255), Ne(x, d.total_in >> 24 & 255)) : (Xe(x, d.adler >>> 16), Xe(x, d.adler & 65535)), qe(d), x.wrap > 0 && (x.wrap = -x.wrap), x.pending !== 0 ? v : c);
  }
  function fe(d) {
    var ne;
    return !d || !d.state ? f : (ne = d.state.status, ne !== le && ne !== se && ne !== be && ne !== Me && ne !== Se && ne !== te && ne !== he ? ye(d, f) : (d.state = null, ne === te ? ye(d, m) : v));
  }
  function Ie(d, ne) {
    var Q = ne.length, x, N, J, Re, _e, Le, je, ft;
    if (!d || !d.state || (x = d.state, Re = x.wrap, Re === 2 || Re === 1 && x.status !== le || x.lookahead))
      return f;
    for (Re === 1 && (d.adler = n(d.adler, ne, Q, 0)), x.wrap = 0, Q >= x.w_size && (Re === 0 && (Ue(x.head), x.strstart = 0, x.block_start = 0, x.insert = 0), ft = new e.Buf8(x.w_size), e.arraySet(ft, ne, Q - x.w_size, x.w_size, 0), ne = ft, Q = x.w_size), _e = d.avail_in, Le = d.next_in, je = d.input, d.avail_in = Q, d.next_in = 0, d.input = ne, bt(x); x.lookahead >= H; ) {
      N = x.strstart, J = x.lookahead - (H - 1);
      do
        x.ins_h = (x.ins_h << x.hash_shift ^ x.window[N + H - 1]) & x.hash_mask, x.prev[N & x.w_mask] = x.head[x.ins_h], x.head[x.ins_h] = N, N++;
      while (--J);
      x.strstart = N, x.lookahead = H - 1, bt(x);
    }
    return x.strstart += x.lookahead, x.block_start = x.strstart, x.insert = x.lookahead, x.lookahead = 0, x.match_length = x.prev_length = H - 1, x.match_available = 0, d.next_in = Le, d.input = je, d.avail_in = _e, x.wrap = Re, v;
  }
  return Vt.deflateInit = re, Vt.deflateInit2 = R, Vt.deflateReset = W, Vt.deflateResetKeep = Y, Vt.deflateSetHeader = ce, Vt.deflate = y, Vt.deflateEnd = fe, Vt.deflateSetDictionary = Ie, Vt.deflateInfo = "pako deflate (from Nodeca project)", Vt;
}
var gn = {}, Ll;
function Jo() {
  if (Ll) return gn;
  Ll = 1;
  var e = cn(), t = !0, n = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    n = !1;
  }
  for (var r = new e.Buf8(256), s = 0; s < 256; s++)
    r[s] = s >= 252 ? 6 : s >= 248 ? 5 : s >= 240 ? 4 : s >= 224 ? 3 : s >= 192 ? 2 : 1;
  r[254] = r[254] = 1, gn.string2buf = function(a) {
    var o, l, h, v, c, f = a.length, m = 0;
    for (v = 0; v < f; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), m += l < 128 ? 1 : l < 2048 ? 2 : l < 65536 ? 3 : 4;
    for (o = new e.Buf8(m), c = 0, v = 0; c < m; v++)
      l = a.charCodeAt(v), (l & 64512) === 55296 && v + 1 < f && (h = a.charCodeAt(v + 1), (h & 64512) === 56320 && (l = 65536 + (l - 55296 << 10) + (h - 56320), v++)), l < 128 ? o[c++] = l : l < 2048 ? (o[c++] = 192 | l >>> 6, o[c++] = 128 | l & 63) : l < 65536 ? (o[c++] = 224 | l >>> 12, o[c++] = 128 | l >>> 6 & 63, o[c++] = 128 | l & 63) : (o[c++] = 240 | l >>> 18, o[c++] = 128 | l >>> 12 & 63, o[c++] = 128 | l >>> 6 & 63, o[c++] = 128 | l & 63);
    return o;
  };
  function i(a, o) {
    if (o < 65534 && (a.subarray && n || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, o));
    for (var l = "", h = 0; h < o; h++)
      l += String.fromCharCode(a[h]);
    return l;
  }
  return gn.buf2binstring = function(a) {
    return i(a, a.length);
  }, gn.binstring2buf = function(a) {
    for (var o = new e.Buf8(a.length), l = 0, h = o.length; l < h; l++)
      o[l] = a.charCodeAt(l);
    return o;
  }, gn.buf2string = function(a, o) {
    var l, h, v, c, f = o || a.length, m = new Array(f * 2);
    for (h = 0, l = 0; l < f; ) {
      if (v = a[l++], v < 128) {
        m[h++] = v;
        continue;
      }
      if (c = r[v], c > 4) {
        m[h++] = 65533, l += c - 1;
        continue;
      }
      for (v &= c === 2 ? 31 : c === 3 ? 15 : 7; c > 1 && l < f; )
        v = v << 6 | a[l++] & 63, c--;
      if (c > 1) {
        m[h++] = 65533;
        continue;
      }
      v < 65536 ? m[h++] = v : (v -= 65536, m[h++] = 55296 | v >> 10 & 1023, m[h++] = 56320 | v & 1023);
    }
    return i(m, h);
  }, gn.utf8border = function(a, o) {
    var l;
    for (o = o || a.length, o > a.length && (o = a.length), l = o - 1; l >= 0 && (a[l] & 192) === 128; )
      l--;
    return l < 0 || l === 0 ? o : l + r[a[l]] > o ? l : o;
  }, gn;
}
var Lr, $l;
function Qo() {
  if ($l) return Lr;
  $l = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return Lr = e, Lr;
}
var Il;
function uh() {
  if (Il) return On;
  Il = 1;
  var e = sh(), t = cn(), n = Jo(), r = gi(), s = Qo(), i = Object.prototype.toString, a = 0, o = 4, l = 0, h = 1, v = 2, c = -1, f = 0, m = 8;
  function u(b) {
    if (!(this instanceof u)) return new u(b);
    this.options = t.assign({
      level: c,
      method: m,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, b || {});
    var _ = this.options;
    _.raw && _.windowBits > 0 ? _.windowBits = -_.windowBits : _.gzip && _.windowBits > 0 && _.windowBits < 16 && (_.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new s(), this.strm.avail_out = 0;
    var T = e.deflateInit2(
      this.strm,
      _.level,
      _.method,
      _.windowBits,
      _.memLevel,
      _.strategy
    );
    if (T !== l)
      throw new Error(r[T]);
    if (_.header && e.deflateSetHeader(this.strm, _.header), _.dictionary) {
      var I;
      if (typeof _.dictionary == "string" ? I = n.string2buf(_.dictionary) : i.call(_.dictionary) === "[object ArrayBuffer]" ? I = new Uint8Array(_.dictionary) : I = _.dictionary, T = e.deflateSetDictionary(this.strm, I), T !== l)
        throw new Error(r[T]);
      this._dict_set = !0;
    }
  }
  u.prototype.push = function(b, _) {
    var T = this.strm, I = this.options.chunkSize, L, C;
    if (this.ended)
      return !1;
    C = _ === ~~_ ? _ : _ === !0 ? o : a, typeof b == "string" ? T.input = n.string2buf(b) : i.call(b) === "[object ArrayBuffer]" ? T.input = new Uint8Array(b) : T.input = b, T.next_in = 0, T.avail_in = T.input.length;
    do {
      if (T.avail_out === 0 && (T.output = new t.Buf8(I), T.next_out = 0, T.avail_out = I), L = e.deflate(T, C), L !== h && L !== l)
        return this.onEnd(L), this.ended = !0, !1;
      (T.avail_out === 0 || T.avail_in === 0 && (C === o || C === v)) && (this.options.to === "string" ? this.onData(n.buf2binstring(t.shrinkBuf(T.output, T.next_out))) : this.onData(t.shrinkBuf(T.output, T.next_out)));
    } while ((T.avail_in > 0 || T.avail_out === 0) && L !== h);
    return C === o ? (L = e.deflateEnd(this.strm), this.onEnd(L), this.ended = !0, L === l) : (C === v && (this.onEnd(l), T.avail_out = 0), !0);
  }, u.prototype.onData = function(b) {
    this.chunks.push(b);
  }, u.prototype.onEnd = function(b) {
    b === l && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = b, this.msg = this.strm.msg;
  };
  function p(b, _) {
    var T = new u(_);
    if (T.push(b, !0), T.err)
      throw T.msg || r[T.err];
    return T.result;
  }
  function S(b, _) {
    return _ = _ || {}, _.raw = !0, p(b, _);
  }
  function g(b, _) {
    return _ = _ || {}, _.gzip = !0, p(b, _);
  }
  return On.Deflate = u, On.deflate = p, On.deflateRaw = S, On.gzip = g, On;
}
var Fn = {}, Bt = {}, $r, Dl;
function ch() {
  if (Dl) return $r;
  Dl = 1;
  var e = 30, t = 12;
  return $r = function(r, s) {
    var i, a, o, l, h, v, c, f, m, u, p, S, g, b, _, T, I, L, C, F, z, X, O, G, P;
    i = r.state, a = r.next_in, G = r.input, o = a + (r.avail_in - 5), l = r.next_out, P = r.output, h = l - (s - r.avail_out), v = l + (r.avail_out - 257), c = i.dmax, f = i.wsize, m = i.whave, u = i.wnext, p = i.window, S = i.hold, g = i.bits, b = i.lencode, _ = i.distcode, T = (1 << i.lenbits) - 1, I = (1 << i.distbits) - 1;
    e:
      do {
        g < 15 && (S += G[a++] << g, g += 8, S += G[a++] << g, g += 8), L = b[S & T];
        t:
          for (; ; ) {
            if (C = L >>> 24, S >>>= C, g -= C, C = L >>> 16 & 255, C === 0)
              P[l++] = L & 65535;
            else if (C & 16) {
              F = L & 65535, C &= 15, C && (g < C && (S += G[a++] << g, g += 8), F += S & (1 << C) - 1, S >>>= C, g -= C), g < 15 && (S += G[a++] << g, g += 8, S += G[a++] << g, g += 8), L = _[S & I];
              n:
                for (; ; ) {
                  if (C = L >>> 24, S >>>= C, g -= C, C = L >>> 16 & 255, C & 16) {
                    if (z = L & 65535, C &= 15, g < C && (S += G[a++] << g, g += 8, g < C && (S += G[a++] << g, g += 8)), z += S & (1 << C) - 1, z > c) {
                      r.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (S >>>= C, g -= C, C = l - h, z > C) {
                      if (C = z - C, C > m && i.sane) {
                        r.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (X = 0, O = p, u === 0) {
                        if (X += f - C, C < F) {
                          F -= C;
                          do
                            P[l++] = p[X++];
                          while (--C);
                          X = l - z, O = P;
                        }
                      } else if (u < C) {
                        if (X += f + u - C, C -= u, C < F) {
                          F -= C;
                          do
                            P[l++] = p[X++];
                          while (--C);
                          if (X = 0, u < F) {
                            C = u, F -= C;
                            do
                              P[l++] = p[X++];
                            while (--C);
                            X = l - z, O = P;
                          }
                        }
                      } else if (X += u - C, C < F) {
                        F -= C;
                        do
                          P[l++] = p[X++];
                        while (--C);
                        X = l - z, O = P;
                      }
                      for (; F > 2; )
                        P[l++] = O[X++], P[l++] = O[X++], P[l++] = O[X++], F -= 3;
                      F && (P[l++] = O[X++], F > 1 && (P[l++] = O[X++]));
                    } else {
                      X = l - z;
                      do
                        P[l++] = P[X++], P[l++] = P[X++], P[l++] = P[X++], F -= 3;
                      while (F > 2);
                      F && (P[l++] = P[X++], F > 1 && (P[l++] = P[X++]));
                    }
                  } else if ((C & 64) === 0) {
                    L = _[(L & 65535) + (S & (1 << C) - 1)];
                    continue n;
                  } else {
                    r.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((C & 64) === 0) {
              L = b[(L & 65535) + (S & (1 << C) - 1)];
              continue t;
            } else if (C & 32) {
              i.mode = t;
              break e;
            } else {
              r.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < o && l < v);
    F = g >> 3, a -= F, g -= F << 3, S &= (1 << g) - 1, r.next_in = a, r.next_out = l, r.avail_in = a < o ? 5 + (o - a) : 5 - (a - o), r.avail_out = l < v ? 257 + (v - l) : 257 - (l - v), i.hold = S, i.bits = g;
  }, $r;
}
var Ir, Ml;
function dh() {
  if (Ml) return Ir;
  Ml = 1;
  var e = cn(), t = 15, n = 852, r = 592, s = 0, i = 1, a = 2, o = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], l = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], h = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], v = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return Ir = function(f, m, u, p, S, g, b, _) {
    var T = _.bits, I = 0, L = 0, C = 0, F = 0, z = 0, X = 0, O = 0, G = 0, P = 0, E = 0, A, V, H, K, B, ae = null, le = 0, se, be = new e.Buf16(t + 1), Me = new e.Buf16(t + 1), Se = null, te = 0, he, ge, pe;
    for (I = 0; I <= t; I++)
      be[I] = 0;
    for (L = 0; L < p; L++)
      be[m[u + L]]++;
    for (z = T, F = t; F >= 1 && be[F] === 0; F--)
      ;
    if (z > F && (z = F), F === 0)
      return S[g++] = 1 << 24 | 64 << 16 | 0, S[g++] = 1 << 24 | 64 << 16 | 0, _.bits = 1, 0;
    for (C = 1; C < F && be[C] === 0; C++)
      ;
    for (z < C && (z = C), G = 1, I = 1; I <= t; I++)
      if (G <<= 1, G -= be[I], G < 0)
        return -1;
    if (G > 0 && (f === s || F !== 1))
      return -1;
    for (Me[1] = 0, I = 1; I < t; I++)
      Me[I + 1] = Me[I] + be[I];
    for (L = 0; L < p; L++)
      m[u + L] !== 0 && (b[Me[m[u + L]]++] = L);
    if (f === s ? (ae = Se = b, se = 19) : f === i ? (ae = o, le -= 257, Se = l, te -= 257, se = 256) : (ae = h, Se = v, se = -1), E = 0, L = 0, I = C, B = g, X = z, O = 0, H = -1, P = 1 << z, K = P - 1, f === i && P > n || f === a && P > r)
      return 1;
    for (; ; ) {
      he = I - O, b[L] < se ? (ge = 0, pe = b[L]) : b[L] > se ? (ge = Se[te + b[L]], pe = ae[le + b[L]]) : (ge = 96, pe = 0), A = 1 << I - O, V = 1 << X, C = V;
      do
        V -= A, S[B + (E >> O) + V] = he << 24 | ge << 16 | pe | 0;
      while (V !== 0);
      for (A = 1 << I - 1; E & A; )
        A >>= 1;
      if (A !== 0 ? (E &= A - 1, E += A) : E = 0, L++, --be[I] === 0) {
        if (I === F)
          break;
        I = m[u + b[L]];
      }
      if (I > z && (E & K) !== H) {
        for (O === 0 && (O = z), B += C, X = I - O, G = 1 << X; X + O < F && (G -= be[X + O], !(G <= 0)); )
          X++, G <<= 1;
        if (P += 1 << X, f === i && P > n || f === a && P > r)
          return 1;
        H = E & K, S[H] = z << 24 | X << 16 | B - g | 0;
      }
    }
    return E !== 0 && (S[B + E] = I - O << 24 | 64 << 16 | 0), _.bits = z, 0;
  }, Ir;
}
var Rl;
function fh() {
  if (Rl) return Bt;
  Rl = 1;
  var e = cn(), t = Go(), n = Ko(), r = ch(), s = dh(), i = 0, a = 1, o = 2, l = 4, h = 5, v = 6, c = 0, f = 1, m = 2, u = -2, p = -3, S = -4, g = -5, b = 8, _ = 1, T = 2, I = 3, L = 4, C = 5, F = 6, z = 7, X = 8, O = 9, G = 10, P = 11, E = 12, A = 13, V = 14, H = 15, K = 16, B = 17, ae = 18, le = 19, se = 20, be = 21, Me = 22, Se = 23, te = 24, he = 25, ge = 26, pe = 27, ze = 28, ue = 29, oe = 30, ye = 31, Pe = 32, Ue = 852, qe = 592, Be = 15, Ne = Be;
  function Xe(R) {
    return (R >>> 24 & 255) + (R >>> 8 & 65280) + ((R & 65280) << 8) + ((R & 255) << 24);
  }
  function ut() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function gt(R) {
    var re;
    return !R || !R.state ? u : (re = R.state, R.total_in = R.total_out = re.total = 0, R.msg = "", re.wrap && (R.adler = re.wrap & 1), re.mode = _, re.last = 0, re.havedict = 0, re.dmax = 32768, re.head = null, re.hold = 0, re.bits = 0, re.lencode = re.lendyn = new e.Buf32(Ue), re.distcode = re.distdyn = new e.Buf32(qe), re.sane = 1, re.back = -1, c);
  }
  function bt(R) {
    var re;
    return !R || !R.state ? u : (re = R.state, re.wsize = 0, re.whave = 0, re.wnext = 0, gt(R));
  }
  function Ft(R, re) {
    var y, fe;
    return !R || !R.state || (fe = R.state, re < 0 ? (y = 0, re = -re) : (y = (re >> 4) + 1, re < 48 && (re &= 15)), re && (re < 8 || re > 15)) ? u : (fe.window !== null && fe.wbits !== re && (fe.window = null), fe.wrap = y, fe.wbits = re, bt(R));
  }
  function Rt(R, re) {
    var y, fe;
    return R ? (fe = new ut(), R.state = fe, fe.window = null, y = Ft(R, re), y !== c && (R.state = null), y) : u;
  }
  function xt(R) {
    return Rt(R, Ne);
  }
  var jt = !0, $t, ct;
  function D(R) {
    if (jt) {
      var re;
      for ($t = new e.Buf32(512), ct = new e.Buf32(32), re = 0; re < 144; )
        R.lens[re++] = 8;
      for (; re < 256; )
        R.lens[re++] = 9;
      for (; re < 280; )
        R.lens[re++] = 7;
      for (; re < 288; )
        R.lens[re++] = 8;
      for (s(a, R.lens, 0, 288, $t, 0, R.work, { bits: 9 }), re = 0; re < 32; )
        R.lens[re++] = 5;
      s(o, R.lens, 0, 32, ct, 0, R.work, { bits: 5 }), jt = !1;
    }
    R.lencode = $t, R.lenbits = 9, R.distcode = ct, R.distbits = 5;
  }
  function k(R, re, y, fe) {
    var Ie, d = R.state;
    return d.window === null && (d.wsize = 1 << d.wbits, d.wnext = 0, d.whave = 0, d.window = new e.Buf8(d.wsize)), fe >= d.wsize ? (e.arraySet(d.window, re, y - d.wsize, d.wsize, 0), d.wnext = 0, d.whave = d.wsize) : (Ie = d.wsize - d.wnext, Ie > fe && (Ie = fe), e.arraySet(d.window, re, y - fe, Ie, d.wnext), fe -= Ie, fe ? (e.arraySet(d.window, re, y - fe, fe, 0), d.wnext = fe, d.whave = d.wsize) : (d.wnext += Ie, d.wnext === d.wsize && (d.wnext = 0), d.whave < d.wsize && (d.whave += Ie))), 0;
  }
  function w(R, re) {
    var y, fe, Ie, d, ne, Q, x, N, J, Re, _e, Le, je, ft, et = 0, Ze, lt, pt, kt, fn, an, tt, At, ht = new e.Buf8(4), zt, Ot, xa = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!R || !R.state || !R.output || !R.input && R.avail_in !== 0)
      return u;
    y = R.state, y.mode === E && (y.mode = A), ne = R.next_out, Ie = R.output, x = R.avail_out, d = R.next_in, fe = R.input, Q = R.avail_in, N = y.hold, J = y.bits, Re = Q, _e = x, At = c;
    e:
      for (; ; )
        switch (y.mode) {
          case _:
            if (y.wrap === 0) {
              y.mode = A;
              break;
            }
            for (; J < 16; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            if (y.wrap & 2 && N === 35615) {
              y.check = 0, ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0), N = 0, J = 0, y.mode = T;
              break;
            }
            if (y.flags = 0, y.head && (y.head.done = !1), !(y.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              R.msg = "incorrect header check", y.mode = oe;
              break;
            }
            if ((N & 15) !== b) {
              R.msg = "unknown compression method", y.mode = oe;
              break;
            }
            if (N >>>= 4, J -= 4, tt = (N & 15) + 8, y.wbits === 0)
              y.wbits = tt;
            else if (tt > y.wbits) {
              R.msg = "invalid window size", y.mode = oe;
              break;
            }
            y.dmax = 1 << tt, R.adler = y.check = 1, y.mode = N & 512 ? G : E, N = 0, J = 0;
            break;
          case T:
            for (; J < 16; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            if (y.flags = N, (y.flags & 255) !== b) {
              R.msg = "unknown compression method", y.mode = oe;
              break;
            }
            if (y.flags & 57344) {
              R.msg = "unknown header flags set", y.mode = oe;
              break;
            }
            y.head && (y.head.text = N >> 8 & 1), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0)), N = 0, J = 0, y.mode = I;
          /* falls through */
          case I:
            for (; J < 32; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            y.head && (y.head.time = N), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, ht[2] = N >>> 16 & 255, ht[3] = N >>> 24 & 255, y.check = n(y.check, ht, 4, 0)), N = 0, J = 0, y.mode = L;
          /* falls through */
          case L:
            for (; J < 16; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            y.head && (y.head.xflags = N & 255, y.head.os = N >> 8), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0)), N = 0, J = 0, y.mode = C;
          /* falls through */
          case C:
            if (y.flags & 1024) {
              for (; J < 16; ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              y.length = N, y.head && (y.head.extra_len = N), y.flags & 512 && (ht[0] = N & 255, ht[1] = N >>> 8 & 255, y.check = n(y.check, ht, 2, 0)), N = 0, J = 0;
            } else y.head && (y.head.extra = null);
            y.mode = F;
          /* falls through */
          case F:
            if (y.flags & 1024 && (Le = y.length, Le > Q && (Le = Q), Le && (y.head && (tt = y.head.extra_len - y.length, y.head.extra || (y.head.extra = new Array(y.head.extra_len)), e.arraySet(
              y.head.extra,
              fe,
              d,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              Le,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              tt
            )), y.flags & 512 && (y.check = n(y.check, fe, Le, d)), Q -= Le, d += Le, y.length -= Le), y.length))
              break e;
            y.length = 0, y.mode = z;
          /* falls through */
          case z:
            if (y.flags & 2048) {
              if (Q === 0)
                break e;
              Le = 0;
              do
                tt = fe[d + Le++], y.head && tt && y.length < 65536 && (y.head.name += String.fromCharCode(tt));
              while (tt && Le < Q);
              if (y.flags & 512 && (y.check = n(y.check, fe, Le, d)), Q -= Le, d += Le, tt)
                break e;
            } else y.head && (y.head.name = null);
            y.length = 0, y.mode = X;
          /* falls through */
          case X:
            if (y.flags & 4096) {
              if (Q === 0)
                break e;
              Le = 0;
              do
                tt = fe[d + Le++], y.head && tt && y.length < 65536 && (y.head.comment += String.fromCharCode(tt));
              while (tt && Le < Q);
              if (y.flags & 512 && (y.check = n(y.check, fe, Le, d)), Q -= Le, d += Le, tt)
                break e;
            } else y.head && (y.head.comment = null);
            y.mode = O;
          /* falls through */
          case O:
            if (y.flags & 512) {
              for (; J < 16; ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              if (N !== (y.check & 65535)) {
                R.msg = "header crc mismatch", y.mode = oe;
                break;
              }
              N = 0, J = 0;
            }
            y.head && (y.head.hcrc = y.flags >> 9 & 1, y.head.done = !0), R.adler = y.check = 0, y.mode = E;
            break;
          case G:
            for (; J < 32; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            R.adler = y.check = Xe(N), N = 0, J = 0, y.mode = P;
          /* falls through */
          case P:
            if (y.havedict === 0)
              return R.next_out = ne, R.avail_out = x, R.next_in = d, R.avail_in = Q, y.hold = N, y.bits = J, m;
            R.adler = y.check = 1, y.mode = E;
          /* falls through */
          case E:
            if (re === h || re === v)
              break e;
          /* falls through */
          case A:
            if (y.last) {
              N >>>= J & 7, J -= J & 7, y.mode = pe;
              break;
            }
            for (; J < 3; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            switch (y.last = N & 1, N >>>= 1, J -= 1, N & 3) {
              case 0:
                y.mode = V;
                break;
              case 1:
                if (D(y), y.mode = se, re === v) {
                  N >>>= 2, J -= 2;
                  break e;
                }
                break;
              case 2:
                y.mode = B;
                break;
              case 3:
                R.msg = "invalid block type", y.mode = oe;
            }
            N >>>= 2, J -= 2;
            break;
          case V:
            for (N >>>= J & 7, J -= J & 7; J < 32; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              R.msg = "invalid stored block lengths", y.mode = oe;
              break;
            }
            if (y.length = N & 65535, N = 0, J = 0, y.mode = H, re === v)
              break e;
          /* falls through */
          case H:
            y.mode = K;
          /* falls through */
          case K:
            if (Le = y.length, Le) {
              if (Le > Q && (Le = Q), Le > x && (Le = x), Le === 0)
                break e;
              e.arraySet(Ie, fe, d, Le, ne), Q -= Le, d += Le, x -= Le, ne += Le, y.length -= Le;
              break;
            }
            y.mode = E;
            break;
          case B:
            for (; J < 14; ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            if (y.nlen = (N & 31) + 257, N >>>= 5, J -= 5, y.ndist = (N & 31) + 1, N >>>= 5, J -= 5, y.ncode = (N & 15) + 4, N >>>= 4, J -= 4, y.nlen > 286 || y.ndist > 30) {
              R.msg = "too many length or distance symbols", y.mode = oe;
              break;
            }
            y.have = 0, y.mode = ae;
          /* falls through */
          case ae:
            for (; y.have < y.ncode; ) {
              for (; J < 3; ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              y.lens[xa[y.have++]] = N & 7, N >>>= 3, J -= 3;
            }
            for (; y.have < 19; )
              y.lens[xa[y.have++]] = 0;
            if (y.lencode = y.lendyn, y.lenbits = 7, zt = { bits: y.lenbits }, At = s(i, y.lens, 0, 19, y.lencode, 0, y.work, zt), y.lenbits = zt.bits, At) {
              R.msg = "invalid code lengths set", y.mode = oe;
              break;
            }
            y.have = 0, y.mode = le;
          /* falls through */
          case le:
            for (; y.have < y.nlen + y.ndist; ) {
              for (; et = y.lencode[N & (1 << y.lenbits) - 1], Ze = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(Ze <= J); ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              if (pt < 16)
                N >>>= Ze, J -= Ze, y.lens[y.have++] = pt;
              else {
                if (pt === 16) {
                  for (Ot = Ze + 2; J < Ot; ) {
                    if (Q === 0)
                      break e;
                    Q--, N += fe[d++] << J, J += 8;
                  }
                  if (N >>>= Ze, J -= Ze, y.have === 0) {
                    R.msg = "invalid bit length repeat", y.mode = oe;
                    break;
                  }
                  tt = y.lens[y.have - 1], Le = 3 + (N & 3), N >>>= 2, J -= 2;
                } else if (pt === 17) {
                  for (Ot = Ze + 3; J < Ot; ) {
                    if (Q === 0)
                      break e;
                    Q--, N += fe[d++] << J, J += 8;
                  }
                  N >>>= Ze, J -= Ze, tt = 0, Le = 3 + (N & 7), N >>>= 3, J -= 3;
                } else {
                  for (Ot = Ze + 7; J < Ot; ) {
                    if (Q === 0)
                      break e;
                    Q--, N += fe[d++] << J, J += 8;
                  }
                  N >>>= Ze, J -= Ze, tt = 0, Le = 11 + (N & 127), N >>>= 7, J -= 7;
                }
                if (y.have + Le > y.nlen + y.ndist) {
                  R.msg = "invalid bit length repeat", y.mode = oe;
                  break;
                }
                for (; Le--; )
                  y.lens[y.have++] = tt;
              }
            }
            if (y.mode === oe)
              break;
            if (y.lens[256] === 0) {
              R.msg = "invalid code -- missing end-of-block", y.mode = oe;
              break;
            }
            if (y.lenbits = 9, zt = { bits: y.lenbits }, At = s(a, y.lens, 0, y.nlen, y.lencode, 0, y.work, zt), y.lenbits = zt.bits, At) {
              R.msg = "invalid literal/lengths set", y.mode = oe;
              break;
            }
            if (y.distbits = 6, y.distcode = y.distdyn, zt = { bits: y.distbits }, At = s(o, y.lens, y.nlen, y.ndist, y.distcode, 0, y.work, zt), y.distbits = zt.bits, At) {
              R.msg = "invalid distances set", y.mode = oe;
              break;
            }
            if (y.mode = se, re === v)
              break e;
          /* falls through */
          case se:
            y.mode = be;
          /* falls through */
          case be:
            if (Q >= 6 && x >= 258) {
              R.next_out = ne, R.avail_out = x, R.next_in = d, R.avail_in = Q, y.hold = N, y.bits = J, r(R, _e), ne = R.next_out, Ie = R.output, x = R.avail_out, d = R.next_in, fe = R.input, Q = R.avail_in, N = y.hold, J = y.bits, y.mode === E && (y.back = -1);
              break;
            }
            for (y.back = 0; et = y.lencode[N & (1 << y.lenbits) - 1], Ze = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(Ze <= J); ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            if (lt && (lt & 240) === 0) {
              for (kt = Ze, fn = lt, an = pt; et = y.lencode[an + ((N & (1 << kt + fn) - 1) >> kt)], Ze = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(kt + Ze <= J); ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              N >>>= kt, J -= kt, y.back += kt;
            }
            if (N >>>= Ze, J -= Ze, y.back += Ze, y.length = pt, lt === 0) {
              y.mode = ge;
              break;
            }
            if (lt & 32) {
              y.back = -1, y.mode = E;
              break;
            }
            if (lt & 64) {
              R.msg = "invalid literal/length code", y.mode = oe;
              break;
            }
            y.extra = lt & 15, y.mode = Me;
          /* falls through */
          case Me:
            if (y.extra) {
              for (Ot = y.extra; J < Ot; ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              y.length += N & (1 << y.extra) - 1, N >>>= y.extra, J -= y.extra, y.back += y.extra;
            }
            y.was = y.length, y.mode = Se;
          /* falls through */
          case Se:
            for (; et = y.distcode[N & (1 << y.distbits) - 1], Ze = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(Ze <= J); ) {
              if (Q === 0)
                break e;
              Q--, N += fe[d++] << J, J += 8;
            }
            if ((lt & 240) === 0) {
              for (kt = Ze, fn = lt, an = pt; et = y.distcode[an + ((N & (1 << kt + fn) - 1) >> kt)], Ze = et >>> 24, lt = et >>> 16 & 255, pt = et & 65535, !(kt + Ze <= J); ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              N >>>= kt, J -= kt, y.back += kt;
            }
            if (N >>>= Ze, J -= Ze, y.back += Ze, lt & 64) {
              R.msg = "invalid distance code", y.mode = oe;
              break;
            }
            y.offset = pt, y.extra = lt & 15, y.mode = te;
          /* falls through */
          case te:
            if (y.extra) {
              for (Ot = y.extra; J < Ot; ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              y.offset += N & (1 << y.extra) - 1, N >>>= y.extra, J -= y.extra, y.back += y.extra;
            }
            if (y.offset > y.dmax) {
              R.msg = "invalid distance too far back", y.mode = oe;
              break;
            }
            y.mode = he;
          /* falls through */
          case he:
            if (x === 0)
              break e;
            if (Le = _e - x, y.offset > Le) {
              if (Le = y.offset - Le, Le > y.whave && y.sane) {
                R.msg = "invalid distance too far back", y.mode = oe;
                break;
              }
              Le > y.wnext ? (Le -= y.wnext, je = y.wsize - Le) : je = y.wnext - Le, Le > y.length && (Le = y.length), ft = y.window;
            } else
              ft = Ie, je = ne - y.offset, Le = y.length;
            Le > x && (Le = x), x -= Le, y.length -= Le;
            do
              Ie[ne++] = ft[je++];
            while (--Le);
            y.length === 0 && (y.mode = be);
            break;
          case ge:
            if (x === 0)
              break e;
            Ie[ne++] = y.length, x--, y.mode = be;
            break;
          case pe:
            if (y.wrap) {
              for (; J < 32; ) {
                if (Q === 0)
                  break e;
                Q--, N |= fe[d++] << J, J += 8;
              }
              if (_e -= x, R.total_out += _e, y.total += _e, _e && (R.adler = y.check = /*UPDATE(state.check, put - _out, _out);*/
              y.flags ? n(y.check, Ie, _e, ne - _e) : t(y.check, Ie, _e, ne - _e)), _e = x, (y.flags ? N : Xe(N)) !== y.check) {
                R.msg = "incorrect data check", y.mode = oe;
                break;
              }
              N = 0, J = 0;
            }
            y.mode = ze;
          /* falls through */
          case ze:
            if (y.wrap && y.flags) {
              for (; J < 32; ) {
                if (Q === 0)
                  break e;
                Q--, N += fe[d++] << J, J += 8;
              }
              if (N !== (y.total & 4294967295)) {
                R.msg = "incorrect length check", y.mode = oe;
                break;
              }
              N = 0, J = 0;
            }
            y.mode = ue;
          /* falls through */
          case ue:
            At = f;
            break e;
          case oe:
            At = p;
            break e;
          case ye:
            return S;
          case Pe:
          /* falls through */
          default:
            return u;
        }
    return R.next_out = ne, R.avail_out = x, R.next_in = d, R.avail_in = Q, y.hold = N, y.bits = J, (y.wsize || _e !== R.avail_out && y.mode < oe && (y.mode < pe || re !== l)) && k(R, R.output, R.next_out, _e - R.avail_out), Re -= R.avail_in, _e -= R.avail_out, R.total_in += Re, R.total_out += _e, y.total += _e, y.wrap && _e && (R.adler = y.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    y.flags ? n(y.check, Ie, _e, R.next_out - _e) : t(y.check, Ie, _e, R.next_out - _e)), R.data_type = y.bits + (y.last ? 64 : 0) + (y.mode === E ? 128 : 0) + (y.mode === se || y.mode === H ? 256 : 0), (Re === 0 && _e === 0 || re === l) && At === c && (At = g), At;
  }
  function Y(R) {
    if (!R || !R.state)
      return u;
    var re = R.state;
    return re.window && (re.window = null), R.state = null, c;
  }
  function W(R, re) {
    var y;
    return !R || !R.state || (y = R.state, (y.wrap & 2) === 0) ? u : (y.head = re, re.done = !1, c);
  }
  function ce(R, re) {
    var y = re.length, fe, Ie, d;
    return !R || !R.state || (fe = R.state, fe.wrap !== 0 && fe.mode !== P) ? u : fe.mode === P && (Ie = 1, Ie = t(Ie, re, y, 0), Ie !== fe.check) ? p : (d = k(R, re, y, y), d ? (fe.mode = ye, S) : (fe.havedict = 1, c));
  }
  return Bt.inflateReset = bt, Bt.inflateReset2 = Ft, Bt.inflateResetKeep = gt, Bt.inflateInit = xt, Bt.inflateInit2 = Rt, Bt.inflate = w, Bt.inflateEnd = Y, Bt.inflateGetHeader = W, Bt.inflateSetDictionary = ce, Bt.inflateInfo = "pako inflate (from Nodeca project)", Bt;
}
var Dr, Ol;
function es() {
  return Ol || (Ol = 1, Dr = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), Dr;
}
var Mr, Fl;
function hh() {
  if (Fl) return Mr;
  Fl = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return Mr = e, Mr;
}
var Nl;
function vh() {
  if (Nl) return Fn;
  Nl = 1;
  var e = fh(), t = cn(), n = Jo(), r = es(), s = gi(), i = Qo(), a = hh(), o = Object.prototype.toString;
  function l(c) {
    if (!(this instanceof l)) return new l(c);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, c || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(c && c.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var m = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (m !== r.Z_OK)
      throw new Error(s[m]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = n.string2buf(f.dictionary) : o.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (m = e.inflateSetDictionary(this.strm, f.dictionary), m !== r.Z_OK)))
      throw new Error(s[m]);
  }
  l.prototype.push = function(c, f) {
    var m = this.strm, u = this.options.chunkSize, p = this.options.dictionary, S, g, b, _, T, I = !1;
    if (this.ended)
      return !1;
    g = f === ~~f ? f : f === !0 ? r.Z_FINISH : r.Z_NO_FLUSH, typeof c == "string" ? m.input = n.binstring2buf(c) : o.call(c) === "[object ArrayBuffer]" ? m.input = new Uint8Array(c) : m.input = c, m.next_in = 0, m.avail_in = m.input.length;
    do {
      if (m.avail_out === 0 && (m.output = new t.Buf8(u), m.next_out = 0, m.avail_out = u), S = e.inflate(m, r.Z_NO_FLUSH), S === r.Z_NEED_DICT && p && (S = e.inflateSetDictionary(this.strm, p)), S === r.Z_BUF_ERROR && I === !0 && (S = r.Z_OK, I = !1), S !== r.Z_STREAM_END && S !== r.Z_OK)
        return this.onEnd(S), this.ended = !0, !1;
      m.next_out && (m.avail_out === 0 || S === r.Z_STREAM_END || m.avail_in === 0 && (g === r.Z_FINISH || g === r.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (b = n.utf8border(m.output, m.next_out), _ = m.next_out - b, T = n.buf2string(m.output, b), m.next_out = _, m.avail_out = u - _, _ && t.arraySet(m.output, m.output, b, _, 0), this.onData(T)) : this.onData(t.shrinkBuf(m.output, m.next_out))), m.avail_in === 0 && m.avail_out === 0 && (I = !0);
    } while ((m.avail_in > 0 || m.avail_out === 0) && S !== r.Z_STREAM_END);
    return S === r.Z_STREAM_END && (g = r.Z_FINISH), g === r.Z_FINISH ? (S = e.inflateEnd(this.strm), this.onEnd(S), this.ended = !0, S === r.Z_OK) : (g === r.Z_SYNC_FLUSH && (this.onEnd(r.Z_OK), m.avail_out = 0), !0);
  }, l.prototype.onData = function(c) {
    this.chunks.push(c);
  }, l.prototype.onEnd = function(c) {
    c === r.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = c, this.msg = this.strm.msg;
  };
  function h(c, f) {
    var m = new l(f);
    if (m.push(c, !0), m.err)
      throw m.msg || s[m.err];
    return m.result;
  }
  function v(c, f) {
    return f = f || {}, f.raw = !0, h(c, f);
  }
  return Fn.Inflate = l, Fn.inflate = h, Fn.inflateRaw = v, Fn.ungzip = h, Fn;
}
var Rr, Bl;
function mh() {
  if (Bl) return Rr;
  Bl = 1;
  var e = cn().assign, t = uh(), n = vh(), r = es(), s = {};
  return e(s, t, n, r), Rr = s, Rr;
}
var Pl;
function gh() {
  return Pl || (Pl = 1, (function(e) {
    (function() {
      var t = {}, n;
      e.exports = t, typeof lh == "function" ? n = mh() : n = window.pako, (function(r, s) {
        r.toRGBA8 = function(i) {
          var a = i.width, o = i.height;
          if (i.tabs.acTL == null) return [r.toRGBA8.decodeImage(i.data, a, o, i).buffer];
          var l = [];
          i.frames[0].data == null && (i.frames[0].data = i.data);
          for (var h, v = new Uint8Array(a * o * 4), c = 0; c < i.frames.length; c++) {
            var f = i.frames[c], m = f.rect.x, u = f.rect.y, p = f.rect.width, S = f.rect.height, g = r.toRGBA8.decodeImage(f.data, p, S, i);
            if (c == 0 ? h = g : f.blend == 0 ? r._copyTile(g, p, S, h, a, o, m, u, 0) : f.blend == 1 && r._copyTile(g, p, S, h, a, o, m, u, 1), l.push(h.buffer), h = h.slice(0), f.dispose != 0) {
              if (f.dispose == 1) r._copyTile(v, p, S, h, a, o, m, u, 0);
              else if (f.dispose == 2) {
                for (var b = c - 1; i.frames[b].dispose == 2; ) b--;
                h = new Uint8Array(l[b]).slice(0);
              }
            }
          }
          return l;
        }, r.toRGBA8.decodeImage = function(i, a, o, l) {
          var h = a * o, v = r.decode._getBPP(l), c = Math.ceil(a * v / 8), f = new Uint8Array(h * 4), m = new Uint32Array(f.buffer), u = l.ctype, p = l.depth, S = r._bin.readUshort;
          if (u == 6) {
            var g = h << 2;
            if (p == 8) for (var b = 0; b < g; b++)
              f[b] = i[b];
            if (p == 16) for (var b = 0; b < g; b++)
              f[b] = i[b << 1];
          } else if (u == 2) {
            var _ = l.tabs.tRNS, T = -1, I = -1, L = -1;
            if (_ && (T = _[0], I = _[1], L = _[2]), p == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 3;
              f[C] = i[F], f[C + 1] = i[F + 1], f[C + 2] = i[F + 2], f[C + 3] = 255, T != -1 && i[F] == T && i[F + 1] == I && i[F + 2] == L && (f[C + 3] = 0);
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, F = b * 6;
              f[C] = i[F], f[C + 1] = i[F + 2], f[C + 2] = i[F + 4], f[C + 3] = 255, T != -1 && S(i, F) == T && S(i, F + 2) == I && S(i, F + 4) == L && (f[C + 3] = 0);
            }
          } else if (u == 3) {
            var z = l.tabs.PLTE, X = l.tabs.tRNS, O = X ? X.length : 0;
            if (p == 1) for (var G = 0; G < o; G++)
              for (var P = G * c, E = G * a, b = 0; b < a; b++) {
                var C = E + b << 2, A = i[P + (b >> 3)] >> 7 - ((b & 7) << 0) & 1, V = 3 * A;
                f[C] = z[V], f[C + 1] = z[V + 1], f[C + 2] = z[V + 2], f[C + 3] = A < O ? X[A] : 255;
              }
            if (p == 2) for (var G = 0; G < o; G++)
              for (var P = G * c, E = G * a, b = 0; b < a; b++) {
                var C = E + b << 2, A = i[P + (b >> 2)] >> 6 - ((b & 3) << 1) & 3, V = 3 * A;
                f[C] = z[V], f[C + 1] = z[V + 1], f[C + 2] = z[V + 2], f[C + 3] = A < O ? X[A] : 255;
              }
            if (p == 4) for (var G = 0; G < o; G++)
              for (var P = G * c, E = G * a, b = 0; b < a; b++) {
                var C = E + b << 2, A = i[P + (b >> 1)] >> 4 - ((b & 1) << 2) & 15, V = 3 * A;
                f[C] = z[V], f[C + 1] = z[V + 1], f[C + 2] = z[V + 2], f[C + 3] = A < O ? X[A] : 255;
              }
            if (p == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, A = i[b], V = 3 * A;
              f[C] = z[V], f[C + 1] = z[V + 1], f[C + 2] = z[V + 2], f[C + 3] = A < O ? X[A] : 255;
            }
          } else if (u == 4) {
            if (p == 8) for (var b = 0; b < h; b++) {
              var C = b << 2, H = b << 1, K = i[H];
              f[C] = K, f[C + 1] = K, f[C + 2] = K, f[C + 3] = i[H + 1];
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var C = b << 2, H = b << 2, K = i[H];
              f[C] = K, f[C + 1] = K, f[C + 2] = K, f[C + 3] = i[H + 2];
            }
          } else if (u == 0) {
            var T = l.tabs.tRNS ? l.tabs.tRNS : -1;
            if (p == 1) for (var b = 0; b < h; b++) {
              var K = 255 * (i[b >> 3] >> 7 - (b & 7) & 1), B = K == T * 255 ? 0 : 255;
              m[b] = B << 24 | K << 16 | K << 8 | K;
            }
            if (p == 2) for (var b = 0; b < h; b++) {
              var K = 85 * (i[b >> 2] >> 6 - ((b & 3) << 1) & 3), B = K == T * 85 ? 0 : 255;
              m[b] = B << 24 | K << 16 | K << 8 | K;
            }
            if (p == 4) for (var b = 0; b < h; b++) {
              var K = 17 * (i[b >> 1] >> 4 - ((b & 1) << 2) & 15), B = K == T * 17 ? 0 : 255;
              m[b] = B << 24 | K << 16 | K << 8 | K;
            }
            if (p == 8) for (var b = 0; b < h; b++) {
              var K = i[b], B = K == T ? 0 : 255;
              m[b] = B << 24 | K << 16 | K << 8 | K;
            }
            if (p == 16) for (var b = 0; b < h; b++) {
              var K = i[b << 1], B = S(i, b << 1) == T ? 0 : 255;
              m[b] = B << 24 | K << 16 | K << 8 | K;
            }
          }
          return f;
        }, r.decode = function(i) {
          for (var a = new Uint8Array(i), o = 8, l = r._bin, h = l.readUshort, v = l.readUint, c = { tabs: {}, frames: [] }, f = new Uint8Array(a.length), m = 0, u, p = 0, S = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) if (a[g] != S[g]) throw "The input is not a PNG file!";
          for (; o < a.length; ) {
            var b = l.readUint(a, o);
            o += 4;
            var _ = l.readASCII(a, o, 4);
            if (o += 4, _ == "IHDR")
              r.decode._IHDR(a, o, c);
            else if (_ == "IDAT") {
              for (var g = 0; g < b; g++) f[m + g] = a[o + g];
              m += b;
            } else if (_ == "acTL")
              c.tabs[_] = { num_frames: v(a, o), num_plays: v(a, o + 4) }, u = new Uint8Array(a.length);
            else if (_ == "fcTL") {
              if (p != 0) {
                var T = c.frames[c.frames.length - 1];
                T.data = r.decode._decompress(c, u.slice(0, p), T.rect.width, T.rect.height), p = 0;
              }
              var I = { x: v(a, o + 12), y: v(a, o + 16), width: v(a, o + 4), height: v(a, o + 8) }, L = h(a, o + 22);
              L = h(a, o + 20) / (L == 0 ? 100 : L);
              var C = { rect: I, delay: Math.round(L * 1e3), dispose: a[o + 24], blend: a[o + 25] };
              c.frames.push(C);
            } else if (_ == "fdAT") {
              for (var g = 0; g < b - 4; g++) u[p + g] = a[o + g + 4];
              p += b - 4;
            } else if (_ == "pHYs")
              c.tabs[_] = [l.readUint(a, o), l.readUint(a, o + 4), a[o + 8]];
            else if (_ == "cHRM") {
              c.tabs[_] = [];
              for (var g = 0; g < 8; g++) c.tabs[_].push(l.readUint(a, o + g * 4));
            } else if (_ == "tEXt") {
              c.tabs[_] == null && (c.tabs[_] = {});
              var F = l.nextZero(a, o), z = l.readASCII(a, o, F - o), X = l.readASCII(a, F + 1, o + b - F - 1);
              c.tabs[_][z] = X;
            } else if (_ == "iTXt") {
              c.tabs[_] == null && (c.tabs[_] = {});
              var F = 0, O = o;
              F = l.nextZero(a, O);
              var z = l.readASCII(a, O, F - O);
              O = F + 1, a[O], a[O + 1], O += 2, F = l.nextZero(a, O), l.readASCII(a, O, F - O), O = F + 1, F = l.nextZero(a, O), l.readUTF8(a, O, F - O), O = F + 1;
              var X = l.readUTF8(a, O, b - (O - o));
              c.tabs[_][z] = X;
            } else if (_ == "PLTE")
              c.tabs[_] = l.readBytes(a, o, b);
            else if (_ == "hIST") {
              var G = c.tabs.PLTE.length / 3;
              c.tabs[_] = [];
              for (var g = 0; g < G; g++) c.tabs[_].push(h(a, o + g * 2));
            } else if (_ == "tRNS")
              c.ctype == 3 ? c.tabs[_] = l.readBytes(a, o, b) : c.ctype == 0 ? c.tabs[_] = h(a, o) : c.ctype == 2 && (c.tabs[_] = [h(a, o), h(a, o + 2), h(a, o + 4)]);
            else if (_ == "gAMA") c.tabs[_] = l.readUint(a, o) / 1e5;
            else if (_ == "sRGB") c.tabs[_] = a[o];
            else if (_ == "bKGD")
              c.ctype == 0 || c.ctype == 4 ? c.tabs[_] = [h(a, o)] : c.ctype == 2 || c.ctype == 6 ? c.tabs[_] = [h(a, o), h(a, o + 2), h(a, o + 4)] : c.ctype == 3 && (c.tabs[_] = a[o]);
            else if (_ == "IEND") {
              if (p != 0) {
                var T = c.frames[c.frames.length - 1];
                T.data = r.decode._decompress(c, u.slice(0, p), T.rect.width, T.rect.height), p = 0;
              }
              c.data = r.decode._decompress(c, f, c.width, c.height);
              break;
            }
            o += b, l.readUint(a, o), o += 4;
          }
          return delete c.compress, delete c.interlace, delete c.filter, c;
        }, r.decode._decompress = function(i, a, o, l) {
          return i.compress == 0 && (a = r.decode._inflate(a)), i.interlace == 0 ? a = r.decode._filterZero(a, i, 0, o, l) : i.interlace == 1 && (a = r.decode._readInterlace(a, i)), a;
        }, r.decode._inflate = function(i) {
          return s.inflate(i);
        }, r.decode._readInterlace = function(i, a) {
          for (var o = a.width, l = a.height, h = r.decode._getBPP(a), v = h >> 3, c = Math.ceil(o * h / 8), f = new Uint8Array(l * c), m = 0, u = [0, 0, 4, 0, 2, 0, 1], p = [0, 4, 0, 2, 0, 1, 0], S = [8, 8, 8, 4, 4, 2, 2], g = [8, 8, 4, 4, 2, 2, 1], b = 0; b < 7; ) {
            for (var _ = S[b], T = g[b], I = 0, L = 0, C = u[b]; C < l; )
              C += _, L++;
            for (var F = p[b]; F < o; )
              F += T, I++;
            var z = Math.ceil(I * h / 8);
            r.decode._filterZero(i, a, m, I, L);
            for (var X = 0, O = u[b]; O < l; ) {
              for (var G = p[b], P = m + X * z << 3; G < o; ) {
                if (h == 1) {
                  var E = i[P >> 3];
                  E = E >> 7 - (P & 7) & 1, f[O * c + (G >> 3)] |= E << 7 - ((G & 3) << 0);
                }
                if (h == 2) {
                  var E = i[P >> 3];
                  E = E >> 6 - (P & 7) & 3, f[O * c + (G >> 2)] |= E << 6 - ((G & 3) << 1);
                }
                if (h == 4) {
                  var E = i[P >> 3];
                  E = E >> 4 - (P & 7) & 15, f[O * c + (G >> 1)] |= E << 4 - ((G & 1) << 2);
                }
                if (h >= 8)
                  for (var A = O * c + G * v, V = 0; V < v; V++) f[A + V] = i[(P >> 3) + V];
                P += h, G += T;
              }
              X++, O += _;
            }
            I * L != 0 && (m += L * (1 + z)), b = b + 1;
          }
          return f;
        }, r.decode._getBPP = function(i) {
          var a = [1, null, 3, 1, 2, null, 4][i.ctype];
          return a * i.depth;
        }, r.decode._filterZero = function(i, a, o, l, h) {
          var v = r.decode._getBPP(a), c = Math.ceil(l * v / 8), f = r.decode._paeth;
          v = Math.ceil(v / 8);
          for (var m = 0; m < h; m++) {
            var u = o + m * c, p = u + m + 1, S = i[p - 1];
            if (S == 0) for (var g = 0; g < c; g++) i[u + g] = i[p + g];
            else if (S == 1) {
              for (var g = 0; g < v; g++) i[u + g] = i[p + g];
              for (var g = v; g < c; g++) i[u + g] = i[p + g] + i[u + g - v] & 255;
            } else if (m == 0) {
              for (var g = 0; g < v; g++) i[u + g] = i[p + g];
              if (S == 2) for (var g = v; g < c; g++) i[u + g] = i[p + g] & 255;
              if (S == 3) for (var g = v; g < c; g++) i[u + g] = i[p + g] + (i[u + g - v] >> 1) & 255;
              if (S == 4) for (var g = v; g < c; g++) i[u + g] = i[p + g] + f(i[u + g - v], 0, 0) & 255;
            } else {
              if (S == 2)
                for (var g = 0; g < c; g++) i[u + g] = i[p + g] + i[u + g - c] & 255;
              if (S == 3) {
                for (var g = 0; g < v; g++) i[u + g] = i[p + g] + (i[u + g - c] >> 1) & 255;
                for (var g = v; g < c; g++) i[u + g] = i[p + g] + (i[u + g - c] + i[u + g - v] >> 1) & 255;
              }
              if (S == 4) {
                for (var g = 0; g < v; g++) i[u + g] = i[p + g] + f(0, i[u + g - c], 0) & 255;
                for (var g = v; g < c; g++) i[u + g] = i[p + g] + f(i[u + g - v], i[u + g - c], i[u + g - v - c]) & 255;
              }
            }
          }
          return i;
        }, r.decode._paeth = function(i, a, o) {
          var l = i + a - o, h = Math.abs(l - i), v = Math.abs(l - a), c = Math.abs(l - o);
          return h <= v && h <= c ? i : v <= c ? a : o;
        }, r.decode._IHDR = function(i, a, o) {
          var l = r._bin;
          o.width = l.readUint(i, a), a += 4, o.height = l.readUint(i, a), a += 4, o.depth = i[a], a++, o.ctype = i[a], a++, o.compress = i[a], a++, o.filter = i[a], a++, o.interlace = i[a], a++;
        }, r._bin = {
          nextZero: function(i, a) {
            for (; i[a] != 0; ) a++;
            return a;
          },
          readUshort: function(i, a) {
            return i[a] << 8 | i[a + 1];
          },
          writeUshort: function(i, a, o) {
            i[a] = o >> 8 & 255, i[a + 1] = o & 255;
          },
          readUint: function(i, a) {
            return i[a] * (256 * 256 * 256) + (i[a + 1] << 16 | i[a + 2] << 8 | i[a + 3]);
          },
          writeUint: function(i, a, o) {
            i[a] = o >> 24 & 255, i[a + 1] = o >> 16 & 255, i[a + 2] = o >> 8 & 255, i[a + 3] = o & 255;
          },
          readASCII: function(i, a, o) {
            for (var l = "", h = 0; h < o; h++) l += String.fromCharCode(i[a + h]);
            return l;
          },
          writeASCII: function(i, a, o) {
            for (var l = 0; l < o.length; l++) i[a + l] = o.charCodeAt(l);
          },
          readBytes: function(i, a, o) {
            for (var l = [], h = 0; h < o; h++) l.push(i[a + h]);
            return l;
          },
          pad: function(i) {
            return i.length < 2 ? "0" + i : i;
          },
          readUTF8: function(i, a, o) {
            for (var l = "", h, v = 0; v < o; v++) l += "%" + r._bin.pad(i[a + v].toString(16));
            try {
              h = decodeURIComponent(l);
            } catch {
              return r._bin.readASCII(i, a, o);
            }
            return h;
          }
        }, r._copyTile = function(i, a, o, l, h, v, c, f, m) {
          for (var u = Math.min(a, h), p = Math.min(o, v), S = 0, g = 0, b = 0; b < p; b++)
            for (var _ = 0; _ < u; _++)
              if (c >= 0 && f >= 0 ? (S = b * a + _ << 2, g = (f + b) * h + c + _ << 2) : (S = (-f + b) * a - c + _ << 2, g = b * h + _ << 2), m == 0)
                l[g] = i[S], l[g + 1] = i[S + 1], l[g + 2] = i[S + 2], l[g + 3] = i[S + 3];
              else if (m == 1) {
                var T = i[S + 3] * 0.00392156862745098, I = i[S] * T, L = i[S + 1] * T, C = i[S + 2] * T, F = l[g + 3] * (1 / 255), z = l[g] * F, X = l[g + 1] * F, O = l[g + 2] * F, G = 1 - T, P = T + F * G, E = P == 0 ? 0 : 1 / P;
                l[g + 3] = 255 * P, l[g + 0] = (I + z * G) * E, l[g + 1] = (L + X * G) * E, l[g + 2] = (C + O * G) * E;
              } else if (m == 2) {
                var T = i[S + 3], I = i[S], L = i[S + 1], C = i[S + 2], F = l[g + 3], z = l[g], X = l[g + 1], O = l[g + 2];
                T == F && I == z && L == X && C == O ? (l[g] = 0, l[g + 1] = 0, l[g + 2] = 0, l[g + 3] = 0) : (l[g] = I, l[g + 1] = L, l[g + 2] = C, l[g + 3] = T);
              } else if (m == 3) {
                var T = i[S + 3], I = i[S], L = i[S + 1], C = i[S + 2], F = l[g + 3], z = l[g], X = l[g + 1], O = l[g + 2];
                if (T == F && I == z && L == X && C == O) continue;
                if (T < 220 && F > 20) return !1;
              }
          return !0;
        }, r.encode = function(i, a, o, l, h, v) {
          l == null && (l = 0), v == null && (v = !1);
          for (var c = new Uint8Array(i[0].byteLength * i.length + 100), f = [137, 80, 78, 71, 13, 10, 26, 10], m = 0; m < 8; m++) c[m] = f[m];
          var u = 8, p = r._bin, S = r.crc.crc, g = p.writeUint, b = p.writeUshort, _ = p.writeASCII, T = r.encode.compressPNG(i, a, o, l, v);
          g(c, u, 13), u += 4, _(c, u, "IHDR"), u += 4, g(c, u, a), u += 4, g(c, u, o), u += 4, c[u] = T.depth, u++, c[u] = T.ctype, u++, c[u] = 0, u++, c[u] = 0, u++, c[u] = 0, u++, g(c, u, S(c, u - 17, 17)), u += 4, g(c, u, 1), u += 4, _(c, u, "sRGB"), u += 4, c[u] = 1, u++, g(c, u, S(c, u - 5, 5)), u += 4;
          var I = i.length > 1;
          if (I && (g(c, u, 8), u += 4, _(c, u, "acTL"), u += 4, g(c, u, i.length), u += 4, g(c, u, 0), u += 4, g(c, u, S(c, u - 12, 12)), u += 4), T.ctype == 3) {
            var L = T.plte.length;
            g(c, u, L * 3), u += 4, _(c, u, "PLTE"), u += 4;
            for (var m = 0; m < L; m++) {
              var C = m * 3, F = T.plte[m], z = F & 255, X = F >> 8 & 255, O = F >> 16 & 255;
              c[u + C + 0] = z, c[u + C + 1] = X, c[u + C + 2] = O;
            }
            if (u += L * 3, g(c, u, S(c, u - L * 3 - 4, L * 3 + 4)), u += 4, T.gotAlpha) {
              g(c, u, L), u += 4, _(c, u, "tRNS"), u += 4;
              for (var m = 0; m < L; m++) c[u + m] = T.plte[m] >> 24 & 255;
              u += L, g(c, u, S(c, u - L - 4, L + 4)), u += 4;
            }
          }
          for (var G = 0, P = 0; P < T.frames.length; P++) {
            var E = T.frames[P];
            I && (g(c, u, 26), u += 4, _(c, u, "fcTL"), u += 4, g(c, u, G++), u += 4, g(c, u, E.rect.width), u += 4, g(c, u, E.rect.height), u += 4, g(c, u, E.rect.x), u += 4, g(c, u, E.rect.y), u += 4, b(c, u, h[P]), u += 2, b(c, u, 1e3), u += 2, c[u] = E.dispose, u++, c[u] = E.blend, u++, g(c, u, S(c, u - 30, 30)), u += 4);
            var A = E.cimg, L = A.length;
            g(c, u, L + (P == 0 ? 0 : 4)), u += 4;
            var V = u;
            _(c, u, P == 0 ? "IDAT" : "fdAT"), u += 4, P != 0 && (g(c, u, G++), u += 4);
            for (var m = 0; m < L; m++) c[u + m] = A[m];
            u += L, g(c, u, S(c, V, u - V)), u += 4;
          }
          return g(c, u, 0), u += 4, _(c, u, "IEND"), u += 4, g(c, u, S(c, u - 4, 4)), u += 4, c.buffer.slice(0, u);
        }, r.encode.compressPNG = function(i, a, o, l, h) {
          for (var v = r.encode.compress(i, a, o, l, !1, h), c = 0; c < i.length; c++) {
            var f = v.frames[c];
            f.rect.width;
            var m = f.rect.height, u = f.bpl, p = f.bpp, S = new Uint8Array(m * u + m);
            f.cimg = r.encode._filterZero(f.img, m, p, u, S);
          }
          return v;
        }, r.encode.compress = function(i, a, o, l, h, v) {
          v == null && (v = !1);
          for (var c = 6, f = 8, m = 4, u = 255, p = 0; p < i.length; p++)
            for (var S = new Uint8Array(i[p]), g = S.length, b = 0; b < g; b += 4) u &= S[b + 3];
          var _ = u != 255, T = {}, I = [];
          if (i.length != 0 && (T[0] = 0, I.push(0), l != 0 && l--), l != 0) {
            var L = r.quantize(i, l, h);
            i = L.bufs;
            for (var b = 0; b < L.plte.length; b++) {
              var C = L.plte[b].est.rgba;
              T[C] == null && (T[C] = I.length, I.push(C));
            }
          } else
            for (var p = 0; p < i.length; p++)
              for (var F = new Uint32Array(i[p]), g = F.length, b = 0; b < g; b++) {
                var C = F[b];
                if ((b < a || C != F[b - 1] && C != F[b - a]) && T[C] == null && (T[C] = I.length, I.push(C), I.length >= 300))
                  break;
              }
          var z = _ ? h : !1, X = I.length;
          X <= 256 && v == !1 && (X <= 2 ? f = 1 : X <= 4 ? f = 2 : X <= 16 ? f = 4 : f = 8, h && (f = 8), _ = !0);
          for (var O = [], p = 0; p < i.length; p++) {
            var G = new Uint8Array(i[p]), P = new Uint32Array(G.buffer), E = 0, A = 0, V = a, H = o, K = 0;
            if (p != 0 && !z) {
              for (var B = h || p == 1 || O[O.length - 2].dispose == 2 ? 1 : 2, ae = 0, le = 1e9, se = 0; se < B; se++) {
                for (var ue = new Uint8Array(i[p - 1 - se]), be = new Uint32Array(i[p - 1 - se]), Me = a, Se = o, te = -1, he = -1, ge = 0; ge < o; ge++) for (var pe = 0; pe < a; pe++) {
                  var b = ge * a + pe;
                  P[b] != be[b] && (pe < Me && (Me = pe), pe > te && (te = pe), ge < Se && (Se = ge), ge > he && (he = ge));
                }
                var ze = te == -1 ? 1 : (te - Me + 1) * (he - Se + 1);
                ze < le && (le = ze, ae = se, te == -1 ? (E = A = 0, V = H = 1) : (E = Me, A = Se, V = te - Me + 1, H = he - Se + 1));
              }
              var ue = new Uint8Array(i[p - 1 - ae]);
              ae == 1 && (O[O.length - 1].dispose = 2);
              var oe = new Uint8Array(V * H * 4);
              new Uint32Array(oe.buffer), r._copyTile(ue, a, o, oe, V, H, -E, -A, 0), r._copyTile(G, a, o, oe, V, H, -E, -A, 3) ? (r._copyTile(G, a, o, oe, V, H, -E, -A, 2), K = 1) : (r._copyTile(G, a, o, oe, V, H, -E, -A, 0), K = 0), G = oe, P = new Uint32Array(G.buffer);
            }
            var ye = 4 * V;
            if (X <= 256 && v == !1) {
              ye = Math.ceil(f * V / 8);
              for (var oe = new Uint8Array(ye * H), ge = 0; ge < H; ge++) {
                var b = ge * ye, Pe = ge * V;
                if (f == 8) for (var pe = 0; pe < V; pe++) oe[b + pe] = T[P[Pe + pe]];
                else if (f == 4) for (var pe = 0; pe < V; pe++) oe[b + (pe >> 1)] |= T[P[Pe + pe]] << 4 - (pe & 1) * 4;
                else if (f == 2) for (var pe = 0; pe < V; pe++) oe[b + (pe >> 2)] |= T[P[Pe + pe]] << 6 - (pe & 3) * 2;
                else if (f == 1) for (var pe = 0; pe < V; pe++) oe[b + (pe >> 3)] |= T[P[Pe + pe]] << 7 - (pe & 7) * 1;
              }
              G = oe, c = 3, m = 1;
            } else if (_ == !1 && i.length == 1) {
              for (var oe = new Uint8Array(V * H * 3), Ue = V * H, b = 0; b < Ue; b++) {
                var qe = b * 3, Be = b * 4;
                oe[qe] = G[Be], oe[qe + 1] = G[Be + 1], oe[qe + 2] = G[Be + 2];
              }
              G = oe, c = 2, m = 3, ye = 3 * V;
            }
            O.push({ rect: { x: E, y: A, width: V, height: H }, img: G, bpl: ye, bpp: m, blend: K, dispose: z ? 1 : 0 });
          }
          return { ctype: c, depth: f, plte: I, gotAlpha: _, frames: O };
        }, r.encode._filterZero = function(i, a, o, l, h) {
          for (var v = [], c = 0; c < 5; c++)
            if (!(a * l > 5e5 && (c == 2 || c == 3 || c == 4))) {
              for (var f = 0; f < a; f++) r.encode._filterLine(h, i, f, l, o, c);
              if (v.push(s.deflate(h)), o == 1) break;
            }
          for (var m, u = 1e9, p = 0; p < v.length; p++) v[p].length < u && (m = p, u = v[p].length);
          return v[m];
        }, r.encode._filterLine = function(i, a, o, l, h, v) {
          var c = o * l, f = c + o, m = r.decode._paeth;
          if (i[f] = v, f++, v == 0) for (var u = 0; u < l; u++) i[f + u] = a[c + u];
          else if (v == 1) {
            for (var u = 0; u < h; u++) i[f + u] = a[c + u];
            for (var u = h; u < l; u++) i[f + u] = a[c + u] - a[c + u - h] + 256 & 255;
          } else if (o == 0) {
            for (var u = 0; u < h; u++) i[f + u] = a[c + u];
            if (v == 2) for (var u = h; u < l; u++) i[f + u] = a[c + u];
            if (v == 3) for (var u = h; u < l; u++) i[f + u] = a[c + u] - (a[c + u - h] >> 1) + 256 & 255;
            if (v == 4) for (var u = h; u < l; u++) i[f + u] = a[c + u] - m(a[c + u - h], 0, 0) + 256 & 255;
          } else {
            if (v == 2)
              for (var u = 0; u < l; u++) i[f + u] = a[c + u] + 256 - a[c + u - l] & 255;
            if (v == 3) {
              for (var u = 0; u < h; u++) i[f + u] = a[c + u] + 256 - (a[c + u - l] >> 1) & 255;
              for (var u = h; u < l; u++) i[f + u] = a[c + u] + 256 - (a[c + u - l] + a[c + u - h] >> 1) & 255;
            }
            if (v == 4) {
              for (var u = 0; u < h; u++) i[f + u] = a[c + u] + 256 - m(0, a[c + u - l], 0) & 255;
              for (var u = h; u < l; u++) i[f + u] = a[c + u] + 256 - m(a[c + u - h], a[c + u - l], a[c + u - h - l]) & 255;
            }
          }
        }, r.crc = {
          table: (function() {
            for (var i = new Uint32Array(256), a = 0; a < 256; a++) {
              for (var o = a, l = 0; l < 8; l++)
                o & 1 ? o = 3988292384 ^ o >>> 1 : o = o >>> 1;
              i[a] = o;
            }
            return i;
          })(),
          update: function(i, a, o, l) {
            for (var h = 0; h < l; h++) i = r.crc.table[(i ^ a[o + h]) & 255] ^ i >>> 8;
            return i;
          },
          crc: function(i, a, o) {
            return r.crc.update(4294967295, i, a, o) ^ 4294967295;
          }
        }, r.quantize = function(i, a, o) {
          for (var l = [], h = 0, v = 0; v < i.length; v++)
            l.push(r.encode.alphaMul(new Uint8Array(i[v]), o)), h += i[v].byteLength;
          for (var c = new Uint8Array(h), f = new Uint32Array(c.buffer), m = 0, v = 0; v < l.length; v++) {
            for (var u = l[v], p = u.length, S = 0; S < p; S++) c[m + S] = u[S];
            m += p;
          }
          var g = { i0: 0, i1: c.length, bst: null, est: null, tdst: 0, left: null, right: null };
          g.bst = r.quantize.stats(c, g.i0, g.i1), g.est = r.quantize.estats(g.bst);
          for (var b = [g]; b.length < a; ) {
            for (var _ = 0, T = 0, v = 0; v < b.length; v++) b[v].est.L > _ && (_ = b[v].est.L, T = v);
            if (_ < 1e-3) break;
            var I = b[T], L = r.quantize.splitPixels(c, f, I.i0, I.i1, I.est.e, I.est.eMq255), C = { i0: I.i0, i1: L, bst: null, est: null, tdst: 0, left: null, right: null };
            C.bst = r.quantize.stats(c, C.i0, C.i1), C.est = r.quantize.estats(C.bst);
            var F = { i0: L, i1: I.i1, bst: null, est: null, tdst: 0, left: null, right: null };
            F.bst = { R: [], m: [], N: I.bst.N - C.bst.N };
            for (var v = 0; v < 16; v++) F.bst.R[v] = I.bst.R[v] - C.bst.R[v];
            for (var v = 0; v < 4; v++) F.bst.m[v] = I.bst.m[v] - C.bst.m[v];
            F.est = r.quantize.estats(F.bst), I.left = C, I.right = F, b[T] = C, b.push(F);
          }
          b.sort(function(B, ae) {
            return ae.bst.N - B.bst.N;
          });
          for (var z = 0; z < l.length; z++) {
            for (var X = r.quantize.planeDst, O = new Uint8Array(l[z].buffer), G = new Uint32Array(l[z].buffer), P = O.length, v = 0; v < P; v += 4) {
              for (var E = O[v] * 0.00392156862745098, A = O[v + 1] * (1 / 255), V = O[v + 2] * (1 / 255), H = O[v + 3] * (1 / 255), K = g; K.left; ) K = X(K.est, E, A, V, H) <= 0 ? K.left : K.right;
              G[v >> 2] = K.est.rgba;
            }
            l[z] = G.buffer;
          }
          return { bufs: l, plte: b };
        }, r.quantize.getNearest = function(i, a, o, l, h) {
          if (i.left == null)
            return i.tdst = r.quantize.dist(i.est.q, a, o, l, h), i;
          var v = r.quantize.planeDst(i.est, a, o, l, h), c = i.left, f = i.right;
          v > 0 && (c = i.right, f = i.left);
          var m = r.quantize.getNearest(c, a, o, l, h);
          if (m.tdst <= v * v) return m;
          var u = r.quantize.getNearest(f, a, o, l, h);
          return u.tdst < m.tdst ? u : m;
        }, r.quantize.planeDst = function(i, a, o, l, h) {
          var v = i.e;
          return v[0] * a + v[1] * o + v[2] * l + v[3] * h - i.eMq;
        }, r.quantize.dist = function(i, a, o, l, h) {
          var v = a - i[0], c = o - i[1], f = l - i[2], m = h - i[3];
          return v * v + c * c + f * f + m * m;
        }, r.quantize.splitPixels = function(i, a, o, l, h, v) {
          var c = r.quantize.vecDot;
          for (l -= 4; o < l; ) {
            for (; c(i, o, h) <= v; ) o += 4;
            for (; c(i, l, h) > v; ) l -= 4;
            if (o >= l) break;
            var f = a[o >> 2];
            a[o >> 2] = a[l >> 2], a[l >> 2] = f, o += 4, l -= 4;
          }
          for (; c(i, o, h) > v; ) o -= 4;
          return o + 4;
        }, r.quantize.vecDot = function(i, a, o) {
          return i[a] * o[0] + i[a + 1] * o[1] + i[a + 2] * o[2] + i[a + 3] * o[3];
        }, r.quantize.stats = function(i, a, o) {
          for (var l = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], h = [0, 0, 0, 0], v = o - a >> 2, c = a; c < o; c += 4) {
            var f = i[c] * 0.00392156862745098, m = i[c + 1] * (1 / 255), u = i[c + 2] * (1 / 255), p = i[c + 3] * (1 / 255);
            h[0] += f, h[1] += m, h[2] += u, h[3] += p, l[0] += f * f, l[1] += f * m, l[2] += f * u, l[3] += f * p, l[5] += m * m, l[6] += m * u, l[7] += m * p, l[10] += u * u, l[11] += u * p, l[15] += p * p;
          }
          return l[4] = l[1], l[8] = l[2], l[12] = l[3], l[9] = l[6], l[13] = l[7], l[14] = l[11], { R: l, m: h, N: v };
        }, r.quantize.estats = function(i) {
          var a = i.R, o = i.m, l = i.N, h = o[0], v = o[1], c = o[2], f = o[3], m = l == 0 ? 0 : 1 / l, u = [
            a[0] - h * h * m,
            a[1] - h * v * m,
            a[2] - h * c * m,
            a[3] - h * f * m,
            a[4] - v * h * m,
            a[5] - v * v * m,
            a[6] - v * c * m,
            a[7] - v * f * m,
            a[8] - c * h * m,
            a[9] - c * v * m,
            a[10] - c * c * m,
            a[11] - c * f * m,
            a[12] - f * h * m,
            a[13] - f * v * m,
            a[14] - f * c * m,
            a[15] - f * f * m
          ], p = u, S = r.M4, g = [0.5, 0.5, 0.5, 0.5], b = 0, _ = 0;
          if (l != 0)
            for (var T = 0; T < 10 && (g = S.multVec(p, g), _ = Math.sqrt(S.dot(g, g)), g = S.sml(1 / _, g), !(Math.abs(_ - b) < 1e-9)); T++)
              b = _;
          var I = [h * m, v * m, c * m, f * m], L = S.dot(S.sml(255, I), g), C = I[3] < 1e-3 ? 0 : 1 / I[3];
          return {
            Cov: u,
            q: I,
            e: g,
            L: b,
            eMq255: L,
            eMq: S.dot(g, I),
            rgba: (Math.round(255 * I[3]) << 24 | Math.round(255 * I[2] * C) << 16 | Math.round(255 * I[1] * C) << 8 | Math.round(255 * I[0] * C) << 0) >>> 0
          };
        }, r.M4 = {
          multVec: function(i, a) {
            return [
              i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3],
              i[4] * a[0] + i[5] * a[1] + i[6] * a[2] + i[7] * a[3],
              i[8] * a[0] + i[9] * a[1] + i[10] * a[2] + i[11] * a[3],
              i[12] * a[0] + i[13] * a[1] + i[14] * a[2] + i[15] * a[3]
            ];
          },
          dot: function(i, a) {
            return i[0] * a[0] + i[1] * a[1] + i[2] * a[2] + i[3] * a[3];
          },
          sml: function(i, a) {
            return [i * a[0], i * a[1], i * a[2], i * a[3]];
          }
        }, r.encode.alphaMul = function(i, a) {
          for (var o = new Uint8Array(i.length), l = i.length >> 2, h = 0; h < l; h++) {
            var v = h << 2, c = i[v + 3];
            a && (c = c < 128 ? 0 : 255);
            var f = c * (1 / 255);
            o[v + 0] = i[v + 0] * f, o[v + 1] = i[v + 1] * f, o[v + 2] = i[v + 2] * f, o[v + 3] = c;
          }
          return o;
        };
      })(t, n);
    })();
  })(_r)), _r.exports;
}
var bh = gh();
const ph = /* @__PURE__ */ ih(bh), yh = () => pa() ? Na("NuxtImg") : "img", wh = ["alt", "src"], Sg = /* @__PURE__ */ Ce({
  __name: "LcImage",
  props: {
    alt: {},
    aspectRatio: {},
    blurHash: {},
    densities: {},
    fetchpriority: { default: "low" },
    height: {},
    loading: { type: Boolean },
    preload: { type: Boolean },
    src: {},
    width: {}
  },
  emits: ["error", "load"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("wrapper"), i = yh(), a = we(!0), o = Z(
      () => typeof e.aspectRatio == "number" ? e.aspectRatio : (Math.round(e.width) / Math.round(e.height)).toFixed(2)
    ), l = Z(() => s.value?.clientHeight ?? 0), h = Z(() => s.value?.clientWidth ?? 0), v = Z(() => e.loading || a.value), c = Z(() => {
      if (!e.blurHash) return;
      const m = rh(e.blurHash, 32, 32), u = new Uint8Array(m), p = ph.encode([u.buffer], 32, 32, 256);
      return "data:image/png;base64," + K0(p);
    }), f = () => {
      a.value = !1, r("load");
    };
    return t({
      clientHeight: l,
      clientWidth: h
    }), (m, u) => ($(), q("div", {
      ref: "wrapper",
      class: "lc-image",
      style: Ct({ "--image-aspect-ratio": o.value })
    }, [
      ($(), ke(Pt(U(i)), Ae({ key: "image" }, {
        alt: e.alt,
        densities: e.densities,
        fetchpriority: e.fetchpriority,
        height: e.height,
        preload: e.preload,
        src: e.src,
        width: e.width
      }, {
        class: "lc-image__image",
        loading: e.fetchpriority === "high" ? void 0 : "lazy",
        onError: u[0] || (u[0] = (p) => m.$emit("error")),
        onLoad: f
      }), null, 16, ["loading"])),
      c.value ? ($(), ke(wn, {
        key: 0,
        name: "lc-image__transition"
      }, {
        default: Te(() => [
          Qt(ee("img", Ae({ key: "placeholder" }, { height: e.height, width: e.width }, {
            alt: e.alt,
            class: "lc-image__placeholder",
            src: c.value
          }), null, 16, wh), [
            [ii, v.value]
          ])
        ]),
        _: 1
      })) : de("", !0)
    ], 4));
  }
}), xh = {
  key: 1,
  class: "lc-info-text__content"
}, kh = {
  key: 0,
  class: "lc-info-text__text"
}, _g = /* @__PURE__ */ Ce({
  __name: "LcInfoText",
  props: {
    headline: {},
    icon: { default: "info" },
    iconAlignment: { default: "top" },
    iconSize: { default: "medium" },
    size: { default: "medium" },
    text: {}
  },
  setup(e) {
    const t = An(), n = Z(() => [
      "lc-info-text",
      {
        [`lc-info-text--icon-align-${e.iconAlignment}`]: !0,
        [`lc-info-text--size-${e.size}`]: !0
      }
    ]), r = Z(() => [
      "lc-info-text__headline",
      {
        "lc-info-text__headline--with-margin": !!e.text || !!t.default
      }
    ]);
    return (s, i) => ($(), q("article", {
      class: xe(n.value)
    }, [
      Fe(U(Qe), {
        name: e.icon,
        size: e.iconSize
      }, null, 8, ["name", "size"]),
      ee("section", null, [
        e.headline ? ($(), q("span", {
          key: 0,
          class: xe(r.value)
        }, De(e.headline), 3)) : de("", !0),
        e.text || s.$slots.default ? ($(), q("div", xh, [
          me(s.$slots, "default", {}, () => [
            e.text ? ($(), q("p", kh, De(e.text), 1)) : de("", !0)
          ])
        ])) : de("", !0)
      ])
    ], 2));
  }
}), Cg = ["center", "top"], Eg = ["medium", "small"], Sh = { class: "lc-link-list" }, Tg = /* @__PURE__ */ Ce({
  __name: "LcLinkList",
  setup(e) {
    return (t, n) => ($(), q("ul", Sh, [
      me(t.$slots, "default")
    ]));
  }
}), _h = { key: 0 }, Ch = { class: "lc-link-list-item__headline" }, Eh = {
  key: 0,
  class: "lc-link-list-item__text"
}, Ag = /* @__PURE__ */ Ce({
  __name: "LcLinkListItem",
  props: {
    href: {},
    target: {},
    to: {},
    headline: {},
    icon: {},
    text: {}
  },
  setup(e) {
    const t = Z(() => [
      "lc-link-list-item",
      {
        "lc-link-list-item--headline-only": !e.text
      }
    ]);
    return (n, r) => ($(), q("li", {
      class: xe(t.value)
    }, [
      Fe(U(si), Ae({ href: e.href, target: e.target, to: e.to }, { class: "lc-link-list-item__link" }), {
        default: Te(() => [
          n.$slots.default ? ($(), q("div", _h, [
            me(n.$slots, "default")
          ])) : ($(), q(Ge, { key: 1 }, [
            e.icon ? ($(), ke(U(Qe), {
              key: 0,
              name: e.icon
            }, null, 8, ["name"])) : de("", !0),
            ee("div", null, [
              ee("span", Ch, De(e.headline), 1),
              e.text ? ($(), q("p", Eh, De(e.text), 1)) : de("", !0)
            ])
          ], 64))
        ]),
        _: 3
      }, 16)
    ], 2));
  }
}), Th = "data:image/svg+xml,%3csvg%20id='eSvZIJXzBLn1'%20width='16'%20height='16'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20viewBox='0%200%2016%2016'%20shape-rendering='geometricPrecision'%20text-rendering='geometricPrecision'%3e%3cstyle%3e%3c![CDATA[%23eSvZIJXzBLn2_to%20{animation:%20eSvZIJXzBLn2_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_to__to%20{%200%25%20{transform:%20translate(7.980026px,1.350002px)}%2024%25%20{transform:%20translate(7.980026px,1.350002px)}%2025%25%20{transform:%20translate(7.980026px,2.07px)}%2028%25%20{transform:%20translate(7.980026px,1px)}%2032%25%20{transform:%20translate(9.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20translate(5.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20translate(8.980026px,1px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20translate(6.980026px,1px)}%2044%25%20{transform:%20translate(7.999896px,1.175001px)}%2048%25%20{transform:%20translate(7.980026px,1.350002px);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2052%25%20{transform:%20translate(7.980026px,1.35px)}%20100%25%20{transform:%20translate(7.980026px,1.35px)}}%20%23eSvZIJXzBLn2_tr%20{animation:%20eSvZIJXzBLn2_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn2_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2028%25%20{transform:%20rotate(0deg)}%2032%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2036%25%20{transform:%20rotate(-8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2038%25%20{transform:%20rotate(8deg);animation-timing-function:%20cubic-bezier(0,0,0.58,1)}%2040%25%20{transform:%20rotate(-8deg)}%2044%25%20{transform:%20rotate(0deg)}%20100%25%20{transform:%20rotate(0deg)}}%20%23eSvZIJXzBLn3_to%20{animation:%20eSvZIJXzBLn3_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn3_tr%20{animation:%20eSvZIJXzBLn3_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn3_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn6_to%20{animation:%20eSvZIJXzBLn6_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000049px,9.6px)}%2044%25%20{transform:%20translate(8.000049px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}%20%23eSvZIJXzBLn6_tr%20{animation:%20eSvZIJXzBLn6_tr__tr%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn6_tr__tr%20{%200%25%20{transform:%20rotate(0deg)}%206%25%20{transform:%20rotate(0deg)}%2024%25%20{transform:%20rotate(360deg)}%20100%25%20{transform:%20rotate(360deg)}}%20%23eSvZIJXzBLn9_to%20{animation:%20eSvZIJXzBLn9_to__to%205000ms%20linear%20infinite%20normal%20forwards}@keyframes%20eSvZIJXzBLn9_to__to%20{%200%25%20{transform:%20translate(8.000025px,9.2px)}%2024%25%20{transform:%20translate(8.000025px,9.2px)}%2026.2%25%20{transform:%20translate(8.000025px,9.6px);animation-timing-function:%20cubic-bezier(0.42,0,1,1)}%2044%25%20{transform:%20translate(8.000025px,9.6px)}%2048%25%20{transform:%20translate(8.000025px,9.2px)}%20100%25%20{transform:%20translate(8.000025px,9.2px)}}]]%3e%3c/style%3e%3cg%20id='eSvZIJXzBLn2_to'%20transform='translate(7.980026,1.350002)'%3e%3cg%20id='eSvZIJXzBLn2_tr'%20transform='rotate(0)'%3e%3cpath%20d='M6.06888,2.13247c.8-.2,1.4-.26667,1.93333-.26667s1.13333.06667,1.86667.26667c.33332.13333.73332-.13333.80002-.46667.1333-.33333-.1334-.733329-.4667-.799996-.77705-.253981-1.07173-.333333-2.19999-.333333-.73333,0-1.40328.079352-2.26667.333333-.33333.066667-.53333.399996-.46666.799996.06666.33334.46666.53334.8.46667Z'%20transform='translate(-7.980026,-1.350002)'%20fill='%23394e8e'/%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn3_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn3_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='4.09313'%20rx='0.638'%20ry='0.638'%20transform='translate(7.36206%205.73901)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn6_to'%20transform='translate(8.000025,9.2)'%3e%3cg%20id='eSvZIJXzBLn6_tr'%20transform='rotate(0)'%3e%3cg%20transform='translate(-8.000049,-9.2)'%3e%3crect%20width='1.276'%20height='3.48663'%20rx='0.638'%20ry='0.638'%20transform='matrix(0-1%201%200%205.14111%209.83799)'%20fill='%23394e8e'/%3e%3ccircle%20r='6.15'%20transform='translate(8.00005%209.2)'%20fill='none'%20stroke='%23394e8e'%20stroke-width='0.1'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cg%20id='eSvZIJXzBLn9_to'%20transform='translate(8.000025,9.2)'%3e%3cpath%20d='M8.00005,14.2C10.7615,14.2,13,11.9614,13,9.2s-2.2385-5-4.99995-5-5,2.23858-5,5s2.23858,5,5,5Zm0,1.2C11.4242,15.4,14.2,12.6242,14.2,9.2s-2.7758-6.2-6.19995-6.2-6.2,2.77583-6.2,6.2s2.77583,6.2,6.2,6.2Z'%20transform='translate(-8.000025,-9.2)'%20clip-rule='evenodd'%20fill='%23394e8e'%20fill-rule='evenodd'/%3e%3c/g%3e%3c/svg%3e", Ah = { class: "lc-lottery-cutoff-time__headline" }, Lh = ["src"], $h = { class: "lc-lottery-cutoff-time__time-to-cutoff" }, Ih = { class: "lc-lottery-cutoff-time__time-is-almost-up" }, Dh = {
  key: 0,
  class: "lc-lottery-cutoff-time__divider"
}, Mh = { class: "lc-lottery-cutoff-time__countdown-wrapper" }, zl = /* @__PURE__ */ Ce({
  __name: "LcLotteryCutoffTime",
  props: {
    countdownVariant: { default: "default" },
    cutoffTime: {},
    locale: { default: () => We.general.locale },
    nextCutoffTime: {},
    singleLine: { type: Boolean },
    startAnimationTime: { default: 90 },
    textCutoffTime: { default: () => We.lcLotteryCutoffTime.textCutoffTime },
    textTimeIsAlmostUp: { default: () => We.lcLotteryCutoffTime.textTimeIsAlmostUp },
    textTimeToCutoff: { default: () => We.lcLotteryCutoffTime.textTimeToCutoff },
    variant: { default: "default" }
  },
  emits: ["cutoff-time-reached"],
  setup(e, { emit: t }) {
    const n = t, r = we(), s = Fo(() => /* @__PURE__ */ new Date()), i = Z(() => [
      "lc-lottery-cutoff-time",
      `lc-lottery-cutoff-time--variant-${e.variant}`,
      {
        "lc-lottery-cutoff-time--animated": h.value,
        "lc-lottery-cutoff-time--single-line": e.singleLine
      }
    ]), a = Z(() => new Date(e.cutoffTime)), o = Z(
      () => Bo({
        date: v.value,
        format: "drawingShort",
        locale: e.locale
      })
    ), l = Z(() => c("days") === 0), h = Z(() => {
      const m = c("minutes");
      return l.value && m ? m < e.startAnimationTime : !1;
    }), v = Z({
      get: () => r.value ?? new Date(e.cutoffTime),
      set: (m) => {
        r.value = m;
      }
    }), c = (m) => {
      if (!li(a.value)) return null;
      const { days: u = 0, hours: p = 0, minutes: S = 0 } = No(s.value, a.value);
      switch (m) {
        case "days":
          return u;
        case "minutes":
          return u * 24 + p * 60 + S;
      }
    }, f = () => {
      n("cutoff-time-reached"), _o(a.value) && e.nextCutoffTime && (v.value = new Date(e.nextCutoffTime));
    };
    return (m, u) => ($(), q("div", {
      class: xe(i.value)
    }, [
      ee("span", Ah, [
        h.value ? ($(), q("img", {
          key: 0,
          alt: "",
          height: "16",
          src: U(Th),
          width: "16"
        }, null, 8, Lh)) : ($(), ke(U(Qe), {
          key: 1,
          name: l.value ? "alarm" : "time",
          size: "small"
        }, null, 8, ["name"])),
        me(m.$slots, "title", {}, () => [
          ee("span", $h, De(l.value ? e.textTimeToCutoff : e.textCutoffTime), 1),
          ee("span", Ih, De(e.textTimeIsAlmostUp), 1)
        ])
      ]),
      e.variant === "default" && e.singleLine ? ($(), q("span", Dh, " : ")) : de("", !0),
      ee("div", Mh, [
        l.value ? ($(), ke(U(Gd), {
          key: 0,
          class: "lc-lottery-cutoff-time__countdown",
          "expires-at": v.value,
          variant: e.countdownVariant,
          onExpired: f,
          onUpdate: u[0] || (u[0] = (p) => s.value = /* @__PURE__ */ new Date())
        }, null, 8, ["expires-at", "variant"])) : ($(), ke(U(To), Ae({
          key: 1,
          class: "lc-lottery-cutoff-time__date-time"
        }, { locale: e.locale, ...U(mi).drawingShort }, { datetime: v.value }), {
          default: Te(() => [
            wt(De(o.value), 1)
          ]),
          _: 1
        }, 16, ["datetime"]))
      ])
    ], 2));
  }
}), Lg = ["default", "expressive"], Rh = {
  key: 0,
  class: "lc-lottery-numbers__icon-wrap"
}, Oh = {
  key: 0,
  class: "lc-lottery-numbers__field-divider"
}, Fh = "extra", Nh = /* @__PURE__ */ Ce({
  __name: "LcLotteryNumbers",
  props: {
    fields: {},
    listClass: {},
    numberClass: { type: Function },
    rows: {},
    size: { default: "medium" },
    spacing: { default: "medium" }
  },
  setup(e) {
    const t = Z(() => [
      "lc-lottery-numbers",
      `lc-lottery-numbers--size-${e.size}`,
      `lc-lottery-numbers--spacing-${e.spacing}`,
      {
        "lc-lottery-numbers--multiple-rows": e.rows
      }
    ]), n = Z(() => s.value.flat().length), r = Z(() => e.rows ? Math.ceil(n.value / e.rows) : n.value), s = Z(
      () => e.fields.map(
        ({ name: i, numbers: a }) => a.map(({ icon: o, ignored: l, matching: h, value: v }) => ({
          empty: !o && !l && (v === void 0 || v === ""),
          icon: o,
          ignored: l,
          matching: h,
          name: i.toLowerCase().replace("_", "-"),
          number: v
        }))
      ).filter((i) => !!i.length)
    );
    return (i, a) => ($(), q("article", {
      class: xe(t.value),
      style: Ct({ "--items-per-row": r.value })
    }, [
      ee("ol", {
        class: xe(["lc-lottery-numbers__list", e.listClass])
      }, [
        ($(!0), q(Ge, null, vt(s.value, (o, l) => ($(), q(Ge, { key: l }, [
          ($(!0), q(Ge, null, vt(o, ({ empty: h, icon: v, ignored: c, matching: f, name: m, number: u }, p) => ($(), q(Ge, {
            key: `${l}-${p}`
          }, [
            ee("li", {
              class: "lc-lottery-numbers__list-item",
              style: Ct({
                "--number-bg": `var(--lottery-numbers-${m}-bg)`,
                "--number-border": `var(--lottery-numbers-${m}-border)`,
                "--number-color": `var(--lottery-numbers-${m}-color)`,
                "--number-font-size": `var(--lottery-numbers-${m}-font-size)`,
                "--number-font-weight": `var(--lottery-numbers-${m}-font-weight)`
              })
            }, [
              me(i.$slots, `highlight-${m}`),
              ee("div", {
                class: xe(["lc-lottery-numbers__number", [
                  {
                    "lc-lottery-numbers__number--empty": h,
                    "lc-lottery-numbers__number--empty-extra": h && m === Fh,
                    "lc-lottery-numbers__number--ignored": c
                  },
                  e.numberClass ? e.numberClass(u, m) : ""
                ]])
              }, [
                f ? ($(), q("div", Rh, [
                  Fe(U(Qe), {
                    class: "lc-lottery-numbers__icon",
                    name: "checkmark-small"
                  })
                ])) : de("", !0),
                me(i.$slots, `number-${m}`, Ae({ ref_for: !0 }, { icon: v, number: u }), () => [
                  v ? ($(), ke(U(Qe), {
                    key: 0,
                    name: v
                  }, null, 8, ["name"])) : ($(), q(Ge, { key: 1 }, [
                    wt(De(c ? "X" : u), 1)
                  ], 64))
                ])
              ], 2)
            ], 4),
            l < s.value.length - 1 && p === o.length - 1 && i.$slots["field-divider"] ? ($(), q("li", Oh, [
              me(i.$slots, "field-divider")
            ])) : de("", !0)
          ], 64))), 128))
        ], 64))), 128))
      ], 2)
    ], 6));
  }
}), $g = ["large", "medium", "small"], Ig = ["medium", "small"], Dg = [
  "custom-cell",
  "default",
  "high-frequency",
  "round"
];
var Zt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Home = "Home", e))(Zt || {});
const Bh = ["id"], Ph = { class: "lc-lottery-number-selector__label" }, zh = ["for"], Vh = ["id", "checked", "disabled", "tabindex", "onChange", "onFocusin", "onKeydown"], Mg = /* @__PURE__ */ Ce({
  __name: "LcLotteryNumberSelector",
  props: {
    allNumbersToggled: { type: Boolean },
    disabled: { type: Boolean },
    fixedColumns: {},
    id: {},
    label: {},
    max: {},
    min: { default: 1 },
    selectableNumbers: {},
    selectableMax: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["complete", "update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Zo(), s = it("numberInputs"), i = Tt(e.id), a = we(e.fixedColumns ?? 0), o = we(0), l = Z(() => T(o.value)), h = Z(
      () => c.value ? u.value : f.value
    ), v = Z(() => L(o.value)), c = Z(() => e.value.length >= e.selectableMax), f = Z(() => {
      const B = Array.from({ length: b.value }, () => []);
      return m.value.map((ae, le) => {
        B[L(le)].push(le);
      }), E(B);
    }), m = Z(() => {
      if (e.selectableNumbers?.length)
        return [...e.selectableNumbers];
      if (e.max === void 0)
        throw Error('LcLotteryNumberSelector: provide "max" or "selectableNumbers".');
      if (e.min < 0)
        throw Error('LcLotteryNumberSelector: "min" must be >= 0.');
      if (e.min >= e.max)
        throw Error('LcLotteryNumberSelector: "max" must be greater than "min".');
      return Array.from({ length: e.max - e.min + 1 }, (B, ae) => e.min + ae);
    }), u = Z(
      () => f.value.map(
        (B) => B.map(
          (ae) => p.value.includes(ae) ? ae : -1
        )
      )
    ), p = Z(() => e.value.map((B) => m.value.indexOf(B))), S = Z(() => Math.min(g.value, a.value)), g = Z(() => m.value.length), b = Z(() => Math.ceil(g.value / S.value)), _ = (B) => {
      const ae = h.value.length, le = h.value[0].length;
      let se = v.value, be = l.value;
      do
        switch (B) {
          case "down":
            se = (se + 1) % ae, se === 0 && (be = (be + 1) % le);
            break;
          case "left":
            be = (be - 1 + le) % le, be === le - 1 && (se = (se - 1 + ae) % ae);
            break;
          case "right":
            be = (be + 1) % le, be === 0 && (se = (se + 1) % ae);
            break;
          case "up":
            se = (se - 1 + ae) % ae, se === ae - 1 && (be = (be - 1 + le) % le);
            break;
        }
      while (h.value[se][be] === -1);
      return h.value[se][be];
    }, T = (B) => B % S.value, I = (B) => ({
      "lc-lottery-number-selector__number": !0,
      "lc-lottery-number-selector__number--all-checked": e.allNumbersToggled,
      "lc-lottery-number-selector__number--checked": A(B),
      "lc-lottery-number-selector__number--disabled": V(B)
    }), L = (B) => Math.floor(B / S.value), C = () => {
      if (c.value) {
        const le = f.value[v.value].filter(
          (se) => se > o.value && p.value.includes(se)
        ).reverse();
        if (!le.length) return;
        o.value = le[0];
        return;
      }
      const B = f.value[v.value];
      o.value = B.at(-1) ?? 0;
    }, F = () => {
      if (c.value) {
        const le = f.value[v.value].filter(
          (se) => se < o.value && p.value.includes(se)
        );
        if (!le.length) return;
        o.value = le[0];
        return;
      }
      const B = f.value[v.value];
      o.value = B[0];
    }, z = () => {
      o.value = c.value ? p.value[0] : 0;
    }, X = () => {
      const B = p.value.at(-1) ?? 0;
      o.value = c.value ? B : g.value - 1;
    }, O = (B) => {
      tn(B.key, Zt) && (B.preventDefault(), B.stopPropagation(), B.ctrlKey ? G(B.key) : P(B.key));
    }, G = (B) => {
      switch (B) {
        case Zt.End:
          X();
          break;
        case Zt.Home:
          z();
          break;
      }
    }, P = (B) => {
      switch (B) {
        case Zt.ArrowDown:
          o.value = _("down");
          break;
        case Zt.ArrowLeft:
          o.value = _("left");
          break;
        case Zt.ArrowRight:
          o.value = _("right");
          break;
        case Zt.ArrowUp:
          o.value = _("up");
          break;
        case Zt.End:
          C();
          break;
        case Zt.Home:
          F();
          break;
      }
    }, E = (B) => {
      const ae = Math.max(...B.map((le) => le.length));
      return B.map((le) => {
        const se = [...le];
        for (; se.length < ae; )
          se.push(-1);
        return se;
      });
    }, A = (B) => e.value.includes(B), V = (B) => e.disabled || !A(B) && c.value || e.allNumbersToggled, H = (B) => {
      const ae = [...e.value], le = ae.indexOf(B);
      le > -1 ? ae.splice(le, 1) : c.value || (ae.push(B), ae.sort((se, be) => se - be)), n("update:value", ae);
    };
    Ve(
      () => e.allNumbersToggled,
      () => {
        const B = e.allNumbersToggled ? m.value : [];
        n("update:value", B);
      }
    ), Ve(o, (B) => {
      s.value?.[B].focus();
    }), Ve(c, (B) => {
      B && n("complete");
    });
    const K = Qs(() => {
      if (e.fixedColumns && e.fixedColumns >= 0) {
        a.value = e.fixedColumns;
        return;
      }
      const B = s.value;
      if (!r || !B?.length) return;
      const ae = B[0].getBoundingClientRect().top;
      let le = 0;
      for (const se of B) {
        if (se.getBoundingClientRect().top !== ae) break;
        le++;
      }
      a.value = le;
    }, 100);
    return Ve(() => e.fixedColumns, K), mt(K), Ut(window, "resize", K), (B, ae) => ($(), q("fieldset", Ae(B.$attrs, {
      id: U(i),
      class: [
        "lc-lottery-number-selector",
        `lc-lottery-number-selector--${e.variant}`,
        {
          "lc-lottery-number-selector--fixed-columns": e.fixedColumns && e.fixedColumns >= 0
        }
      ],
      style: {
        "--fixed-columns": e.fixedColumns,
        "--hfg-number-background": "var(--lottery-numbers-extra-bg)",
        "--number-bg": "var(--lottery-numbers-extra-bg)",
        "--round-number-bg": `var(--lottery-number-rounded-${e.id}-bg)`,
        "--round-number-color": `var(--lottery-number-rounded-${e.id}-color)`
      }
    }), [
      ee("legend", Ph, De(e.label), 1),
      ($(!0), q(Ge, null, vt(m.value, (le, se) => ($(), q("label", {
        key: le,
        class: xe(I(le)),
        for: `gridcell-${T(se)}-${L(se)}-${U(i)}`
      }, [
        ee("input", {
          id: `gridcell-${T(se)}-${L(se)}-${U(i)}`,
          ref_for: !0,
          ref: "numberInputs",
          checked: A(le),
          class: "lc-lottery-number-selector__input",
          disabled: V(le),
          tabindex: o.value === se || A(le) ? 0 : -1,
          type: "checkbox",
          onChange: () => H(le),
          onFocusin: (be) => o.value = se,
          onKeydown: [
            O,
            ri(() => H(le), ["enter"])
          ]
        }, null, 40, Vh),
        me(B.$slots, "cell", Ae({ ref_for: !0 }, {
          checked: A(le),
          disabled: V(le),
          number: le
        }), () => [
          wt(De(le), 1)
        ])
      ], 10, zh))), 128))
    ], 16, Bh));
  }
}), Hh = { class: "w-full" }, Uh = {
  key: 0,
  class: "lc-lottery-teaser__jackpot-text"
}, qh = {
  key: 1,
  class: "lc-lottery-teaser__jackpot-text"
}, jh = { class: "lc-lottery-teaser__button-container" }, Zh = { class: "lc-lottery-teaser__button-wrap" }, Wh = {
  key: 0,
  class: "lc-lottery-teaser__button-wrap"
}, Yh = {
  key: 0,
  class: "lc-lottery-teaser__draw-date"
}, Xh = { class: "lc-lottery-teaser__draw-date-headline" }, Rg = /* @__PURE__ */ Ce({
  __name: "LcLotteryTeaser",
  props: {
    cutoffTime: {},
    nextCutoffTime: {},
    backgroundPattern: {},
    badge: {},
    comingSoon: { type: Boolean },
    drawDate: {},
    drawDateHeadline: {},
    headline: {},
    jackpot: {},
    locale: { default: () => We.general.locale },
    onTeaserClick: { type: Function },
    primaryButtonProps: {},
    secondaryButtonProps: {},
    subline: {},
    variant: { default: "default" }
  },
  emits: ["outdated", "primary-button-click", "secondary-button-click"],
  setup(e) {
    const t = An(), n = Z(() => [
      "lc-lottery-teaser",
      `lc-lottery-teaser--variant-${e.variant}`,
      {
        "lc-lottery-teaser--two-buttons": s.value
      }
    ]), r = Z(
      () => Bo({
        date: e.drawDate,
        format: "drawingShort",
        locale: e.locale
      })
    ), s = Z(
      () => e.variant !== "expressive" && !!(e.secondaryButtonProps?.text || t["secondary-button"])
    ), i = Z(
      () => e.primaryButtonProps.to ? Yn(e.primaryButtonProps.to) : "div"
    );
    return (a, o) => ($(), ke(U(nr), Ae({ badge: e.badge, backgroundPattern: e.backgroundPattern }, {
      "body-class": "lc-lottery-teaser__body",
      class: n.value,
      "footer-class": "lc-lottery-teaser__footer",
      "header-class": "lc-lottery-teaser__header",
      "header-to": e.primaryButtonProps.to,
      style: {
        "--teaser-frame-color": "var(--lottery-teaser-frame-color)"
      },
      variant: e.variant === "expressive" ? "default" : e.variant,
      onHeaderClick: e.onTeaserClick
    }), Xa({
      header: Te(() => [
        me(a.$slots, "lottery-logo")
      ]),
      default: Te(() => [
        e.variant === "expressive" ? ($(), ke(U(zl), Ae({ key: 0 }, { cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
          class: "lc-lottery-teaser__cutoff-time",
          variant: "expressive",
          onCutoffTimeReached: o[0] || (o[0] = (l) => a.$emit("outdated"))
        }), null, 16)) : de("", !0),
        ee("section", Hh, [
          ($(), ke(Pt(i.value), {
            class: "lc-lottery-teaser__jackpot-wrap",
            tabindex: "-1",
            to: e.primaryButtonProps.to,
            onClick: e.onTeaserClick
          }, {
            default: Te(() => [
              e.headline ? ($(), q("strong", Uh, De(e.headline), 1)) : de("", !0),
              Fe(U(jo), Ae(e.jackpot, { size: "small" }), null, 16),
              e.subline ? ($(), q("strong", qh, De(e.subline), 1)) : de("", !0)
            ]),
            _: 1
          }, 8, ["to", "onClick"]))
        ]),
        ee("section", jh, [
          ee("div", Zh, [
            me(a.$slots, "primary-button", {}, () => [
              Fe(U(Et), Ae(e.primaryButtonProps, {
                "aria-label": e.primaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                variant: s.value ? "primary-ghost" : "primary",
                onClick: o[1] || (o[1] = (l) => a.$emit("primary-button-click"))
              }), {
                default: Te(() => [
                  wt(De(e.primaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label", "variant"])
            ])
          ]),
          s.value ? ($(), q("div", Wh, [
            me(a.$slots, "secondary-button", {}, () => [
              e.secondaryButtonProps ? ($(), ke(U(Et), Ae({ key: 0 }, e.secondaryButtonProps, {
                "aria-label": e.secondaryButtonProps.ariaLabel,
                class: "lc-lottery-teaser__button",
                "no-padding": "",
                onClick: o[2] || (o[2] = (l) => a.$emit("secondary-button-click"))
              }), {
                default: Te(() => [
                  wt(De(e.secondaryButtonProps.text), 1)
                ]),
                _: 1
              }, 16, ["aria-label"])) : de("", !0)
            ])
          ])) : de("", !0)
        ])
      ]),
      _: 2
    }, [
      e.variant !== "expressive" ? {
        name: "footer",
        fn: Te(() => [
          ["default", "badge"].includes(e.variant) ? ($(), q("div", Yh, [
            ee("div", Xh, [
              Fe(U(Qe), {
                name: "calendar",
                size: "small"
              }),
              ee("span", null, De(e.drawDateHeadline), 1)
            ]),
            Fe(U(To), Ae({ locale: e.locale, ...U(mi).drawingShort }, { datetime: e.drawDate }), {
              default: Te(() => [
                wt(De(r.value), 1)
              ]),
              _: 1
            }, 16, ["datetime"])
          ])) : de("", !0),
          Fe(U(zl), Ae({ cutoffTime: e.cutoffTime, nextCutoffTime: e.nextCutoffTime }, {
            "single-line": e.variant === "hero",
            variant: e.variant === "hero" ? "expressive" : "default",
            onCutoffTimeReached: o[3] || (o[3] = (l) => a.$emit("outdated"))
          }), null, 16, ["single-line", "variant"])
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["class", "header-to", "variant", "onHeaderClick"]));
  }
}), Og = [...Yo, "expressive"], Gh = { class: "lc-masked-value-display" }, Fg = /* @__PURE__ */ Ce({
  __name: "LcMaskedValueDisplay",
  props: {
    masksPerPart: { default: 4 },
    parts: { default: 1 }
  },
  setup(e) {
    return (t, n) => ($(), q("span", Gh, [
      ($(!0), q(Ge, null, vt(e.parts, (r) => ($(), q("span", {
        key: r,
        class: "lc-masked-value-display__part"
      }, [
        ($(!0), q(Ge, null, vt(e.masksPerPart, (s) => ($(), q("span", {
          key: s,
          class: "lc-masked-value-display__mask"
        }))), 128))
      ]))), 128)),
      me(t.$slots, "default")
    ]));
  }
}), Xr = Math.min, Pn = Math.max, qa = Math.round, Da = Math.floor, Jt = (e) => ({
  x: e,
  y: e
}), Kh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function bi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function jn(e) {
  return e.split("-")[0];
}
function ar(e) {
  return e.split("-")[1];
}
function Jh(e) {
  return e === "x" ? "y" : "x";
}
function ts(e) {
  return e === "y" ? "height" : "width";
}
function yn(e) {
  const t = e[0];
  return t === "t" || t === "b" ? "y" : "x";
}
function ns(e) {
  return Jh(yn(e));
}
function Qh(e, t, n) {
  n === void 0 && (n = !1);
  const r = ar(e), s = ns(e), i = ts(s);
  let a = s === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = ja(a)), [a, ja(a)];
}
function ev(e) {
  const t = ja(e);
  return [Gr(e), t, Gr(t)];
}
function Gr(e) {
  return e.includes("start") ? e.replace("start", "end") : e.replace("end", "start");
}
const Vl = ["left", "right"], Hl = ["right", "left"], tv = ["top", "bottom"], nv = ["bottom", "top"];
function av(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Hl : Vl : t ? Vl : Hl;
    case "left":
    case "right":
      return t ? tv : nv;
    default:
      return [];
  }
}
function rv(e, t, n, r) {
  const s = ar(e);
  let i = av(jn(e), n === "start", r);
  return s && (i = i.map((a) => a + "-" + s), t && (i = i.concat(i.map(Gr)))), i;
}
function ja(e) {
  const t = jn(e);
  return Kh[t] + e.slice(t.length);
}
function iv(e) {
  var t, n, r, s;
  return {
    top: (t = e.top) != null ? t : 0,
    right: (n = e.right) != null ? n : 0,
    bottom: (r = e.bottom) != null ? r : 0,
    left: (s = e.left) != null ? s : 0
  };
}
function lv(e) {
  return typeof e != "number" ? iv(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Za(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: s
  } = e;
  return {
    width: r,
    height: s,
    top: n,
    left: t,
    right: t + r,
    bottom: n + s,
    x: t,
    y: n
  };
}
function Ul(e, t, n) {
  let {
    reference: r,
    floating: s
  } = e;
  const i = yn(t), a = ns(t), o = ts(a), l = jn(t), h = i === "y", v = r.x + r.width / 2 - s.width / 2, c = r.y + r.height / 2 - s.height / 2, f = r[o] / 2 - s[o] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: v,
        y: r.y - s.height
      };
      break;
    case "bottom":
      m = {
        x: v,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: c
      };
      break;
    case "left":
      m = {
        x: r.x - s.width,
        y: c
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  const u = ar(t);
  return u && (m[a] += f * (u === "end" ? 1 : -1) * (n && h ? -1 : 1)), m;
}
async function ov(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: s,
    platform: i,
    rects: a,
    elements: o,
    strategy: l
  } = e, {
    boundary: h = "clippingAncestors",
    rootBoundary: v = "viewport",
    elementContext: c = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = bi(t, e), u = lv(m), S = o[f ? c === "floating" ? "reference" : "floating" : c], g = Za(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(S))) == null || n ? S : S.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(o.floating)),
    boundary: h,
    rootBoundary: v,
    strategy: l
  })), b = c === "floating" ? {
    x: r,
    y: s,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, _ = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(o.floating)), T = await (i.isElement == null ? void 0 : i.isElement(_)) && await (i.getScale == null ? void 0 : i.getScale(_)) || {
    x: 1,
    y: 1
  }, I = Za(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: b,
    offsetParent: _,
    strategy: l
  }) : b);
  return {
    top: (g.top - I.top + u.top) / T.y,
    bottom: (I.bottom - g.bottom + u.bottom) / T.y,
    left: (g.left - I.left + u.left) / T.x,
    right: (I.right - g.right + u.right) / T.x
  };
}
const sv = 50, uv = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: s = "absolute",
    middleware: i = [],
    platform: a
  } = n, o = a.detectOverflow ? a : {
    ...a,
    detectOverflow: ov
  }, l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let h = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: s
  }), {
    x: v,
    y: c
  } = Ul(h, r, l), f = r, m = 0;
  const u = {};
  for (let p = 0; p < i.length; p++) {
    const S = i[p];
    if (!S)
      continue;
    const {
      name: g,
      fn: b
    } = S, {
      x: _,
      y: T,
      data: I,
      reset: L
    } = await b({
      x: v,
      y: c,
      initialPlacement: r,
      placement: f,
      strategy: s,
      middlewareData: u,
      rects: h,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    v = _ ?? v, c = T ?? c, u[g] = {
      ...u[g],
      ...I
    }, L && m < sv && (m++, typeof L == "object" && (L.placement && (f = L.placement), L.rects && (h = L.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: s
    }) : L.rects), {
      x: v,
      y: c
    } = Ul(h, f, l)), p = -1);
  }
  return {
    x: v,
    y: c,
    placement: f,
    strategy: s,
    middlewareData: u
  };
}, cv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: s,
        middlewareData: i,
        rects: a,
        initialPlacement: o,
        platform: l,
        elements: h
      } = t, {
        mainAxis: v = !0,
        crossAxis: c = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: u = "none",
        flipAlignment: p = !0,
        ...S
      } = bi(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const g = jn(s), b = yn(o), _ = jn(o) === o, T = await (l.isRTL == null ? void 0 : l.isRTL(h.floating)), I = f || (_ || !p ? [ja(o)] : ev(o)), L = u !== "none";
      !f && L && I.push(...rv(o, p, u, T));
      const C = [o, ...I], F = await l.detectOverflow(t, S), z = [];
      let X = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (v && z.push(F[g]), c) {
        const E = Qh(s, a, T);
        z.push(F[E[0]], F[E[1]]);
      }
      if (X = [...X, {
        placement: s,
        overflows: z
      }], !z.every((E) => E <= 0)) {
        var O, G;
        const E = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, A = C[E];
        if (A && (!(c === "alignment" ? b !== yn(A) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        X.every((K) => yn(K.placement) === b ? K.overflows[0] > 0 : !0)))
          return {
            data: {
              index: E,
              overflows: X
            },
            reset: {
              placement: A
            }
          };
        let V = (G = X.filter((H) => H.overflows[0] <= 0).sort((H, K) => H.overflows[1] - K.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!V)
          switch (m) {
            case "bestFit": {
              var P;
              const H = (P = X.filter((K) => {
                if (L) {
                  const B = yn(K.placement);
                  return B === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  B === "y";
                }
                return !0;
              }).map((K) => [K.placement, K.overflows.filter((B) => B > 0).reduce((B, ae) => B + ae, 0)]).sort((K, B) => K[1] - B[1])[0]) == null ? void 0 : P[0];
              H && (V = H);
              break;
            }
            case "initialPlacement":
              V = o;
              break;
          }
        if (s !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
}, dv = /* @__PURE__ */ new Set(["left", "top"]);
async function fv(e, t) {
  const {
    placement: n,
    platform: r,
    elements: s
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(s.floating)), a = jn(n), o = ar(n), l = yn(n) === "y", h = dv.has(a) ? -1 : 1, v = i && l ? -1 : 1, c = bi(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: u
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return o && typeof u == "number" && (m = o === "end" ? u * -1 : u), l ? {
    x: m * v,
    y: f * h
  } : {
    x: f * h,
    y: m * v
  };
}
const hv = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: s,
        y: i,
        placement: a,
        middlewareData: o
      } = t, l = await fv(t, e);
      return a === ((n = o.offset) == null ? void 0 : n.placement) && (r = o.arrow) != null && r.alignmentOffset ? {} : {
        x: s + l.x,
        y: i + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
};
function rr() {
  return typeof window < "u";
}
function In(e) {
  return pi(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function It(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function nn(e) {
  var t;
  return (t = (pi(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function pi(e) {
  return rr() ? e instanceof Node || e instanceof It(e).Node : !1;
}
function Yt(e) {
  return rr() ? e instanceof Element || e instanceof It(e).Element : !1;
}
function dn(e) {
  return rr() ? e instanceof HTMLElement || e instanceof It(e).HTMLElement : !1;
}
function ql(e) {
  return !rr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof It(e).ShadowRoot;
}
function ir(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: s
  } = Xt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && s !== "inline" && s !== "contents";
}
function vv(e) {
  return /^(table|td|th)$/.test(In(e));
}
function lr(e) {
  try {
    if (e.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return e.matches(":modal");
  } catch {
    return !1;
  }
}
const mv = /transform|translate|scale|rotate|perspective|filter/, gv = /paint|layout|strict|content/, bn = (e) => !!e && e !== "none";
let Or;
function yi(e) {
  const t = Yt(e) ? Xt(e) : e;
  return bn(t.transform) || bn(t.translate) || bn(t.scale) || bn(t.rotate) || bn(t.perspective) || !wi() && (bn(t.backdropFilter) || bn(t.filter)) || mv.test(t.willChange || "") || gv.test(t.contain || "");
}
function bv(e) {
  let t = En(e);
  for (; dn(t) && !va(t); ) {
    if (yi(t))
      return t;
    if (lr(t))
      return null;
    t = En(t);
  }
  return null;
}
function wi() {
  return Or == null && (Or = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Or;
}
function va(e) {
  return /^(html|body|#document)$/.test(In(e));
}
function Xt(e) {
  return It(e).getComputedStyle(e);
}
function or(e) {
  return Yt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function En(e) {
  if (In(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ql(e) && e.host || // Fallback.
    nn(e)
  );
  return ql(t) ? t.host : t;
}
function as(e) {
  const t = En(e);
  return va(t) ? (e.ownerDocument || e).body : dn(t) && ir(t) ? t : as(t);
}
function ma(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const s = as(e), i = s === ((r = e.ownerDocument) == null ? void 0 : r.body), a = It(s);
  if (i) {
    const o = Kr(a);
    return t.concat(a, a.visualViewport || [], ir(s) ? s : [], o && n ? ma(o) : []);
  } else
    return t.concat(s, ma(s, [], n));
}
function Kr(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function rs(e) {
  const t = Xt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const s = dn(e), i = s ? e.offsetWidth : n, a = s ? e.offsetHeight : r, o = qa(n) !== i || qa(r) !== a;
  return o && (n = i, r = a), {
    width: n,
    height: r,
    $: o
  };
}
function xi(e) {
  return Yt(e) ? e : e.contextElement;
}
function zn(e) {
  const t = xi(e);
  if (!dn(t))
    return Jt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: s,
    $: i
  } = rs(t);
  let a = (i ? qa(n.width) : n.width) / r, o = (i ? qa(n.height) : n.height) / s;
  return (!a || !Number.isFinite(a)) && (a = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: a,
    y: o
  };
}
const pv = /* @__PURE__ */ Jt(0);
function is(e) {
  const t = It(e);
  return !wi() || !t.visualViewport ? pv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function yv(e, t, n) {
  return t === void 0 && (t = !1), !!n && t && n === It(e);
}
function Tn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const s = e.getBoundingClientRect(), i = xi(e);
  let a = Jt(1);
  t && (r ? Yt(r) && (a = zn(r)) : a = zn(e));
  const o = yv(i, n, r) ? is(i) : Jt(0);
  let l = (s.left + o.x) / a.x, h = (s.top + o.y) / a.y, v = s.width / a.x, c = s.height / a.y;
  if (i && r) {
    const f = It(i), m = Yt(r) ? It(r) : r;
    let u = f, p = Kr(u);
    for (; p && m !== u; ) {
      const S = zn(p), g = p.getBoundingClientRect(), b = Xt(p), _ = g.left + (p.clientLeft + parseFloat(b.paddingLeft)) * S.x, T = g.top + (p.clientTop + parseFloat(b.paddingTop)) * S.y;
      l *= S.x, h *= S.y, v *= S.x, c *= S.y, l += _, h += T, u = It(p), p = Kr(u);
    }
  }
  return Za({
    width: v,
    height: c,
    x: l,
    y: h
  });
}
function sr(e, t) {
  const n = or(e).scrollLeft;
  return t ? t.left + n : Tn(nn(e)).left + n;
}
function ls(e, t) {
  const n = e.getBoundingClientRect(), r = n.left + t.scrollLeft - sr(e, n), s = n.top + t.scrollTop;
  return {
    x: r,
    y: s
  };
}
function wv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: s
  } = e;
  const i = s === "fixed", a = nn(r), o = t ? lr(t.floating) : !1;
  if (r === a || o && i)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, h = Jt(1);
  const v = Jt(0), c = dn(r);
  if ((c || !i) && ((In(r) !== "body" || ir(a)) && (l = or(r)), c)) {
    const m = Tn(r);
    h = zn(r), v.x = m.x + r.clientLeft, v.y = m.y + r.clientTop;
  }
  const f = a && !c && !i ? ls(a, l) : Jt(0);
  return {
    width: n.width * h.x,
    height: n.height * h.y,
    x: n.x * h.x - l.scrollLeft * h.x + v.x + f.x,
    y: n.y * h.y - l.scrollTop * h.y + v.y + f.y
  };
}
function xv(e) {
  return e.getClientRects ? Array.from(e.getClientRects()) : [];
}
function kv(e) {
  const t = or(e), n = e.ownerDocument.body, r = Pn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), s = Pn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + sr(e);
  const a = -t.scrollTop;
  return Xt(n).direction === "rtl" && (i += Pn(e.clientWidth, n.clientWidth) - r), {
    width: r,
    height: s,
    x: i,
    y: a
  };
}
const Sv = 25;
function _v(e, t, n) {
  n === void 0 && (n = "viewport");
  const r = n === "layoutViewport", s = It(e), i = nn(e), a = s.visualViewport;
  let o = i.clientWidth, l = i.clientHeight, h = 0, v = 0;
  if (a) {
    const f = !wi() || t === "fixed";
    r ? f || (h = -a.offsetLeft, v = -a.offsetTop) : (o = a.width, l = a.height, f && (h = a.offsetLeft, v = a.offsetTop));
  }
  if (sr(i) <= 0) {
    const f = i.ownerDocument, m = f.body, u = getComputedStyle(m), p = f.compatMode === "CSS1Compat" && parseFloat(u.marginLeft) + parseFloat(u.marginRight) || 0, S = Math.abs(i.clientWidth - m.clientWidth - p), g = getComputedStyle(i).scrollbarGutter === "stable both-edges" ? S / 2 : S;
    g <= Sv && (o -= g);
  }
  return {
    width: o,
    height: l,
    x: h,
    y: v
  };
}
function Cv(e, t) {
  const n = Tn(e, !0, t === "fixed"), r = n.top + e.clientTop, s = n.left + e.clientLeft, i = zn(e), a = e.clientWidth * i.x, o = e.clientHeight * i.y, l = s * i.x, h = r * i.y;
  return {
    width: a,
    height: o,
    x: l,
    y: h
  };
}
function jl(e, t, n) {
  let r;
  if (t === "viewport" || t === "layoutViewport")
    r = _v(e, n, t);
  else if (t === "document")
    r = kv(nn(e));
  else if (Yt(t))
    r = Cv(t, n);
  else {
    const s = is(e);
    r = {
      x: t.x - s.x,
      y: t.y - s.y,
      width: t.width,
      height: t.height
    };
  }
  return Za(r);
}
function Ev(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = ma(e, [], !1).filter((o) => Yt(o) && In(o) !== "body"), s = null;
  const i = Xt(e).position === "fixed";
  let a = i ? En(e) : e;
  for (; Yt(a) && !va(a); ) {
    const o = Xt(a), l = yi(a), h = s ? s.position : i ? "fixed" : "";
    !l && (h === "fixed" || h === "absolute" && o.position === "static") ? r = r.filter((c) => c !== a) : s = o, a = En(a);
  }
  return t.set(e, r), r;
}
function Tv(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: s
  } = e;
  const a = [...n === "clippingAncestors" ? lr(t) ? [] : Ev(t, this._c) : [].concat(n), r], o = jl(t, a[0], s);
  let l = o.top, h = o.right, v = o.bottom, c = o.left;
  for (let f = 1; f < a.length; f++) {
    const m = jl(t, a[f], s);
    l = Pn(m.top, l), h = Xr(m.right, h), v = Xr(m.bottom, v), c = Pn(m.left, c);
  }
  return {
    width: h - c,
    height: v - l,
    x: c,
    y: l
  };
}
function Av(e) {
  const {
    width: t,
    height: n
  } = rs(e);
  return {
    width: t,
    height: n
  };
}
function Lv(e, t, n) {
  const r = dn(t), s = nn(t), i = n === "fixed", a = Tn(e, !0, i, t);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Jt(0);
  if ((r || !i) && ((In(t) !== "body" || ir(s)) && (o = or(t)), r)) {
    const f = Tn(t, !0, i, t);
    l.x = f.x + t.clientLeft, l.y = f.y + t.clientTop;
  }
  !r && s && (l.x = sr(s));
  const h = s && !r && !i ? ls(s, o) : Jt(0), v = a.left + o.scrollLeft - l.x - h.x, c = a.top + o.scrollTop - l.y - h.y;
  return {
    x: v,
    y: c,
    width: a.width,
    height: a.height
  };
}
function Fr(e) {
  return Xt(e).position === "static";
}
function Zl(e, t) {
  if (!dn(e) || Xt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return nn(e) === n && (n = n.ownerDocument.body), n;
}
function os(e, t) {
  const n = It(e);
  if (lr(e))
    return n;
  if (!dn(e)) {
    let s = En(e);
    for (; s && !va(s); ) {
      if (Yt(s) && !Fr(s))
        return s;
      s = En(s);
    }
    return n;
  }
  let r = Zl(e, t);
  for (; r && vv(r) && Fr(r); )
    r = Zl(r, t);
  return r && va(r) && Fr(r) && !yi(r) ? n : r || bv(e) || n;
}
const $v = async function(e) {
  const t = this.getOffsetParent || os, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Lv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Iv(e) {
  return Xt(e).direction === "rtl";
}
const Dv = {
  convertOffsetParentRelativeRectToViewportRelativeRect: wv,
  getDocumentElement: nn,
  getClippingRect: Tv,
  getOffsetParent: os,
  getElementRects: $v,
  getClientRects: xv,
  getDimensions: Av,
  getScale: zn,
  isElement: Yt,
  isRTL: Iv
};
function ss(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Mv(e, t, n) {
  let r = null, s;
  const i = nn(e);
  function a() {
    var v;
    clearTimeout(s), (v = r) == null || v.disconnect(), r = null;
  }
  function o(v, c) {
    v === void 0 && (v = !1), c === void 0 && (c = 1), a();
    const f = e.getBoundingClientRect(), {
      left: m,
      top: u,
      width: p,
      height: S
    } = f;
    if (v || t(), !p || !S)
      return;
    const g = Da(u), b = Da(i.clientWidth - (m + p)), _ = Da(i.clientHeight - (u + S)), T = Da(m), L = {
      rootMargin: -g + "px " + -b + "px " + -_ + "px " + -T + "px",
      threshold: Pn(0, Xr(1, c)) || 1
    };
    let C = !0;
    function F(z) {
      const X = z[0].intersectionRatio;
      if (!ss(f, e.getBoundingClientRect()))
        return o();
      if (X !== c) {
        if (!C)
          return o();
        X ? o(!1, X) : s = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(F, {
        ...L,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(F, L);
    }
    r.observe(e);
  }
  const l = It(e), h = () => o(n);
  return l.addEventListener("resize", h), o(!0), () => {
    l.removeEventListener("resize", h), a();
  };
}
function us(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: s = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: o = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, h = xi(e), v = s || i ? [...h ? ma(h) : [], ...t ? ma(t) : []] : [];
  v.forEach((g) => {
    s && g.addEventListener("scroll", n), i && g.addEventListener("resize", n);
  });
  const c = h && o ? Mv(h, n, i) : null;
  let f = -1, m = null;
  a && (m = new ResizeObserver((g) => {
    let [b] = g;
    b && b.target === h && m && t && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var _;
      (_ = m) == null || _.observe(t);
    })), n();
  }), h && !l && m.observe(h), t && m.observe(t));
  let u, p = l ? Tn(e) : null;
  l && S();
  function S() {
    const g = Tn(e);
    p && !ss(p, g) && n(), p = g, u = requestAnimationFrame(S);
  }
  return n(), () => {
    var g;
    v.forEach((b) => {
      s && b.removeEventListener("scroll", n), i && b.removeEventListener("resize", n);
    }), c?.(), (g = m) == null || g.disconnect(), m = null, l && cancelAnimationFrame(u);
  };
}
const cs = hv, ds = cv, Rv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), s = n ?? {}, i = {
    ...Dv,
    ...s.platform,
    _c: r
  };
  return uv(e, t, {
    ...s,
    platform: i
  });
};
function Ov(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Wl(e) {
  if (Ov(e)) {
    const t = e.$el;
    return pi(t) && In(t) === "#comment" ? null : t;
  }
  return e;
}
function fs(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Yl(e, t) {
  const n = fs(e);
  return Math.round(t * n) / n;
}
function hs(e, t, n) {
  n === void 0 && (n = {});
  const r = n.whileElementsMounted, s = Z(() => {
    var C;
    return (C = Ke(n.open)) != null ? C : !0;
  }), i = Z(() => Ke(n.middleware)), a = Z(() => {
    var C;
    return (C = Ke(n.placement)) != null ? C : "bottom";
  }), o = Z(() => {
    var C;
    return (C = Ke(n.strategy)) != null ? C : "absolute";
  }), l = Z(() => {
    var C;
    return (C = Ke(n.transform)) != null ? C : !0;
  }), h = Z(() => Wl(e.value)), v = Z(() => Wl(t.value)), c = we(0), f = we(0), m = we(o.value), u = we(a.value), p = kn({}), S = we(!1), g = Z(() => {
    const C = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!v.value)
      return C;
    const F = Yl(v.value, c.value), z = Yl(v.value, f.value);
    return l.value ? {
      ...C,
      transform: "translate(" + F + "px, " + z + "px)",
      ...fs(v.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: F + "px",
      top: z + "px"
    };
  });
  let b;
  function _() {
    if (h.value == null || v.value == null)
      return;
    const C = s.value;
    Rv(h.value, v.value, {
      middleware: i.value,
      placement: a.value,
      strategy: o.value
    }).then((F) => {
      c.value = F.x, f.value = F.y, m.value = F.strategy, u.value = F.placement, p.value = F.middlewareData, S.value = C !== !1;
    });
  }
  function T() {
    typeof b == "function" && (b(), b = void 0);
  }
  function I() {
    if (T(), r === void 0) {
      _();
      return;
    }
    if (h.value != null && v.value != null) {
      b = r(h.value, v.value, _);
      return;
    }
  }
  function L() {
    s.value || (S.value = !1);
  }
  return Ve([i, a, o, s], _, {
    flush: "sync"
  }), Ve([h, v], I, {
    flush: "sync"
  }), Ve(s, L, {
    flush: "sync"
  }), Ps() && zs(T), {
    x: Mn(c),
    y: Mn(f),
    strategy: Mn(m),
    placement: Mn(u),
    middlewareData: Mn(p),
    isPositioned: Mn(S),
    floatingStyles: g,
    update: _
  };
}
const Oa = we(!1);
let Vn, Hn, Un, Jr = 0;
const ki = () => (mt(() => {
  Jr += 1, Fv();
}), Ln(() => {
  Jr -= 1, Nv();
}), Oa), Fv = () => {
  typeof window > "u" || (Vn || (Vn = () => Oa.value = !0, window.addEventListener("keydown", Vn, !0)), Hn || (Hn = () => Oa.value = !1, window.addEventListener("mousedown", Hn, !0)), Un || (Un = () => Oa.value = !1, window.addEventListener("pointerdown", Un, !0)));
}, Nv = () => {
  typeof window > "u" || Jr || (Vn && (window.removeEventListener("keydown", Vn, !0), Vn = null), Hn && (window.removeEventListener("mousedown", Hn, !0), Hn = null), Un && (window.removeEventListener("pointerdown", Un, !0), Un = null));
}, vs = {
  fn: (e) => ({ x: e.x < 0 ? e.rects.reference.x : e.x }),
  name: "positionHelper"
}, Ng = [
  "top-start",
  "top-end",
  "bottom-start",
  "bottom-end"
];
var Ht = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Escape = "Escape", e.Home = "Home", e.Space = " ", e.Tab = "Tab", e))(Ht || {});
const Bv = {
  ref: "container",
  class: "lc-menu-button"
}, Pv = ["id", "aria-activedescendant"], zv = ["id", "aria-selected", "onClick"], Bg = /* @__PURE__ */ Ce({
  __name: "LcMenuButton",
  props: {
    ignoreOutsideClickOn: { default: () => [] },
    icon: { default: "more-horizontal" },
    id: {},
    options: {},
    placement: { default: "bottom-end" },
    value: {},
    zIndex: { default: 99 }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("button"), i = it("menu"), a = we(null), o = we(!1), { floatingStyles: l } = hs(s, i, {
      middleware: [
        cs({
          alignmentAxis: 4
        }),
        ds(),
        vs
      ],
      placement: () => e.placement,
      whileElementsMounted: us
    }), h = Tt(e.id), v = ki(), c = Z(() => {
      if (!(!o.value || !St(a.value)))
        return `${h}-menuitem-${a.value}`;
    }), f = Z(
      () => e.options.findIndex((b) => "value" in b && b.value === e.value)
    ), m = () => {
      o.value && (a.value = null, o.value = !1);
    }, u = () => {
      if (o.value) {
        m();
        return;
      }
      g();
    }, p = (b) => {
      if (m(), b?.onClick) {
        b.onClick();
        return;
      }
      r("update:value", b.value);
    }, S = (b) => {
      if (!tn(b.key, Ht)) return;
      b.key !== Ht.Tab && (b.preventDefault(), b.stopPropagation());
      const _ = e.options.length - 1;
      switch (b.key) {
        case Ht.ArrowDown:
          if (o.value && St(a.value)) {
            a.value = Math.min(_, a.value + 1);
            break;
          }
          a.value = 0, g();
          break;
        case Ht.ArrowUp:
          if (o.value && St(a.value)) {
            a.value = Math.max(0, a.value - 1);
            break;
          }
          a.value = _, g();
          break;
        case Ht.End:
          if (!o.value) return;
          a.value = _;
          break;
        case Ht.Enter:
        case Ht.Space:
          if (o.value && St(a.value)) {
            p(e.options[a.value]);
            break;
          }
          a.value = 0, g();
          break;
        case Ht.Escape:
        case Ht.Tab:
          m();
          break;
        case Ht.Home:
          if (!o.value) return;
          a.value = 0;
          break;
      }
    }, g = () => {
      o.value || (o.value = !0, e.value && (a.value = f.value));
    };
    return Ga(i, m, {
      ignore: [s, ...Ke(e.ignoreOutsideClickOn)]
    }), t({ menuRef: i }), mt(() => {
      e.value && (a.value = f.value);
    }), (b, _) => ($(), q("div", Bv, [
      Fe(U(Et), Ae({
        id: U(h),
        ref: "button"
      }, { icon: e.icon }, {
        "aria-controls": `${U(h)}-menu`,
        "aria-expanded": o.value,
        "aria-haspopup": "menu",
        size: "small",
        variant: "tertiary",
        onClickPassive: u,
        onKeydown: S
      }), null, 16, ["id", "aria-controls", "aria-expanded"]),
      ($(), ke(ba, { to: "body" }, [
        o.value ? ($(), ke(U(ya), {
          key: 0,
          ref: "menu",
          "body-class": "lc-menu-button__menu-wrap-body",
          class: "lc-menu-button__menu-wrap",
          style: Ct({ ...U(l), zIndex: e.zIndex })
        }, {
          default: Te(() => [
            ee("ul", {
              id: `${U(h)}-menu`,
              "aria-activedescendant": c.value,
              class: "lc-menu-button__menu",
              role: "menu"
            }, [
              ($(!0), q(Ge, null, vt(e.options, (T, I) => ($(), q("li", {
                key: `${T.label}-${"value" in T ? T.value : "action"}`,
                class: xe(["lc-menu-button__menu-item", {
                  "lc-menu-button__menu-item--focused": a.value === I && U(v),
                  "lc-menu-button__menu-item--selected": "value" in T && T.value === e.value
                }])
              }, [
                ee("button", {
                  id: `${U(h)}-menuitem-${I}`,
                  "aria-selected": "value" in T && T.value === e.value,
                  class: "lc-menu-button__menu-item-button",
                  role: "menuitem",
                  tabindex: "-1",
                  type: "button",
                  onClick: (L) => p(T)
                }, [
                  Fe(U(Qe), {
                    name: T.icon
                  }, null, 8, ["name"]),
                  ee("span", null, De(T.label), 1),
                  "value" in T && T.value === e.value ? ($(), ke(U(Qe), {
                    key: 0,
                    class: "lc-menu-button__menu-item-checkmark",
                    name: "checkmark"
                  })) : de("", !0)
                ], 8, zv)
              ], 2))), 128))
            ], 8, Pv)
          ]),
          _: 1
        }, 8, ["style"])) : de("", !0)
      ]))
    ], 512));
  }
}), Vv = { class: "lc-message-box__headline" }, Hv = {
  key: 0,
  class: "lc-message-box__text"
}, Pg = /* @__PURE__ */ Ce({
  __name: "LcMessageBox",
  props: /* @__PURE__ */ Sn({
    id: {},
    modelValue: { type: Boolean },
    headline: {},
    size: { default: "medium" },
    text: {},
    variant: { default: "default" }
  }, {
    modelValue: { default: !0, type: Boolean },
    modelModifiers: {}
  }),
  emits: ["update:modelValue"],
  setup(e) {
    const t = {
      default: "info",
      info: "info",
      warning: "alert-circle"
    }, n = Wa(e, "modelValue"), r = Z(() => [
      "lc-message-box",
      `lc-message-box--size-${e.size}`,
      `lc-message-box--variant-${e.variant}`
    ]);
    return (s, i) => ($(), ke(U(Ef), {
      modelValue: n.value,
      "onUpdate:modelValue": i[0] || (i[0] = (a) => n.value = a),
      class: xe(r.value),
      "content-class": "lc-message-box__content",
      "header-class": "lc-message-box__header"
    }, {
      header: Te(() => [
        ee("span", Vv, [
          Fe(U(Qe), {
            name: t[e.variant]
          }, null, 8, ["name"]),
          ee("span", null, De(e.headline), 1)
        ])
      ]),
      default: Te(() => [
        me(s.$slots, "default", {}, () => [
          e.text ? ($(), q("p", Hv, De(e.text), 1)) : de("", !0)
        ])
      ]),
      _: 3
    }, 8, ["modelValue", "class"]));
  }
}), zg = ["medium", "small"], Vg = ["default", "info", "warning"];
var sn;
(function(e) {
  e.symbol = "symbol", e.narrowSymbol = "narrowSymbol", e.code = "code", e.name = "name", e.hidden = "hidden";
})(sn || (sn = {}));
var on;
(function(e) {
  e.precision = "precision", e.thousands = "thousands", e.tenThousands = "tenThousands", e.millions = "millions", e.billions = "billions";
})(on || (on = {}));
const Fa = (e) => e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), ms = (e) => e.replace(/^0+(0$|[^0])/, "$1"), Nr = (e, t) => (e.match(new RegExp(Fa(t), "g")) || []).length, Uv = (e, t) => e.substring(0, e.indexOf(t)), gs = [
  ",",
  ".",
  "٫",
  "。"
], Xl = "(0|[1-9]\\d*)";
class qv {
  constructor(t) {
    var n, r, s, i, a, o;
    const { currency: l, currencyDisplay: h, locale: v, precision: c, accountingSign: f, useGrouping: m } = t;
    this.locale = v, this.options = {
      currency: l,
      useGrouping: m,
      style: "currency",
      currencySign: f ? "accounting" : void 0,
      currencyDisplay: h !== sn.hidden ? h : void 0
    };
    const u = new Intl.NumberFormat(v, this.options), p = u.formatToParts(123456);
    this.currency = (n = p.find(({ type: b }) => b === "currency")) === null || n === void 0 ? void 0 : n.value, this.digits = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((b) => b.toLocaleString(v)), this.decimalSymbol = (r = p.find(({ type: b }) => b === "decimal")) === null || r === void 0 ? void 0 : r.value, this.groupingSymbol = (s = p.find(({ type: b }) => b === "group")) === null || s === void 0 ? void 0 : s.value, this.minusSign = (i = u.formatToParts(-1).find(({ type: b }) => b === "minusSign")) === null || i === void 0 ? void 0 : i.value, this.decimalSymbol === void 0 ? this.minimumFractionDigits = this.maximumFractionDigits = 0 : typeof c == "number" ? this.minimumFractionDigits = this.maximumFractionDigits = c : (this.minimumFractionDigits = (a = c?.min) !== null && a !== void 0 ? a : u.resolvedOptions().minimumFractionDigits, this.maximumFractionDigits = (o = c?.max) !== null && o !== void 0 ? o : u.resolvedOptions().maximumFractionDigits);
    const S = (b) => Uv(b, this.digits[1]), g = (b) => b.substring(b.lastIndexOf(this.decimalSymbol ? this.digits[0] : this.digits[1]) + 1);
    this.prefix = S(u.format(1)), this.suffix = g(u.format(1)), this.negativePrefix = S(u.format(-1)), this.negativeSuffix = g(u.format(-1));
  }
  parse(t) {
    if (t) {
      const n = this.isNegative(t);
      t = this.normalizeDigits(t), t = this.stripCurrency(t, n), t = this.stripSignLiterals(t);
      const r = this.decimalSymbol ? `(?:${Fa(this.decimalSymbol)}(\\d*))?` : "", s = this.stripGroupingSeparator(t).match(new RegExp(`^${Xl}${r}$`));
      if (s && this.isValidIntegerFormat(this.decimalSymbol ? t.split(this.decimalSymbol)[0] : t, Number(s[1])))
        return +`${n ? "-" : ""}${this.onlyDigits(s[1])}.${this.onlyDigits(s[2] || "")}`;
    }
    return null;
  }
  isValidIntegerFormat(t, n) {
    const r = { ...this.options, minimumFractionDigits: 0 };
    return [
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !0 })), !1),
      this.stripCurrency(this.normalizeDigits(n.toLocaleString(this.locale, { ...r, useGrouping: !1 })), !1)
    ].includes(t);
  }
  format(t, n = {
    minimumFractionDigits: this.minimumFractionDigits,
    maximumFractionDigits: this.maximumFractionDigits
  }) {
    return t != null ? t.toLocaleString(this.locale, { ...this.options, ...n }) : "";
  }
  toFraction(t) {
    return `${this.digits[0]}${this.decimalSymbol}${this.onlyLocaleDigits(t.substring(1)).substring(0, this.maximumFractionDigits)}`;
  }
  isFractionIncomplete(t) {
    return !!this.normalizeDigits(this.stripGroupingSeparator(t)).match(new RegExp(`^${Xl}${Fa(this.decimalSymbol)}$`));
  }
  isNegative(t) {
    return t.startsWith(this.negativePrefix) || this.minusSign === void 0 && (t.startsWith("(") || t.startsWith("-")) || this.minusSign !== void 0 && t.replace("-", this.minusSign).startsWith(this.minusSign);
  }
  insertCurrency(t, n) {
    return `${n ? this.negativePrefix : this.prefix}${t}${n ? this.negativeSuffix : this.suffix}`;
  }
  stripGroupingSeparator(t) {
    return this.groupingSymbol !== void 0 ? t.replace(new RegExp(Fa(this.groupingSymbol), "g"), "") : t;
  }
  stripSignLiterals(t) {
    return this.minusSign !== void 0 ? t.replace("-", this.minusSign).replace(this.minusSign, "") : t.replace(/[-()]/g, "");
  }
  stripCurrency(t, n) {
    return t.replace(n ? this.negativePrefix : this.prefix, "").replace(n ? this.negativeSuffix : this.suffix, "");
  }
  normalizeDecimalSeparator(t, n) {
    return gs.forEach((r) => {
      t = t.substring(0, n) + t.substring(n).replace(r, this.decimalSymbol);
    }), t;
  }
  normalizeDigits(t) {
    return this.digits[0] !== "0" && this.digits.forEach((n, r) => {
      t = t.replace(new RegExp(n, "g"), String(r));
    }), t;
  }
  onlyDigits(t) {
    return this.normalizeDigits(t).replace(/\D+/g, "");
  }
  onlyLocaleDigits(t) {
    return t.replace(new RegExp(`[^${this.digits.join("")}]*`, "g"), "");
  }
}
class bs {
  constructor(t) {
    this.currencyFormat = t;
  }
}
class jv extends bs {
  conformToMask(t, n = "") {
    const r = this.currencyFormat.isNegative(t), s = (u) => u === "" && r && !(this.currencyFormat.minusSign === void 0 ? n === this.currencyFormat.negativePrefix + this.currencyFormat.negativeSuffix : n === this.currencyFormat.negativePrefix), i = (u) => {
      if (s(u))
        return "";
      if (this.currencyFormat.maximumFractionDigits > 0) {
        if (this.currencyFormat.isFractionIncomplete(u))
          return u;
        if (u.startsWith(this.currencyFormat.decimalSymbol))
          return this.currencyFormat.toFraction(u);
      }
      return null;
    };
    let a = t;
    a = this.currencyFormat.stripCurrency(a, r), a = this.currencyFormat.stripSignLiterals(a);
    const o = i(a);
    if (o != null)
      return this.currencyFormat.insertCurrency(o, r);
    const [l, ...h] = a.split(this.currencyFormat.decimalSymbol), v = ms(this.currencyFormat.onlyDigits(l)), c = this.currencyFormat.onlyDigits(h.join("")).substring(0, this.currencyFormat.maximumFractionDigits), f = h.length > 0 && c.length === 0, m = v === "" && r && (this.currencyFormat.minusSign === void 0 ? n === t.slice(0, -2) + this.currencyFormat.negativeSuffix : n === t.slice(0, -1));
    return f || m || s(v) ? n : v.match(/\d+/) ? {
      numberValue: +`${r ? "-" : ""}${v}.${c}`,
      fractionDigits: c
    } : "";
  }
}
class Zv extends bs {
  conformToMask(t, n = "") {
    if (t === "" || t === this.currencyFormat.decimalSymbol || this.currencyFormat.parse(n) === 0 && this.currencyFormat.stripCurrency(n, !0).slice(0, -1) === this.currencyFormat.stripCurrency(t, !0))
      return "";
    const r = this.currencyFormat.isNegative(t), s = this.currencyFormat.stripSignLiterals(t) === "" ? -0 : +`${r ? "-" : ""}${ms(this.currencyFormat.onlyDigits(t))}` / Math.pow(10, this.currencyFormat.maximumFractionDigits);
    return {
      numberValue: s,
      fractionDigits: s.toFixed(this.currencyFormat.maximumFractionDigits).slice(-this.currencyFormat.maximumFractionDigits)
    };
  }
}
const Wv = {
  locale: void 0,
  currency: void 0,
  currencyDisplay: void 0,
  hideGroupingSeparatorOnFocus: !0,
  hideCurrencySymbolOnFocus: !0,
  hideNegligibleDecimalDigitsOnFocus: !0,
  precision: void 0,
  autoDecimalDigits: !1,
  valueRange: void 0,
  useGrouping: void 0,
  valueScaling: void 0
};
class Yv {
  constructor(t) {
    this.el = t.el, this.onInput = t.onInput, this.onChange = t.onChange, this.addEventListener(), this.init(t.options);
  }
  setOptions(t) {
    this.init(t), this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.onChange(this.getValue());
  }
  getValue() {
    return { number: this.valueScaling && this.numberValue != null ? this.toInteger(this.numberValue, this.valueScaling) : this.numberValue, formatted: this.formattedValue };
  }
  setValue(t) {
    const n = this.valueScaling !== void 0 && t != null ? this.toFloat(t, this.valueScaling) : t;
    n !== this.numberValue && (this.format(this.currencyFormat.format(this.validateValueRange(n))), this.onChange(this.getValue()));
  }
  init(t) {
    this.options = {
      ...Wv,
      ...t
    }, this.options.autoDecimalDigits && (this.options.hideNegligibleDecimalDigitsOnFocus = !1), this.el.getAttribute("inputmode") || this.el.setAttribute("inputmode", this.options.autoDecimalDigits ? "numeric" : "decimal"), this.currencyFormat = new qv(this.options), this.numberMask = this.options.autoDecimalDigits ? new Zv(this.currencyFormat) : new jv(this.currencyFormat);
    const n = {
      [on.precision]: this.currencyFormat.maximumFractionDigits,
      [on.thousands]: 3,
      [on.tenThousands]: 4,
      [on.millions]: 6,
      [on.billions]: 9
    };
    this.valueScaling = this.options.valueScaling ? n[this.options.valueScaling] : void 0, this.valueScalingFractionDigits = this.valueScaling !== void 0 && this.options.valueScaling !== on.precision ? this.valueScaling + this.currencyFormat.maximumFractionDigits : this.currencyFormat.maximumFractionDigits, this.minValue = this.getMinValue(), this.maxValue = this.getMaxValue();
  }
  getMinValue() {
    var t, n;
    let r = this.toFloat(-Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.min) !== void 0 && (r = Math.max((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.min, this.toFloat(-Number.MAX_SAFE_INTEGER))), r;
  }
  getMaxValue() {
    var t, n;
    let r = this.toFloat(Number.MAX_SAFE_INTEGER);
    return ((t = this.options.valueRange) === null || t === void 0 ? void 0 : t.max) !== void 0 && (r = Math.min((n = this.options.valueRange) === null || n === void 0 ? void 0 : n.max, this.toFloat(Number.MAX_SAFE_INTEGER))), r;
  }
  toFloat(t, n) {
    return t / Math.pow(10, n ?? this.valueScalingFractionDigits);
  }
  toInteger(t, n) {
    return Number(t.toFixed(n ?? this.valueScalingFractionDigits).split(".").join(""));
  }
  validateValueRange(t) {
    return t != null ? Math.min(Math.max(t, this.minValue), this.maxValue) : t;
  }
  format(t, n = !1) {
    if (t != null) {
      this.decimalSymbolInsertedAt !== void 0 && (t = this.currencyFormat.normalizeDecimalSeparator(t, this.decimalSymbolInsertedAt), this.decimalSymbolInsertedAt = void 0);
      const r = this.numberMask.conformToMask(t, this.formattedValue);
      let s;
      if (typeof r == "object") {
        const { numberValue: i, fractionDigits: a } = r;
        let { maximumFractionDigits: o, minimumFractionDigits: l } = this.currencyFormat;
        this.focus ? l = n ? a.replace(/0+$/, "").length : Math.min(o, a.length) : Number.isInteger(i) && !this.options.autoDecimalDigits && (this.options.precision === void 0 || l === 0) && (l = o = 0), s = this.toInteger(Math.abs(i)) > Number.MAX_SAFE_INTEGER ? this.formattedValue : this.currencyFormat.format(i, {
          useGrouping: this.options.useGrouping !== !1 && !(this.focus && this.options.hideGroupingSeparatorOnFocus),
          minimumFractionDigits: l,
          maximumFractionDigits: o
        });
      } else
        s = r;
      this.maxValue <= 0 && !this.currencyFormat.isNegative(s) && this.currencyFormat.parse(s) !== 0 && (s = s.replace(this.currencyFormat.prefix, this.currencyFormat.negativePrefix)), this.minValue >= 0 && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.prefix)), (this.options.currencyDisplay === sn.hidden || this.focus && this.options.hideCurrencySymbolOnFocus) && (s = s.replace(this.currencyFormat.negativePrefix, this.currencyFormat.minusSign !== void 0 ? this.currencyFormat.minusSign : "(").replace(this.currencyFormat.negativeSuffix, this.currencyFormat.minusSign !== void 0 ? "" : ")").replace(this.currencyFormat.prefix, "").replace(this.currencyFormat.suffix, "")), this.el.value = s, this.numberValue = this.currencyFormat.parse(s);
    } else
      this.el.value = "", this.numberValue = null;
    this.formattedValue = this.el.value, this.onInput(this.getValue());
  }
  addEventListener() {
    this.el.addEventListener("input", (t) => {
      const { value: n, selectionStart: r } = this.el, s = t;
      if (r && s.data && gs.includes(s.data) && (this.decimalSymbolInsertedAt = r - 1), this.format(n), this.focus && r != null) {
        const i = () => {
          const { prefix: a, suffix: o, decimalSymbol: l, maximumFractionDigits: h, groupingSymbol: v } = this.currencyFormat;
          let c = n.length - r;
          const f = this.formattedValue.length;
          if (this.currencyFormat.minusSign === void 0 && (n.startsWith("(") || n.startsWith("-")) && !n.endsWith(")"))
            return f - this.currencyFormat.negativeSuffix.length > 1 ? this.formattedValue.substring(r).length : 1;
          if (this.formattedValue.substring(r, 1) === v && Nr(this.formattedValue, v) === Nr(n, v) + 1)
            return f - c - 1;
          if (f < c)
            return r;
          if (l !== void 0 && n.indexOf(l) !== -1) {
            const m = n.indexOf(l) + 1;
            if (Math.abs(f - n.length) > 1 && r <= m)
              return this.formattedValue.indexOf(l) + 1;
            !this.options.autoDecimalDigits && r > m && this.currencyFormat.onlyDigits(n.substring(m)).length - 1 === h && (c -= 1);
          }
          return this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden ? f - c : Math.max(f - Math.max(c, o.length), a.length);
        };
        this.setCaretPosition(i());
      }
    }), this.el.addEventListener("focus", () => {
      this.focus = !0, this.numberValueOnFocus = this.numberValue, setTimeout(() => {
        const { value: t, selectionStart: n, selectionEnd: r } = this.el;
        if (this.format(t, this.options.hideNegligibleDecimalDigitsOnFocus), n != null && r != null && Math.abs(n - r) > 0)
          this.setCaretPosition(0, this.el.value.length);
        else if (n != null) {
          const s = this.getCaretPositionOnFocus(t, n);
          this.setCaretPosition(s);
        }
      });
    }), this.el.addEventListener("blur", () => {
      this.focus = !1, this.format(this.currencyFormat.format(this.validateValueRange(this.numberValue))), this.numberValueOnFocus !== this.numberValue && this.onChange(this.getValue());
    });
  }
  getCaretPositionOnFocus(t, n) {
    if (this.numberValue == null)
      return n;
    const { prefix: r, negativePrefix: s, suffix: i, negativeSuffix: a, groupingSymbol: o, currency: l } = this.currencyFormat, h = this.numberValue < 0, v = h ? s : r, c = v.length;
    if (this.options.hideCurrencySymbolOnFocus || this.options.currencyDisplay === sn.hidden) {
      if (h) {
        if (n <= 1)
          return 1;
        if (t.endsWith(")") && n > t.indexOf(")"))
          return this.formattedValue.length - 1;
      }
    } else {
      const m = h ? a.length : i.length;
      if (n >= t.length - m)
        return this.formattedValue.length - m;
      if (n < c)
        return c;
    }
    let f = n;
    return this.options.hideCurrencySymbolOnFocus && this.options.currencyDisplay !== sn.hidden && n >= c && l !== void 0 && v.includes(l) && (f -= c, h && (f += 1)), this.options.hideGroupingSeparatorOnFocus && o !== void 0 && (f -= Nr(t.substring(0, n), o)), f;
  }
  setCaretPosition(t, n = t) {
    this.el.setSelectionRange(t, n);
  }
}
const Xv = (e) => e?.matches("input") ? e : e?.querySelector("input");
function Gv(e, t) {
  var n, r, s, i;
  let a;
  const o = we(null), l = we(null), h = we(null), v = ti();
  v?.emit || ((r = (n = v?.proxy) === null || n === void 0 ? void 0 : n.$emit) === null || r === void 0 || r.bind(v?.proxy));
  const c = v?.props || ((s = v?.proxy) === null || s === void 0 ? void 0 : s.$props), f = Vs.startsWith("3");
  f && ((i = v?.attrs.modelModifiers) === null || i === void 0 || i.lazy);
  const m = Z(() => c?.[f ? "modelValue" : "value"]);
  return Ve(o, (u) => {
    var p;
    if (u) {
      const S = Xv((p = u?.$el) !== null && p !== void 0 ? p : u);
      S ? (a = new Yv({
        el: S,
        options: e,
        onInput: (g) => {
          h.value = g.number, l.value = g.formatted;
        },
        onChange: (g) => {
        }
      }), a.setValue(m.value)) : console.error('No input element found. Please make sure that the "inputRef" template ref is properly assigned.');
    } else
      a = null;
  }), {
    inputRef: o,
    numberValue: h,
    formattedValue: l,
    setValue: (u) => a?.setValue(u),
    setOptions: (u) => a?.setOptions(u)
  };
}
const Gl = 2, Hg = /* @__PURE__ */ Ce({
  __name: "LcMoneyInput",
  props: {
    autocomplete: { default: "off" },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: { default: "0.00" },
    prefixClass: {},
    suffixClass: {},
    valueRange: { default: () => ({
      max: 1e6,
      min: 0
    }) },
    currency: { default: () => We.general.currency },
    locale: { default: () => We.general.locale },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = ga(e, ["autocomplete", "currency", "locale", "placeholder", "value", "valueRange"]), { formattedValue: s, inputRef: i, numberValue: a, setValue: o } = Gv(
      {
        currency: e.currency,
        currencyDisplay: sn.hidden,
        locale: e.locale,
        precision: Gl,
        valueRange: e.valueRange
      }
    ), l = Z(
      () => new Intl.NumberFormat(e.locale, {
        currency: e.currency,
        style: "currency"
      }).formatToParts(1).find(({ type: c }) => c === "currency")?.value ?? e.currency
    ), h = Z(
      () => St(a.value) ? parseFloat((a.value * 100).toFixed()) : null
    ), v = (c) => {
      o(St(c) ? parseFloat((c / 100).toFixed(Gl)) : null);
    };
    return mt(async () => {
      St(e.value) && (await Ya(), v(e.value));
    }), Ve(h, (c) => {
      n("update:value", c);
    }), Ve(
      () => e.value,
      (c) => {
        c !== h.value && v(c);
      }
    ), (c, f) => ($(), ke(U(tr), Ae({
      ref_key: "inputRef",
      ref: i
    }, { ...c.$attrs, ...r, autocomplete: e.autocomplete, placeholder: e.placeholder, value: e.value }, {
      class: "lc-money-input",
      spellcheck: !1,
      value: U(s)
    }), Xa({
      prefix: Te(() => [
        wt(De(l.value), 1)
      ]),
      _: 2
    }, [
      c.$slots.suffix ? {
        name: "suffix",
        fn: Te(() => [
          me(c.$slots, "suffix")
        ]),
        key: "0"
      } : void 0
    ]), 1040, ["value"]));
  }
}), Kv = ["aria-checked", "aria-label"], Ug = /* @__PURE__ */ Ce({
  __name: "LcPasswordInput",
  props: {
    autocomplete: {},
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    inputmode: {},
    label: {},
    mask: { type: [Object, String, Array, Function, null] },
    name: {},
    noFeedback: { type: Boolean },
    pattern: {},
    placeholder: {},
    prefixClass: {},
    spellcheck: { type: Boolean },
    suffixClass: {},
    value: {},
    toggleAriaLabel: { default: () => We.lcPasswordInput.toggleAriaLabel }
  },
  setup(e) {
    const t = ga(e, ["toggleAriaLabel"]), n = we("password"), r = Z(() => s.value ? "eye-off" : "eye"), s = Z(() => n.value === "text"), i = () => {
      n.value = s.value ? "password" : "text";
    };
    return (a, o) => ($(), ke(U(tr), Ae({ ...a.$attrs, ...t }, {
      class: "lc-password-input",
      spellcheck: !1,
      type: n.value
    }), {
      suffix: Te(() => [
        ee("button", {
          "aria-checked": s.value,
          "aria-label": e.toggleAriaLabel,
          class: "lc-password-input__toggle",
          role: "switch",
          type: "button",
          onClickPassive: i
        }, [
          Fe(U(Qe), { name: r.value }, null, 8, ["name"])
        ], 40, Kv),
        me(a.$slots, "suffix")
      ]),
      _: 3
    }, 16, ["type"]));
  }
}), qg = ["password", "text"], Jv = ["aria-valuenow"], jg = /* @__PURE__ */ Ce({
  __name: "LcProgressIndicator",
  props: {
    icon: {},
    progress: { default: 0 },
    size: { default: "medium" },
    variant: { default: "info" }
  },
  setup(e) {
    const t = Z(() => e.size === "medium" ? 36 : 24);
    return (n, r) => ($(), q("div", {
      "aria-live": "polite",
      "aria-valuenow": e.progress,
      class: xe([
        "lc-progress-indicator",
        `lc-progress-indicator--size-${e.size}`,
        `lc-progress-indicator--variant-${e.variant}`
      ]),
      role: "progressbar"
    }, [
      Fe(U($o), Ae({ progress: e.progress, radius: t.value }, { "progress-class": "lc-progress-indicator__progress" }), null, 16),
      Fe(wn, {
        mode: "out-in",
        name: "lc-progress-indicator__transition"
      }, {
        default: Te(() => [
          ($(), ke(U(Qe), {
            key: e.icon,
            class: "lc-progress-indicator__icon",
            name: e.icon,
            size: e.size === "medium" ? "large" : "medium"
          }, null, 8, ["name", "size"]))
        ]),
        _: 1
      })
    ], 10, Jv));
  }
}), Zg = ["medium", "small"], Wg = ["info", "success"], Si = /* @__PURE__ */ Symbol(), Qv = ["for"], em = { class: "lc-radio__control" }, tm = ["id", "aria-labelledby", "data-click-name", "name"], nm = ["id"], am = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcRadio",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] }
  },
  emits: ["change"],
  setup(e, { emit: t }) {
    const n = t, r = Wn(Si), s = Tt(e.id), i = Z(() => [
      "lc-radio",
      {
        "lc-radio--checked": a.value,
        "lc-radio--disabled": !!Ke(r?.disabled) || e.disabled,
        "lc-radio--error": !!Ke(r?.hasError)
      }
    ]), a = Z(() => e.value === Ke(r?.value) || e.checked), o = Z({
      get: () => a.value,
      set: () => {
        if (r) {
          r.updateValue(e.value);
          return;
        }
        n("change");
      }
    }), l = Z(() => {
      if (Ke(r?.value))
        return a.value ? 0 : -1;
    }), h = Z(() => Ke(r?.name) ?? e.name);
    return (v, c) => ($(), q("label", {
      class: xe([i.value, v.$attrs.class]),
      for: U(s)
    }, [
      ee("div", em, [
        Qt(ee("input", Ae({ id: U(s) }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          tabindex: l.value
        }, {
          "onUpdate:modelValue": c[0] || (c[0] = (f) => o.value = f),
          "aria-labelledby": e.label ? `${U(s)}-label` : void 0,
          class: "lc-radio__input",
          "data-click-name": e.dataClickName || `${h.value?.toLowerCase()}_radio`,
          name: h.value,
          type: "radio"
        }), null, 16, tm), [
          [Hs, o.value]
        ])
      ]),
      e.label ? ($(), q("span", {
        key: 0,
        id: `${U(s)}-label`,
        class: xe(["lc-radio__label", e.labelClass])
      }, De(e.label), 11, nm)) : de("", !0)
    ], 10, Qv));
  }
}), rm = { class: "lc-radio-card__main" }, Yg = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcRadioCard",
  props: {
    checked: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    id: {},
    label: {},
    labelClass: {},
    name: {},
    value: { type: [Boolean, Number, String] },
    bodyClass: {}
  },
  setup(e) {
    const t = it("radio"), n = Wn(Si), r = Z(() => [
      "lc-radio-card",
      {
        "lc-radio-card--disabled": i.value
      }
    ]), s = Z(() => e.value === Ke(n?.value) || e.checked), i = Z(() => e.disabled || Ke(n?.disabled)), a = () => {
      if (i.value) return;
      n?.updateValue(e.value);
      const o = t.value?.$el?.querySelector("input");
      if (!o) return;
      const l = new Event("focusin", { bubbles: !0 }), h = new Event("focusout", { bubbles: !0 });
      o.dispatchEvent(l), o.dispatchEvent(h);
    };
    return (o, l) => ($(), ke(U(ya), {
      "body-class": ["lc-radio-card__body", e.bodyClass],
      class: xe([r.value, o.$attrs.class]),
      onClick: a
    }, {
      default: Te(() => [
        ee("div", rm, [
          Fe(U(am), Ae({ ref: "radio" }, {
            ...en(o.$attrs, ["class"]),
            ...o.$props
          }), null, 16),
          me(o.$slots, "default", {
            checked: s.value,
            disabled: i.value
          })
        ]),
        Qt(ee("div", {
          class: "lc-radio-card__underneath",
          onClick: l[0] || (l[0] = sa(() => {
          }, ["stop"]))
        }, [
          me(o.$slots, "underneath", { disabled: i.value })
        ], 512), [
          [ii, s.value && o.$slots.underneath]
        ]),
        me(o.$slots, "bottom")
      ]),
      _: 3
    }, 8, ["body-class", "class"]));
  }
}), im = ["id", "aria-labelledby"], lm = ["id"], Xg = /* @__PURE__ */ Ce({
  __name: "LcRadioGroup",
  props: {
    contentWrapClass: {},
    defaultValue: { type: [Boolean, Number, String] },
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    layout: { default: "horizontal" },
    name: { default: "radio-group" },
    noFeedback: { type: Boolean },
    value: { type: [Boolean, null, Number, String], default: null }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Tt(e.id), s = Z(() => [
      "lc-radio-group",
      `lc-radio-group--${e.layout}`,
      {
        "lc-radio-group--disabled": e.disabled,
        "lc-radio-group--error": i.value
      }
    ]), i = Z(() => !!e.errorMessage);
    return mt(() => {
      e.defaultValue && n("update:value", e.defaultValue);
    }), ai(Si, {
      disabled: () => e.disabled,
      hasError: so(i),
      name: () => e.name,
      updateValue: (a) => {
        n("update:value", a);
      },
      value: () => e.value
    }), (a, o) => ($(), q("fieldset", Ae({
      ...a.$attrs,
      disabled: e.disabled,
      name: e.name
    }, {
      id: U(r),
      "aria-labelledby": e.label ? `${U(r)}-label` : void 0,
      class: s.value,
      role: "radiogroup"
    }), [
      e.label ? ($(), q("legend", {
        key: 0,
        id: `${U(r)}-label`,
        class: "lc-radio-group__label"
      }, De(e.label), 9, lm)) : de("", !0),
      ee("div", {
        class: xe(["lc-radio-group__wrap", e.contentWrapClass])
      }, [
        me(a.$slots, "default")
      ], 2),
      e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 16, im));
  }
}), Gg = ["horizontal", "vertical"], om = { class: "lc-rating" }, Kg = /* @__PURE__ */ Ce({
  __name: "LcRating",
  props: {
    max: { default: 5 },
    rating: { default: 0 }
  },
  setup(e) {
    return (t, n) => ($(), q("div", om, [
      ($(!0), q(Ge, null, vt(new Array(e.max), (r, s) => ($(), q("svg", {
        key: s,
        class: xe(["lc-rating__star", s < e.rating ? "lc-rating__star--active" : "lc-rating__star--inactive"]),
        fill: "none",
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg"
      }, [...n[0] || (n[0] = [
        ee("path", { d: "M7.639.68c.148-.299.574-.299.722 0l2.16 4.377c.059.119.172.201.303.22l4.831.702c.33.048.462.454.223.686l-3.496 3.407c-.095.092-.138.226-.116.356l.825 4.811c.056.329-.289.579-.584.424l-4.321-2.271c-.117-.062-.257-.062-.374 0l-4.321 2.271c-.295.155-.64-.095-.584-.424l.825-4.811c.022-.131-.021-.264-.116-.356L.122 6.665c-.239-.233-.107-.638.223-.686l4.831-.702c.131-.019.244-.101.303-.22L7.639.68z" }, null, -1),
        ee("path", {
          d: "M.262 6.522l-.14.143.14-.143c-.12-.117-.054-.321.112-.345l4.831-.702a.6.6 0 0 0 .454-.33L7.819.768c.074-.15.289-.15.363 0l2.16 4.377c.088.178.257.301.454.33l4.831.702c.166.024.232.228.112.345l-3.496 3.407c-.142.138-.207.338-.173.533l.825 4.811c.028.165-.145.291-.294.213l-4.321-2.271a.6.6 0 0 0-.561 0l-4.321 2.271.093.177-.093-.177c-.148.078-.322-.048-.294-.213l.825-4.811a.6.6 0 0 0-.173-.533L.262 6.522z",
          "stroke-width": ".4"
        }, null, -1)
      ])], 2))), 128))
    ]));
  }
}), sm = /* @__PURE__ */ Ce({
  __name: "LcSkeleton",
  props: {
    height: { default: "1rem" },
    opacity: { default: 0.4 },
    radius: { default: "large" },
    width: { default: "100%" }
  },
  setup(e) {
    return (t, n) => ($(), q("div", {
      "aria-hidden": "true",
      class: xe(["lc-skeleton", `lc-skeleton--radius-${e.radius}`]),
      style: Ct({
        "--skeleton-height": e.height,
        "--skeleton-radius": e.radius,
        "--skeleton-width": e.width,
        "--skeleton-opacity": e.opacity
      })
    }, null, 6));
  }
}), Jg = ["full", "half", "large", "medium", "none", "small"], um = { class: "lc-remote-list__content" }, cm = {
  key: 0,
  class: "lc-remote-list__cta-wrap"
}, Qg = /* @__PURE__ */ Ce({
  __name: "LcRemoteList",
  props: {
    buttonText: {},
    count: {},
    hideSeparator: { type: Boolean },
    loading: { type: Boolean },
    numberOfSkeletons: { default: 3 },
    skeletonHeight: { default: "10.75rem" },
    total: {}
  },
  emits: ["fetch-more"],
  setup(e, { emit: t }) {
    const n = t, r = Z(() => [
      "lc-remote-list",
      {
        "lc-remote-list--separator": !e.hideSeparator
      }
    ]), s = Z(() => e.count < e.total), i = () => {
      s.value && n("fetch-more");
    };
    return (a, o) => ($(), q("section", {
      class: xe(r.value)
    }, [
      ee("ul", um, [
        me(a.$slots, "default"),
        e.loading ? me(a.$slots, "loading", {}, () => [
          ($(!0), q(Ge, null, vt(e.numberOfSkeletons, (l) => ($(), ke(U(sm), {
            key: l,
            height: e.skeletonHeight,
            radius: "medium"
          }, null, 8, ["height"]))), 128))
        ], void 0, 0) : de("", !0)
      ]),
      !e.loading && s.value ? ($(), q("div", cm, [
        me(a.$slots, "load-more", _t(Dt({ fetchMore: i })), () => [
          Fe(U(Et), {
            class: "lc-remote-list__cta",
            size: "medium",
            variant: "secondary",
            onClickPassive: i
          }, {
            default: Te(() => [
              wt(De(e.buttonText), 1)
            ]),
            _: 1
          })
        ]),
        e.hideSeparator ? de("", !0) : ($(), ke(U(ui), { key: 0 }))
      ])) : de("", !0)
    ], 2));
  }
}), dm = { class: "lc-scratchcard-teaser__button-wrap" }, e2 = /* @__PURE__ */ Ce({
  __name: "LcScratchcardTeaser",
  props: {
    href: {},
    target: {},
    to: {},
    backgroundPattern: {},
    badge: {},
    buttonAriaLabel: {},
    buttonText: {},
    variant: { default: "default" }
  },
  emits: ["primary-button-click"],
  setup(e) {
    return (t, n) => ($(), ke(U(nr), Ae({ badge: e.badge, backgroundPattern: e.backgroundPattern, variant: e.variant }, {
      "body-class": "lc-scratchcard-teaser__body",
      class: ["lc-scratchcard-teaser", `lc-scratchcard-teaser--variant-${e.variant}`],
      style: {
        "--teaser-frame-color": "var(--scratchcard-teaser-frame-color)"
      }
    }), {
      default: Te(() => [
        Fe(U(si), Ae({ href: e.href, target: e.target, to: e.to }, {
          class: "lc-scratchcard-teaser__link",
          tabindex: "-1"
        }), {
          default: Te(() => [
            me(t.$slots, "image")
          ]),
          _: 3
        }, 16),
        ee("div", dm, [
          Fe(U(Et), Ae({ "aria-label": e.buttonAriaLabel }, { href: e.href, target: e.target, to: e.to }, {
            class: "lc-scratchcard-teaser__button",
            "no-padding": "",
            onClick: n[0] || (n[0] = (r) => t.$emit("primary-button-click"))
          }), {
            default: Te(() => [
              wt(De(e.buttonText), 1)
            ]),
            _: 1
          }, 16, ["aria-label"])
        ])
      ]),
      _: 3
    }, 16, ["class"]));
  }
}), t2 = [...Yo];
var Gt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.Enter = "Enter", e.Escape = "Escape", e.Space = " ", e.Tab = "Tab", e))(Gt || {});
const fm = ["id", "aria-controls", "aria-expanded", "aria-haspopup", "aria-labelledby", "data-click-name", "disabled", "role"], hm = ["id"], vm = { class: "lc-select__input" }, mm = ["id", "aria-activedescendant", "aria-labelledby"], gm = ["id", "aria-selected", "onClickPassive"], n2 = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcSelect",
  props: {
    ignoreOutsideClickOn: { default: () => [We.lcModal.to] },
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    name: { default: "select" },
    noFeedback: { type: Boolean },
    noTeleport: { type: Boolean },
    notNullable: { type: Boolean },
    onBlur: {},
    options: {},
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = it("button"), s = it("container"), i = it("menu"), a = it("options"), o = we(null), l = we(!1), h = ei({
      focusin: !1,
      focusout: !1
    }), { floatingStyles: v } = hs(r, i, {
      middleware: [ds(), vs, cs(2)],
      whileElementsMounted: us
    }), { width: c } = Vr(s), f = Tt(e.id), m = ki(), u = Z(() => {
      if (!(!l.value || !St(o.value)))
        return `${f}-option-${o.value}`;
    }), p = Z(() => [
      "lc-select",
      {
        "lc-select--disabled": e.disabled,
        "lc-select--fixed-value": b.value,
        "lc-select--error": !!e.errorMessage,
        "lc-select--expanded": l.value,
        "lc-select--has-label": !b.value && !!e.label
      }
    ]), S = Z(
      () => b.value || e.value ? e.options[g.value].label : ""
    ), g = Z(() => e.options.findIndex((A) => A.value === e.value)), b = Z(() => e.notNullable && e.options.length === 1 && !!e.value), _ = Z(() => [
      "lc-select__label",
      {
        "lc-select__label--floating": !!e.value
      }
    ]), T = Z(() => [
      "lc-select__menu",
      {
        "lc-select__menu--scrollable": e.options.length > 6
      }
    ]), I = Z(() => ({
      ...v.value,
      minWidth: `${c.value}px`
    })), L = () => {
      l.value && (o.value = null, l.value = !1, e.onBlur?.(), C("focusout"));
    }, C = (A) => {
      const V = r.value;
      if (!V) return;
      h[A] = !0;
      const H = new Event(A, { bubbles: !0 });
      V.dispatchEvent(H);
    }, F = async () => {
      l.value || await P();
    }, z = (A) => {
      const V = A.type;
      if (!G(V)) return;
      h[V] ? h[V] = !1 : A.stopPropagation();
    }, X = async (A) => {
      if (!tn(A.key, Gt)) return;
      A.key !== Gt.Tab && (A.preventDefault(), A.stopPropagation());
      const V = e.options.length - 1;
      switch (A.key) {
        case Gt.ArrowDown:
          if (l.value && St(o.value)) {
            o.value = Math.min(V, o.value + 1), E();
            break;
          }
          o.value = 0, await P();
          break;
        case Gt.ArrowUp:
          if (l.value && St(o.value)) {
            o.value = Math.max(0, o.value - 1), E();
            break;
          }
          o.value = V, await P();
          break;
        case Gt.Enter:
        case Gt.Space:
          if (l.value && St(o.value)) {
            O(e.options[o.value].value);
            break;
          }
          await P();
          break;
        case Gt.Escape:
          L();
          break;
        case Gt.Tab:
          if (!l.value || !St(o.value)) break;
          O(e.options[o.value].value);
          break;
      }
    }, O = (A) => {
      const V = e.value === A ? null : A;
      e.notNullable && V === null || (n("update:value", V), L());
    }, G = (A) => A === "focusin" || A === "focusout", P = async () => {
      l.value || (l.value = !0, e.value && (o.value = g.value), C("focusin"), await Ya(), E());
    }, E = () => {
      if (!St(o.value)) return;
      a.value?.[o.value]?.scrollIntoView({ block: "center" });
    };
    return Ga(i, L, {
      ignore: [r, ...Ke(e.ignoreOutsideClickOn)]
    }), mt(() => {
      e.autofocus && r.value?.focus(), e.value && (o.value = g.value);
    }), (A, V) => ($(), q("div", {
      ref: "container",
      class: xe([p.value, A.$attrs.class])
    }, [
      ee("button", Ae({
        id: U(f),
        ref: "button"
      }, en(A.$attrs, ["class"]), {
        "aria-controls": b.value ? void 0 : `${U(f)}-listbox`,
        "aria-expanded": b.value ? void 0 : l.value,
        "aria-haspopup": b.value ? void 0 : "listbox",
        "aria-labelledby": e.label ? `${U(f)}-label` : void 0,
        class: "lc-select__wrap",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_select`,
        disabled: b.value || e.disabled,
        role: b.value ? void 0 : "combobox",
        type: "button",
        onClickPassive: F,
        onFocusin: z,
        onFocusout: z,
        onKeydown: X
      }), [
        !b.value && e.label ? ($(), q("span", {
          key: 0,
          id: `${U(f)}-label`,
          class: xe(_.value)
        }, De(e.label), 11, hm)) : de("", !0),
        ee("div", vm, De(S.value), 1),
        b.value ? de("", !0) : ($(), ke(U(Qe), {
          key: 1,
          class: "lc-select__icon",
          name: "chevron-down"
        }))
      ], 16, fm),
      b.value ? de("", !0) : ($(), ke(U(yc), {
        key: 0,
        to: e.noTeleport ? void 0 : "body"
      }, {
        default: Te(() => [
          l.value ? ($(), q("div", {
            key: 0,
            ref: "menu",
            class: xe(T.value),
            style: Ct(I.value)
          }, [
            ee("ul", {
              id: `${U(f)}-listbox`,
              "aria-activedescendant": u.value,
              "aria-labelledby": e.label ? `${U(f)}-label` : void 0,
              class: "lc-select__menu-list",
              role: "listbox"
            }, [
              ($(!0), q(Ge, null, vt(e.options, (H, K) => ($(), q("li", {
                key: `${H.label}-${H.value}`,
                class: xe(["lc-select__menu-item", {
                  "lc-select__menu-item--focused": o.value === K && U(m),
                  "lc-select__menu-item--selected": H.value === e.value
                }])
              }, [
                ee("button", {
                  id: `${U(f)}-option-${K}`,
                  ref_for: !0,
                  ref: "options",
                  "aria-selected": H.value === e.value,
                  class: "lc-select__menu-item-button",
                  role: "option",
                  tabindex: "-1",
                  type: "button",
                  onClickPassive: (B) => O(H.value)
                }, [
                  ee("span", null, De(H.label), 1),
                  H.value === e.value ? ($(), ke(U(Qe), {
                    key: 0,
                    class: "lc-select__menu-item-checkmark",
                    name: "checkmark"
                  })) : de("", !0)
                ], 40, gm)
              ], 2))), 128))
            ], 8, mm)
          ], 6)) : de("", !0)
        ]),
        _: 1
      }, 8, ["to"])),
      e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({ key: 1 }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 2));
  }
}), a2 = ["default", "discreet"];
var Wt = /* @__PURE__ */ ((e) => (e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.ArrowUp = "ArrowUp", e.End = "End", e.Enter = "Enter", e.Home = "Home", e.Space = " ", e))(Wt || {});
const bm = ["id", "aria-activedescendant"], r2 = /* @__PURE__ */ Ce({
  __name: "LcSelectList",
  props: {
    horizontal: { type: Boolean },
    id: {},
    multiple: { type: Boolean },
    optionComponent: {},
    options: {},
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = it("list"), s = we(null), i = Tt(e.id), a = ki(), o = Z(() => {
      if (St(s.value))
        return `${i}-option-${s.value}`;
    }), l = Z(() => !r.value || !St(s.value) ? null : r.value.querySelectorAll('[role="option"]')[s.value]), h = Z(() => [
      "lc-select-list",
      `lc-select-list--variant-${e.variant}`,
      {
        "lc-select-list--focus-hidden": e.options.length <= 1,
        "lc-select-list--horizontal": e.horizontal
      }
    ]), v = Z(
      () => e.options.findIndex((T) => T.value === (Array.isArray(e.value) ? e.value[0] : e.value))
    ), c = (T) => e.optionComponent ? g(T) ? "span" : e.optionComponent : S(T) ? g(T) ? "span" : Yn(T.to) : "button", f = () => {
      a.value && (s.value = Math.max(0, v.value));
    }, m = () => {
      a.value && (s.value = null);
    }, u = (T) => {
      if (!tn(T.key, Wt) || !St(s.value))
        return;
      T.preventDefault(), T.stopPropagation();
      const I = e.options.length - 1;
      switch (T.key) {
        case Wt.ArrowDown:
        case Wt.ArrowRight:
          s.value = Math.min(I, s.value + 1);
          break;
        case Wt.ArrowLeft:
        case Wt.ArrowUp:
          s.value = Math.max(0, s.value - 1);
          break;
        case Wt.End:
          s.value = I;
          break;
        case Wt.Enter:
        case Wt.Space:
          l.value?.dispatchEvent(new MouseEvent("click"));
          break;
        case Wt.Home:
          s.value = 0;
          break;
      }
    }, p = (T) => {
      let I;
      if (e.multiple) {
        const L = Array.isArray(e.value) ? e.value : [];
        I = L.includes(T) ? L.filter((C) => C !== T) : _([...L, T]);
      } else
        I = e.value === T ? void 0 : T;
      n("update:value", I);
    }, S = ({ href: T, to: I }) => !!(T || I), g = (T) => Array.isArray(e.value) ? e.value.includes(T.value) : e.value === T.value, b = () => {
      l.value?.scrollIntoView(
        e.horizontal ? { block: "nearest", inline: "center" } : { block: "center", inline: "nearest" }
      );
    }, _ = (T) => {
      const I = new Map(e.options.map((L, C) => [L.value, C]));
      return [...T].sort(
        (L, C) => (I.get(L) ?? 1 / 0) - (I.get(C) ?? 1 / 0)
      );
    };
    return mt(() => {
      if (e.value) {
        if (e.multiple && !Array.isArray(e.value))
          throw Error('LcSelectList: "value" must be an array when "multiple" is true.');
        if (!e.multiple && Array.isArray(e.value))
          throw Error('LcSelectList: "value" must not be an array when "multiple" is false.');
      }
    }), Ve(s, (T) => {
      T !== null && b();
    }), (T, I) => ($(), q("div", {
      class: xe(h.value)
    }, [
      ee("ul", {
        id: U(i),
        ref: "list",
        "aria-activedescendant": o.value,
        class: "lc-select-list__list",
        role: "listbox",
        tabindex: "0",
        onFocusin: f,
        onFocusout: m,
        onKeydown: u
      }, [
        ($(!0), q(Ge, null, vt(e.options, (L, C) => ($(), q("li", {
          key: `${L.label}-${L.value}`,
          class: xe(["lc-select-list__item", {
            "lc-select-list__item--focused": s.value === C && U(a),
            "lc-select-list__item--selected": g(L)
          }])
        }, [
          ($(), ke(Pt(c(L)), Ae({
            id: `${U(i)}-option-${C}`
          }, { ref_for: !0 }, {
            ...uc(L, ["href", "target", "to"]),
            ...L?.additionalProps ?? {}
          }, {
            "aria-label": L.ariaLabelText,
            "aria-selected": g(L),
            class: "lc-select-list__item-button",
            role: "option",
            tabindex: "-1",
            type: S(L) && !g(L) ? void 0 : "button",
            onClickPassive: (F) => p(L.value)
          }), {
            default: Te(() => [
              ee("span", null, De(L.label), 1),
              g(L) ? ($(), ke(U(Qe), {
                key: 0,
                class: "lc-select-list__item-checkmark",
                name: e.variant === "discreet" ? "checkmark-small" : "checkmark"
              }, null, 8, ["name"])) : de("", !0)
            ]),
            _: 2
          }, 1040, ["id", "aria-label", "aria-selected", "type", "onClickPassive"]))
        ], 2))), 128))
      ], 40, bm)
    ], 2));
  }
});
function Ma(e) {
  return [null, void 0, !1].indexOf(e) !== -1;
}
function pm(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function ps(e) {
  var t = { exports: {} };
  return e(t, t.exports), t.exports;
}
var Kl = ps((function(e, t) {
  e.exports = /* @__PURE__ */ (function() {
    var n = ["decimals", "thousand", "mark", "prefix", "suffix", "encoder", "decoder", "negativeBefore", "negative", "edit", "undo"];
    function r(u) {
      return u.split("").reverse().join("");
    }
    function s(u, p) {
      return u.substring(0, p.length) === p;
    }
    function i(u, p) {
      return u.slice(-1 * p.length) === p;
    }
    function a(u, p, S) {
      if ((u[p] || u[S]) && u[p] === u[S]) throw new Error(p);
    }
    function o(u) {
      return typeof u == "number" && isFinite(u);
    }
    function l(u, p) {
      return u = u.toString().split("e"), (+((u = (u = Math.round(+(u[0] + "e" + (u[1] ? +u[1] + p : p)))).toString().split("e"))[0] + "e" + (u[1] ? +u[1] - p : -p))).toFixed(p);
    }
    function h(u, p, S, g, b, _, T, I, L, C, F, z) {
      var X, O, G, P = z, E = "", A = "";
      return _ && (z = _(z)), !!o(z) && (u !== !1 && parseFloat(z.toFixed(u)) === 0 && (z = 0), z < 0 && (X = !0, z = Math.abs(z)), u !== !1 && (z = l(z, u)), (z = z.toString()).indexOf(".") !== -1 ? (G = (O = z.split("."))[0], S && (E = S + O[1])) : G = z, p && (G = r(G).match(/.{1,3}/g), G = r(G.join(r(p)))), X && I && (A += I), g && (A += g), X && L && (A += L), A += G, A += E, b && (A += b), C && (A = C(A, P)), A);
    }
    function v(u, p, S, g, b, _, T, I, L, C, F, z) {
      var X, O = "";
      return F && (z = F(z)), !(!z || typeof z != "string") && (I && s(z, I) && (z = z.replace(I, ""), X = !0), g && s(z, g) && (z = z.replace(g, "")), L && s(z, L) && (z = z.replace(L, ""), X = !0), b && i(z, b) && (z = z.slice(0, -1 * b.length)), p && (z = z.split(p).join("")), S && (z = z.replace(S, ".")), X && (O += "-"), (O = (O += z).replace(/[^0-9\.\-.]/g, "")) !== "" && (O = Number(O), T && (O = T(O)), !!o(O) && O));
    }
    function c(u) {
      var p, S, g, b = {};
      for (u.suffix === void 0 && (u.suffix = u.postfix), p = 0; p < n.length; p += 1) if ((g = u[S = n[p]]) === void 0) S !== "negative" || b.negativeBefore ? S === "mark" && b.thousand !== "." ? b[S] = "." : b[S] = !1 : b[S] = "-";
      else if (S === "decimals") {
        if (!(g >= 0 && g < 8)) throw new Error(S);
        b[S] = g;
      } else if (S === "encoder" || S === "decoder" || S === "edit" || S === "undo") {
        if (typeof g != "function") throw new Error(S);
        b[S] = g;
      } else {
        if (typeof g != "string") throw new Error(S);
        b[S] = g;
      }
      return a(b, "mark", "thousand"), a(b, "prefix", "negative"), a(b, "prefix", "negativeBefore"), b;
    }
    function f(u, p, S) {
      var g, b = [];
      for (g = 0; g < n.length; g += 1) b.push(u[n[g]]);
      return b.push(S), p.apply("", b);
    }
    function m(u) {
      if (!(this instanceof m)) return new m(u);
      typeof u == "object" && (u = c(u), this.to = function(p) {
        return f(u, h, p);
      }, this.from = function(p) {
        return f(u, v, p);
      });
    }
    return m;
  })();
})), ym = pm(ps((function(e, t) {
  (function(n) {
    function r(D) {
      return s(D) && typeof D.from == "function";
    }
    function s(D) {
      return typeof D == "object" && typeof D.to == "function";
    }
    function i(D) {
      D.parentElement.removeChild(D);
    }
    function a(D) {
      return D != null;
    }
    function o(D) {
      D.preventDefault();
    }
    function l(D) {
      return D.filter((function(k) {
        return !this[k] && (this[k] = !0);
      }), {});
    }
    function h(D, k) {
      return Math.round(D / k) * k;
    }
    function v(D, k) {
      var w = D.getBoundingClientRect(), Y = D.ownerDocument, W = Y.documentElement, ce = _(Y);
      return /webkit.*Chrome.*Mobile/i.test(navigator.userAgent) && (ce.x = 0), k ? w.top + ce.y - W.clientTop : w.left + ce.x - W.clientLeft;
    }
    function c(D) {
      return typeof D == "number" && !isNaN(D) && isFinite(D);
    }
    function f(D, k, w) {
      w > 0 && (S(D, k), setTimeout((function() {
        g(D, k);
      }), w));
    }
    function m(D) {
      return Math.max(Math.min(D, 100), 0);
    }
    function u(D) {
      return Array.isArray(D) ? D : [D];
    }
    function p(D) {
      var k = (D = String(D)).split(".");
      return k.length > 1 ? k[1].length : 0;
    }
    function S(D, k) {
      D.classList && !/\s/.test(k) ? D.classList.add(k) : D.className += " " + k;
    }
    function g(D, k) {
      D.classList && !/\s/.test(k) ? D.classList.remove(k) : D.className = D.className.replace(new RegExp("(^|\\b)" + k.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    }
    function b(D, k) {
      return D.classList ? D.classList.contains(k) : new RegExp("\\b" + k + "\\b").test(D.className);
    }
    function _(D) {
      var k = window.pageXOffset !== void 0, w = (D.compatMode || "") === "CSS1Compat";
      return { x: k ? window.pageXOffset : w ? D.documentElement.scrollLeft : D.body.scrollLeft, y: k ? window.pageYOffset : w ? D.documentElement.scrollTop : D.body.scrollTop };
    }
    function T() {
      return window.navigator.pointerEnabled ? { start: "pointerdown", move: "pointermove", end: "pointerup" } : window.navigator.msPointerEnabled ? { start: "MSPointerDown", move: "MSPointerMove", end: "MSPointerUp" } : { start: "mousedown touchstart", move: "mousemove touchmove", end: "mouseup touchend" };
    }
    function I() {
      var D = !1;
      try {
        var k = Object.defineProperty({}, "passive", { get: function() {
          D = !0;
        } });
        window.addEventListener("test", null, k);
      } catch {
      }
      return D;
    }
    function L() {
      return window.CSS && CSS.supports && CSS.supports("touch-action", "none");
    }
    function C(D, k) {
      return 100 / (k - D);
    }
    function F(D, k, w) {
      return 100 * k / (D[w + 1] - D[w]);
    }
    function z(D, k) {
      return F(D, D[0] < 0 ? k + Math.abs(D[0]) : k - D[0], 0);
    }
    function X(D, k) {
      return k * (D[1] - D[0]) / 100 + D[0];
    }
    function O(D, k) {
      for (var w = 1; D >= k[w]; ) w += 1;
      return w;
    }
    function G(D, k, w) {
      if (w >= D.slice(-1)[0]) return 100;
      var Y = O(w, D), W = D[Y - 1], ce = D[Y], R = k[Y - 1], re = k[Y];
      return R + z([W, ce], w) / C(R, re);
    }
    function P(D, k, w) {
      if (w >= 100) return D.slice(-1)[0];
      var Y = O(w, k), W = D[Y - 1], ce = D[Y], R = k[Y - 1];
      return X([W, ce], (w - R) * C(R, k[Y]));
    }
    function E(D, k, w, Y) {
      if (Y === 100) return Y;
      var W = O(Y, D), ce = D[W - 1], R = D[W];
      return w ? Y - ce > (R - ce) / 2 ? R : ce : k[W - 1] ? D[W - 1] + h(Y - D[W - 1], k[W - 1]) : Y;
    }
    var A, V;
    n.PipsMode = void 0, (V = n.PipsMode || (n.PipsMode = {})).Range = "range", V.Steps = "steps", V.Positions = "positions", V.Count = "count", V.Values = "values", n.PipsType = void 0, (A = n.PipsType || (n.PipsType = {}))[A.None = -1] = "None", A[A.NoValue = 0] = "NoValue", A[A.LargeValue = 1] = "LargeValue", A[A.SmallValue = 2] = "SmallValue";
    var H = (function() {
      function D(k, w, Y) {
        var W;
        this.xPct = [], this.xVal = [], this.xSteps = [], this.xNumSteps = [], this.xHighestCompleteStep = [], this.xSteps = [Y || !1], this.xNumSteps = [!1], this.snap = w;
        var ce = [];
        for (Object.keys(k).forEach((function(R) {
          ce.push([u(k[R]), R]);
        })), ce.sort((function(R, re) {
          return R[0][0] - re[0][0];
        })), W = 0; W < ce.length; W++) this.handleEntryPoint(ce[W][1], ce[W][0]);
        for (this.xNumSteps = this.xSteps.slice(0), W = 0; W < this.xNumSteps.length; W++) this.handleStepPoint(W, this.xNumSteps[W]);
      }
      return D.prototype.getDistance = function(k) {
        for (var w = [], Y = 0; Y < this.xNumSteps.length - 1; Y++) w[Y] = F(this.xVal, k, Y);
        return w;
      }, D.prototype.getAbsoluteDistance = function(k, w, Y) {
        var W, ce = 0;
        if (k < this.xPct[this.xPct.length - 1]) for (; k > this.xPct[ce + 1]; ) ce++;
        else k === this.xPct[this.xPct.length - 1] && (ce = this.xPct.length - 2);
        Y || k !== this.xPct[ce + 1] || ce++, w === null && (w = []);
        var R = 1, re = w[ce], y = 0, fe = 0, Ie = 0, d = 0;
        for (W = Y ? (k - this.xPct[ce]) / (this.xPct[ce + 1] - this.xPct[ce]) : (this.xPct[ce + 1] - k) / (this.xPct[ce + 1] - this.xPct[ce]); re > 0; ) y = this.xPct[ce + 1 + d] - this.xPct[ce + d], w[ce + d] * R + 100 - 100 * W > 100 ? (fe = y * W, R = (re - 100 * W) / w[ce + d], W = 1) : (fe = w[ce + d] * y / 100 * R, R = 0), Y ? (Ie -= fe, this.xPct.length + d >= 1 && d--) : (Ie += fe, this.xPct.length - d >= 1 && d++), re = w[ce + d] * R;
        return k + Ie;
      }, D.prototype.toStepping = function(k) {
        return k = G(this.xVal, this.xPct, k);
      }, D.prototype.fromStepping = function(k) {
        return P(this.xVal, this.xPct, k);
      }, D.prototype.getStep = function(k) {
        return k = E(this.xPct, this.xSteps, this.snap, k);
      }, D.prototype.getDefaultStep = function(k, w, Y) {
        var W = O(k, this.xPct);
        return (k === 100 || w && k === this.xPct[W - 1]) && (W = Math.max(W - 1, 1)), (this.xVal[W] - this.xVal[W - 1]) / Y;
      }, D.prototype.getNearbySteps = function(k) {
        var w = O(k, this.xPct);
        return { stepBefore: { startValue: this.xVal[w - 2], step: this.xNumSteps[w - 2], highestStep: this.xHighestCompleteStep[w - 2] }, thisStep: { startValue: this.xVal[w - 1], step: this.xNumSteps[w - 1], highestStep: this.xHighestCompleteStep[w - 1] }, stepAfter: { startValue: this.xVal[w], step: this.xNumSteps[w], highestStep: this.xHighestCompleteStep[w] } };
      }, D.prototype.countStepDecimals = function() {
        var k = this.xNumSteps.map(p);
        return Math.max.apply(null, k);
      }, D.prototype.hasNoSize = function() {
        return this.xVal[0] === this.xVal[this.xVal.length - 1];
      }, D.prototype.convert = function(k) {
        return this.getStep(this.toStepping(k));
      }, D.prototype.handleEntryPoint = function(k, w) {
        var Y;
        if (!c(Y = k === "min" ? 0 : k === "max" ? 100 : parseFloat(k)) || !c(w[0])) throw new Error("noUiSlider: 'range' value isn't numeric.");
        this.xPct.push(Y), this.xVal.push(w[0]);
        var W = Number(w[1]);
        Y ? this.xSteps.push(!isNaN(W) && W) : isNaN(W) || (this.xSteps[0] = W), this.xHighestCompleteStep.push(0);
      }, D.prototype.handleStepPoint = function(k, w) {
        if (w) if (this.xVal[k] !== this.xVal[k + 1]) {
          this.xSteps[k] = F([this.xVal[k], this.xVal[k + 1]], w, 0) / C(this.xPct[k], this.xPct[k + 1]);
          var Y = (this.xVal[k + 1] - this.xVal[k]) / this.xNumSteps[k], W = Math.ceil(Number(Y.toFixed(3)) - 1), ce = this.xVal[k] + this.xNumSteps[k] * W;
          this.xHighestCompleteStep[k] = ce;
        } else this.xSteps[k] = this.xHighestCompleteStep[k] = this.xVal[k];
      }, D;
    })(), K = { to: function(D) {
      return D === void 0 ? "" : D.toFixed(2);
    }, from: Number }, B = { target: "target", base: "base", origin: "origin", handle: "handle", handleLower: "handle-lower", handleUpper: "handle-upper", touchArea: "touch-area", horizontal: "horizontal", vertical: "vertical", background: "background", connect: "connect", connects: "connects", ltr: "ltr", rtl: "rtl", textDirectionLtr: "txt-dir-ltr", textDirectionRtl: "txt-dir-rtl", draggable: "draggable", drag: "state-drag", tap: "state-tap", active: "active", tooltip: "tooltip", pips: "pips", pipsHorizontal: "pips-horizontal", pipsVertical: "pips-vertical", marker: "marker", markerHorizontal: "marker-horizontal", markerVertical: "marker-vertical", markerNormal: "marker-normal", markerLarge: "marker-large", markerSub: "marker-sub", value: "value", valueHorizontal: "value-horizontal", valueVertical: "value-vertical", valueNormal: "value-normal", valueLarge: "value-large", valueSub: "value-sub" }, ae = { tooltips: ".__tooltips", aria: ".__aria" };
    function le(D, k) {
      if (!c(k)) throw new Error("noUiSlider: 'step' is not numeric.");
      D.singleStep = k;
    }
    function se(D, k) {
      if (!c(k)) throw new Error("noUiSlider: 'keyboardPageMultiplier' is not numeric.");
      D.keyboardPageMultiplier = k;
    }
    function be(D, k) {
      if (!c(k)) throw new Error("noUiSlider: 'keyboardMultiplier' is not numeric.");
      D.keyboardMultiplier = k;
    }
    function Me(D, k) {
      if (!c(k)) throw new Error("noUiSlider: 'keyboardDefaultStep' is not numeric.");
      D.keyboardDefaultStep = k;
    }
    function Se(D, k) {
      if (typeof k != "object" || Array.isArray(k)) throw new Error("noUiSlider: 'range' is not an object.");
      if (k.min === void 0 || k.max === void 0) throw new Error("noUiSlider: Missing 'min' or 'max' in 'range'.");
      D.spectrum = new H(k, D.snap || !1, D.singleStep);
    }
    function te(D, k) {
      if (k = u(k), !Array.isArray(k) || !k.length) throw new Error("noUiSlider: 'start' option is incorrect.");
      D.handles = k.length, D.start = k;
    }
    function he(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'snap' option must be a boolean.");
      D.snap = k;
    }
    function ge(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'animate' option must be a boolean.");
      D.animate = k;
    }
    function pe(D, k) {
      if (typeof k != "number") throw new Error("noUiSlider: 'animationDuration' option must be a number.");
      D.animationDuration = k;
    }
    function ze(D, k) {
      var w, Y = [!1];
      if (k === "lower" ? k = [!0, !1] : k === "upper" && (k = [!1, !0]), k === !0 || k === !1) {
        for (w = 1; w < D.handles; w++) Y.push(k);
        Y.push(!1);
      } else {
        if (!Array.isArray(k) || !k.length || k.length !== D.handles + 1) throw new Error("noUiSlider: 'connect' option doesn't match handle count.");
        Y = k;
      }
      D.connect = Y;
    }
    function ue(D, k) {
      switch (k) {
        case "horizontal":
          D.ort = 0;
          break;
        case "vertical":
          D.ort = 1;
          break;
        default:
          throw new Error("noUiSlider: 'orientation' option is invalid.");
      }
    }
    function oe(D, k) {
      if (!c(k)) throw new Error("noUiSlider: 'margin' option must be numeric.");
      k !== 0 && (D.margin = D.spectrum.getDistance(k));
    }
    function ye(D, k) {
      if (!c(k)) throw new Error("noUiSlider: 'limit' option must be numeric.");
      if (D.limit = D.spectrum.getDistance(k), !D.limit || D.handles < 2) throw new Error("noUiSlider: 'limit' option is only supported on linear sliders with 2 or more handles.");
    }
    function Pe(D, k) {
      var w;
      if (!c(k) && !Array.isArray(k)) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (Array.isArray(k) && k.length !== 2 && !c(k[0]) && !c(k[1])) throw new Error("noUiSlider: 'padding' option must be numeric or array of exactly 2 numbers.");
      if (k !== 0) {
        for (Array.isArray(k) || (k = [k, k]), D.padding = [D.spectrum.getDistance(k[0]), D.spectrum.getDistance(k[1])], w = 0; w < D.spectrum.xNumSteps.length - 1; w++) if (D.padding[0][w] < 0 || D.padding[1][w] < 0) throw new Error("noUiSlider: 'padding' option must be a positive number(s).");
        var Y = k[0] + k[1], W = D.spectrum.xVal[0];
        if (Y / (D.spectrum.xVal[D.spectrum.xVal.length - 1] - W) > 1) throw new Error("noUiSlider: 'padding' option must not exceed 100% of the range.");
      }
    }
    function Ue(D, k) {
      switch (k) {
        case "ltr":
          D.dir = 0;
          break;
        case "rtl":
          D.dir = 1;
          break;
        default:
          throw new Error("noUiSlider: 'direction' option was not recognized.");
      }
    }
    function qe(D, k) {
      if (typeof k != "string") throw new Error("noUiSlider: 'behaviour' must be a string containing options.");
      var w = k.indexOf("tap") >= 0, Y = k.indexOf("drag") >= 0, W = k.indexOf("fixed") >= 0, ce = k.indexOf("snap") >= 0, R = k.indexOf("hover") >= 0, re = k.indexOf("unconstrained") >= 0, y = k.indexOf("drag-all") >= 0, fe = k.indexOf("smooth-steps") >= 0;
      if (W) {
        if (D.handles !== 2) throw new Error("noUiSlider: 'fixed' behaviour must be used with 2 handles");
        oe(D, D.start[1] - D.start[0]);
      }
      if (re && (D.margin || D.limit)) throw new Error("noUiSlider: 'unconstrained' behaviour cannot be used with margin or limit");
      D.events = { tap: w || ce, drag: Y, dragAll: y, smoothSteps: fe, fixed: W, snap: ce, hover: R, unconstrained: re };
    }
    function Be(D, k) {
      if (k !== !1) if (k === !0 || s(k)) {
        D.tooltips = [];
        for (var w = 0; w < D.handles; w++) D.tooltips.push(k);
      } else {
        if ((k = u(k)).length !== D.handles) throw new Error("noUiSlider: must pass a formatter for all handles.");
        k.forEach((function(Y) {
          if (typeof Y != "boolean" && !s(Y)) throw new Error("noUiSlider: 'tooltips' must be passed a formatter or 'false'.");
        })), D.tooltips = k;
      }
    }
    function Ne(D, k) {
      if (k.length !== D.handles) throw new Error("noUiSlider: must pass a attributes for all handles.");
      D.handleAttributes = k;
    }
    function Xe(D, k) {
      if (!s(k)) throw new Error("noUiSlider: 'ariaFormat' requires 'to' method.");
      D.ariaFormat = k;
    }
    function ut(D, k) {
      if (!r(k)) throw new Error("noUiSlider: 'format' requires 'to' and 'from' methods.");
      D.format = k;
    }
    function gt(D, k) {
      if (typeof k != "boolean") throw new Error("noUiSlider: 'keyboardSupport' option must be a boolean.");
      D.keyboardSupport = k;
    }
    function bt(D, k) {
      D.documentElement = k;
    }
    function Ft(D, k) {
      if (typeof k != "string" && k !== !1) throw new Error("noUiSlider: 'cssPrefix' must be a string or `false`.");
      D.cssPrefix = k;
    }
    function Rt(D, k) {
      if (typeof k != "object") throw new Error("noUiSlider: 'cssClasses' must be an object.");
      typeof D.cssPrefix == "string" ? (D.cssClasses = {}, Object.keys(k).forEach((function(w) {
        D.cssClasses[w] = D.cssPrefix + k[w];
      }))) : D.cssClasses = k;
    }
    function xt(D) {
      var k = { margin: null, limit: null, padding: null, animate: !0, animationDuration: 300, ariaFormat: K, format: K }, w = { step: { r: !1, t: le }, keyboardPageMultiplier: { r: !1, t: se }, keyboardMultiplier: { r: !1, t: be }, keyboardDefaultStep: { r: !1, t: Me }, start: { r: !0, t: te }, connect: { r: !0, t: ze }, direction: { r: !0, t: Ue }, snap: { r: !1, t: he }, animate: { r: !1, t: ge }, animationDuration: { r: !1, t: pe }, range: { r: !0, t: Se }, orientation: { r: !1, t: ue }, margin: { r: !1, t: oe }, limit: { r: !1, t: ye }, padding: { r: !1, t: Pe }, behaviour: { r: !0, t: qe }, ariaFormat: { r: !1, t: Xe }, format: { r: !1, t: ut }, tooltips: { r: !1, t: Be }, keyboardSupport: { r: !0, t: gt }, documentElement: { r: !1, t: bt }, cssPrefix: { r: !0, t: Ft }, cssClasses: { r: !0, t: Rt }, handleAttributes: { r: !1, t: Ne } }, Y = { connect: !1, direction: "ltr", behaviour: "tap", orientation: "horizontal", keyboardSupport: !0, cssPrefix: "noUi-", cssClasses: B, keyboardPageMultiplier: 5, keyboardMultiplier: 1, keyboardDefaultStep: 10 };
      D.format && !D.ariaFormat && (D.ariaFormat = D.format), Object.keys(w).forEach((function(y) {
        if (a(D[y]) || Y[y] !== void 0) w[y].t(k, a(D[y]) ? D[y] : Y[y]);
        else if (w[y].r) throw new Error("noUiSlider: '" + y + "' is required.");
      })), k.pips = D.pips;
      var W = document.createElement("div"), ce = W.style.msTransform !== void 0, R = W.style.transform !== void 0;
      k.transformRule = R ? "transform" : ce ? "msTransform" : "webkitTransform";
      var re = [["left", "top"], ["right", "bottom"]];
      return k.style = re[k.dir][k.ort], k;
    }
    function jt(D, k, w) {
      var Y, W, ce, R, re, y = T(), fe = L() && I(), Ie = D, d = k.spectrum, ne = [], Q = [], x = [], N = 0, J = {}, Re = D.ownerDocument, _e = k.documentElement || Re.documentElement, Le = Re.body, je = Re.dir === "rtl" || k.ort === 1 ? 0 : 100;
      function ft(M, j) {
        var ie = Re.createElement("div");
        return j && S(ie, j), M.appendChild(ie), ie;
      }
      function et(M, j) {
        var ie = ft(M, k.cssClasses.origin), ve = ft(ie, k.cssClasses.handle);
        if (ft(ve, k.cssClasses.touchArea), ve.setAttribute("data-handle", String(j)), k.keyboardSupport && (ve.setAttribute("tabindex", "0"), ve.addEventListener("keydown", (function(Ee) {
          return Es(Ee, j);
        }))), k.handleAttributes !== void 0) {
          var $e = k.handleAttributes[j];
          Object.keys($e).forEach((function(Ee) {
            ve.setAttribute(Ee, $e[Ee]);
          }));
        }
        return ve.setAttribute("role", "slider"), ve.setAttribute("aria-orientation", k.ort ? "vertical" : "horizontal"), j === 0 ? S(ve, k.cssClasses.handleLower) : j === k.handles - 1 && S(ve, k.cssClasses.handleUpper), ie;
      }
      function Ze(M, j) {
        return !!j && ft(M, k.cssClasses.connect);
      }
      function lt(M, j) {
        var ie = ft(j, k.cssClasses.connects);
        W = [], (ce = []).push(Ze(ie, M[0]));
        for (var ve = 0; ve < k.handles; ve++) W.push(et(j, ve)), x[ve] = ve, ce.push(Ze(ie, M[ve + 1]));
      }
      function pt(M) {
        return S(M, k.cssClasses.target), k.dir === 0 ? S(M, k.cssClasses.ltr) : S(M, k.cssClasses.rtl), k.ort === 0 ? S(M, k.cssClasses.horizontal) : S(M, k.cssClasses.vertical), S(M, getComputedStyle(M).direction === "rtl" ? k.cssClasses.textDirectionRtl : k.cssClasses.textDirectionLtr), ft(M, k.cssClasses.base);
      }
      function kt(M, j) {
        return !(!k.tooltips || !k.tooltips[j]) && ft(M.firstChild, k.cssClasses.tooltip);
      }
      function fn() {
        return Ie.hasAttribute("disabled");
      }
      function an(M) {
        return W[M].hasAttribute("disabled");
      }
      function tt() {
        re && (Xn("update" + ae.tooltips), re.forEach((function(M) {
          M && i(M);
        })), re = null);
      }
      function At() {
        tt(), re = W.map(kt), hr("update" + ae.tooltips, (function(M, j, ie) {
          if (re && k.tooltips && re[j] !== !1) {
            var ve = M[j];
            k.tooltips[j] !== !0 && (ve = k.tooltips[j].to(ie[j])), re[j].innerHTML = ve;
          }
        }));
      }
      function ht() {
        Xn("update" + ae.aria), hr("update" + ae.aria, (function(M, j, ie, ve, $e) {
          x.forEach((function(Ee) {
            var He = W[Ee], Oe = ka(Q, Ee, 0, !0, !0, !0), st = ka(Q, Ee, 100, !0, !0, !0), rt = $e[Ee], Je = String(k.ariaFormat.to(ie[Ee]));
            Oe = d.fromStepping(Oe).toFixed(1), st = d.fromStepping(st).toFixed(1), rt = d.fromStepping(rt).toFixed(1), He.children[0].setAttribute("aria-valuemin", Oe), He.children[0].setAttribute("aria-valuemax", st), He.children[0].setAttribute("aria-valuenow", rt), He.children[0].setAttribute("aria-valuetext", Je);
          }));
        }));
      }
      function zt(M) {
        if (M.mode === n.PipsMode.Range || M.mode === n.PipsMode.Steps) return d.xVal;
        if (M.mode === n.PipsMode.Count) {
          if (M.values < 2) throw new Error("noUiSlider: 'values' (>= 2) required for mode 'count'.");
          for (var j = M.values - 1, ie = 100 / j, ve = []; j--; ) ve[j] = j * ie;
          return ve.push(100), Ot(ve, M.stepped);
        }
        return M.mode === n.PipsMode.Positions ? Ot(M.values, M.stepped) : M.mode === n.PipsMode.Values ? M.stepped ? M.values.map((function($e) {
          return d.fromStepping(d.getStep(d.toStepping($e)));
        })) : M.values : [];
      }
      function Ot(M, j) {
        return M.map((function(ie) {
          return d.fromStepping(j ? d.getStep(ie) : ie);
        }));
      }
      function xa(M) {
        function j(rt, Je) {
          return Number((rt + Je).toFixed(7));
        }
        var ie = zt(M), ve = {}, $e = d.xVal[0], Ee = d.xVal[d.xVal.length - 1], He = !1, Oe = !1, st = 0;
        return (ie = l(ie.slice().sort((function(rt, Je) {
          return rt - Je;
        }))))[0] !== $e && (ie.unshift($e), He = !0), ie[ie.length - 1] !== Ee && (ie.push(Ee), Oe = !0), ie.forEach((function(rt, Je) {
          var nt, Ye, yt, Lt, dt, Mi, gr, Ri, Oi, Fi, br = rt, Dn = ie[Je + 1], Ni = M.mode === n.PipsMode.Steps;
          for (Ni && (nt = d.xNumSteps[Je]), nt || (nt = Dn - br), Dn === void 0 && (Dn = br), nt = Math.max(nt, 1e-7), Ye = br; Ye <= Dn; Ye = j(Ye, nt)) {
            for (Ri = (dt = (Lt = d.toStepping(Ye)) - st) / (M.density || 1), Fi = dt / (Oi = Math.round(Ri)), yt = 1; yt <= Oi; yt += 1) ve[(Mi = st + yt * Fi).toFixed(5)] = [d.fromStepping(Mi), 0];
            gr = ie.indexOf(Ye) > -1 ? n.PipsType.LargeValue : Ni ? n.PipsType.SmallValue : n.PipsType.NoValue, !Je && He && Ye !== Dn && (gr = 0), Ye === Dn && Oe || (ve[Lt.toFixed(5)] = [Ye, gr]), st = Lt;
          }
        })), ve;
      }
      function ys(M, j, ie) {
        var ve, $e, Ee = Re.createElement("div"), He = ((ve = {})[n.PipsType.None] = "", ve[n.PipsType.NoValue] = k.cssClasses.valueNormal, ve[n.PipsType.LargeValue] = k.cssClasses.valueLarge, ve[n.PipsType.SmallValue] = k.cssClasses.valueSub, ve), Oe = (($e = {})[n.PipsType.None] = "", $e[n.PipsType.NoValue] = k.cssClasses.markerNormal, $e[n.PipsType.LargeValue] = k.cssClasses.markerLarge, $e[n.PipsType.SmallValue] = k.cssClasses.markerSub, $e), st = [k.cssClasses.valueHorizontal, k.cssClasses.valueVertical], rt = [k.cssClasses.markerHorizontal, k.cssClasses.markerVertical];
        function Je(Ye, yt) {
          var Lt = yt === k.cssClasses.value, dt = Lt ? He : Oe;
          return yt + " " + (Lt ? st : rt)[k.ort] + " " + dt[Ye];
        }
        function nt(Ye, yt, Lt) {
          if ((Lt = j ? j(yt, Lt) : Lt) !== n.PipsType.None) {
            var dt = ft(Ee, !1);
            dt.className = Je(Lt, k.cssClasses.marker), dt.style[k.style] = Ye + "%", Lt > n.PipsType.NoValue && ((dt = ft(Ee, !1)).className = Je(Lt, k.cssClasses.value), dt.setAttribute("data-value", String(yt)), dt.style[k.style] = Ye + "%", dt.innerHTML = String(ie.to(yt)));
          }
        }
        return S(Ee, k.cssClasses.pips), S(Ee, k.ort === 0 ? k.cssClasses.pipsHorizontal : k.cssClasses.pipsVertical), Object.keys(M).forEach((function(Ye) {
          nt(Ye, M[Ye][0], M[Ye][1]);
        })), Ee;
      }
      function ur() {
        R && (i(R), R = null);
      }
      function cr(M) {
        ur();
        var j = xa(M), ie = M.filter, ve = M.format || { to: function($e) {
          return String(Math.round($e));
        } };
        return R = Ie.appendChild(ys(j, ie, ve));
      }
      function Ci() {
        var M = Y.getBoundingClientRect(), j = "offset" + ["Width", "Height"][k.ort];
        return k.ort === 0 ? M.width || Y[j] : M.height || Y[j];
      }
      function hn(M, j, ie, ve) {
        var $e = function(He) {
          var Oe = ws(He, ve.pageOffset, ve.target || j);
          return !!Oe && !(fn() && !ve.doNotReject) && !(b(Ie, k.cssClasses.tap) && !ve.doNotReject) && !(M === y.start && Oe.buttons !== void 0 && Oe.buttons > 1) && (!ve.hover || !Oe.buttons) && (fe || Oe.preventDefault(), Oe.calcPoint = Oe.points[k.ort], void ie(Oe, ve));
        }, Ee = [];
        return M.split(" ").forEach((function(He) {
          j.addEventListener(He, $e, !!fe && { passive: !0 }), Ee.push([He, $e]);
        })), Ee;
      }
      function ws(M, j, ie) {
        var ve = M.type.indexOf("touch") === 0, $e = M.type.indexOf("mouse") === 0, Ee = M.type.indexOf("pointer") === 0, He = 0, Oe = 0;
        if (M.type.indexOf("MSPointer") === 0 && (Ee = !0), M.type === "mousedown" && !M.buttons && !M.touches) return !1;
        if (ve) {
          var st = function(nt) {
            var Ye = nt.target;
            return Ye === ie || ie.contains(Ye) || M.composed && M.composedPath().shift() === ie;
          };
          if (M.type === "touchstart") {
            var rt = Array.prototype.filter.call(M.touches, st);
            if (rt.length > 1) return !1;
            He = rt[0].pageX, Oe = rt[0].pageY;
          } else {
            var Je = Array.prototype.find.call(M.changedTouches, st);
            if (!Je) return !1;
            He = Je.pageX, Oe = Je.pageY;
          }
        }
        return j = j || _(Re), ($e || Ee) && (He = M.clientX + j.x, Oe = M.clientY + j.y), M.pageOffset = j, M.points = [He, Oe], M.cursor = $e || Ee, M;
      }
      function Ei(M) {
        var j = 100 * (M - v(Y, k.ort)) / Ci();
        return j = m(j), k.dir ? 100 - j : j;
      }
      function xs(M) {
        var j = 100, ie = !1;
        return W.forEach((function(ve, $e) {
          if (!an($e)) {
            var Ee = Q[$e], He = Math.abs(Ee - M);
            (He < j || He <= j && M > Ee || He === 100 && j === 100) && (ie = $e, j = He);
          }
        })), ie;
      }
      function ks(M, j) {
        M.type === "mouseout" && M.target.nodeName === "HTML" && M.relatedTarget === null && dr(M, j);
      }
      function Ss(M, j) {
        if (navigator.appVersion.indexOf("MSIE 9") === -1 && M.buttons === 0 && j.buttonsProperty !== 0) return dr(M, j);
        var ie = (k.dir ? -1 : 1) * (M.calcPoint - j.startCalcPoint);
        Ti(ie > 0, 100 * ie / j.baseSize, j.locations, j.handleNumbers, j.connect);
      }
      function dr(M, j) {
        j.handle && (g(j.handle, k.cssClasses.active), N -= 1), j.listeners.forEach((function(ie) {
          _e.removeEventListener(ie[0], ie[1]);
        })), N === 0 && (g(Ie, k.cssClasses.drag), mr(), M.cursor && (Le.style.cursor = "", Le.removeEventListener("selectstart", o))), k.events.smoothSteps && (j.handleNumbers.forEach((function(ie) {
          vn(ie, Q[ie], !0, !0, !1, !1);
        })), j.handleNumbers.forEach((function(ie) {
          ot("update", ie);
        }))), j.handleNumbers.forEach((function(ie) {
          ot("change", ie), ot("set", ie), ot("end", ie);
        }));
      }
      function fr(M, j) {
        if (!j.handleNumbers.some(an)) {
          var ie;
          j.handleNumbers.length === 1 && (ie = W[j.handleNumbers[0]].children[0], N += 1, S(ie, k.cssClasses.active)), M.stopPropagation();
          var ve = [], $e = hn(y.move, _e, Ss, { target: M.target, handle: ie, connect: j.connect, listeners: ve, startCalcPoint: M.calcPoint, baseSize: Ci(), pageOffset: M.pageOffset, handleNumbers: j.handleNumbers, buttonsProperty: M.buttons, locations: Q.slice() }), Ee = hn(y.end, _e, dr, { target: M.target, handle: ie, listeners: ve, doNotReject: !0, handleNumbers: j.handleNumbers }), He = hn("mouseout", _e, ks, { target: M.target, handle: ie, listeners: ve, doNotReject: !0, handleNumbers: j.handleNumbers });
          ve.push.apply(ve, $e.concat(Ee, He)), M.cursor && (Le.style.cursor = getComputedStyle(M.target).cursor, W.length > 1 && S(Ie, k.cssClasses.drag), Le.addEventListener("selectstart", o, !1)), j.handleNumbers.forEach((function(Oe) {
            ot("start", Oe);
          }));
        }
      }
      function _s(M) {
        M.stopPropagation();
        var j = Ei(M.calcPoint), ie = xs(j);
        ie !== !1 && (k.events.snap || f(Ie, k.cssClasses.tap, k.animationDuration), vn(ie, j, !0, !0), mr(), ot("slide", ie, !0), ot("update", ie, !0), k.events.snap ? fr(M, { handleNumbers: [ie] }) : (ot("change", ie, !0), ot("set", ie, !0)));
      }
      function Cs(M) {
        var j = Ei(M.calcPoint), ie = d.getStep(j), ve = d.fromStepping(ie);
        Object.keys(J).forEach((function($e) {
          $e.split(".")[0] === "hover" && J[$e].forEach((function(Ee) {
            Ee.call(_a, ve);
          }));
        }));
      }
      function Es(M, j) {
        if (fn() || an(j)) return !1;
        var ie = ["Left", "Right"], ve = ["Down", "Up"], $e = ["PageDown", "PageUp"], Ee = ["Home", "End"];
        k.dir && !k.ort ? ie.reverse() : k.ort && !k.dir && (ve.reverse(), $e.reverse());
        var He, Oe = M.key.replace("Arrow", ""), st = Oe === $e[0], rt = Oe === $e[1], Je = Oe === ve[0] || Oe === ie[0] || st, nt = Oe === ve[1] || Oe === ie[1] || rt, Ye = Oe === Ee[0], yt = Oe === Ee[1];
        if (!(Je || nt || Ye || yt)) return !0;
        if (M.preventDefault(), nt || Je) {
          var Lt = Je ? 0 : 1, dt = Di(j)[Lt];
          if (dt === null) return !1;
          dt === !1 && (dt = d.getDefaultStep(Q[j], Je, k.keyboardDefaultStep)), dt *= rt || st ? k.keyboardPageMultiplier : k.keyboardMultiplier, dt = Math.max(dt, 1e-7), dt *= Je ? -1 : 1, He = ne[j] + dt;
        } else He = yt ? k.spectrum.xVal[k.spectrum.xVal.length - 1] : k.spectrum.xVal[0];
        return vn(j, d.toStepping(He), !0, !0), ot("slide", j), ot("update", j), ot("change", j), ot("set", j), !1;
      }
      function Ts(M) {
        M.fixed || W.forEach((function(j, ie) {
          hn(y.start, j.children[0], fr, { handleNumbers: [ie] });
        })), M.tap && hn(y.start, Y, _s, {}), M.hover && hn(y.move, Y, Cs, { hover: !0 }), M.drag && ce.forEach((function(j, ie) {
          if (j !== !1 && ie !== 0 && ie !== ce.length - 1) {
            var ve = W[ie - 1], $e = W[ie], Ee = [j], He = [ve, $e], Oe = [ie - 1, ie];
            S(j, k.cssClasses.draggable), M.fixed && (Ee.push(ve.children[0]), Ee.push($e.children[0])), M.dragAll && (He = W, Oe = x), Ee.forEach((function(st) {
              hn(y.start, st, fr, { handles: He, handleNumbers: Oe, connect: j });
            }));
          }
        }));
      }
      function hr(M, j) {
        J[M] = J[M] || [], J[M].push(j), M.split(".")[0] === "update" && W.forEach((function(ie, ve) {
          ot("update", ve);
        }));
      }
      function As(M) {
        return M === ae.aria || M === ae.tooltips;
      }
      function Xn(M) {
        var j = M && M.split(".")[0], ie = j ? M.substring(j.length) : M;
        Object.keys(J).forEach((function(ve) {
          var $e = ve.split(".")[0], Ee = ve.substring($e.length);
          j && j !== $e || ie && ie !== Ee || As(Ee) && ie !== Ee || delete J[ve];
        }));
      }
      function ot(M, j, ie) {
        Object.keys(J).forEach((function(ve) {
          var $e = ve.split(".")[0];
          M === $e && J[ve].forEach((function(Ee) {
            Ee.call(_a, ne.map(k.format.to), j, ne.slice(), ie || !1, Q.slice(), _a);
          }));
        }));
      }
      function ka(M, j, ie, ve, $e, Ee, He) {
        var Oe;
        return W.length > 1 && !k.events.unconstrained && (ve && j > 0 && (Oe = d.getAbsoluteDistance(M[j - 1], k.margin, !1), ie = Math.max(ie, Oe)), $e && j < W.length - 1 && (Oe = d.getAbsoluteDistance(M[j + 1], k.margin, !0), ie = Math.min(ie, Oe))), W.length > 1 && k.limit && (ve && j > 0 && (Oe = d.getAbsoluteDistance(M[j - 1], k.limit, !1), ie = Math.min(ie, Oe)), $e && j < W.length - 1 && (Oe = d.getAbsoluteDistance(M[j + 1], k.limit, !0), ie = Math.max(ie, Oe))), k.padding && (j === 0 && (Oe = d.getAbsoluteDistance(0, k.padding[0], !1), ie = Math.max(ie, Oe)), j === W.length - 1 && (Oe = d.getAbsoluteDistance(100, k.padding[1], !0), ie = Math.min(ie, Oe))), He || (ie = d.getStep(ie)), !((ie = m(ie)) === M[j] && !Ee) && ie;
      }
      function vr(M, j) {
        var ie = k.ort;
        return (ie ? j : M) + ", " + (ie ? M : j);
      }
      function Ti(M, j, ie, ve, $e) {
        var Ee = ie.slice(), He = ve[0], Oe = k.events.smoothSteps, st = [!M, M], rt = [M, !M];
        ve = ve.slice(), M && ve.reverse(), ve.length > 1 ? ve.forEach((function(nt, Ye) {
          var yt = ka(Ee, nt, Ee[nt] + j, st[Ye], rt[Ye], !1, Oe);
          yt === !1 ? j = 0 : (j = yt - Ee[nt], Ee[nt] = yt);
        })) : st = rt = [!0];
        var Je = !1;
        ve.forEach((function(nt, Ye) {
          Je = vn(nt, ie[nt] + j, st[Ye], rt[Ye], !1, Oe) || Je;
        })), Je && (ve.forEach((function(nt) {
          ot("update", nt), ot("slide", nt);
        })), $e != null && ot("drag", He));
      }
      function Ai(M, j) {
        return k.dir ? 100 - M - j : M;
      }
      function Ls(M, j) {
        Q[M] = j, ne[M] = d.fromStepping(j);
        var ie = "translate(" + vr(Ai(j, 0) - je + "%", "0") + ")";
        W[M].style[k.transformRule] = ie, Li(M), Li(M + 1);
      }
      function mr() {
        x.forEach((function(M) {
          var j = Q[M] > 50 ? -1 : 1, ie = 3 + (W.length + j * M);
          W[M].style.zIndex = String(ie);
        }));
      }
      function vn(M, j, ie, ve, $e, Ee) {
        return $e || (j = ka(Q, M, j, ie, ve, !1, Ee)), j !== !1 && (Ls(M, j), !0);
      }
      function Li(M) {
        if (ce[M]) {
          var j = 0, ie = 100;
          M !== 0 && (j = Q[M - 1]), M !== ce.length - 1 && (ie = Q[M]);
          var ve = ie - j, $e = "translate(" + vr(Ai(j, ve) + "%", "0") + ")", Ee = "scale(" + vr(ve / 100, "1") + ")";
          ce[M].style[k.transformRule] = $e + " " + Ee;
        }
      }
      function $i(M, j) {
        return M === null || M === !1 || M === void 0 ? Q[j] : (typeof M == "number" && (M = String(M)), (M = k.format.from(M)) !== !1 && (M = d.toStepping(M)), M === !1 || isNaN(M) ? Q[j] : M);
      }
      function Sa(M, j, ie) {
        var ve = u(M), $e = Q[0] === void 0;
        j = j === void 0 || j, k.animate && !$e && f(Ie, k.cssClasses.tap, k.animationDuration), x.forEach((function(Oe) {
          vn(Oe, $i(ve[Oe], Oe), !0, !1, ie);
        }));
        var Ee = x.length === 1 ? 0 : 1;
        if ($e && d.hasNoSize() && (ie = !0, Q[0] = 0, x.length > 1)) {
          var He = 100 / (x.length - 1);
          x.forEach((function(Oe) {
            Q[Oe] = Oe * He;
          }));
        }
        for (; Ee < x.length; ++Ee) x.forEach((function(Oe) {
          vn(Oe, Q[Oe], !0, !0, ie);
        }));
        mr(), x.forEach((function(Oe) {
          ot("update", Oe), ve[Oe] !== null && j && ot("set", Oe);
        }));
      }
      function $s(M) {
        Sa(k.start, M);
      }
      function Is(M, j, ie, ve) {
        if (!((M = Number(M)) >= 0 && M < x.length)) throw new Error("noUiSlider: invalid handle number, got: " + M);
        vn(M, $i(j, M), !0, !0, ve), ot("update", M), ie && ot("set", M);
      }
      function Ii(M) {
        if (M === void 0 && (M = !1), M) return ne.length === 1 ? ne[0] : ne.slice(0);
        var j = ne.map(k.format.to);
        return j.length === 1 ? j[0] : j;
      }
      function Ds() {
        for (Xn(ae.aria), Xn(ae.tooltips), Object.keys(k.cssClasses).forEach((function(M) {
          g(Ie, k.cssClasses[M]);
        })); Ie.firstChild; ) Ie.removeChild(Ie.firstChild);
        delete Ie.noUiSlider;
      }
      function Di(M) {
        var j = Q[M], ie = d.getNearbySteps(j), ve = ne[M], $e = ie.thisStep.step, Ee = null;
        if (k.snap) return [ve - ie.stepBefore.startValue || null, ie.stepAfter.startValue - ve || null];
        $e !== !1 && ve + $e > ie.stepAfter.startValue && ($e = ie.stepAfter.startValue - ve), Ee = ve > ie.thisStep.startValue ? ie.thisStep.step : ie.stepBefore.step !== !1 && ve - ie.stepBefore.highestStep, j === 100 ? $e = null : j === 0 && (Ee = null);
        var He = d.countStepDecimals();
        return $e !== null && $e !== !1 && ($e = Number($e.toFixed(He))), Ee !== null && Ee !== !1 && (Ee = Number(Ee.toFixed(He))), [Ee, $e];
      }
      function Ms() {
        return x.map(Di);
      }
      function Rs(M, j) {
        var ie = Ii(), ve = ["margin", "limit", "padding", "range", "animate", "snap", "step", "format", "pips", "tooltips"];
        ve.forEach((function(Ee) {
          M[Ee] !== void 0 && (w[Ee] = M[Ee]);
        }));
        var $e = xt(w);
        ve.forEach((function(Ee) {
          M[Ee] !== void 0 && (k[Ee] = $e[Ee]);
        })), d = $e.spectrum, k.margin = $e.margin, k.limit = $e.limit, k.padding = $e.padding, k.pips ? cr(k.pips) : ur(), k.tooltips ? At() : tt(), Q = [], Sa(a(M.start) ? M.start : ie, j);
      }
      function Os() {
        Y = pt(Ie), lt(k.connect, Y), Ts(k.events), Sa(k.start), k.pips && cr(k.pips), k.tooltips && At(), ht();
      }
      Os();
      var _a = { destroy: Ds, steps: Ms, on: hr, off: Xn, get: Ii, set: Sa, setHandle: Is, reset: $s, __moveHandles: function(M, j, ie) {
        Ti(M, j, Q, ie);
      }, options: w, updateOptions: Rs, target: Ie, removePips: ur, removeTooltips: tt, getPositions: function() {
        return Q.slice();
      }, getTooltips: function() {
        return re;
      }, getOrigins: function() {
        return W;
      }, pips: cr };
      return _a;
    }
    function $t(D, k) {
      if (!D || !D.nodeName) throw new Error("noUiSlider: create requires a single element, got: " + D);
      if (D.noUiSlider) throw new Error("noUiSlider: Slider was already initialized.");
      var w = jt(D, xt(k), k);
      return D.noUiSlider = w, w;
    }
    var ct = { __spectrum: H, cssClasses: B, create: $t };
    n.create = $t, n.cssClasses = B, n.default = ct, Object.defineProperty(n, "__esModule", { value: !0 });
  })(t);
})));
function Jl(e, t) {
  if (!Array.isArray(e) || !Array.isArray(t)) return !1;
  const n = t.slice().sort();
  return e.length === t.length && e.slice().sort().every((function(r, s) {
    return r === n[s];
  }));
}
var Qr = { name: "Slider", emits: ["input", "update:modelValue", "start", "slide", "drag", "update", "change", "set", "end"], props: { value: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, modelValue: { validator: function(e) {
  return (t) => typeof t == "number" || t instanceof Array || t == null || t === !1;
}, required: !1 }, id: { type: [String, Number], required: !1 }, disabled: { type: Boolean, required: !1, default: !1 }, min: { type: Number, required: !1, default: 0 }, max: { type: Number, required: !1, default: 100 }, step: { type: Number, required: !1, default: 1 }, orientation: { type: String, required: !1, default: "horizontal" }, direction: { type: String, required: !1, default: "ltr" }, tooltips: { type: Boolean, required: !1, default: !0 }, options: { type: Object, required: !1, default: () => ({}) }, merge: { type: Number, required: !1, default: -1 }, format: { type: [Object, Function, Boolean], required: !1, default: null }, classes: { type: Object, required: !1, default: () => ({}) }, showTooltip: { type: String, required: !1, default: "always" }, tooltipPosition: { type: String, required: !1, default: null }, lazy: { type: Boolean, required: !1, default: !0 }, ariaLabelledby: { type: String, required: !1, default: void 0 }, aria: { required: !1, type: Object, default: () => ({}) } }, setup(e, t) {
  const n = (function(a, o, l) {
    const { value: h, modelValue: v, min: c } = Ca(a);
    let f = v && v.value !== void 0 ? v : h;
    const m = we(f.value);
    if (Ma(f.value) && (f = we(c.value)), Array.isArray(f.value) && f.value.length == 0) throw new Error("Slider v-model must not be an empty array");
    return { value: f, initialValue: m };
  })(e), r = (function(a, o, l) {
    const { classes: h, showTooltip: v, tooltipPosition: c, orientation: f } = Ca(a), m = Z((() => ({ target: "slider-target", focused: "slider-focused", tooltipFocus: "slider-tooltip-focus", tooltipDrag: "slider-tooltip-drag", ltr: "slider-ltr", rtl: "slider-rtl", horizontal: "slider-horizontal", vertical: "slider-vertical", textDirectionRtl: "slider-txt-dir-rtl", textDirectionLtr: "slider-txt-dir-ltr", base: "slider-base", connects: "slider-connects", connect: "slider-connect", origin: "slider-origin", handle: "slider-handle", handleLower: "slider-handle-lower", handleUpper: "slider-handle-upper", touchArea: "slider-touch-area", tooltip: "slider-tooltip", tooltipTop: "slider-tooltip-top", tooltipBottom: "slider-tooltip-bottom", tooltipLeft: "slider-tooltip-left", tooltipRight: "slider-tooltip-right", tooltipHidden: "slider-tooltip-hidden", active: "slider-active", draggable: "slider-draggable", tap: "slider-state-tap", drag: "slider-state-drag", pips: "slider-pips", pipsHorizontal: "slider-pips-horizontal", pipsVertical: "slider-pips-vertical", marker: "slider-marker", markerHorizontal: "slider-marker-horizontal", markerVertical: "slider-marker-vertical", markerNormal: "slider-marker-normal", markerLarge: "slider-marker-large", markerSub: "slider-marker-sub", value: "slider-value", valueHorizontal: "slider-value-horizontal", valueVertical: "slider-value-vertical", valueNormal: "slider-value-normal", valueLarge: "slider-value-large", valueSub: "slider-value-sub", ...h.value })));
    return { classList: Z((() => {
      const u = { ...m.value };
      return Object.keys(u).forEach(((p) => {
        u[p] = Array.isArray(u[p]) ? u[p].filter(((S) => S !== null)).join(" ") : u[p];
      })), v.value !== "always" && (u.target += ` ${v.value === "drag" ? u.tooltipDrag : u.tooltipFocus}`), f.value === "horizontal" && (u.tooltip += c.value === "bottom" ? ` ${u.tooltipBottom}` : ` ${u.tooltipTop}`), f.value === "vertical" && (u.tooltip += c.value === "right" ? ` ${u.tooltipRight}` : ` ${u.tooltipLeft}`), u;
    })) };
  })(e), s = (function(a, o, l) {
    const { format: h, step: v } = Ca(a), c = l.value, f = l.classList, m = Z((() => h && h.value ? typeof h.value == "function" ? { to: h.value } : Kl({ ...h.value }) : Kl({ decimals: v.value >= 0 ? 0 : 2 }))), u = Z((() => Array.isArray(c.value) ? c.value.map(((p) => m.value)) : m.value));
    return { tooltipFormat: m, tooltipsFormat: u, tooltipsMerge: (p, S, g) => {
      var b = getComputedStyle(p).direction === "rtl", _ = p.noUiSlider.options.direction === "rtl", T = p.noUiSlider.options.orientation === "vertical", I = p.noUiSlider.getTooltips(), L = p.noUiSlider.getOrigins();
      I.forEach((function(C, F) {
        C && L[F].appendChild(C);
      })), p.noUiSlider.on("update", (function(C, F, z, X, O) {
        var G = [[]], P = [[]], E = [[]], A = 0;
        I[0] && (G[0][0] = 0, P[0][0] = O[0], E[0][0] = m.value.to(parseFloat(C[0])));
        for (var V = 1; V < C.length; V++) (!I[V] || C[V] - C[V - 1] > S) && (G[++A] = [], E[A] = [], P[A] = []), I[V] && (G[A].push(V), E[A].push(m.value.to(parseFloat(C[V]))), P[A].push(O[V]));
        G.forEach((function(H, K) {
          for (var B = H.length, ae = 0; ae < B; ae++) {
            var le = H[ae];
            if (ae === B - 1) {
              var se = 0;
              P[K].forEach((function(te) {
                se += 1e3 - te;
              }));
              var be = T ? "bottom" : "right", Me = _ ? 0 : B - 1, Se = 1e3 - P[K][Me];
              se = (b && !T ? 100 : 0) + se / B - Se, I[le].innerHTML = E[K].join(g), I[le].style.display = "block", I[le].style[be] = se + "%", f.value.tooltipHidden.split(" ").forEach(((te) => {
                I[le].classList.contains(te) && I[le].classList.remove(te);
              }));
            } else I[le].style.display = "none", f.value.tooltipHidden.split(" ").forEach(((te) => {
              I[le].classList.add(te);
            }));
          }
        }));
      }));
    } };
  })(e, 0, { value: n.value, classList: r.classList }), i = (function(a, o, l) {
    const { orientation: h, direction: v, tooltips: c, step: f, min: m, max: u, merge: p, id: S, disabled: g, options: b, classes: _, format: T, lazy: I, ariaLabelledby: L, aria: C } = Ca(a), F = l.value, z = l.initialValue, X = l.tooltipsFormat, O = l.tooltipsMerge, G = l.tooltipFormat, P = l.classList, E = we(null), A = we(null), V = we(!1), H = Z((() => {
      let te = { cssPrefix: "", cssClasses: P.value, orientation: h.value, direction: v.value, tooltips: !!c.value && X.value, connect: "lower", start: Ma(F.value) ? m.value : F.value, range: { min: m.value, max: u.value } };
      if (f.value > 0 && (te.step = f.value), Array.isArray(F.value) && (te.connect = !0), L && L.value || C && Object.keys(C.value).length) {
        let he = Array.isArray(F.value) ? F.value : [F.value];
        te.handleAttributes = he.map(((ge) => Object.assign({}, C.value, L && L.value ? { "aria-labelledby": L.value } : {})));
      }
      return T.value && (te.ariaFormat = G.value), te;
    })), K = Z((() => {
      let te = { id: S && S.value ? S.value : void 0 };
      return g.value && (te.disabled = !0), te;
    })), B = Z((() => Array.isArray(F.value))), ae = () => {
      let te = A.value.get();
      return Array.isArray(te) ? te.map(((he) => parseFloat(he))) : parseFloat(te);
    }, le = function(te) {
      let he = !(arguments.length > 1 && arguments[1] !== void 0) || arguments[1];
      A.value.set(te, he);
    }, se = (te) => {
      o.emit("input", te), o.emit("update:modelValue", te), o.emit("update", te);
    }, be = () => {
      A.value = ym.create(E.value, Object.assign({}, H.value, b.value)), c.value && B.value && p.value >= 0 && O(E.value, p.value, " - "), A.value.on("set", (() => {
        const te = ae();
        o.emit("change", te), o.emit("set", te), I.value && se(te);
      })), A.value.on("update", (() => {
        if (!V.value) return;
        const te = ae();
        B.value && Jl(F.value, te) || !B.value && F.value == te ? o.emit("update", te) : I.value || se(te);
      })), A.value.on("start", (() => {
        o.emit("start", ae());
      })), A.value.on("end", (() => {
        o.emit("end", ae());
      })), A.value.on("slide", (() => {
        o.emit("slide", ae());
      })), A.value.on("drag", (() => {
        o.emit("drag", ae());
      })), E.value.querySelectorAll("[data-handle]").forEach(((te) => {
        te.onblur = () => {
          E.value && P.value.focused.split(" ").forEach(((he) => {
            E.value.classList.remove(he);
          }));
        }, te.onfocus = () => {
          P.value.focused.split(" ").forEach(((he) => {
            E.value.classList.add(he);
          }));
        };
      })), V.value = !0;
    }, Me = () => {
      A.value.off(), A.value.destroy(), A.value = null;
    }, Se = (te, he) => {
      V.value = !1, Me(), be();
    };
    return mt(be), Ln(Me), Ve(B, Se, { immediate: !1 }), Ve(m, Se, { immediate: !1 }), Ve(u, Se, { immediate: !1 }), Ve(f, Se, { immediate: !1 }), Ve(h, Se, { immediate: !1 }), Ve(v, Se, { immediate: !1 }), Ve(c, Se, { immediate: !1 }), Ve(p, Se, { immediate: !1 }), Ve(T, Se, { immediate: !1, deep: !0 }), Ve(b, Se, { immediate: !1, deep: !0 }), Ve(_, Se, { immediate: !1, deep: !0 }), Ve(F, ((te, he) => {
      he && (typeof he == "object" && typeof te == "object" && te && Object.keys(he) > Object.keys(te) || typeof he == "object" && typeof te != "object" || Ma(te)) && Se();
    }), { immediate: !1 }), Ve(F, ((te) => {
      if (Ma(te)) return void le(m.value, !1);
      let he = ae();
      B.value && !Array.isArray(he) && (he = [he]), (B.value && !Jl(te, he) || !B.value && te != he) && le(te, !1);
    }), { deep: !0 }), { slider: E, slider$: A, isRange: B, sliderProps: K, init: be, destroy: Me, refresh: Se, update: le, reset: () => {
      se(z.value);
    } };
  })(e, t, { value: n.value, initialValue: n.initialValue, tooltipFormat: s.tooltipFormat, tooltipsFormat: s.tooltipsFormat, tooltipsMerge: s.tooltipsMerge, classList: r.classList });
  return { ...r, ...s, ...i };
} };
Qr.render = function(e, t, n, r, s, i) {
  return $(), q("div", Ae(e.sliderProps, { ref: "slider" }), null, 16);
}, Qr.__file = "src/Slider.vue";
const wm = ["data-click-name"], xm = { class: "lc-slider__wrap" }, km = {
  key: 0,
  class: "lc-slider__min"
}, Sm = {
  key: 0,
  class: "lc-slider__slider-marks"
}, _m = ["data-testid"], Cm = {
  key: 1,
  class: "lc-slider__max"
}, Em = 1, i2 = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcSlider",
  props: {
    containerClass: {},
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    format: { type: Function, default: (e) => String(e) },
    helpMessage: {},
    hideMax: { type: Boolean },
    hideMin: { type: Boolean },
    hideStepMarkers: { type: Boolean },
    lazy: { type: Boolean, default: !0 },
    marker: {},
    max: {},
    min: {},
    name: {},
    noFeedback: { type: Boolean },
    step: { default: 1 },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = we(!1), r = it("slider"), s = t, i = Z({
      get: () => e.value,
      set: (f) => s("update:value", f)
    }), a = Z(() => {
      if (!e.marker) return;
      const { snap: f, steps: m } = e.marker;
      return {
        range: {
          min: e.min,
          ...m,
          max: e.max
        },
        snap: f
      };
    }), o = Z(() => {
      if (a.value) return Object.keys(a.value.range);
      const f = (e.max - e.min) / e.step + Em;
      return Array.from({ length: f }, (m, u) => u);
    }), l = (f) => {
      const m = r.value;
      if (!m) return;
      const u = new Event(f, { bubbles: !0 });
      m.dispatchEvent(u);
    }, h = () => {
      n.value || (l("focusin"), l("focusout"));
    }, v = (f) => {
      n.value = f === "focusin", l(f);
    }, c = (f) => ["max", "min"].includes(String(f));
    return (f, m) => ($(), q("div", {
      ref: "slider",
      class: xe(["lc-slider", [
        {
          "lc-slider--disabled": e.disabled,
          "lc-slider--fixed-steps": !!a.value
        },
        e.containerClass,
        f.$attrs.class
      ]]),
      "data-click-name": e.dataClickName || `${e.name?.toLowerCase()}_slider`
    }, [
      ee("div", xm, [
        e.hideMin ? de("", !0) : ($(), q("span", km, [
          me(f.$slots, "min", _t(Dt({ min: e.min })), () => [
            wt(De(e.format(e.min)), 1)
          ])
        ])),
        ee("div", {
          class: "lc-slider__slider-container",
          onFocusin: m[1] || (m[1] = sa(() => v("focusin"), ["stop"])),
          onFocusout: m[2] || (m[2] = sa(() => v("focusout"), ["stop"]))
        }, [
          Fe(U(Qr), Ae({
            ...en(f.$attrs, ["class"]),
            ...f.$props,
            lazy: e.lazy
          }, {
            modelValue: i.value,
            "onUpdate:modelValue": m[0] || (m[0] = (u) => i.value = u),
            class: "lc-slider__slider",
            options: a.value,
            onChange: h
          }), null, 16, ["modelValue", "options"]),
          e.hideStepMarkers ? de("", !0) : ($(), q("div", Sm, [
            ($(!0), q(Ge, null, vt(o.value, (u) => ($(), q("span", {
              key: u,
              class: xe(["lc-slider__slider-mark", {
                [`lc-slider__slider-mark--${u}`]: c(u)
              }]),
              "data-testid": `lc-slider-mark-${u}`,
              style: Ct(
                typeof u == "string" && !c(u) ? `left:${u}%` : null
              )
            }, null, 14, _m))), 128))
          ]))
        ], 32),
        e.hideMax ? de("", !0) : ($(), q("span", Cm, [
          me(f.$slots, "max", _t(Dt({ max: e.max })), () => [
            wt(De(e.format(e.max)), 1)
          ])
        ]))
      ]),
      e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({
        key: 0,
        class: "lc-slider__feedback"
      }, { disabled: e.disabled }, {
        content: e.errorMessage || e.helpMessage,
        variant: e.errorMessage ? "error" : "default"
      }), null, 16, ["content", "variant"]))
    ], 10, wm));
  }
});
function xn() {
  return xn = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, xn.apply(this, arguments);
}
var Tm = 0.996, Am = function(t, n) {
  return n === void 0 && (n = Tm), t * n / (1 - n);
};
function Lm(e) {
  return e[e.length - 1];
}
function $m(e) {
  return e.reduce(function(t, n) {
    return t + n;
  }) / e.length;
}
var Im = function(t, n, r) {
  return Math.min(Math.max(n, t), r);
};
function Br(e, t) {
  if (e.length !== t.length)
    throw new Error("vectors must be same length");
  return e.map(function(n, r) {
    return n + t[r];
  });
}
function Ql(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function Zn(e) {
  return Object.freeze(e), Object.values(e).forEach(function(t) {
    t !== null && typeof t == "object" && !Object.isFrozen(t) && Zn(t);
  }), e;
}
function Dm() {
  var e = {};
  function t(s, i) {
    return e[s] = (e[s] || []).concat(i), function() {
      return n(s, i);
    };
  }
  function n(s, i) {
    e[s] = (e[s] || []).filter(function(a) {
      return a !== i;
    });
  }
  function r(s, i) {
    s in e && e[s].forEach(function(a) {
      return a(i);
    });
  }
  return Zn({
    on: t,
    off: n,
    dispatch: r
  });
}
function Mm(e) {
  var t = [], n = function(a) {
    return a.addEventListener("wheel", e, {
      passive: !1
    }), t.push(a), function() {
      return r(a);
    };
  }, r = function(a) {
    a.removeEventListener("wheel", e), t = t.filter(function(o) {
      return o !== a;
    });
  }, s = function() {
    t.forEach(r);
  };
  return Zn({
    observe: n,
    unobserve: r,
    disconnect: s
  });
}
var Rm = 16 * 1.125, Om = typeof window < "u" && window.innerHeight || 800, Pr = [1, Rm, Om];
function Fm(e) {
  var t = e.deltaX * Pr[e.deltaMode], n = e.deltaY * Pr[e.deltaMode], r = (e.deltaZ || 0) * Pr[e.deltaMode];
  return {
    timeStamp: e.timeStamp,
    axisDelta: [t, n, r]
  };
}
var Nm = [-1, -1, -1];
function Bm(e, t) {
  if (!t)
    return e;
  var n = t === !0 ? Nm : t.map(function(r) {
    return r ? -1 : 1;
  });
  return xn({}, e, {
    axisDelta: e.axisDelta.map(function(r, s) {
      return r * n[s];
    })
  });
}
var eo = 700, Pm = function(t) {
  return xn({}, t, {
    axisDelta: t.axisDelta.map(function(n) {
      return Im(n, -eo, eo);
    })
  });
}, zr = process.env.NODE_ENV !== "production", zm = 0.6, Vm = 0.96, Hm = 2, to = 5, no = /* @__PURE__ */ Zn({
  preventWheelAction: !0,
  reverseSign: [!0, !0, !1]
}), Um = 400;
function ao() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: Um
  };
}
function qm(e) {
  e === void 0 && (e = {});
  var t = Dm(), n = t.on, r = t.off, s = t.dispatch, i = no, a = ao(), o, l = !1, h, v = function(E) {
    Array.isArray(E) ? E.forEach(function(A) {
      return u(A);
    }) : u(E);
  }, c = function(E) {
    return E === void 0 && (E = {}), Object.values(E).some(function(A) {
      return A == null;
    }) ? (zr && console.error("updateOptions ignored! undefined & null options not allowed"), i) : i = Zn(xn({}, no, i, E));
  }, f = function(E) {
    var A = xn({
      event: o,
      isStart: !1,
      isEnding: !1,
      isMomentumCancel: !1,
      isMomentum: a.isMomentum,
      axisDelta: [0, 0, 0],
      axisVelocity: a.axisVelocity,
      axisMovement: a.axisMovement,
      get axisMovementProjection() {
        return Br(A.axisMovement, A.axisVelocity.map(function(V) {
          return Am(V);
        }));
      }
    }, E);
    s("wheel", xn({}, A, {
      previous: h
    })), h = A;
  }, m = function(E, A) {
    var V = i, H = V.preventWheelAction, K = A[0], B = A[1], ae = A[2];
    if (typeof H == "boolean") return H;
    switch (H) {
      case "x":
        return Math.abs(K) >= E;
      case "y":
        return Math.abs(B) >= E;
      case "z":
        return Math.abs(ae) >= E;
      default:
        return zr && console.warn("unsupported preventWheelAction value: " + H, "warn"), !1;
    }
  }, u = function(E) {
    var A = Pm(Bm(Fm(E), i.reverseSign)), V = A.axisDelta, H = A.timeStamp, K = Ql(V);
    if (E.preventDefault && m(K, V) && E.preventDefault(), a.isStarted ? a.isMomentum && K > Math.max(2, a.lastAbsDelta * 2) && (F(!0), L()) : L(), K === 0 && Object.is && Object.is(E.deltaX, -0)) {
      l = !0;
      return;
    }
    o = E, a.axisMovement = Br(a.axisMovement, V), a.lastAbsDelta = K, a.scrollPointsToMerge.push({
      axisDelta: V,
      timeStamp: H
    }), p(), f({
      axisDelta: V,
      isStart: !a.isStartPublished
    }), a.isStartPublished = !0, C();
  }, p = function() {
    a.scrollPointsToMerge.length === Hm ? (a.scrollPoints.unshift({
      axisDeltaSum: a.scrollPointsToMerge.map(function(E) {
        return E.axisDelta;
      }).reduce(Br),
      timeStamp: $m(a.scrollPointsToMerge.map(function(E) {
        return E.timeStamp;
      }))
    }), g(), a.scrollPointsToMerge.length = 0, a.scrollPoints.length = 1, a.isMomentum || T()) : a.isStartPublished || S();
  }, S = function() {
    a.axisVelocity = Lm(a.scrollPointsToMerge).axisDelta.map(function(E) {
      return E / a.willEndTimeout;
    });
  }, g = function() {
    var E = a.scrollPoints, A = E[0], V = E[1];
    if (!(!V || !A)) {
      var H = A.timeStamp - V.timeStamp;
      if (H <= 0) {
        zr && console.warn("invalid deltaTime");
        return;
      }
      var K = A.axisDeltaSum.map(function(ae) {
        return ae / H;
      }), B = K.map(function(ae, le) {
        return ae / (a.axisVelocity[le] || 1);
      });
      a.axisVelocity = K, a.accelerationFactors.push(B), b(H);
    }
  }, b = function(E) {
    var A = Math.ceil(E / 10) * 10 * 1.2;
    a.isMomentum || (A = Math.max(100, A * 2)), a.willEndTimeout = Math.min(1e3, Math.round(A));
  }, _ = function(E) {
    return E === 0 ? !0 : E <= Vm && E >= zm;
  }, T = function() {
    if (a.accelerationFactors.length >= to) {
      if (l && (l = !1, Ql(a.axisVelocity) >= 0.2)) {
        I();
        return;
      }
      var E = a.accelerationFactors.slice(to * -1), A = E.every(function(V) {
        var H = !!V.reduce(function(B, ae) {
          return B && B < 1 && B === ae ? 1 : 0;
        }), K = V.filter(_).length === V.length;
        return H || K;
      });
      A && I(), a.accelerationFactors = E;
    }
  }, I = function() {
    a.isMomentum = !0;
  }, L = function() {
    a = ao(), a.isStarted = !0, a.startTime = Date.now(), h = void 0, l = !1;
  }, C = /* @__PURE__ */ (function() {
    var P;
    return function() {
      clearTimeout(P), P = setTimeout(F, a.willEndTimeout);
    };
  })(), F = function(E) {
    E === void 0 && (E = !1), a.isStarted && (a.isMomentum && E ? f({
      isEnding: !0,
      isMomentumCancel: !0
    }) : f({
      isEnding: !0
    }), a.isMomentum = !1, a.isStarted = !1);
  }, z = Mm(v), X = z.observe, O = z.unobserve, G = z.disconnect;
  return c(e), Zn({
    on: n,
    off: r,
    observe: X,
    unobserve: O,
    disconnect: G,
    feedWheel: v,
    updateOptions: c
  });
}
var jm = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0
};
_i.globalOptions = void 0;
var Zm = process.env.NODE_ENV !== "production";
function _i(e) {
  e === void 0 && (e = {});
  var t, n = function() {
  };
  function r(i, a) {
    var o, l, h = a.mergeOptions, v = a.optionsAtMedia, c = h(jm, _i.globalOptions), f = h(c, e);
    t = v(f);
    var m = i.internalEngine(), u = (o = t.target) != null ? o : i.containerNode().parentNode, p = (l = t.forceWheelAxis) != null ? l : m.options.axis, S = qm({
      preventWheelAction: p,
      reverseSign: [!0, !0, !1]
    });
    function g() {
      C = (p === "x" ? m.containerRect.width : m.containerRect.height) / 2;
    }
    var b = S.observe(u), _ = S.on("wheel", K), T = !1, I, L = 0, C = 0, F = !1;
    g(), i.on("resize", g);
    function z(B) {
      try {
        I = new MouseEvent("mousedown", B.event), A(I);
      } catch {
        return Zm && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), n();
      }
      T = !0, L = 0, O(), t.wheelDraggingClass && u.classList.add(t.wheelDraggingClass);
    }
    function X(B) {
      T = !1, A(E("mouseup", B)), G(), t.wheelDraggingClass && u.classList.remove(t.wheelDraggingClass);
    }
    function O() {
      document.documentElement.addEventListener("mousemove", P, !0), document.documentElement.addEventListener("mouseup", P, !0), document.documentElement.addEventListener("mousedown", P, !0);
    }
    function G() {
      document.documentElement.removeEventListener("mousemove", P, !0), document.documentElement.removeEventListener("mouseup", P, !0), document.documentElement.removeEventListener("mousedown", P, !0);
    }
    function P(B) {
      T && B.isTrusted && B.stopImmediatePropagation();
    }
    function E(B, ae) {
      var le, se;
      if (p === m.options.axis) {
        var be = ae.axisMovement;
        le = be[0], se = be[1];
      } else {
        var Me = ae.axisMovement;
        se = Me[0], le = Me[1];
      }
      var Se = V(ae), te = Se.isAtBoundary;
      if (te) {
        var he = Math.min(L / C, 1), ge = 0.25 + he * 0.5, pe = le > 0 ? -1 : 1, ze = L * pe, ue = ze * ge;
        le += ue, se += ue;
      }
      if (!m.options.skipSnaps && !m.options.dragFree) {
        var oe = m.containerRect.width, ye = m.containerRect.height;
        le = le < 0 ? Math.max(le, -oe) : Math.min(le, oe), se = se < 0 ? Math.max(se, -ye) : Math.min(se, ye);
      }
      return new MouseEvent(B, {
        clientX: I.clientX + le,
        clientY: I.clientY + se,
        screenX: I.screenX + le,
        screenY: I.screenY + se,
        movementX: le,
        movementY: se,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0
      });
    }
    function A(B) {
      i.containerNode().dispatchEvent(B);
    }
    function V(B) {
      var ae = B.axisDelta, le = ae[0], se = ae[1], be = i.scrollProgress(), Me = be < 1, Se = be > 0, te = p === "x" ? le : se, he = te < 0, ge = te > 0, pe = he && !Me || ge && !Se;
      return {
        isAtBoundary: pe,
        primaryAxisDelta: te
      };
    }
    function H(B) {
      var ae = V(B), le = ae.isAtBoundary, se = ae.primaryAxisDelta;
      if (le && !B.isMomentum) {
        if (L += Math.abs(se), L > C)
          return F = !0, X(B), !0;
      } else
        L = 0;
      return !1;
    }
    function K(B) {
      var ae = B.axisDelta, le = ae[0], se = ae[1], be = p === "x" ? le : se, Me = p === "x" ? se : le, Se = B.isMomentum && B.previous && !B.previous.isMomentum, te = B.isEnding && !B.isMomentum || Se, he = Math.abs(be) > Math.abs(Me);
      he && !T && !B.isMomentum && !F && z(B), F && B.isEnding && (F = !1), T && (H(B) || (te ? X(B) : A(E("mousemove", B))));
    }
    n = function() {
      b(), _(), i.off("resize", g), G();
    };
  }
  var s = {
    name: "wheelGestures",
    options: e,
    init: r,
    destroy: function() {
      return n();
    }
  };
  return s;
}
const Wm = { class: "lc-slot-wheel__wrap" }, l2 = /* @__PURE__ */ Ce({
  __name: "LcSlotWheel",
  props: {
    options: {},
    value: {}
  },
  emits: ["optionsChanged", "ready", "reInit", "update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = {
      axis: "y",
      loop: !0,
      skipSnaps: !0
    }, i = [
      Ja({
        draggable: "lc-slot-wheel--draggable",
        dragging: "lc-slot-wheel--dragging",
        inView: "",
        loop: "",
        snapped: "lc-slot-wheel__slide--snapped"
      }),
      _i()
    ], [a, o] = er(
      {
        ...s,
        startIndex: Math.max(
          0,
          e.options.findIndex((L) => L.value === e.value)
        )
      },
      i
    ), l = Wn(Yr, () => null, !0), h = ho(), v = () => {
      o.value?.reInit({
        ...s,
        watchDrag: !1
      });
    }, c = () => {
      o.value?.reInit({
        ...s,
        watchDrag: !0
      });
    }, f = (L) => Math.max(
      0,
      e.options.findIndex((C) => C.value === L)
    ), m = (L) => !L || h.value === "reduce", u = (L, C = !0) => {
      o.value?.scrollTo(f(L), m(C));
    }, p = () => {
      I(), r("ready");
    }, S = () => {
      l?.disable();
    }, g = () => {
      l?.enable();
    }, b = () => {
      I(), r("reInit");
    }, _ = () => {
      const L = o.value?.selectedScrollSnap() ?? 0;
      r("update:value", e.options[L].value);
    }, T = () => {
      r("optionsChanged");
    }, I = () => {
      if (!o.value) return;
      const { rootNode: L, slideNodes: C } = o.value, z = L().getBoundingClientRect(), X = z.top + z.height / 2;
      C().forEach((O) => {
        const G = O.getBoundingClientRect(), A = (G.top + G.height / 2 - X) / (z.height / 2), V = Math.max(-1, Math.min(1, A)), H = 1 - Math.abs(V) * 0.3, K = O.style.transform.split(" ").filter((B) => !B.startsWith("scale("));
        K.push(`scale(${H})`), O.style.transform = K.join(" ");
      });
    };
    return mt(() => {
      o.value && o.value.on("init", p).on("pointerDown", S).on("pointerUp", g).on("reInit", b).on("scroll", I).on("select", _).on("slidesChanged", T);
    }), Ve(
      () => e.value,
      (L) => u(L)
    ), t({
      disable: v,
      enable: c,
      moveToOption: u
    }), (L, C) => ($(), q("div", {
      ref_key: "emblaRef",
      ref: a,
      class: "lc-slot-wheel"
    }, [
      ee("div", Wm, [
        ($(!0), q(Ge, null, vt(e.options, (F, z) => ($(), q("div", {
          key: `${F.label}-${F.value}`,
          className: "lc-slot-wheel__option"
        }, [
          me(L.$slots, "option", Ae({ ref_for: !0 }, { index: z, option: F }), () => [
            wt(De(F.label), 1)
          ])
        ]))), 128))
      ])
    ], 512));
  }
}), Ym = ["for"], Xm = ["id", "aria-label", "data-click-name"], Gm = { class: "lc-switch__toggle" }, o2 = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcSwitch",
  props: {
    ariaLabelText: {},
    dataClickName: {},
    disabled: { type: Boolean },
    icon: { default: "checkmark" },
    id: {},
    name: { default: "switch" },
    value: { type: Boolean },
    variant: { default: "success" }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = Tt(e.id), { vibrate: s } = vo(), i = Z(() => [
      "lc-switch",
      `lc-switch--variant-${e.variant}`,
      {
        "lc-switch--checked": e.value,
        "lc-switch--disabled": e.disabled
      }
    ]), a = Z({
      get: () => e.value,
      set: (o) => {
        n("update:value", o), s();
      }
    });
    return (o, l) => ($(), q("label", {
      class: xe([i.value, o.$attrs.class]),
      for: U(r)
    }, [
      Qt(ee("input", Ae({
        ...en(o.$attrs, ["class"]),
        disabled: e.disabled,
        name: e.name
      }, {
        id: U(r),
        "onUpdate:modelValue": l[0] || (l[0] = (h) => a.value = h),
        "aria-label": e.ariaLabelText,
        class: "lc-switch__input",
        "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_switch`,
        role: "switch",
        type: "checkbox",
        onKeydown: l[1] || (l[1] = ri((h) => a.value = !a.value, ["enter"]))
      }), null, 16, Xm), [
        [oo, a.value]
      ]),
      l[2] || (l[2] = ee("div", { class: "lc-switch__track" }, null, -1)),
      ee("div", Gm, [
        Fe(U(Qe), {
          class: "lc-switch__icon",
          name: e.icon
        }, null, 8, ["name"])
      ])
    ], 10, Ym));
  }
}), s2 = ["info", "success"], u2 = /* @__PURE__ */ Ce({
  __name: "LcTable",
  props: {
    bordered: { type: Boolean },
    padding: { default: "medium" }
  },
  setup(e) {
    const t = Z(() => [
      "lc-table",
      `lc-table--padding-${e.padding}`,
      {
        "lc-table--bordered": e.bordered
      }
    ]);
    return (n, r) => ($(), q("table", {
      class: xe(t.value)
    }, [
      me(n.$slots, "default")
    ], 2));
  }
}), c2 = ["medium", "small"], d2 = ["column", "row"], f2 = ["bottom", "top"], h2 = ["automatic", "manual"], v2 = ["default", "divider"], m2 = /* @__PURE__ */ Symbol();
var Nn = /* @__PURE__ */ ((e) => (e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.End = "End", e.Home = "Home", e))(Nn || {});
const Km = ["id"], Jm = ["id"], Qm = { class: "lc-tabs__tablist-inner" }, e1 = ["id", "aria-controls", "aria-selected", "disabled", "tabindex", "onClickPassive"], t1 = {
  key: 1,
  class: "lc-tabs__header"
}, n1 = ["aria-labelledby"], a1 = ["id", "aria-labelledby"], g2 = /* @__PURE__ */ Ce({
  __name: "LcTabs",
  props: {
    adaptiveHeight: { type: Boolean },
    disableSwipe: { type: Boolean },
    id: {},
    navigationPosition: { default: "top" },
    renderOnlyVisible: { type: Boolean },
    containerClass: {},
    tabFlexDirection: { default: "column" },
    tabs: {},
    trigger: { default: "automatic" },
    value: {},
    variant: { default: "default" }
  },
  emits: ["update:value"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("carousel"), i = it("container"), a = it("tabs"), o = Tt(e.id), l = we(0), h = we(0), v = we(null), c = we(null), f = we(!1), m = we(!1);
    let u = null;
    const p = Z(() => [
      "lc-tabs",
      `lc-tabs--navigation-${e.navigationPosition}`,
      `lc-tabs--variant-${e.variant}`,
      {
        "lc-tabs--tablist-hidden": b.value
      }
    ]), S = () => {
      m.value = !0, u && clearTimeout(u), u = setTimeout(() => m.value = !1, 250);
    }, g = () => {
      const O = a.value?.[l.value];
      O && (v.value = `${O.offsetWidth}px`, c.value = `${O.offsetLeft}px`);
    };
    Ut(window, "resize", [g, S]), eu(i, g);
    const b = Z(() => e.tabs.length <= 1), _ = (O, G) => {
      O !== l.value && (l.value = O, G?.skipCarousel || s.value?.moveToIndex(O), G?.skipUpdateEvent || r("update:value", e.tabs[O].name));
    }, T = (O) => {
      a.value?.[O].focus();
    }, I = (O) => {
      if (O !== l.value)
        return {
          "aria-hidden": "true",
          inert: "true"
        };
    }, L = () => h.value === e.tabs.length - 1 ? 0 : h.value + 1, C = () => h.value === 0 ? e.tabs.length - 1 : h.value - 1, F = (O) => e.tabs.findIndex((G) => G.name === O), z = (O) => {
      if (!tn(O.key, Nn)) return;
      O.preventDefault(), O.stopPropagation();
      let G;
      switch (O.key) {
        case Nn.ArrowLeft:
          G = C();
          break;
        case Nn.ArrowRight:
          G = L();
          break;
        case Nn.End:
          G = e.tabs.length - 1;
          break;
        case Nn.Home:
          G = 0;
          break;
      }
      h.value = G, e.trigger === "automatic" && _(G);
    }, X = () => {
      const O = F(e.value);
      O !== -1 && (l.value = O, h.value = O);
    };
    return Us(X), qs(X), mt(() => {
      g(), b.value || (f.value = !0);
    }), Ve(l, g), Ve(h, T), Ve(
      () => e.value,
      (O) => {
        if (!O) return;
        const G = F(O);
        G !== -1 && _(G, { skipUpdateEvent: !0 });
      }
    ), t({
      containerRef: i
    }), (O, G) => ($(), q("section", {
      id: U(o),
      class: xe(p.value)
    }, [
      me(O.$slots, "top"),
      b.value ? de("", !0) : ($(), q("div", {
        key: 0,
        ref: "container",
        class: xe(["lc-tabs__nav_container", e.containerClass])
      }, [
        ee("nav", {
          id: U(o),
          class: xe(["lc-tabs__tablist", {
            "lc-tabs__tablist--no-transition": m.value
          }]),
          role: "tablist",
          style: Ct({
            "--active-tab-index": l.value,
            ...c.value && { "--indicator-offset": c.value },
            ...v.value && { "--indicator-size": v.value },
            "--tab-count": e.tabs.length
          })
        }, [
          ee("div", Qm, [
            ($(!0), q(Ge, null, vt(e.tabs, (P, E) => ($(), q("button", {
              id: `${U(o)}-tab-${E}`,
              key: P.name,
              ref_for: !0,
              ref: "tabs",
              "aria-controls": `${U(o)}-tabpanel-${E}`,
              "aria-selected": l.value === E,
              class: xe(["lc-tabs__tab", `lc-tabs__tab--flex-${e.tabFlexDirection}`]),
              disabled: !f.value,
              role: "tab",
              tabindex: l.value !== E ? -1 : void 0,
              type: "button",
              onClickPassive: (A) => _(E),
              onKeydown: z
            }, [
              O.$slots.tab ? me(O.$slots, "tab", Ae({ ref_for: !0 }, { tab: P, index: E }), void 0, void 0, 0) : ($(), q(Ge, { key: 1 }, [
                P.icon ? ($(), ke(U(Qe), {
                  key: 0,
                  name: P.icon,
                  size: e.variant === "divider" ? "small" : "medium"
                }, null, 8, ["name", "size"])) : de("", !0),
                wt(" " + De(P.title ?? P.name), 1)
              ], 64))
            ], 42, e1))), 128))
          ])
        ], 14, Jm),
        me(O.$slots, "subnav")
      ], 2)),
      O.$slots.header ? ($(), q("header", t1, [
        me(O.$slots, "header")
      ])) : de("", !0),
      !f.value && e.tabs.length > 0 ? ($(), q("div", {
        key: 2,
        "aria-labelledby": `${U(o)}-tab-${l.value}`,
        class: xe(["lc-tabs__tabpanel", "lc-tabs__tabpanel--single-tab"]),
        role: "tabpanel"
      }, [
        me(O.$slots, "tab-panel", {
          index: l.value,
          tab: e.tabs[l.value]
        })
      ], 8, n1)) : de("", !0),
      b.value ? de("", !0) : ($(), ke(U(qd), {
        key: 3,
        ref: "carousel",
        "adaptive-height": e.renderOnlyVisible ? !1 : e.adaptiveHeight,
        class: xe(["lc-tabs__carousel", {
          "lc-tabs__carousel--unmounted": !f.value
        }]),
        "default-index": l.value,
        "disable-swipe": e.disableSwipe || b.value,
        duration: 15,
        "key-prop": "name",
        slides: e.tabs,
        onChanged: G[0] || (G[0] = (P) => _(P, { skipCarousel: !0 })),
        onReady: G[1] || (G[1] = (P) => f.value = !0)
      }, {
        slide: Te(({ index: P, isVisible: E, slide: A }) => [
          ee("div", Ae({
            id: `${U(o)}-tabpanel-${P}`
          }, I(P), {
            "aria-labelledby": `${U(o)}-tab-${P}`,
            class: "lc-tabs__tabpanel",
            role: "tabpanel"
          }), [
            !e.renderOnlyVisible || E || P === l.value ? me(O.$slots, "tab-panel", _t(Dt({ tab: A, index: P })), void 0, void 0, 0) : de("", !0)
          ], 16, a1)
        ]),
        _: 3
      }, 8, ["adaptive-height", "class", "default-index", "disable-swipe", "slides"]))
    ], 10, Km));
  }
}), r1 = ["for"], i1 = ["id"], l1 = ["id", "aria-labelledby", "data-click-error", "data-click-name"], o1 = { class: "lc-textarea__feedback-wrap" }, s1 = { class: "lc-textarea__counter" }, b2 = /* @__PURE__ */ Ce({
  inheritAttrs: !1,
  __name: "LcTextarea",
  props: {
    autofocus: { type: Boolean },
    dataClickName: {},
    disabled: { type: Boolean },
    errorMessage: {},
    helpMessage: {},
    id: {},
    label: {},
    maxlength: { default: 82 },
    name: { default: "textarea" },
    noFeedback: { type: Boolean },
    placeholder: {},
    resizeable: { type: Boolean },
    rows: { default: 2 },
    spellcheck: { type: Boolean },
    value: {}
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const n = t, r = it("textarea"), s = Tt(e.id), i = we(!1), a = Z(() => [
      "lc-textarea",
      {
        "lc-textarea--disabled": e.disabled,
        "lc-textarea--error": !!e.errorMessage,
        "lc-textarea--has-label": !!e.label
      }
    ]), o = Z(() => typeof h.value == "number" ? String(h.value).length : h.value?.length ?? 0), l = Z(() => [
      "lc-textarea__label",
      {
        "lc-textarea__label--floating": i.value || !!e.value || typeof e.value == "number"
      }
    ]), h = Z({
      get: () => e.value,
      set: (v) => n("update:value", v)
    });
    return mt(() => {
      e.autofocus && r.value?.focus();
    }), (v, c) => ($(), q("div", {
      class: xe([a.value, v.$attrs.class])
    }, [
      ee("label", {
        class: "lc-textarea__wrap",
        for: U(s)
      }, [
        e.label ? ($(), q("span", {
          key: 0,
          id: `${U(s)}-label`,
          class: xe(l.value)
        }, De(e.label), 11, i1)) : de("", !0),
        Qt(ee("textarea", Ae({
          id: U(s),
          ref: "textarea"
        }, {
          ...en(v.$attrs, ["class"]),
          disabled: e.disabled,
          maxlength: e.maxlength,
          name: e.name,
          placeholder: e.placeholder,
          resizeable: e.resizeable,
          rows: e.rows,
          spellcheck: e.spellcheck
        }, {
          "onUpdate:modelValue": c[0] || (c[0] = (f) => h.value = f),
          "aria-labelledby": e.label ? `${U(s)}-label` : void 0,
          class: "lc-textarea__input",
          "data-click-error": e.errorMessage ?? "",
          "data-click-name": e.dataClickName || `${e.name.toLowerCase()}_textarea`,
          onFocusin: c[1] || (c[1] = (f) => i.value = !0),
          onFocusout: c[2] || (c[2] = (f) => i.value = !1)
        }), null, 16, l1), [
          [js, h.value]
        ])
      ], 8, r1),
      ee("div", o1, [
        e.noFeedback ? de("", !0) : ($(), ke(U($n), Ae({ key: 0 }, { disabled: e.disabled }, {
          content: e.errorMessage || e.helpMessage,
          variant: e.errorMessage ? "error" : "default"
        }), null, 16, ["content", "variant"])),
        ee("span", s1, [
          ee("span", null, De(o.value) + "/" + De(e.maxlength), 1)
        ])
      ])
    ], 2));
  }
}), u1 = { class: "lc-toast__indicator" }, c1 = { class: "lc-toast__content" }, d1 = {
  key: 0,
  class: "lc-toast__title"
}, f1 = {
  key: 0,
  class: "lc-toast__text"
}, p2 = /* @__PURE__ */ Ce({
  __name: "LcToast",
  props: {
    closable: { type: Boolean, default: !0 },
    headline: {},
    text: {},
    variant: { default: "info" }
  },
  emits: ["close"],
  setup(e) {
    const t = {
      danger: "alert-triangle",
      info: "info",
      success: "checkmark",
      warning: "bell",
      win: "winning"
    };
    return (n, r) => ($(), q("article", {
      class: xe(["lc-toast", `lc-toast--variant-${e.variant}`]),
      role: "alert"
    }, [
      ee("aside", u1, [
        Fe(U(Qe), {
          name: t[e.variant]
        }, null, 8, ["name"])
      ]),
      ee("section", c1, [
        e.headline ? ($(), q("span", d1, De(e.headline), 1)) : de("", !0),
        me(n.$slots, "default", {}, () => [
          e.text ? ($(), q("p", f1, De(e.text), 1)) : de("", !0)
        ])
      ]),
      e.closable ? ($(), ke(U(Et), {
        key: 0,
        "aria-label": U(We).lcToast.closeButtonAriaLabel,
        class: "lc-toast__button-close",
        icon: "close",
        size: "small",
        variant: "tertiary",
        onClickPassive: r[0] || (r[0] = (s) => n.$emit("close"))
      }, null, 8, ["aria-label"])) : de("", !0)
    ], 2));
  }
}), y2 = ["danger", "info", "success", "warning", "win"], h1 = ["left", "right"], v1 = 0.4, m1 = 0.75, ro = 0.85, g1 = 0.2, io = 150, b1 = 8, p1 = {
  key: 1,
  class: "lc-swipeable__action-label"
}, w2 = /* @__PURE__ */ Ce({
  __name: "LcSwipeable",
  props: {
    disabled: { type: Boolean },
    leftAction: {},
    pointerTypes: {},
    rightAction: {}
  },
  emits: ["swipe-end", "swipe-start", "trigger"],
  setup(e, { expose: t, emit: n }) {
    const r = n, s = it("lcSwipeableRef"), i = An(), a = we(null), o = we(0), l = we(0), h = we(0), v = we(!1), c = we(!1), f = we(!1), m = we(!1), u = we(!1), p = we(null);
    let S = 0, g = null;
    const { direction: b, distanceX: _ } = tu(s, {
      pointerTypes: e.pointerTypes,
      threshold: b1,
      onSwipe: () => {
        if (p.value === null || e.disabled || !s.value) return;
        v.value || V();
        const ue = s.value.clientWidth, oe = l.value - _.value, ye = P(oe);
        if (ye && !F(ye)) {
          o.value = 0;
          return;
        }
        const Pe = X(ye), Ue = G(oe, ue, z(ye));
        m.value = E(ue, Pe), h.value = Math.min(1, Math.abs(_.value) / (ue * Pe));
        const qe = !!(ye && C(ye)?.fullSwipe && m.value);
        H(qe), K(ye), o.value = qe && ye ? A(ye, ue) : Ue, ye && ye !== a.value && B(ye);
      },
      onSwipeEnd: (ue, oe) => ge(oe)
    }), T = Z(() => h1.map((ue) => ({ side: ue, action: C(ue) }))), I = Z(() => [
      "lc-swipeable__content",
      { "lc-swipeable__content--dragging": v.value && !c.value }
    ]), L = Z(() => ro + (1 - ro) * h.value), C = (ue) => ue === "left" ? e.leftAction : ue === "right" ? e.rightAction : void 0, F = (ue) => !!(C(ue) || i[`${ue}-action`]), z = (ue) => C(ue)?.resistanceThreshold ?? m1, X = (ue) => {
      const oe = C(ue);
      return oe?.fullSwipe ? z(ue) : oe?.activationThreshold ?? v1;
    }, O = () => {
      if (!s.value) return 0;
      const ue = s.value.querySelector(
        ".lc-swipeable__content"
      );
      if (!ue) return 0;
      const oe = getComputedStyle(ue).transform;
      if (!oe || oe === "none") return 0;
      const ye = new DOMMatrix(oe).m41;
      return Number.isFinite(ye) ? ye : 0;
    }, G = (ue, oe, ye) => {
      const Pe = oe * ye, Ue = Math.abs(ue);
      if (Ue <= Pe) return ue;
      const qe = oe * g1, Ne = (1 - 1 / ((Ue - Pe) / qe + 1)) * qe;
      return Math.sign(ue) * (Pe + Ne);
    }, P = (ue) => ue < 0 ? "left" : ue > 0 ? "right" : null, E = (ue, oe) => Math.abs(_.value) >= ue * oe, A = (ue, oe) => ue === "left" ? -oe : oe, V = () => {
      l.value = O(), v.value = !0, p.value !== null && be(p.value);
    }, H = (ue) => {
      ue !== f.value && (f.value = ue, c.value = !0, S = performance.now());
    }, K = (ue) => {
      !c.value || f.value || !(performance.now() - S >= io) && ue === a.value || (c.value = !1);
    }, B = (ue) => {
      a.value = ue, u.value = !0, r("swipe-start", ue);
    }, ae = () => {
      !u.value || !a.value || (u.value = !1, r("swipe-end", a.value));
    }, le = () => {
      l.value = 0, h.value = 0, v.value = !1, f.value = !1, c.value = !1;
    }, se = (ue) => !e.pointerTypes || e.pointerTypes.includes(ue.pointerType), be = (ue) => {
      s.value?.setPointerCapture?.(ue);
    }, Me = (ue) => {
      s.value?.hasPointerCapture?.(ue) && s.value.releasePointerCapture(ue);
    }, Se = () => {
      g !== null && (clearTimeout(g), g = null);
    }, te = () => {
      Se(), p.value === null && (a.value = null);
    }, he = () => {
      Se(), g = setTimeout(te, io);
    }, ge = (ue) => {
      if (p.value === null) return;
      Me(p.value), p.value = null, ae();
      const oe = f.value;
      le(), m.value = !1;
      const ye = !e.disabled && (ue === "left" || ue === "right") && F(ue) && s.value !== null && E(s.value.clientWidth, X(ue));
      (!ye || !oe) && (o.value = 0), (!ye || !oe) && he(), ye && r("trigger", ue);
    }, pe = () => {
      c.value = !1, p.value === null && o.value === 0 && te();
    }, ze = () => {
      const ue = a.value, oe = u.value;
      p.value !== null && (Me(p.value), p.value = null), le(), o.value = 0, m.value = !1, u.value = !1, oe && ue && r("swipe-end", ue), he();
    };
    return Ut(s, "pointerdown", (ue) => {
      se(ue) && (Se(), p.value = ue.pointerId);
    }), Ut(window, ["pointerup", "pointercancel"], (ue) => {
      ue.pointerId === p.value && ge(b.value);
    }), Ut(window, "pointermove", (ue) => {
      p.value !== null && (ue.pointerType !== "mouse" || ue.buttons !== 0 || ge(b.value));
    }), Ut(s, "pointercancel", ze), Ve(
      () => e.disabled,
      (ue) => {
        ue && ze();
      }
    ), ni(Se), t({ close: ze }), (ue, oe) => ($(), q("div", {
      ref_key: "lcSwipeableRef",
      ref: s,
      class: "lc-swipeable"
    }, [
      ($(!0), q(Ge, null, vt(T.value, ({ side: ye, action: Pe }) => ($(), q(Ge, { key: ye }, [
        Pe || ue.$slots[`${ye}-action`] ? ($(), q("div", {
          key: 0,
          class: xe([
            "lc-swipeable__action",
            `lc-swipeable__action--${ye}`,
            {
              "lc-swipeable__action--hidden": a.value !== ye,
              "lc-swipeable__action--dragging": v.value && !c.value,
              "lc-swipeable__action--past-threshold": m.value && a.value === ye
            }
          ])
        }, [
          me(ue.$slots, `${ye}-action`, {}, () => [
            Pe ? ($(), q("span", {
              key: 0,
              class: "lc-swipeable__action-icon",
              style: Ct(a.value === ye ? { transform: `scale(${L.value})` } : void 0)
            }, [
              Fe(U(Qe), {
                name: Pe.icon
              }, null, 8, ["name"])
            ], 4)) : de("", !0),
            Pe?.label ? ($(), q("span", p1, De(Pe.label), 1)) : de("", !0)
          ])
        ], 2)) : de("", !0)
      ], 64))), 128)),
      ee("div", {
        class: xe(I.value),
        style: Ct({ transform: `translateX(${o.value}px)` }),
        onTransitionend: sa(pe, ["self"])
      }, [
        me(ue.$slots, "default")
      ], 38)
    ], 512));
  }
}), y1 = { class: "lc-lottery-remaining-picks__headline" }, w1 = { class: "lc-lottery-remaining-picks__done" }, x1 = {
  "aria-hidden": "true",
  class: "lc-lottery-remaining-picks__check"
}, k1 = {
  key: 0,
  class: "lc-lottery-remaining-picks__label"
}, S1 = /* @__PURE__ */ Ce({
  __name: "LcLotteryRemainingPicks",
  props: {
    complete: { type: Boolean, default: !1 },
    doneLabel: { default: () => We.lcLotteryRemainingPicks.doneLabel }
  },
  setup(e) {
    const t = we(!1);
    Ve(
      () => e.complete,
      (r, s) => {
        r && !s ? t.value = !0 : r || (t.value = !1);
      }
    );
    const n = (r) => {
      const s = e.doneLabel ? "lc-lottery-remaining-picks-label" : "lc-lottery-remaining-picks-pop";
      r.animationName === s && (t.value = !1);
    };
    return (r, s) => ($(), q("div", {
      class: xe([
        "lc-lottery-remaining-picks",
        {
          "lc-lottery-remaining-picks--complete": e.complete,
          "lc-lottery-remaining-picks--playing": t.value
        }
      ]),
      onAnimationend: n
    }, [
      ee("div", y1, [
        me(r.$slots, "default", { countClass: "lc-lottery-remaining-picks__count" })
      ]),
      ee("div", w1, [
        ee("span", x1, [
          Fe(U(Qe), {
            name: "checkmark-small",
            size: "medium"
          })
        ]),
        e.doneLabel ? ($(), q("span", k1, De(e.doneLabel), 1)) : de("", !0)
      ])
    ], 34));
  }
}), _1 = ["aria-hidden"], C1 = ["aria-hidden"], E1 = {
  key: 1,
  class: "lc-lottery-editor-card__labels"
}, T1 = {
  key: 0,
  class: "lc-lottery-editor-card__label"
}, A1 = {
  key: 1,
  class: "lc-lottery-editor-card__label"
}, L1 = { class: "lc-lottery-editor-card__footer" }, $1 = "medium", x2 = /* @__PURE__ */ Ce({
  __name: "LcLotteryEditorCard",
  props: /* @__PURE__ */ Sn({
    id: {},
    radius: { default: "large" },
    shadow: { default: "small" },
    betType: {},
    clearDisabled: { type: Boolean },
    clearLabel: { default: () => We.lcLotteryEditorCard.clearLabel },
    complete: { type: Boolean },
    doneLabel: {},
    expanded: { type: Boolean },
    fields: {},
    quickPickLabel: { default: () => We.lcLotteryEditorCard.quickPickLabel },
    remaining: {},
    toggleAriaLabel: { default: () => We.lcLotteryEditorCard.toggleAriaLabel },
    wager: {},
    separated: { type: Boolean, default: !1 }
  }, {
    expanded: { type: Boolean, default: !0 },
    expandedModifiers: {}
  }),
  emits: /* @__PURE__ */ Sn(["clear", "collapse", "collapsed", "expand", "expanded", "quick-pick", "update:expanded"], ["update:expanded"]),
  setup(e, { emit: t }) {
    const n = t, r = Wa(e, "expanded"), s = it("summary"), i = it("numbers"), a = (f) => i.value?.$el?.querySelector(f) ?? void 0, o = Z(() => a(".lc-lottery-numbers__number")), { width: l } = Vr(s), { width: h } = Vr(o), v = Z(
      () => e.fields?.reduce((f, { numbers: m }) => f + m.length, 0) ?? 0
    ), c = Z(() => {
      if (!l.value || !h.value || !v.value) return;
      const f = a(".lc-lottery-numbers__list"), m = f && parseFloat(getComputedStyle(f).columnGap) || 0, u = Math.max(
        1,
        Math.floor((l.value + m) / (h.value + m))
      ), p = Math.ceil(v.value / u);
      return p > 1 ? p : void 0;
    });
    return (f, m) => ($(), ke(U(ya), Ae({
      modelValue: r.value,
      "onUpdate:modelValue": m[2] || (m[2] = (u) => r.value = u),
      animated: "",
      "body-class": "lc-lottery-editor-card__body",
      class: ["lc-lottery-editor-card", { "lc-lottery-editor-card--separated": e.separated }],
      expandable: "",
      "footer-class": "lc-lottery-editor-card__footer-slot",
      "header-class": r.value ? "lc-lottery-editor-card__header--expanded" : "lc-lottery-editor-card__header"
    }, { id: e.id, radius: e.radius, shadow: e.shadow, toggleAriaLabel: e.toggleAriaLabel }, {
      onCollapse: m[3] || (m[3] = (u) => n("collapse")),
      onCollapsed: m[4] || (m[4] = (u) => n("collapsed")),
      onExpand: m[5] || (m[5] = (u) => n("expand")),
      onExpanded: m[6] || (m[6] = (u) => n("expanded"))
    }), {
      header: Te(() => [
        ee("div", {
          class: xe([
            "lc-lottery-editor-card__header-content",
            { "lc-lottery-editor-card__header-content--collapsed": !r.value }
          ])
        }, [
          ee("div", {
            "aria-hidden": !r.value,
            class: "lc-lottery-editor-card__expanded"
          }, [
            Fe(U(S1), _t(Dt({ complete: e.complete, doneLabel: e.doneLabel, remaining: e.remaining })), {
              default: Te(({ countClass: u }) => [
                me(f.$slots, "headline", _t(Dt({ countClass: u })))
              ]),
              _: 3
            }, 16)
          ], 8, _1),
          ee("div", {
            ref: "summary",
            "aria-hidden": r.value,
            class: "lc-lottery-editor-card__summary"
          }, [
            e.fields ? ($(), ke(U(Nh), Ae({
              key: 0,
              ref: "numbers"
            }, { fields: e.fields }, {
              rows: c.value,
              size: $1
            }), null, 16, ["rows"])) : de("", !0),
            e.wager || e.betType ? ($(), q("div", E1, [
              e.wager ? ($(), q("span", T1, De(e.wager), 1)) : de("", !0),
              e.betType ? ($(), q("span", A1, De(e.betType), 1)) : de("", !0)
            ])) : de("", !0)
          ], 8, C1)
        ], 2)
      ]),
      footer: Te(() => [
        ee("div", L1, [
          Fe(U(Et), {
            class: "lc-lottery-editor-card__clear",
            disabled: e.clearDisabled,
            icon: "trash-full",
            size: "medium",
            variant: e.clearDisabled ? "tertiary" : "raised",
            onClick: m[0] || (m[0] = (u) => n("clear"))
          }, {
            default: Te(() => [
              wt(De(e.clearLabel), 1)
            ]),
            _: 1
          }, 8, ["disabled", "variant"]),
          Fe(U(Et), {
            class: "lc-lottery-editor-card__quick-pick",
            icon: "flash",
            size: "medium",
            variant: "raised",
            onClick: m[1] || (m[1] = (u) => n("quick-pick"))
          }, {
            default: Te(() => [
              wt(De(e.quickPickLabel), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: Te(() => [
        e.separated ? ($(), ke(U(ui), {
          key: 0,
          class: "lc-lottery-editor-card__divider"
        })) : de("", !0),
        me(f.$slots, "default")
      ]),
      _: 3
    }, 16, ["modelValue", "class", "header-class"]));
  }
});
export {
  Uo as AmplitudeEvents,
  Nt as FORM_FIELD_EVENTS,
  G1 as LC_BOTTOM_SHEET_CLOSE_TRIGGERS,
  B1 as LC_BUTTON_ICON_POSITIONS,
  P1 as LC_BUTTON_SIZES,
  V1 as LC_BUTTON_TRIGGERS,
  z1 as LC_BUTTON_TYPES,
  H1 as LC_BUTTON_VARIANTS,
  q1 as LC_CARD_RADII,
  j1 as LC_CARD_SHADOWS,
  Z1 as LC_CARD_VARIANTS,
  J1 as LC_CAROUSEL_MOVE_TRIGGERS,
  K1 as LC_CAROUSEL_VARIANTS,
  eg as LC_COUNTDOWN_VARIANTS,
  fg as LC_FORM_FIELD_INTERACTION_MODES,
  O1 as LC_ICON_NAMES,
  R1 as LC_ICON_SIZES,
  gg as LC_INFO_BUTTON_VARIANTS,
  Cg as LC_INFO_TEXT_ICON_ALIGNMENTS,
  Eg as LC_INFO_TEXT_SIZES,
  ag as LC_INPUT_MODES,
  rg as LC_INPUT_TYPES,
  Lg as LC_LOTTERY_CUTOFF_TIME_VARIANTS,
  mg as LC_LOTTERY_JACPOT_SIZES,
  Dg as LC_LOTTERY_NUMBER_SELECTOR_VARIANTS,
  $g as LC_LOTTERY_NUMBER_SIZES,
  Ig as LC_LOTTERY_NUMBER_SPACINGS,
  Og as LC_LOTTERY_TEASER_VARIANTS,
  Ng as LC_MENU_BUTTON_PLACEMENTS,
  zg as LC_MESSAGE_BOX_SIZES,
  Vg as LC_MESSAGE_BOX_VARIANTS,
  W1 as LC_MODAL_CLOSE_TRIGGERS,
  Y1 as LC_MODAL_SPACINGS,
  qg as LC_PASSWORD_INPUT_TYPES,
  Zg as LC_PROGRESS_INDICATOR_SIZES,
  Wg as LC_PROGRESS_INDICATOR_VARIANTS,
  Gg as LC_RADIO_GROUP_LAYOUTS,
  t2 as LC_SCRATCHCARD_TEASER_VARIANTS,
  a2 as LC_SELECT_LIST_VARIANTS,
  U1 as LC_SEPARATOR_VARIANTS,
  Jg as LC_SKELETON_RADII,
  s2 as LC_SWITCH_VARIANTS,
  c2 as LC_TABLE_PADDINGS,
  d2 as LC_TABS_FLEX_DIRECTIONS,
  f2 as LC_TABS_NAVIGATION_POSITIONS,
  h2 as LC_TABS_TRIGGERS,
  v2 as LC_TABS_VARIANTS,
  bg as LC_TEASER_BACKGROUND_PATTERNS,
  pg as LC_TEASER_BADGE_VARIANTS,
  yg as LC_TEASER_HERO_BADGE_VARIANTS,
  Yo as LC_TEASER_VARIANTS,
  y2 as LC_TOAST_VARIANTS,
  F1 as LcBadge,
  X1 as LcBottomSheet,
  Et as LcButton,
  jr as LcButtonActiveKeys,
  ya as LcCard,
  qd as LcCarousel,
  Ra as LcCarouselActiveKeys,
  Q1 as LcCheckbox,
  Hr as LcCountBubble,
  Gd as LcCountdown,
  tg as LcDataList,
  ng as LcDataListItem,
  ig as LcDateInput,
  lg as LcDescriptionList,
  og as LcDigitInput,
  ln as LcDigitInputActiveKeys,
  sg as LcDigitInputGroup,
  Ef as LcExpandable,
  ug as LcExpandableList,
  cg as LcFlyOut,
  dg as LcForm,
  hg as LcFormField,
  vg as LcHeader,
  Zf as LcHighFrequencyBall,
  qo as LcHighFrequencyBallBackground,
  wg as LcHighFrequencyTeaser,
  xg as LcHighFrequencyTeaserWatch,
  Qe as LcIcon,
  Sg as LcImage,
  Wo as LcInfoButton,
  _g as LcInfoText,
  tr as LcInput,
  Tg as LcLinkList,
  Ag as LcLinkListItem,
  zl as LcLotteryCutoffTime,
  x2 as LcLotteryEditorCard,
  jo as LcLotteryJackpot,
  Mg as LcLotteryNumberSelector,
  Zt as LcLotteryNumberSelectorActiveKeys,
  Nh as LcLotteryNumbers,
  S1 as LcLotteryRemainingPicks,
  Rg as LcLotteryTeaser,
  Fg as LcMaskedValueDisplay,
  Bg as LcMenuButton,
  Ht as LcMenuButtonActiveKeys,
  Pg as LcMessageBox,
  Io as LcModal,
  Hg as LcMoneyInput,
  Ug as LcPasswordInput,
  jg as LcProgressIndicator,
  am as LcRadio,
  Yg as LcRadioCard,
  Xg as LcRadioGroup,
  Kg as LcRating,
  Qg as LcRemoteList,
  e2 as LcScratchcardTeaser,
  n2 as LcSelect,
  Gt as LcSelectActiveKeys,
  r2 as LcSelectList,
  Wt as LcSelectListActiveKeys,
  ui as LcSeparator,
  sm as LcSkeleton,
  i2 as LcSlider,
  l2 as LcSlotWheel,
  w2 as LcSwipeable,
  o2 as LcSwitch,
  u2 as LcTable,
  g2 as LcTabs,
  Nn as LcTabsActiveKeys,
  nr as LcTeaser,
  v0 as LcTeaserBadge,
  g0 as LcTeaserHeroBadge,
  Xo as LcTeaserHeroBadgeColor,
  b2 as LcTextarea,
  p2 as LcToast,
  Yr as carouselContext,
  We as globalConfig,
  b0 as isHeroBadge,
  dc as nuxtAppContext,
  N1 as setGlobalConfig,
  m2 as tabContext
};
